(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./.."));

var _escapeHtml = _interopRequireDefault(require("../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AGREEMENT_URL = '<a href="%(url)s" target="_blank">%(agreement)s</a>';

var RegisterLegalFootnote = function RegisterLegalFootnote(props) {
  var errors = props.errors,
      privacyPolicy = props.privacyPolicy,
      termsOfService = props.termsOfService,
      onPrivacyPolicyChange = props.onPrivacyPolicyChange,
      onTermsOfServiceChange = props.onTermsOfServiceChange;

  var termsOfServiceId = _.default.get("TERMS_OF_SERVICE_ID");

  var termsOfServiceUrl = _.default.get("TERMS_OF_SERVICE_URL");

  var privacyPolicyId = _.default.get("PRIVACY_POLICY_ID");

  var privacyPolicyUrl = _.default.get("PRIVACY_POLICY_URL");

  if (!termsOfServiceId && !privacyPolicyId) return null;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(LegalAgreement, {
    agreement: gettext("the terms of service"),
    checked: termsOfService !== null,
    errors: errors.termsOfService,
    url: termsOfServiceUrl,
    value: termsOfServiceId,
    onChange: onTermsOfServiceChange
  }), /*#__PURE__*/_react.default.createElement(LegalAgreement, {
    agreement: gettext("the privacy policy"),
    checked: privacyPolicy !== null,
    errors: errors.privacyPolicy,
    url: privacyPolicyUrl,
    value: privacyPolicyId,
    onChange: onPrivacyPolicyChange
  }));
};

var LegalAgreement = function LegalAgreement(props) {
  var agreement = props.agreement,
      checked = props.checked,
      errors = props.errors,
      url = props.url,
      value = props.value,
      onChange = props.onChange;
  if (!url) return null;
  var agreementHtml = interpolate(AGREEMENT_URL, {
    agreement: (0, _escapeHtml.default)(agreement),
    url: (0, _escapeHtml.default)(url)
  }, true);
  var label = interpolate(gettext("I have read and accept %(agreement)s."), {
    agreement: agreementHtml
  }, true);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox legal-footnote"
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", {
    checked: checked,
    type: "checkbox",
    value: value,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  })), errors && errors.map(function (error, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "help-block errors",
      key: i
    }, error);
  }));
};

var _default = RegisterLegalFootnote;
exports.default = _default;

},{"../utils/escape-html":383,"./..":302,"react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartSocialAuth = function StartSocialAuth(props) {
  var buttonClassName = props.buttonClassName,
      buttonLabel = props.buttonLabel,
      formLabel = props.formLabel,
      header = props.header,
      labelClassName = props.labelClassName;

  var socialAuth = _.default.get("SOCIAL_AUTH");

  if (socialAuth.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group form-social-auth"
  }, /*#__PURE__*/_react.default.createElement(FormHeader, {
    className: labelClassName,
    text: header
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, socialAuth.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        button_text = _ref.button_text,
        button_color = _ref.button_color,
        url = _ref.url;
    var className = "btn btn-block btn-default btn-social-" + id;
    var style = button_color ? {
      color: button_color
    } : null;
    var finalButtonLabel = button_text || interpolate(buttonLabel, {
      site: name
    }, true);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: buttonClassName || "col-xs-12",
      key: id
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: className,
      style: style,
      href: url
    }, finalButtonLabel));
  })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(FormHeader, {
    className: labelClassName,
    text: formLabel
  }));
};

var FormHeader = function FormHeader(_ref2) {
  var className = _ref2.className,
      text = _ref2.text;
  if (!text) return null;
  return /*#__PURE__*/_react.default.createElement("h5", {
    className: className || ""
  }, text);
};

var _default = StartSocialAuth;
exports.default = _default;

},{"./..":302,"react":"react"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AcceptAgreement = /*#__PURE__*/function (_React$Component) {
  _inherits(AcceptAgreement, _React$Component);

  var _super = _createSuper(AcceptAgreement);

  function AcceptAgreement(props) {
    var _this;

    _classCallCheck(this, AcceptAgreement);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDecline", function () {
      if (_this.state.submiting) return;
      var confirmation = confirm(gettext("Declining will result in immediate deactivation and deletion of your account. This action is not reversible."));
      if (!confirmation) return;

      _this.setState({
        submiting: true
      });

      _ajax.default.post(_this.props.api, {
        accept: false
      }).then(function () {
        location.reload(true);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAccept", function () {
      if (_this.state.submiting) return;

      _this.setState({
        submiting: true
      });

      _ajax.default.post(_this.props.api, {
        accept: true
      }).then(function () {
        location.reload(true);
      });
    });

    _this.state = {
      submiting: false
    };
    return _this;
  }

  _createClass(AcceptAgreement, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        disabled: this.state.submiting,
        type: "buton",
        onClick: this.handleDecline
      }, gettext("Decline")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary",
        disabled: this.state.submiting,
        type: "buton",
        onClick: this.handleAccept
      }, gettext("Accept and continue")));
    }
  }]);

  return AcceptAgreement;
}(_react.default.Component);

exports.default = AcceptAgreement;

},{"../services/ajax":365,"react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("./form"));

var _formGroup = _interopRequireDefault(require("./form-group"));

var participants = _interopRequireWildcard(require("../reducers/participants"));

var _thread = require("../reducers/thread");

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _store = _interopRequireDefault(require("../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUsernameChange", function (event) {
      _this.changeValue("username", event.target.value);
    });

    _this.state = {
      isLoading: false,
      username: ""
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.state.username.trim().length) {
        _snackbar.default.error(gettext("You have to enter user name."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.patch(this.props.thread.api.index, [{
        op: "add",
        path: "participants",
        value: this.state.username
      }, {
        op: "add",
        path: "acl",
        value: 1
      }]);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      _store.default.dispatch((0, _thread.updateAcl)(data));

      _store.default.dispatch(participants.replace(data.participants));

      _snackbar.default.success(gettext("New participant has been added to thread."));

      _modal.default.hide();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog modal-sm",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_username",
        label: gettext("User to add")
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "id_username",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.onUsernameChange,
        type: "text",
        value: this.state.username
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-block btn-primary",
        disabled: this.state.isLoading
      }, gettext("Add participant")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-block btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function ModalHeader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Add participant")));
}

},{"../reducers/participants":351,"../reducers/thread":360,"../services/ajax":365,"../services/modal":371,"../services/snackbar":376,"../services/store":377,"./form":56,"./form-group":55,"react":"react"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "refresh",
    value: function refresh() {
      window.location.reload();
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      if (this.props.signedIn) {
        return interpolate(gettext("You have signed in as %(username)s. Please refresh the page before continuing."), {
          username: this.props.signedIn.username
        }, true);
      } else if (this.props.signedOut) {
        return interpolate(gettext("%(username)s, you have been signed out. Please refresh the page before continuing."), {
          username: this.props.user.username
        }, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = "auth-message";

      if (this.props.signedIn || this.props.signedOut) {
        className += " show";
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.getMessage()), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        type: "button",
        onClick: this.refresh
      }, gettext("Reload page")), /*#__PURE__*/_react.default.createElement("span", {
        className: "hidden-xs hidden-sm"
      }, " " + gettext("or press F5 key.")))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function select(state) {
  return {
    user: state.auth.user,
    signedIn: state.auth.signedIn,
    signedOut: state.auth.signedOut
  };
}

},{"react":"react"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getSrc = getSrc;
exports.resolveAvatarForSize = resolveAvatarForSize;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var size = props.size || 100;
  var size2x = props.size2x || size;
  return /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    className: props.className || "user-avatar",
    src: getSrc(props.user, size),
    srcSet: getSrc(props.user, size2x),
    width: size,
    height: size
  });
}

function getSrc(user, size) {
  if (user && user.id) {
    // just avatar hash, size and user id
    return resolveAvatarForSize(user.avatars, size).url;
  } else {
    // just append avatar size to file to produce no-avatar placeholder
    return _.default.get("BLANK_AVATAR_URL");
  }
}

function resolveAvatarForSize(avatars, size) {
  var avatar = avatars[0];
  avatars.forEach(function (av) {
    if (av.size >= size) {
      avatar = av;
    }
  });
  return avatar;
}

},{"./..":302,"react":"react"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getReasonMessage",
    value: function getReasonMessage() {
      if (this.props.message.html) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "lead",
          dangerouslySetInnerHTML: {
            __html: this.props.message.html
          }
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "lead"
        }, this.props.message.plain);
      }
    }
  }, {
    key: "getExpirationMessage",
    value: function getExpirationMessage() {
      if (this.props.expires) {
        if (this.props.expires.isAfter((0, _moment.default)())) {
          var title = interpolate(gettext("This ban expires on %(expires_on)s."), {
            expires_on: this.props.expires.format("LL, LT")
          }, true);
          var message = interpolate(gettext("This ban expires %(expires_on)s."), {
            expires_on: this.props.expires.fromNow()
          }, true);
          return /*#__PURE__*/_react.default.createElement("abbr", {
            title: title
          }, message);
        } else {
          return gettext("This ban has expired.");
        }
      } else {
        return gettext("This ban is permanent.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-error page-error-banned"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-panel"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "highlight_off")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, this.getReasonMessage(), /*#__PURE__*/_react.default.createElement("p", {
        className: "message-footnote"
      }, this.getExpirationMessage())))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"moment":"moment","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var className = "btn " + this.props.className;
      var disabled = this.props.disabled;

      if (this.props.loading) {
        className += " btn-loading";
        disabled = true;
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        className: className,
        disabled: disabled,
        onClick: this.props.onClick,
        type: this.props.onClick ? "button" : "submit"
      }, this.props.children, this.props.loading ? /*#__PURE__*/_react.default.createElement(_loader.default, null) : null);
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;
Button.defaultProps = {
  className: "btn-default",
  type: "submit",
  loading: false,
  disabled: false,
  onClick: null
};

},{"./loader":58,"react":"react"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "categories-list"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-group"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "list-group-item empty-message"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("No categories exist or you don't have permission to see them.")))));
}

},{"react":"react"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _category = _interopRequireDefault(require("./category"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var categories = _ref.categories;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "categories-list"
  }, categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_category.default, {
      category: category,
      key: category.id
    });
  }));
}

},{"./category":11,"react":"react"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _listItem = _interopRequireDefault(require("./list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  var className = "list-group list-group-category";

  if (category.css_class) {
    className += " list-group-category-has-flavor";
    className += " list-group-category-" + category.css_class;
  }

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_listItem.default, {
    category: category,
    isFirst: true
  }), category.subcategories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_listItem.default, {
      category: category,
      isFirst: false,
      key: category.id
    });
  }));
}

},{"./list-item":14,"react":"react"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  if (!category.description) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "category-description",
    dangerouslySetInnerHTML: {
      __html: category.description.html
    }
  });
}

},{"react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getClassName = getClassName;
exports.getTitle = getTitle;
exports.getIcon = getIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: getClassName(category),
    title: getTitle(category)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, getIcon(category)));
}

function getClassName(category) {
  if (category.is_read) {
    return "read-status item-read";
  }

  return "read-status item-new";
}

function getTitle(category) {
  if (category.is_closed) {
    if (category.is_read) {
      return gettext("This category has no new posts. (closed)");
    }

    return gettext("This category has new posts. (closed)");
  }

  if (category.is_read) {
    return gettext("This category has no new posts.");
  }

  return gettext("This category has new posts.");
}

function getIcon(category) {
  if (category.is_closed) {
    if (category.is_read) {
      return "lock_outline";
    }

    return "lock";
  }

  if (category.is_read) {
    return "chat_bubble_outline";
  }

  return "chat_bubble";
}

},{"react":"react"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _main = _interopRequireDefault(require("./main"));

var _lastThread = _interopRequireDefault(require("./last-thread"));

var _stats = _interopRequireDefault(require("./stats"));

var _subcategories = _interopRequireDefault(require("./subcategories"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category,
      isFirst = _ref.isFirst;
  var className = "list-group-item";

  if (category.description) {
    className += " list-group-category-has-description";
  } else {
    className += " list-group-category-no-description";
  }

  if (isFirst) {
    className += " list-group-item-first";
  }

  if (category.css_class) {
    className += " list-group-category-has-flavor";
    className += " list-group-item-category-" + category.css_class;
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(_main.default, {
    category: category
  }), /*#__PURE__*/_react.default.createElement(_stats.default, {
    category: category
  }), /*#__PURE__*/_react.default.createElement(_lastThread.default, {
    category: category
  })), /*#__PURE__*/_react.default.createElement(_subcategories.default, {
    category: category,
    isFirst: isFirst
  }));
}

},{"./last-thread":15,"./main":16,"./stats":17,"./subcategories":18,"react":"react"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.LastThread = LastThread;
exports.LastPosterAvatar = LastPosterAvatar;
exports.LastPosterName = LastPosterName;
exports.Empty = Empty;
exports.Private = Private;
exports.Protected = Protected;
exports.Message = Message;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-4 category-last-thread"
  }, /*#__PURE__*/_react.default.createElement(LastThread, {
    category: category
  }), /*#__PURE__*/_react.default.createElement(Empty, {
    category: category
  }), /*#__PURE__*/_react.default.createElement(Private, {
    category: category
  }), /*#__PURE__*/_react.default.createElement(Protected, {
    category: category
  }));
}

function LastThread(_ref2) {
  var category = _ref2.category;
  if (!category.acl.can_browse) return null;
  if (!category.acl.can_see_all_threads) return null;
  if (!category.last_thread_title) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(LastPosterAvatar, {
    category: category
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "item-title thread-title",
    href: category.url.last_thread_new,
    title: category.last_thread_title
  }, category.last_thread_title)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "category-last-thread-poster"
  }, /*#__PURE__*/_react.default.createElement(LastPosterName, {
    category: category
  })), /*#__PURE__*/_react.default.createElement("li", {
    className: "divider"
  }, "\u2014"), /*#__PURE__*/_react.default.createElement("li", {
    className: "category-last-thread-date"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: category.url.last_post
  }, category.last_post_on.fromNow())))));
}

function LastPosterAvatar(_ref3) {
  var category = _ref3.category;

  if (category.last_poster) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "last-poster-avatar",
      href: category.last_poster.url,
      title: category.last_poster_name
    }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
      className: "media-object",
      size: 40,
      user: category.last_poster
    }));
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "last-poster-avatar",
    title: category.last_poster_name
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "media-object",
    size: 40
  }));
}

function LastPosterName(_ref4) {
  var category = _ref4.category;

  if (category.last_poster) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "item-title",
      href: category.last_poster.url
    }, category.last_poster_name);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "item-title"
  }, category.last_poster_name);
}

function Empty(_ref5) {
  var category = _ref5.category;
  if (!category.acl.can_browse) return null;
  if (!category.acl.can_see_all_threads) return null;
  if (category.last_thread_title) return null;
  return /*#__PURE__*/_react.default.createElement(Message, {
    message: gettext("This category is empty. No threads were posted within it so far.")
  });
}

function Private(_ref6) {
  var category = _ref6.category;
  if (!category.acl.can_browse) return null;
  if (category.acl.can_see_all_threads) return null;
  return /*#__PURE__*/_react.default.createElement(Message, {
    message: gettext("This category is private. You can see only your own threads within it.")
  });
}

function Protected(_ref7) {
  var category = _ref7.category;
  if (category.acl.can_browse) return null;
  return /*#__PURE__*/_react.default.createElement(Message, {
    message: gettext("This category is protected. You can't browse its contents.")
  });
}

function Message(_ref8) {
  var message = _ref8.message;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "media category-thread-message"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("p", null, message)));
}

},{"../../../avatar":6,"react":"react"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _description = _interopRequireDefault(require("./description"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-6 category-main"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    category: category
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: category.url.index
  }, category.name)), /*#__PURE__*/_react.default.createElement(_description.default, {
    category: category
  }))));
}

},{"./description":12,"./icon":13,"react":"react"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Threads = Threads;
exports.Posts = Posts;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-2 hidden-xs hidden-sm"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled category-stats"
  }, /*#__PURE__*/_react.default.createElement(Threads, {
    threads: category.threads
  }), /*#__PURE__*/_react.default.createElement(Posts, {
    posts: category.posts
  })));
}

function Threads(_ref2) {
  var threads = _ref2.threads;
  var message = ngettext("%(threads)s thread", "%(threads)s threads", threads);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "category-stat-threads"
  }, interpolate(message, {
    threads: threads
  }, true));
}

function Posts(_ref3) {
  var posts = _ref3.posts;
  var message = ngettext("%(posts)s post", "%(posts)s posts", posts);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "category-stat-posts"
  }, interpolate(message, {
    posts: posts
  }, true));
}

},{"../../../avatar":6,"react":"react"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _listItem = _interopRequireDefault(require("./list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category,
      isFirst = _ref.isFirst;
  if (isFirst) return null;
  if (category.subcategories.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row subcategories-list"
  }, category.subcategories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_listItem.default, {
      category: category,
      key: category.id
    });
  }));
}

},{"./list-item":19,"react":"react"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getIcon = getIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category;
  var className = "btn btn-default btn-block btn-sm btn-subcategory";

  if (!category.is_read) {
    className += " btn-subcategory-new";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-4 col-md-3"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: className,
    href: category.url.index
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, getIcon(category)), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-text"
  }, category.name)));
}

function getIcon(category) {
  if (category.is_closed) {
    if (category.is_read) {
      return "lock_outline";
    }

    return "lock";
  }

  if (category.is_read) {
    return "chat_bubble_outline";
  }

  return "chat_bubble";
}

},{"react":"react"}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _blankslate = _interopRequireDefault(require("./blankslate"));

var _categoriesList = _interopRequireDefault(require("./categories-list"));

var _ = _interopRequireDefault(require("../.."));

var _polls = _interopRequireDefault(require("../../services/polls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hydrate = function hydrate(category) {
  return Object.assign({}, category, {
    last_post_on: category.last_post_on ? (0, _moment.default)(category.last_post_on) : null,
    subcategories: category.subcategories.map(hydrate)
  });
};

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (data) {
      _this.setState({
        categories: data.map(hydrate)
      });
    });

    _this.state = {
      categories: _.default.get("CATEGORIES").map(hydrate)
    };

    _this.startPolling(_.default.get("CATEGORIES_API"));

    return _this;
  }

  _createClass(_default, [{
    key: "startPolling",
    value: function startPolling(api) {
      _polls.default.start({
        poll: "categories",
        url: api,
        frequency: 180 * 1000,
        update: this.update
      });
    }
  }, {
    key: "render",
    value: function render() {
      var categories = this.state.categories;

      if (categories.length === 0) {
        return /*#__PURE__*/_react.default.createElement(_blankslate.default, null);
      }

      return /*#__PURE__*/_react.default.createElement(_categoriesList.default, {
        categories: categories
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function select(store) {
  return {
    tick: store.tick.tick
  };
}

},{"../..":302,"../../services/polls":374,"./blankslate":9,"./categories-list":10,"moment":"moment","react":"react"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("select", {
    className: props.className || "form-control",
    disabled: props.disabled || false,
    id: props.id || null,
    onChange: props.onChange,
    value: props.value
  }, props.choices.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      disabled: item.disabled || false,
      key: item.value,
      value: item.value
    }, "- - ".repeat(item.level) + item.label);
  }));
}

},{"react":"react"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _button = _interopRequireDefault(require("../button"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "cropAvatar", function () {
      if (_this.state.isLoading) {
        return false;
      }

      _this.setState({
        isLoading: true
      });

      var avatarType = _this.props.upload ? "crop_tmp" : "crop_src";
      var cropit = $(".crop-form");
      var deviceRatio = cropit.cropit("exportZoom");
      var cropitOffset = cropit.cropit("offset");

      _ajax.default.post(_this.props.user.api.avatar, {
        avatar: avatarType,
        crop: {
          offset: {
            x: cropitOffset.x * deviceRatio,
            y: cropitOffset.y * deviceRatio
          },
          zoom: cropit.cropit("zoom") * deviceRatio
        }
      }).then(function (data) {
        _this.props.onComplete(data);

        _snackbar.default.success(data.detail);
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail);

          _this.setState({
            isLoading: false
          });
        } else {
          _this.props.showError(rejection);
        }
      });
    });

    _this.state = {
      isLoading: false,
      deviceRatio: 1
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getAvatarSize",
    value: function getAvatarSize() {
      if (this.props.upload) {
        return this.props.options.crop_tmp.size;
      } else {
        return this.props.options.crop_src.size;
      }
    }
  }, {
    key: "getImagePath",
    value: function getImagePath() {
      if (this.props.upload) {
        return this.props.dataUrl;
      } else {
        return this.props.options.crop_src.url;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var cropit = $(".crop-form");
      var cropperWidth = this.getAvatarSize();
      var initialWidth = cropit.width();

      while (initialWidth < cropperWidth) {
        cropperWidth = cropperWidth / 2;
      }

      var deviceRatio = this.getAvatarSize() / cropperWidth;
      cropit.width(cropperWidth);
      cropit.cropit({
        width: cropperWidth,
        height: cropperWidth,
        exportZoom: deviceRatio,
        imageState: {
          src: this.getImagePath()
        },
        onImageLoaded: function onImageLoaded() {
          if (_this2.props.upload) {
            // center uploaded image
            var zoomLevel = cropit.cropit("zoom");
            var imageSize = cropit.cropit("imageSize"); // is it wider than taller?

            if (imageSize.width > imageSize.height) {
              var displayedWidth = imageSize.width * zoomLevel;
              var offsetX = (displayedWidth - _this2.getAvatarSize()) / -2;
              cropit.cropit("offset", {
                x: offsetX,
                y: 0
              });
            } else if (imageSize.width < imageSize.height) {
              var displayedHeight = imageSize.height * zoomLevel;
              var offsetY = (displayedHeight - _this2.getAvatarSize()) / -2;
              cropit.cropit("offset", {
                x: 0,
                y: offsetY
              });
            } else {
              cropit.cropit("offset", {
                x: 0,
                y: 0
              });
            }
          } else {
            // use preserved crop
            var crop = _this2.props.options.crop_src.crop;

            if (crop) {
              cropit.cropit("zoom", crop.zoom);
              cropit.cropit("offset", {
                x: crop.x,
                y: crop.y
              });
            }
          }
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(".crop-form").cropit("disable");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-avatar-crop"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "crop-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cropit-preview"
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "range",
        className: "cropit-image-zoom-input"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-6 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.cropAvatar,
        loading: this.state.isLoading,
        className: "btn-primary btn-block"
      }, this.props.upload ? gettext("Set avatar") : gettext("Crop image")), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.showIndex,
        disabled: this.state.isLoading,
        className: "btn-default btn-block"
      }, gettext("Cancel")))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../services/ajax":365,"../../services/snackbar":376,"../avatar":6,"../button":8,"react":"react"}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Gallery = exports.GalleryItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _button = _interopRequireDefault(require("../button"));

var _ = _interopRequireDefault(require("../.."));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _batch = _interopRequireDefault(require("../../utils/batch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GalleryItem = /*#__PURE__*/function (_React$Component) {
  _inherits(GalleryItem, _React$Component);

  var _super = _createSuper(GalleryItem);

  function GalleryItem() {
    var _this;

    _classCallCheck(this, GalleryItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "select", function () {
      _this.props.select(_this.props.id);
    });

    return _this;
  }

  _createClass(GalleryItem, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.selection === this.props.id) {
        if (this.props.disabled) {
          return "btn btn-avatar btn-disabled avatar-selected";
        } else {
          return "btn btn-avatar avatar-selected";
        }
      } else if (this.props.disabled) {
        return "btn btn-avatar btn-disabled";
      } else {
        return "btn btn-avatar";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: this.getClassName(),
        disabled: this.props.disabled,
        onClick: this.select
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.url
      }));
    }
  }]);

  return GalleryItem;
}(_react.default.Component);

exports.GalleryItem = GalleryItem;

var Gallery = /*#__PURE__*/function (_React$Component2) {
  _inherits(Gallery, _React$Component2);

  var _super2 = _createSuper(Gallery);

  function Gallery() {
    _classCallCheck(this, Gallery);

    return _super2.apply(this, arguments);
  }

  _createClass(Gallery, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "avatars-gallery"
      }, /*#__PURE__*/_react.default.createElement("h3", null, this.props.name), /*#__PURE__*/_react.default.createElement("div", {
        className: "avatars-gallery-images"
      }, (0, _batch.default)(this.props.images, 4, null).map(function (row, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "row",
          key: i
        }, row.map(function (item, i) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "col-xs-3",
            key: i
          }, item ? /*#__PURE__*/_react.default.createElement(GalleryItem, _extends({
            disabled: _this2.props.disabled,
            select: _this2.props.select,
            selection: _this2.props.selection
          }, item)) : /*#__PURE__*/_react.default.createElement("div", {
            className: "blank-avatar"
          }));
        }));
      })));
    }
  }]);

  return Gallery;
}(_react.default.Component);

exports.Gallery = Gallery;

var _default = /*#__PURE__*/function (_React$Component3) {
  _inherits(_default, _React$Component3);

  var _super3 = _createSuper(_default);

  function _default(props) {
    var _this3;

    _classCallCheck(this, _default);

    _this3 = _super3.call(this, props);

    _defineProperty(_assertThisInitialized(_this3), "select", function (image) {
      _this3.setState({
        selection: image
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "save", function () {
      if (_this3.state.isLoading) {
        return false;
      }

      _this3.setState({
        isLoading: true
      });

      _ajax.default.post(_this3.props.user.api.avatar, {
        avatar: "galleries",
        image: _this3.state.selection
      }).then(function (response) {
        _this3.setState({
          isLoading: false
        });

        _snackbar.default.success(response.detail);

        _this3.props.onComplete(response);

        _this3.props.showIndex();
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail);

          _this3.setState({
            isLoading: false
          });
        } else {
          _this3.props.showError(rejection);
        }
      });
    });

    _this3.state = {
      selection: null,
      isLoading: false
    };
    return _this3;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-avatar-gallery"
      }, this.props.options.galleries.map(function (item, i) {
        return /*#__PURE__*/_react.default.createElement(Gallery, {
          name: item.name,
          images: item.images,
          selection: _this4.state.selection,
          disabled: _this4.state.isLoading,
          select: _this4.select,
          key: i
        });
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-6 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.save,
        loading: this.state.isLoading,
        disabled: !this.state.selection,
        className: "btn-primary btn-block"
      }, this.state.selection ? gettext("Save choice") : gettext("Select avatar")), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.showIndex,
        disabled: this.state.isLoading,
        className: "btn-default btn-block"
      }, gettext("Cancel"))))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../services/ajax":365,"../../services/snackbar":376,"../../utils/batch":380,"../avatar":6,"../button":8,"react":"react"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _button = _interopRequireDefault(require("../button"));

var _loader = _interopRequireDefault(require("../loader"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setGravatar", function () {
      _this.callApi("gravatar");
    });

    _defineProperty(_assertThisInitialized(_this), "setGenerated", function () {
      _this.callApi("generated");
    });

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "callApi",
    value: function callApi(avatarType) {
      var _this2 = this;

      if (this.state.isLoading) {
        return false;
      }

      this.setState({
        isLoading: true
      });

      _ajax.default.post(this.props.user.api.avatar, {
        avatar: avatarType
      }).then(function (response) {
        _this2.setState({
          isLoading: false
        });

        _snackbar.default.success(response.detail);

        _this2.props.onComplete(response);
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail);

          _this2.setState({
            isLoading: false
          });
        } else {
          _this2.props.showError(rejection);
        }
      });
    }
  }, {
    key: "getGravatarButton",
    value: function getGravatarButton() {
      if (this.props.options.gravatar) {
        return /*#__PURE__*/_react.default.createElement(_button.default, {
          onClick: this.setGravatar,
          disabled: this.state.isLoading,
          className: "btn-default btn-block btn-avatar-gravatar"
        }, gettext("Download my Gravatar"));
      } else {
        return null;
      }
    }
  }, {
    key: "getCropButton",
    value: function getCropButton() {
      if (!this.props.options.crop_src) return null;
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-default btn-block btn-avatar-crop",
        disabled: this.state.isLoading,
        onClick: this.props.showCrop
      }, gettext("Re-crop uploaded image"));
    }
  }, {
    key: "getUploadButton",
    value: function getUploadButton() {
      if (!this.props.options.upload) return null;
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-default btn-block btn-avatar-upload",
        disabled: this.state.isLoading,
        onClick: this.props.showUpload
      }, gettext("Upload new image"));
    }
  }, {
    key: "getGalleryButton",
    value: function getGalleryButton() {
      if (!this.props.options.galleries) return null;
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-default btn-block btn-avatar-gallery",
        disabled: this.state.isLoading,
        onClick: this.props.showGallery
      }, gettext("Pick avatar from gallery"));
    }
  }, {
    key: "getAvatarPreview",
    value: function getAvatarPreview() {
      var userPeview = {
        id: this.props.user.id,
        avatars: this.props.options.avatars
      };

      if (this.state.isLoading) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "avatar-preview preview-loading"
        }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
          size: "200",
          user: userPeview
        }), /*#__PURE__*/_react.default.createElement(_loader.default, null));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "avatar-preview"
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "200",
        user: userPeview
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-avatar-index"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-5"
      }, this.getAvatarPreview()), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-7"
      }, this.getGravatarButton(), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.setGenerated,
        disabled: this.state.isLoading,
        className: "btn-default btn-block btn-avatar-generate"
      }, gettext("Generate my individual avatar")), this.getCropButton(), this.getUploadButton(), this.getGalleryButton())));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../services/ajax":365,"../../services/snackbar":376,"../avatar":6,"../button":8,"../loader":58,"react":"react"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.default = exports.ChangeAvatarError = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index"));

var _crop = _interopRequireDefault(require("./crop"));

var _upload = _interopRequireDefault(require("./upload"));

var _gallery = _interopRequireDefault(require("./gallery"));

var _modalLoader = _interopRequireDefault(require("../modal-loader"));

var _users = require("../../reducers/users");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ChangeAvatarError = /*#__PURE__*/function (_React$Component) {
  _inherits(ChangeAvatarError, _React$Component);

  var _super = _createSuper(ChangeAvatarError);

  function ChangeAvatarError() {
    _classCallCheck(this, ChangeAvatarError);

    return _super.apply(this, arguments);
  }

  _createClass(ChangeAvatarError, [{
    key: "getErrorReason",
    value: function getErrorReason() {
      if (this.props.reason) {
        return /*#__PURE__*/_react.default.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: this.props.reason
          }
        });
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "remove_circle_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.props.message), this.getErrorReason(), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        type: "button"
      }, gettext("Ok"))));
    }
  }]);

  return ChangeAvatarError;
}(_react.default.Component);

exports.ChangeAvatarError = ChangeAvatarError;

var _default = /*#__PURE__*/function (_React$Component2) {
  _inherits(_default, _React$Component2);

  var _super2 = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "showError", function (error) {
      _this.setState({
        error: error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showIndex", function () {
      _this.setState({
        component: _index.default
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showUpload", function () {
      _this.setState({
        component: _upload.default
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showCrop", function () {
      _this.setState({
        component: _crop.default
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showGallery", function () {
      _this.setState({
        component: _gallery.default
      });
    });

    _defineProperty(_assertThisInitialized(_this), "completeFlow", function (options) {
      _store.default.dispatch((0, _users.updateAvatar)(_this.props.user, options.avatars));

      _this.setState({
        component: _index.default,
        options: options
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.user.api.avatar).then(function (options) {
        _this2.setState({
          component: _index.default,
          options: options,
          error: null
        });
      }, function (rejection) {
        _this2.showError(rejection);
      });
    }
  }, {
    key: "getBody",
    value: function getBody() {
      if (this.state) {
        if (this.state.error) {
          return /*#__PURE__*/_react.default.createElement(ChangeAvatarError, {
            message: this.state.error.detail,
            reason: this.state.error.reason
          });
        } else {
          return /*#__PURE__*/_react.default.createElement(this.state.component, {
            options: this.state.options,
            user: this.props.user,
            onComplete: this.completeFlow,
            showError: this.showError,
            showIndex: this.showIndex,
            showCrop: this.showCrop,
            showUpload: this.showUpload,
            showGallery: this.showGallery
          });
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_modalLoader.default, null);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.state && this.state.error) {
        return "modal-dialog modal-message modal-change-avatar";
      } else {
        return "modal-dialog modal-change-avatar";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Change your avatar"))), this.getBody()));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function select(state) {
  return {
    user: state.auth.user
  };
}

},{"../../reducers/users":364,"../../services/ajax":365,"../../services/store":377,"../modal-loader":61,"./crop":22,"./gallery":23,"./index":24,"./upload":26,"react":"react"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _crop = _interopRequireDefault(require("./crop"));

var _button = _interopRequireDefault(require("../button"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _fileSize = _interopRequireDefault(require("../../utils/file-size"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "pickFile", function () {
      document.getElementById("avatar-hidden-upload").click();
    });

    _defineProperty(_assertThisInitialized(_this), "uploadFile", function () {
      var image = document.getElementById("avatar-hidden-upload").files[0];
      if (!image) return;

      var validationError = _this.validateFile(image);

      if (validationError) {
        _snackbar.default.error(validationError);

        return;
      }

      _this.setState({
        image: image,
        preview: URL.createObjectURL(image),
        progress: 0
      });

      var data = new FormData();
      data.append("avatar", "upload");
      data.append("image", image);

      _ajax.default.upload(_this.props.user.api.avatar, data, function (progress) {
        _this.setState({
          progress: progress
        });
      }).then(function (data) {
        _this.setState({
          options: data,
          uploaded: data.detail
        });

        _snackbar.default.info(gettext("Your image has been uploaded and you may now crop it."));
      }, function (rejection) {
        if (rejection.status === 400 || rejection.status === 413) {
          _snackbar.default.error(rejection.detail);

          _this.setState({
            isLoading: false,
            image: null,
            progress: 0
          });
        } else {
          _this.props.showError(rejection);
        }
      });
    });

    _this.state = {
      image: null,
      preview: null,
      progress: 0,
      uploaded: null,
      dataUrl: null
    };
    return _this;
  }

  _createClass(_default, [{
    key: "validateFile",
    value: function validateFile(image) {
      if (image.size > this.props.options.upload.limit) {
        return interpolate(gettext("Selected file is too big. (%(filesize)s)"), {
          filesize: (0, _fileSize.default)(image.size)
        }, true);
      }

      var invalidTypeMsg = gettext("Selected file type is not supported.");

      if (this.props.options.upload.allowed_mime_types.indexOf(image.type) === -1) {
        return invalidTypeMsg;
      }

      var extensionFound = false;
      var loweredFilename = image.name.toLowerCase();
      this.props.options.upload.allowed_extensions.map(function (extension) {
        if (loweredFilename.substr(extension.length * -1) === extension) {
          extensionFound = true;
        }
      });

      if (!extensionFound) {
        return invalidTypeMsg;
      }

      return false;
    }
  }, {
    key: "getUploadRequirements",
    value: function getUploadRequirements(options) {
      var extensions = options.allowed_extensions.map(function (extension) {
        return extension.substr(1);
      });
      return interpolate(gettext("%(files)s files smaller than %(limit)s"), {
        files: extensions.join(", "),
        limit: (0, _fileSize.default)(options.limit)
      }, true);
    }
  }, {
    key: "getUploadButton",
    value: function getUploadButton() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-avatar-upload"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-pick-file",
        onClick: this.pickFile
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "material-icon"
      }, "input"), gettext("Select file")), /*#__PURE__*/_react.default.createElement("p", {
        className: "text-muted"
      }, this.getUploadRequirements(this.props.options.upload)));
    }
  }, {
    key: "getUploadProgressLabel",
    value: function getUploadProgressLabel() {
      return interpolate(gettext("%(progress)s % complete"), {
        progress: this.state.progress
      }, true);
    }
  }, {
    key: "getUploadProgress",
    value: function getUploadProgress() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-avatar-upload"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-progress"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.state.preview
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-bar",
        role: "progressbar",
        "aria-valuenow": "{this.state.progress}",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        style: {
          width: this.state.progress + "%"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, this.getUploadProgressLabel())))));
    }
  }, {
    key: "renderUpload",
    value: function renderUpload() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        type: "file",
        id: "avatar-hidden-upload",
        className: "hidden-file-upload",
        onChange: this.uploadFile
      }), this.state.image ? this.getUploadProgress() : this.getUploadButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-6 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.showIndex,
        disabled: !!this.state.image,
        className: "btn-default btn-block"
      }, gettext("Cancel")))));
    }
  }, {
    key: "renderCrop",
    value: function renderCrop() {
      return /*#__PURE__*/_react.default.createElement(_crop.default, {
        options: this.state.options,
        user: this.props.user,
        upload: this.state.uploaded,
        dataUrl: this.state.preview,
        onComplete: this.props.onComplete,
        showError: this.props.showError,
        showIndex: this.props.showIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.uploaded) return this.renderCrop();
      return this.renderUpload();
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../services/ajax":365,"../../services/snackbar":376,"../../utils/file-size":384,"../button":8,"./crop":22,"react":"react"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.dropdown) {
        return "btn btn-default btn-aligned btn-icon btn-dropdown-toggle open hidden-md hidden-lg";
      } else {
        return "btn btn-default btn-aligned btn-icon btn-dropdown-toggle hidden-md hidden-lg";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: this.getClassName(),
        type: "button",
        onClick: this.props.toggleNav,
        "aria-haspopup": "true",
        "aria-expanded": this.props.dropdown ? "true" : "false"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icon"
      }, "menu"));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _panelMessage = _interopRequireDefault(require("../panel-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var display = _ref.display;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement(_panelMessage.default, {
    helpText: gettext("No profile details are editable at this time."),
    message: gettext("This option is currently unavailable.")
  });
}

},{"../panel-message":94,"react":"react"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _select = _interopRequireDefault(require("../select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (ev) {
      var _this$props = _this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;
      onChange(field.fieldname, ev.target.value);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          field = _this$props2.field,
          value = _this$props2.value;
      var input = field.input;

      if (input.type === "select") {
        return /*#__PURE__*/_react.default.createElement(_select.default, {
          choices: input.choices,
          disabled: disabled,
          id: "id_" + field.fieldname,
          onChange: this.onChange,
          value: value
        });
      }

      if (input.type === "textarea") {
        return /*#__PURE__*/_react.default.createElement("textarea", {
          className: "form-control",
          disabled: disabled,
          id: "id_" + field.fieldname,
          onChange: this.onChange,
          rows: "4",
          type: "text",
          value: value
        });
      }

      if (input.type === "text") {
        return /*#__PURE__*/_react.default.createElement("input", {
          className: "form-control",
          disabled: disabled,
          id: "id_" + field.fieldname,
          onChange: this.onChange,
          type: "text",
          value: value
        });
      }

      return null;
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../select":210,"react":"react"}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _fieldInput = _interopRequireDefault(require("./field-input"));

var _formGroup = _interopRequireDefault(require("../form-group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var disabled = _ref.disabled,
      errors = _ref.errors,
      fields = _ref.fields,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", null, name), fields.map(function (field) {
    return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
      for: "id_" + field.fieldname,
      helpText: field.help_text,
      key: field.fieldname,
      label: field.label,
      validation: errors[field.fieldname]
    }, /*#__PURE__*/_react.default.createElement(_fieldInput.default, {
      disabled: disabled,
      field: field,
      onChange: onChange,
      value: value[field.fieldname]
    }));
  }));
}

},{"../form-group":55,"./field-input":29,"react":"react"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelButton = CancelButton;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _fieldset = _interopRequireDefault(require("./fieldset"));

var _button = _interopRequireDefault(require("../button"));

var _form = _interopRequireDefault(require("../form"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (name, value) {
      _this.setState(_defineProperty({}, name, value));
    });

    _this.state = {
      isLoading: false,
      errors: {}
    };
    var groups = props.groups.length;

    for (var i = 0; i < groups; i++) {
      var group = props.groups[i];
      var fields = group.fields.length;

      for (var f = 0; f < fields; f++) {
        var fieldname = group.fields[f].fieldname;
        var initial = group.fields[f].initial;
        _this.state[fieldname] = initial;
      }
    }

    return _this;
  }

  _createClass(_default, [{
    key: "send",
    value: function send() {
      var data = Object.assign({}, this.state, {
        errors: null,
        isLoading: null
      });
      return _ajax.default.post(this.props.api, data);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      this.props.onSuccess(data);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(gettext("Form contains errors."));

        this.setState({
          errors: rejection
        });
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, this.props.groups.map(function (group, i) {
        return /*#__PURE__*/_react.default.createElement(_fieldset.default, {
          disabled: _this2.state.isLoading,
          errors: _this2.state.errors,
          fields: group.fields,
          name: group.name,
          key: i,
          onChange: _this2.onChange,
          value: _this2.state
        });
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer text-right"
      }, /*#__PURE__*/_react.default.createElement(CancelButton, {
        disabled: this.state.isLoading,
        onCancel: this.props.onCancel
      }), " ", /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Save changes"))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function CancelButton(_ref) {
  var onCancel = _ref.onCancel,
      disabled = _ref.disabled;
  if (!onCancel) return null;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default",
    disabled: disabled,
    onClick: onCancel,
    type: "button"
  }, gettext("Cancel"));
}

},{"../../services/ajax":365,"../../services/snackbar":376,"../button":8,"../form":56,"./fieldset":30,"react":"react"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDisplay = FormDisplay;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _blankslate = _interopRequireDefault(require("./blankslate"));

var _loader = _interopRequireDefault(require("./loader"));

var _form = _interopRequireDefault(require("./form"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      loading: true,
      groups: null
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.api).then(function (groups) {
        _this2.setState({
          loading: false,
          groups: groups
        });
      }, function (rejection) {
        _snackbar.default.apiError(rejection);

        if (_this2.props.cancel) {
          _this2.props.cancel();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          groups = _this$state.groups,
          loading = _this$state.loading;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Edit details"))), /*#__PURE__*/_react.default.createElement(_loader.default, {
        display: loading
      }), /*#__PURE__*/_react.default.createElement(_blankslate.default, {
        display: !loading && !groups.length
      }), /*#__PURE__*/_react.default.createElement(FormDisplay, {
        api: this.props.api,
        display: !loading && groups.length,
        groups: groups,
        onCancel: this.props.onCancel,
        onSuccess: this.props.onSuccess
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function FormDisplay(_ref) {
  var api = _ref.api,
      display = _ref.display,
      groups = _ref.groups,
      onCancel = _ref.onCancel,
      onSuccess = _ref.onSuccess;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    api: api,
    groups: groups,
    onCancel: onCancel,
    onSuccess: onSuccess
  });
}

},{"../../services/ajax":365,"../../services/snackbar":376,"./blankslate":28,"./form":31,"./loader":33,"react":"react"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var display = _ref.display;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement(_loader.default, null));
}

},{"../loader":58,"react":"react"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.props.replaceSelection(_this.props.execAction);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-icon " + this.props.className,
        disabled: this.props.disabled,
        onClick: this.onClick,
        title: this.props.title,
        type: "button"
      }, this.props.children);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertCode = insertCode;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertCode,
    title: gettext("Insert code")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "functions"));
}

function insertCode(selection, replace) {
  var syntax = $.trim(prompt(gettext("Enter name of syntax of your code (optional)") + ":"));
  replace("\n\n```" + syntax + "\n" + selection + "\n```\n\n");
}

},{"./action":34,"react":"react"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.makeEmphasis = makeEmphasis;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: makeEmphasis,
    title: gettext("Emphase selection")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "format_italic"));
}

function makeEmphasis(selection, replace) {
  if (selection.length) {
    replace("*" + selection + "*");
  }
}

},{"./action":34,"react":"react"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertHr = insertHr;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertHr,
    title: gettext("Insert horizontal ruler")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "remove"));
}

function insertHr(selection, replace) {
  replace("\n\n- - - - -\n\n");
}

},{"./action":34,"react":"react"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertImage = insertImage;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

var _isUrl = _interopRequireDefault(require("../../../utils/is-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertImage,
    title: gettext("Insert image")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "insert_photo"));
}

function insertImage(selection, replace) {
  var url = "";
  var label = "";

  if (selection.length) {
    if ((0, _isUrl.default)(selection)) {
      url = selection;
    } else {
      label = selection;
    }
  }

  url = $.trim(prompt(gettext("Enter link to image") + ":", url));
  label = $.trim(prompt(gettext("Enter image label (optional)") + ":", label));

  if (url.length) {
    if (label.length > 0) {
      replace("![" + label + "](" + url + ")");
    } else {
      replace("!(" + url + ")");
    }
  }
}

},{"../../../utils/is-url":385,"./action":34,"react":"react"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertLink = insertLink;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

var _isUrl = _interopRequireDefault(require("../../../utils/is-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertLink,
    title: gettext("Insert link")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "insert_link"));
}

function insertLink(selection, replace) {
  var url = "";
  var label = "";

  if (selection.length) {
    if ((0, _isUrl.default)(selection)) {
      url = selection;
    } else {
      label = selection;
    }
  }

  url = $.trim(prompt(gettext("Enter link address") + ":", url) || "");
  if (url.length === 0) return false;
  label = $.trim(prompt(gettext("Enter link label (optional)") + ":", label));

  if (url.length) {
    if (label.length > 0) {
      replace("[" + label + "](" + url + ")");
    } else {
      replace(url);
    }
  }
}

},{"../../../utils/is-url":385,"./action":34,"react":"react"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertQuote = insertQuote;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

var _isUrl = _interopRequireDefault(require("../../../utils/is-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertQuote,
    title: gettext("Insert quote")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "format_quote"));
}

function insertQuote(selection, replace) {
  var title = $.trim(prompt(gettext("Enter quote autor, prefix usernames with @") + ":", title));

  if (title) {
    replace('\n\n[quote="' + title + '"]\n' + selection + "\n[/quote]\n\n");
  } else {
    replace("\n\n[quote]\n" + selection + "\n[/quote]\n\n");
  }
}

},{"../../../utils/is-url":385,"./action":34,"react":"react"}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.insertSpoiler = insertSpoiler;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

var _isUrl = _interopRequireDefault(require("../../../utils/is-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: insertSpoiler,
    title: gettext("Insert spoiler")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "not_interested"));
}

function insertSpoiler(selection, replace) {
  replace("\n\n[spoiler]\n" + selection + "\n[/spoiler]\n\n");
}

},{"../../../utils/is-url":385,"./action":34,"react":"react"}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.makeStrikethrough = makeStrikethrough;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: makeStrikethrough,
    title: gettext("Strikethrough selection")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "format_strikethrough"));
}

function makeStrikethrough(selection, replace) {
  if (selection.length) {
    replace("~~" + selection + "~~");
  }
}

},{"./action":34,"react":"react"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.makeStrong = makeStrong;

var _react = _interopRequireDefault(require("react"));

var _action = _interopRequireDefault(require("./action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_action.default, _extends({
    execAction: makeStrong,
    title: gettext("Bolder selection")
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "format_bold"));
}

function makeStrong(selection, replace) {
  if (selection.length) {
    replace("**" + selection + "**");
  }
}

},{"./action":34,"react":"react"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = Preview;
exports.Image = Image;
exports.Icon = Icon;
exports.Filename = Filename;
exports.Details = Details;
exports.Actions = Actions;
exports.Insert = Insert;
exports.Remove = Remove;
exports.Undo = Undo;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../../../.."));

var _escapeHtml = _interopRequireDefault(require("../../../../utils/escape-html"));

var _fileSize = _interopRequireDefault(require("../../../../utils/file-size"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onInsert", function () {
      _this.props.replaceSelection(_this.insertAttachment);
    });

    _defineProperty(_assertThisInitialized(_this), "insertAttachment", function (selection, replace) {
      var item = _this.props.item;

      if (item.is_image) {
        if (item.url.thumb) {
          replace("[![" + item.filename + "](" + item.url.thumb + ")](" + item.url.index + ")");
        } else {
          replace("[![" + item.filename + "](" + item.url.index + ")](" + item.url.index + ")");
        }
      } else {
        replace("[" + item.filename + "](" + item.url.index + ")");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      _this.updateItem({
        isRemoved: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUndo", function () {
      _this.updateItem({
        isRemoved: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateItem", function (newState) {
      var updatedAttachments = _this.props.attachments.map(function (item) {
        if (item.id === _this.props.item.id) {
          return Object.assign({}, item, newState);
        } else {
          return item;
        }
      });

      _this.props.onAttachmentsChange(updatedAttachments);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "editor-attachment-complete"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-8 col-md-9"
      }, /*#__PURE__*/_react.default.createElement(Preview, this.props), /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-attachment-details"
      }, /*#__PURE__*/_react.default.createElement(Filename, this.props), /*#__PURE__*/_react.default.createElement(Details, this.props))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-4 col-md-3 xs-margin-top-half"
      }, /*#__PURE__*/_react.default.createElement(Actions, _extends({
        onInsert: this.onInsert,
        onRemove: this.onRemove,
        onUndo: this.onUndo
      }, this.props)))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function Preview(props) {
  if (props.item.is_image) {
    return /*#__PURE__*/_react.default.createElement(Image, props);
  } else {
    return /*#__PURE__*/_react.default.createElement(Icon, props);
  }
}

function Image(props) {
  var thumbnailUrl = props.item.url.thumb || props.item.url.index;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachment-image"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.item.url.index + "?shva=1",
    style: {
      backgroundImage: "url('" + thumbnailUrl + "?shva=1')"
    },
    target: "_blank"
  }));
}

function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachment-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "insert_drive_file"));
}

function Filename(props) {
  return /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("a", {
    className: "item-title",
    href: props.item.url.index + "?shva=1",
    target: "_blank"
  }, props.item.filename));
}

function Details(props) {
  var user = null;

  if (props.item.url.uploader) {
    user = interpolate(USER_URL, {
      url: (0, _escapeHtml.default)(props.item.url.uploader),
      user: (0, _escapeHtml.default)(props.item.uploader_name)
    }, true);
  } else {
    user = interpolate(USER_SPAN, {
      user: (0, _escapeHtml.default)(props.item.uploader_name)
    }, true);
  }

  var date = interpolate(DATE_ABBR, {
    absolute: (0, _escapeHtml.default)(props.item.uploaded_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.item.uploaded_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("%(filetype)s, %(size)s, uploaded by %(uploader)s %(uploaded_on)s.")), {
    filetype: props.item.filetype,
    size: (0, _fileSize.default)(props.item.size),
    uploader: user,
    uploaded_on: date
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function Actions(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachment-actions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(Insert, props), /*#__PURE__*/_react.default.createElement(Remove, props), /*#__PURE__*/_react.default.createElement(Undo, props)));
}

function Insert(props) {
  if (!!props.item.isRemoved) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-sm btn-block",
    onClick: props.onInsert,
    type: "button"
  }, gettext("Insert")));
}

function Remove(props) {
  if (!!props.item.isRemoved && props.item.acl.can_delete) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-sm btn-block",
    onClick: props.onRemove,
    type: "button"
  }, gettext("Remove")));
}

function Undo(props) {
  if (!props.item.isRemoved) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-sm btn-block",
    onClick: props.onUndo,
    type: "button"
  }, gettext("Undo removal")));
}

},{"../../../..":302,"../../../../utils/escape-html":383,"../../../../utils/file-size":384,"react":"react"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STRONG = "<strong>%(name)s</strong>";

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var filteredAttachments = _this.props.attachments.filter(function (item) {
        return item.key !== _this.props.item.key;
      });

      _this.props.onAttachmentsChange(filteredAttachments);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var filename = interpolate(STRONG, {
        name: (0, _escapeHtml.default)(this.props.item.filename)
      }, true);
      var title = interpolate(gettext("Error uploading %(filename)s"), {
        filename: filename,
        progress: this.props.item.progress + "%"
      }, true);
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "editor-attachment-error"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-attachment-error-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "warning")), /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-attachment-error-message"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        dangerouslySetInnerHTML: {
          __html: title + ":"
        }
      }), /*#__PURE__*/_react.default.createElement("p", null, this.props.item.error), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-sm",
        onClick: this.onClick,
        type: "button"
      }, gettext("Dismiss"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../../utils/escape-html":383,"react":"react"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _complete = _interopRequireDefault(require("./complete"));

var _error = _interopRequireDefault(require("./error"));

var _upload = _interopRequireDefault(require("./upload"));

var _ = _interopRequireDefault(require("../../../.."));

var _escapeHtml = _interopRequireDefault(require("../../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (props.item.id) {
    return /*#__PURE__*/_react.default.createElement(_complete.default, props);
  }

  if (props.item.error) {
    return /*#__PURE__*/_react.default.createElement(_error.default, props);
  }

  return /*#__PURE__*/_react.default.createElement(_upload.default, props);
}

},{"../../../..":302,"../../../../utils/escape-html":383,"./complete":44,"./error":45,"./upload":47,"react":"react"}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STRONG = "<strong>%(name)s</strong>";

function _default(props) {
  var filename = interpolate(STRONG, {
    name: (0, _escapeHtml.default)(props.item.filename)
  }, true);
  var message = interpolate(gettext("Uploading %(filename)s... %(progress)s"), {
    filename: filename,
    progress: props.item.progress + "%"
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "editor-attachment-upload"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachment-progress-bar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachment-progress",
    style: {
      width: props.item.progress + "%"
    }
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "editor-attachment-upload-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  }));
}

},{"../../../../utils/escape-html":383,"react":"react"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _list = _interopRequireDefault(require("./list"));

var _uploader = _interopRequireDefault(require("./uploader"));

var _ = _interopRequireDefault(require("../../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (!_.default.get("user").acl.max_attachment_size) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "editor-attachments"
  }, /*#__PURE__*/_react.default.createElement(_list.default, props), /*#__PURE__*/_react.default.createElement(_uploader.default, props));
}

},{"../../..":302,"./list":49,"./uploader":51,"react":"react"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _attachment = _interopRequireDefault(require("./attachment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled editor-attachments-list"
  }, props.attachments.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_attachment.default, _extends({
      item: item,
      key: item.id || item.key
    }, props));
  }));
}

},{"./attachment":46,"react":"react"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      document.getElementById("editor-upload-field").click();
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (!_.default.get("user").acl.max_attachment_size) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-icon " + this.props.className,
        disabled: this.props.disabled,
        onClick: this.onClick,
        title: gettext("Upload file"),
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "file_upload"));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"react":"react"}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRandomKey = getRandomKey;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _ = _interopRequireDefault(require("../../.."));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var file = event.target.files[0];

      if (!file) {
        return;
      }

      var upload = {
        id: null,
        key: getRandomKey(),
        progress: 0,
        error: null,
        filename: file.name
      };

      _this.props.onAttachmentsChange([upload].concat(_this.props.attachments));

      var data = new FormData();
      data.append("upload", file);

      _ajax.default.upload(_.default.get("ATTACHMENTS_API"), data, function (progress) {
        upload.progress = progress;

        _this.props.onAttachmentsChange(_this.props.attachments.concat());
      }).then(function (data) {
        data.uploaded_on = (0, _moment.default)(data.uploaded_on);
        Object.assign(upload, data);

        _this.props.onAttachmentsChange(_this.props.attachments.concat());
      }, function (rejection) {
        if (rejection.status === 400 || rejection.status === 413) {
          upload.error = rejection.detail;

          _this.props.onAttachmentsChange(_this.props.attachments.concat());
        } else {
          _snackbar.default.apiError(rejection);
        }
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("input", {
        id: "editor-upload-field",
        onChange: this.onChange,
        type: "file"
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function getRandomKey() {
  return "upld-" + Math.round(new Date().getTime());
}

},{"../../..":302,"../../../services/ajax":365,"../../../services/snackbar":376,"moment":"moment","react":"react"}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Protect = Protect;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _code = _interopRequireDefault(require("./actions/code"));

var _emphasis = _interopRequireDefault(require("./actions/emphasis"));

var _hr = _interopRequireDefault(require("./actions/hr"));

var _image = _interopRequireDefault(require("./actions/image"));

var _link = _interopRequireDefault(require("./actions/link"));

var _spoiler = _interopRequireDefault(require("./actions/spoiler"));

var _strikethrough = _interopRequireDefault(require("./actions/strikethrough"));

var _strong = _interopRequireDefault(require("./actions/strong"));

var _quote = _interopRequireDefault(require("./actions/quote"));

var _attachments = _interopRequireDefault(require("./attachments"));

var _uploadButton = _interopRequireDefault(require("./attachments/upload-button"));

var _markupPreview = _interopRequireDefault(require("./markup-preview"));

var textUtils = _interopRequireWildcard(require("./textutils"));

var _button = _interopRequireDefault(require("../button"));

var _ = _interopRequireDefault(require("../.."));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _modal = _interopRequireDefault(require("../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPreviewClick", function () {
      if (_this.state.isPreviewLoading) {
        return;
      }

      _this.setState({
        isPreviewLoading: true
      });

      _ajax.default.post(_.default.get("PARSE_MARKUP_API"), {
        post: _this.props.value
      }).then(function (data) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(_markupPreview.default, {
          markup: data.parsed
        }));

        _this.setState({
          isPreviewLoading: false
        });
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail);
        } else {
          _snackbar.default.apiError(rejection);
        }

        _this.setState({
          isPreviewLoading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "replaceSelection", function (operation) {
      operation(textUtils.getSelectionText(), _this._replaceSelection);
    });

    _defineProperty(_assertThisInitialized(_this), "_replaceSelection", function (newValue) {
      _this.props.onChange({
        target: {
          value: textUtils.replace(newValue)
        }
      });
    });

    _this.state = {
      isPreviewLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      $("#editor-textarea").atwho({
        at: "@",
        displayTpl: '<li><img src="${avatar}" alt="">${username}</li>',
        insertTpl: "@${username}",
        searchKey: "username",
        callbacks: {
          remoteFilter: function remoteFilter(query, callback) {
            $.getJSON(_.default.get("MENTION_API"), {
              q: query
            }, callback);
          }
        }
      });
      $("#editor-textarea").on("inserted.atwho", function (event, flag, query) {
        _this2.props.onChange(event);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-border"
      }, /*#__PURE__*/_react.default.createElement("textarea", {
        className: "form-control",
        value: this.props.value,
        disabled: this.props.loading,
        id: "editor-textarea",
        onChange: this.props.onChange,
        rows: "9"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "buttons-list pull-left"
      }, /*#__PURE__*/_react.default.createElement(_strong.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_emphasis.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_strikethrough.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_hr.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_link.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_image.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_quote.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_spoiler.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_code.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        replaceSelection: this.replaceSelection
      }), /*#__PURE__*/_react.default.createElement(_uploadButton.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-default btn-sm pull-left",
        disabled: this.props.loading || this.state.isPreviewLoading,
        onClick: this.onPreviewClick,
        type: "button"
      }, gettext("Preview")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-sm pull-right",
        loading: this.props.loading
      }, this.props.submitLabel || gettext("Post")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-sm pull-right",
        disabled: this.props.loading,
        onClick: this.props.onCancel,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix visible-xs-block"
      }), /*#__PURE__*/_react.default.createElement(Protect, {
        canProtect: this.props.canProtect,
        disabled: this.props.loading,
        onProtect: this.props.onProtect,
        onUnprotect: this.props.onUnprotect,
        protect: this.props.protect
      })), /*#__PURE__*/_react.default.createElement(_attachments.default, {
        attachments: this.props.attachments,
        onAttachmentsChange: this.props.onAttachmentsChange,
        placeholder: this.props.placeholder,
        replaceSelection: this.replaceSelection
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function Protect(props) {
  if (!props.canProtect) return null;
  var label = props.protect ? gettext("Protected") : gettext("Protect");
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-icon btn-default btn-protect btn-sm pull-right",
    disabled: props.disabled,
    onClick: props.protect ? props.onUnprotect : props.onProtect,
    title: label,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, props.protect ? "lock" : "lock_outline"), /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-text hidden-md hidden-lg"
  }, label));
}

},{"../..":302,"../../services/ajax":365,"../../services/modal":371,"../../services/snackbar":376,"../button":8,"./actions/code":35,"./actions/emphasis":36,"./actions/hr":37,"./actions/image":38,"./actions/link":39,"./actions/quote":40,"./actions/spoiler":41,"./actions/strikethrough":42,"./actions/strong":43,"./attachments":48,"./attachments/upload-button":50,"./markup-preview":53,"./textutils":54,"react":"react"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _misagoMarkup = _interopRequireDefault(require("../misago-markup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog",
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Preview message"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body markup-preview"
  }, /*#__PURE__*/_react.default.createElement(_misagoMarkup.default, {
    markup: props.markup
  }))));
}

},{"../misago-markup":60,"react":"react"}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextarea = getTextarea;
exports.getValue = getValue;
exports.getSelectionRange = getSelectionRange;
exports.getSelection = getSelection;
exports.getSelectionText = getSelectionText;
exports.setSelection = setSelection;
exports._replace = _replace;
exports.replace = replace;
exports.textareaId = void 0;
var textareaId = "editor-textarea";
exports.textareaId = textareaId;

function getTextarea() {
  return document.getElementById(textareaId);
}

function getValue() {
  return document.getElementById(textareaId).value;
}

function getSelectionRange(start, end) {
  return {
    start: start,
    end: end
  };
}

function getSelection() {
  var ctrl = getTextarea();

  if (document.selection) {
    ctrl.focus();
    var range = document.selection.createRange();
    var length = range.text.length;
    range.moveStart("character", -ctrl.value.length);
    return getSelectionRange(range.text.length - length, range.text.length);
  } else if (ctrl.selectionStart || ctrl.selectionStart == "0") {
    return getSelectionRange(ctrl.selectionStart, ctrl.selectionEnd);
  }
}

function getSelectionText() {
  var range = getSelection();
  return $.trim(getValue().substring(range.start, range.end));
}

function setSelection(selectionRange) {
  var ctrl = getTextarea();

  if (ctrl.setSelectionRange) {
    ctrl.focus();
    ctrl.setSelectionRange(selectionRange.start, selectionRange.end);
  } else if (ctrl.createTextRange) {
    var range = ctrl.createTextRange();
    range.collapse(true);
    range.moveStart("character", selectionRange.start);
    range.moveEnd("character", selectionRange.end);
    range.select();
  }
}

function _replace(myRange, replacement) {
  var ctrl = getTextarea();
  var text = ctrl.value;
  var startText = text.substring(0, myRange.start);
  ctrl.value = text.substring(0, myRange.start) + replacement + text.substring(myRange.end);
  setSelection(getSelectionRange(startText.length + replacement.length, startText.length + replacement.length));
  return ctrl.value;
}

function replace(replacement) {
  return _replace(getSelection(), replacement);
}

},{}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "isValidated",
    value: function isValidated() {
      return typeof this.props.validation !== "undefined";
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var className = "form-group";

      if (this.isValidated()) {
        className += " has-feedback";

        if (this.props.validation === null) {
          className += " has-success";
        } else {
          className += " has-error";
        }
      }

      return className;
    }
  }, {
    key: "getFeedback",
    value: function getFeedback() {
      var _this = this;

      if (this.props.validation) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "help-block errors"
        }, this.props.validation.map(function (error, i) {
          return /*#__PURE__*/_react.default.createElement("p", {
            key: _this.props.for + "FeedbackItem" + i
          }, error);
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "getFeedbackDescription",
    value: function getFeedbackDescription() {
      if (this.isValidated()) {
        return /*#__PURE__*/_react.default.createElement("span", {
          id: this.props.for + "_status",
          className: "sr-only"
        }, this.props.validation ? gettext("(error)") : gettext("(success)"));
      } else {
        return null;
      }
    }
  }, {
    key: "getHelpText",
    value: function getHelpText() {
      if (this.props.helpText) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "help-block"
        }, this.props.helpText);
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "control-label " + (this.props.labelClass || ""),
        htmlFor: this.props.for || ""
      }, this.props.label + ":"), /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.controlClass || ""
      }, this.props.children, this.getFeedbackDescription(), this.getFeedback(), this.getHelpText(), this.props.extra || null));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _validators = require("../utils/validators");

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validateRequired = (0, _validators.required)();

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "bindInput", function (name) {
      return function (event) {
        _this.changeValue(name, event.target.value);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (name, value) {
      var newState = _defineProperty({}, name, value);

      var formErrors = _this.state.errors || {};
      formErrors[name] = _this.validateField(name, newState[name]);
      newState.errors = formErrors;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      // we don't reload page on submissions
      if (event) {
        event.preventDefault();
      }

      if (_this.state.isLoading) {
        return;
      }

      if (_this.clean()) {
        _this.setState({
          isLoading: true
        });

        var promise = _this.send();

        if (promise) {
          promise.then(function (success) {
            _this.setState({
              isLoading: false
            });

            _this.handleSuccess(success);
          }, function (rejection) {
            _this.setState({
              isLoading: false
            });

            _this.handleError(rejection);
          });
        } else {
          _this.setState({
            isLoading: false
          });
        }
      }
    });

    return _this;
  }

  _createClass(_default, [{
    key: "validate",
    value: function validate() {
      var errors = {};

      if (!this.state.validators) {
        return errors;
      }

      var validators = {
        required: this.state.validators.required || this.state.validators,
        optional: this.state.validators.optional || {}
      };
      var validatedFields = []; // add required fields to validation

      for (var name in validators.required) {
        if (validators.required.hasOwnProperty(name) && validators.required[name]) {
          validatedFields.push(name);
        }
      } // add optional fields to validation


      for (var _name in validators.optional) {
        if (validators.optional.hasOwnProperty(_name) && validators.optional[_name]) {
          validatedFields.push(_name);
        }
      } // validate fields values


      for (var i in validatedFields) {
        var _name2 = validatedFields[i];
        var fieldErrors = this.validateField(_name2, this.state[_name2]);

        if (fieldErrors === null) {
          errors[_name2] = null;
        } else if (fieldErrors) {
          errors[_name2] = fieldErrors;
        }
      }

      return errors;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var errors = this.validate();

      for (var field in errors) {
        if (errors.hasOwnProperty(field)) {
          if (errors[field] !== null) {
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "validateField",
    value: function validateField(name, value) {
      var errors = [];

      if (!this.state.validators) {
        return errors;
      }

      var validators = {
        required: (this.state.validators.required || this.state.validators)[name],
        optional: (this.state.validators.optional || {})[name]
      };
      var requiredError = validateRequired(value) || false;

      if (validators.required) {
        if (requiredError) {
          errors = [requiredError];
        } else {
          for (var i in validators.required) {
            var validationError = validators.required[i](value);

            if (validationError) {
              errors.push(validationError);
            }
          }
        }

        return errors.length ? errors : null;
      } else if (requiredError === false && validators.optional) {
        for (var _i in validators.optional) {
          var _validationError = validators.optional[_i](value);

          if (_validationError) {
            errors.push(_validationError);
          }
        }

        return errors.length ? errors : null;
      }

      return false; // false === field wasn't validated
    }
  }, {
    key: "clean",
    value: function clean() {
      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return null;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      return;
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      _snackbar.default.apiError(rejection);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/snackbar":376,"../utils/validators":393,"react":"react"}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "isActive",
    value: function isActive() {
      if (this.props.isControlled) {
        return this.props.isActive;
      } else {
        if (this.props.path) {
          return document.location.pathname.indexOf(this.props.path) === 0;
        } else {
          return false;
        }
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.isActive()) {
        return (this.props.className || "") + " " + (this.props.activeClassName || "active");
      } else {
        return this.props.className || "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: this.getClassName()
      }, this.props.children);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className || "loader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-spinning-wheel"
  }));
}

},{"react":"react"}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BestAnswerSelect = BestAnswerSelect;
exports.PollSelect = PollSelect;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _formGroup = _interopRequireDefault(require("./form-group"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _modal = _interopRequireDefault(require("../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSuccess", function (success) {
      _this.props.onSuccess(success);

      _modal.default.hide();
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (rejection) {
      _this.props.onError(rejection);
    });

    _defineProperty(_assertThisInitialized(_this), "onBestAnswerChange", function (event) {
      _this.changeValue("bestAnswer", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onPollChange", function (event) {
      _this.changeValue("poll", event.target.value);
    });

    _this.state = {
      isLoading: false,
      bestAnswer: "0",
      poll: "0"
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (this.props.polls && this.state.poll === "0") {
        var confirmation = confirm(gettext("Are you sure you want to delete all polls?"));
        return confirmation;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      var data = Object.assign({}, this.props.data, {
        best_answer: this.state.bestAnswer,
        poll: this.state.poll
      });
      return _ajax.default.post(this.props.api, data);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": gettext("Close"),
        className: "close",
        "data-dismiss": "modal",
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Merge threads"))), /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(BestAnswerSelect, {
        choices: this.props.bestAnswers,
        onChange: this.onBestAnswerChange,
        value: this.state.bestAnswer
      }), /*#__PURE__*/_react.default.createElement(PollSelect, {
        choices: this.props.polls,
        onChange: this.onPollChange,
        value: this.state.poll
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Merge threads"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function BestAnswerSelect(_ref) {
  var choices = _ref.choices,
      onChange = _ref.onChange,
      value = _ref.value;
  if (!choices) return null;
  return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
    label: gettext("Best answer"),
    helpText: gettext("Please select the best answer for your newly merged thread. No posts will be deleted during the merge."),
    for: "id_best_answer"
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: "form-control",
    id: "id_best_answer",
    onChange: onChange,
    value: value
  }, choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: choice[0],
      key: choice[0]
    }, choice[1]);
  })));
}

function PollSelect(_ref2) {
  var choices = _ref2.choices,
      onChange = _ref2.onChange,
      value = _ref2.value;
  if (!choices) return null;
  return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
    label: gettext("Poll"),
    helpText: gettext("Please select the poll for your newly merged thread. Rejected polls will be permanently deleted and cannot be recovered."),
    for: "id_poll"
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: "form-control",
    id: "id_poll",
    onChange: onChange,
    value: value
  }, choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: choice[0],
      key: choice[0]
    }, choice[1]);
  })));
}

},{"../services/ajax":365,"../services/modal":371,"./button":8,"./form":56,"./form-group":55,"react":"react"}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _oneBox = _interopRequireDefault(require("../services/one-box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _oneBox.default.render(this.documentNode);

      $(this.documentNode).find(".spoiler-reveal").click(revealSpoiler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      _oneBox.default.render(this.documentNode);

      $(this.documentNode).find(".spoiler-reveal").click(revealSpoiler);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.markup !== this.props.markup;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("article", {
        className: "misago-markup",
        dangerouslySetInnerHTML: {
          __html: this.props.markup
        },
        ref: function ref(node) {
          _this.documentNode = node;
        }
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function revealSpoiler(event) {
  var btn = event.target;
  $(btn).parent().parent().addClass("revealed");
}

},{"../services/one-box":372,"react":"react"}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-loader"
      }, /*#__PURE__*/_react.default.createElement(_loader.default, null));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./loader":58,"react":"react"}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _panelMessage = _interopRequireDefault(require("./panel-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_PanelMessage) {
  _inherits(_default, _PanelMessage);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getHelpText",
    value: function getHelpText() {
      if (this.props.helpText) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "help-block"
        }, this.props.helpText);
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.props.icon || "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.props.message), this.getHelpText(), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        type: "button"
      }, gettext("Ok"))));
    }
  }]);

  return _default;
}(_panelMessage.default);

exports.default = _default;

},{"./panel-message":94,"react":"react"}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var MAX_RESULTS = 5;

function _default(data) {
  var filtered = data.filter(function (section) {
    return section.results.count > 0;
  });
  return filtered.map(function (section) {
    return Object.assign({}, section, {
      count: section.results.count,
      results: section.results.results.slice(0, MAX_RESULTS)
    });
  });
}

},{}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOOTER = exports.RESULT = exports.HEADER = void 0;
var HEADER = "HEADER";
exports.HEADER = HEADER;
var RESULT = "RESULT";
exports.RESULT = RESULT;
var FOOTER = "FOOTER";
exports.FOOTER = FOOTER;

},{}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _input = _interopRequireDefault(require("./input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      query = _ref.query;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu dropdown-search-results",
    role: "menu"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    value: query,
    onChange: onChange
  })), children);
}

},{"./input":69,"react":"react"}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default() {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-search-message"
  }, gettext("Search returned no results."));
}

},{"react":"react"}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _constants = require("./constants");

function _default(results) {
  var flatlist = [];
  flattenProviders(results, flatlist);
  return flatlist;
}

function flattenProviders(results, flatlist) {
  var arrayLength = results.length;

  for (var i = 0; i < arrayLength; i++) {
    var provider = results[i];
    flatlist.push({
      provider: provider,
      type: _constants.HEADER
    });
    flattenProvider(provider, flatlist);
  }
}

function flattenProvider(provider, flatlist) {
  var arrayLength = provider.results.length;

  for (var i = 0; i < arrayLength; i++) {
    var result = provider.results[i];
    flatlist.push({
      provider: provider,
      result: result,
      type: _constants.RESULT
    });
  }

  flatlist.push({
    provider: provider,
    type: _constants.FOOTER
  });
}

},{"./constants":64}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _dropdownMenu = _interopRequireDefault(require("./dropdown-menu"));

var _empty = _interopRequireDefault(require("./empty"));

var _loader = _interopRequireDefault(require("./loader"));

var _result = _interopRequireDefault(require("./result"));

var _flattenResults = _interopRequireDefault(require("./flatten-results"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(_ref) {
  var isLoading = _ref.isLoading,
      onChange = _ref.onChange,
      results = _ref.results,
      query = _ref.query;

  if (!query.trim().length) {
    return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
      onChange: onChange,
      query: query
    });
  }

  if (results.length) {
    var flatResults = (0, _flattenResults.default)(results);
    return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
      onChange: onChange,
      query: query
    }, flatResults.map(function (props) {
      var type = props.type,
          provider = props.provider,
          result = props.result;

      if (type === _constants.RESULT) {
        return /*#__PURE__*/_react.default.createElement(_result.default, _extends({
          key: [provider.id, type, result.id].join("_")
        }, props));
      }

      return /*#__PURE__*/_react.default.createElement(_result.default, _extends({
        key: [provider.id, type].join("_"),
        query: query
      }, props));
    }));
  } else if (isLoading) {
    return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
      onChange: onChange,
      query: query
    }, /*#__PURE__*/_react.default.createElement(_loader.default, null));
  }

  return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
    onChange: onChange,
    query: query
  }, /*#__PURE__*/_react.default.createElement(_empty.default, null));
}

},{"./constants":64,"./dropdown-menu":65,"./empty":66,"./flatten-results":67,"./loader":70,"./result":73,"react":"react"}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement("input", {
    "aria-haspopup": "true",
    "aria-expanded": "false",
    "aria-controls": "dropdown-menu dropdown-search-results",
    autoComplete: "off",
    className: "form-control",
    value: value,
    onChange: onChange,
    placeholder: gettext("Search"),
    role: "combobox",
    type: "text"
  });
}

},{"react":"react"}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("../../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-search-loader"
  }, /*#__PURE__*/_react.default.createElement(_loader.default, null));
}

},{"../../loader":58,"react":"react"}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var provider = _ref.provider,
      query = _ref.query;
  var url = provider.url + "?q=" + encodeURI(query);
  var label = ngettext('See full "%(provider)s" results page with %(count)s result.', 'See full "%(provider)s" results page with %(count)s results.', provider.count);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-search-footer"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: url
  }, interpolate(label, {
    count: provider.count,
    provider: provider.name
  }, true)));
}

},{"react":"react"}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var provider = _ref.provider;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-search-header"
  }, provider.name);
}

},{"react":"react"}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _constants = require("../constants");

var _footer = _interopRequireDefault(require("./footer"));

var _header = _interopRequireDefault(require("./header"));

var _result = _interopRequireDefault(require("./result"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var provider = _ref.provider,
      result = _ref.result,
      type = _ref.type,
      query = _ref.query;

  if (type === _constants.HEADER) {
    return /*#__PURE__*/_react.default.createElement(_header.default, {
      provider: provider
    });
  } else if (type === _constants.FOOTER) {
    return /*#__PURE__*/_react.default.createElement(_footer.default, {
      provider: provider,
      query: query
    });
  }

  return /*#__PURE__*/_react.default.createElement(_result.default, {
    provider: provider,
    result: result
  });
}

},{"../constants":64,"./footer":71,"./header":72,"./result":74,"react":"react"}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _thread = _interopRequireDefault(require("./thread"));

var _user = _interopRequireDefault(require("./user"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var provider = _ref.provider,
      result = _ref.result;

  if (provider.id === "threads") {
    return /*#__PURE__*/_react.default.createElement(_thread.default, {
      result: result
    });
  }

  return /*#__PURE__*/_react.default.createElement(_user.default, {
    result: result
  });
}

},{"./thread":75,"./user":76,"react":"react"}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var result = _ref.result;
  var poster = result.poster,
      thread = result.thread;
  var footer = gettext("Posted by %(poster)s on %(posted_on)s in %(category)s.");
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: result.url.index,
    className: "dropdown-search-thread"
  }, /*#__PURE__*/_react.default.createElement("h5", null, thread.title), /*#__PURE__*/_react.default.createElement("small", {
    className: "dropdown-search-post-content"
  }, $(result.content).text()), /*#__PURE__*/_react.default.createElement("small", {
    className: "dropdown-search-post-footer"
  }, interpolate(footer, {
    category: result.category.name,
    posted_on: (0, _moment.default)(result.posted_on).format("LL"),
    poster: result.poster_name
  }, true))));
}

},{"moment":"moment","react":"react"}],76:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var result = _ref.result;
  var rank = result.rank;
  var detail = gettext("%(title)s, joined on %(joined_on)s");
  var title = result.title || rank.title || rank.name;
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: result.url,
    className: "dropdown-search-user"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: 38,
    user: result
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "media-heading"
  }, result.username), /*#__PURE__*/_react.default.createElement("small", null, interpolate(detail, {
    title: title,
    joined_on: (0, _moment.default)(result.joined_on).format("LL")
  }, true))))));
}

},{"../../../avatar":6,"moment":"moment","react":"react"}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _ = _interopRequireDefault(require("../.."));

var _cleanResults = _interopRequireDefault(require("./clean-results"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onToggle", function (ev) {
      _this.setState(function (prevState, props) {
        if (!prevState.isOpen) {
          window.setTimeout(function () {
            _this.container.querySelector("input").focus();
          }, 100);
        }

        return {
          isOpen: !prevState.isOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function (ev) {
      var closeResults = true;
      var node = ev.target;

      while (node !== null && node !== document) {
        if (node === _this.container) {
          closeResults = false;
          return;
        }

        node = node.parentNode;
      }

      if (closeResults) {
        _this.setState({
          isOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEscape", function (ev) {
      if (ev.key === "Escape") {
        _this.setState({
          isOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (ev) {
      var query = ev.target.value;

      _this.setState({
        query: query
      });

      _this.loadResults(query.trim());
    });

    _this.state = {
      isLoading: false,
      isOpen: false,
      query: "",
      results: []
    };
    _this.intervalId = null;
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.onDocumentMouseDown);
      document.addEventListener("keydown", this.onEscape);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.onDocumentMouseDown);
      document.removeEventListener("keydown", this.onEscape);
    }
  }, {
    key: "loadResults",
    value: function loadResults(query) {
      var _this2 = this;

      if (!query.length) return;
      var delay = 300 + Math.random() * 300;

      if (this.intervalId) {
        window.clearTimeout(this.intervalId);
      }

      this.setState({
        isLoading: true
      });
      this.intervalId = window.setTimeout(function () {
        _ajax.default.get(_.default.get("SEARCH_API"), {
          q: query
        }).then(function (data) {
          _this2.setState({
            intervalId: null,
            isLoading: false,
            results: (0, _cleanResults.default)(data)
          });
        }, function (rejection) {
          _snackbar.default.apiError(rejection);

          _this2.setState({
            intervalId: null,
            isLoading: false,
            results: []
          });
        });
      }, delay);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var className = "navbar-search dropdown";
      if (this.state.isOpen) className += " open";
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        ref: function ref(container) {
          return _this3.container = container;
        }
      }, /*#__PURE__*/_react.default.createElement("a", {
        "aria-haspopup": "true",
        "aria-expanded": "false",
        className: "navbar-icon",
        "data-toggle": "dropdown",
        href: _.default.get("SEARCH_URL"),
        onClick: this.onToggle
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icon"
      }, "search")), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        isLoading: this.state.isLoading,
        onChange: this.onChange,
        results: this.state.results,
        query: this.state.query
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../services/ajax":365,"../../services/snackbar":376,"./clean-results":63,"./dropdown":68,"react":"react"}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _panelLoader = _interopRequireDefault(require("../../panel-loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "panel-title"
  }, gettext("Change username"))), /*#__PURE__*/_react.default.createElement(_panelLoader.default, null));
}

},{"../../panel-loader":93,"react":"react"}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _panelMessage = _interopRequireDefault(require("../../panel-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getHelpText",
    value: function getHelpText() {
      if (this.props.options.next_on) {
        return interpolate(gettext("You will be able to change your username %(next_change)s."), {
          next_change: this.props.options.next_on.fromNow()
        }, true);
      } else {
        return gettext("You have used up available name changes.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Change username"))), /*#__PURE__*/_react.default.createElement(_panelMessage.default, {
        helpText: this.getHelpText(),
        message: gettext("You can't change your username at the moment.")
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../panel-message":94,"react":"react"}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var validators = _interopRequireWildcard(require("../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      username: "",
      validators: {
        username: [validators.usernameContent(), validators.usernameMinLength(props.options.length_min), validators.usernameMaxLength(props.options.length_max)]
      },
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getHelpText",
    value: function getHelpText() {
      var phrases = [];

      if (this.props.options.changes_left > 0) {
        var message = ngettext("You can change your username %(changes_left)s more time.", "You can change your username %(changes_left)s more times.", this.props.options.changes_left);
        phrases.push(interpolate(message, {
          changes_left: this.props.options.changes_left
        }, true));
      }

      if (this.props.user.acl.name_changes_expire > 0) {
        var _message = ngettext("Used changes become available again after %(name_changes_expire)s day.", "Used changes become available again after %(name_changes_expire)s days.", this.props.user.acl.name_changes_expire);

        phrases.push(interpolate(_message, {
          name_changes_expire: this.props.user.acl.name_changes_expire
        }, true));
      }

      return phrases.length ? phrases.join(" ") : null;
    }
  }, {
    key: "clean",
    value: function clean() {
      var errors = this.validate();

      if (errors.username) {
        _snackbar.default.error(errors.username[0]);

        return false;
      }

      if (this.state.username.trim() === this.props.user.username) {
        _snackbar.default.info(gettext("Your new username is same as current one."));

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.user.api.username, {
        username: this.state.username
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      this.setState({
        username: ""
      });
      this.props.complete(success.username, success.slug, success.options);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      _snackbar.default.apiError(rejection);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Change username"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("New username"),
        for: "id_username",
        helpText: this.getHelpText()
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_username",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("username"),
        value: this.state.username
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Change username")))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../services/ajax":365,"../../../services/snackbar":376,"../../../utils/validators":393,"../../button":8,"../../form":56,"../../form-group":55,"react":"react"}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _formLoading = _interopRequireDefault(require("./form-loading"));

var _formLocked = _interopRequireDefault(require("./form-locked"));

var _form = _interopRequireDefault(require("./form"));

var _root = _interopRequireDefault(require("../../username-history/root"));

var _ = _interopRequireDefault(require("../../.."));

var _usernameHistory = require("../../../reducers/username-history");

var _users = require("../../../reducers/users");

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onComplete", function (username, slug, options) {
      _this.setState({
        options: options
      });

      _store.default.dispatch((0, _usernameHistory.addNameChange)({
        username: username,
        slug: slug
      }, _this.props.user, _this.props.user));

      _store.default.dispatch((0, _users.updateUsername)(_this.props.user, username, slug));

      _snackbar.default.success(gettext("Your username has been changed successfully."));
    });

    _this.state = {
      isLoaded: false,
      options: null
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _pageTitle.default.set({
        title: gettext("Change username"),
        parent: gettext("Change your options")
      });

      Promise.all([_ajax.default.get(this.props.user.api.username), _ajax.default.get(_.default.get("USERNAME_CHANGES_API"), {
        user: this.props.user.id
      })]).then(function (data) {
        _store.default.dispatch((0, _usernameHistory.hydrate)(data[1].results));

        _this2.setState({
          isLoaded: true,
          options: {
            changes_left: data[0].changes_left,
            length_min: data[0].length_min,
            length_max: data[0].length_max,
            next_on: data[0].next_on ? (0, _moment.default)(data[0].next_on) : null
          }
        });
      });
    }
  }, {
    key: "getChangeForm",
    value: function getChangeForm() {
      if (!this.state.isLoaded) {
        return /*#__PURE__*/_react.default.createElement(_formLoading.default, null);
      }

      if (this.state.options.changes_left === 0) {
        return /*#__PURE__*/_react.default.createElement(_formLocked.default, {
          options: this.state.options
        });
      }

      return /*#__PURE__*/_react.default.createElement(_form.default, {
        complete: this.onComplete,
        options: this.state.options,
        user: this.props.user
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, this.getChangeForm(), /*#__PURE__*/_react.default.createElement(_root.default, {
        changes: this.props["username-history"],
        isLoaded: this.state.isLoaded
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"../../../reducers/username-history":363,"../../../reducers/users":364,"../../../services/ajax":365,"../../../services/page-title":373,"../../../services/snackbar":376,"../../../services/store":377,"../../username-history/root":280,"./form":80,"./form-loading":78,"./form-locked":79,"moment":"moment","react":"react"}],82:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPasswordChange", function (event) {
      _this.setState({
        password: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          isLoading = _this$state.isLoading,
          password = _this$state.password;
      var user = _this.props.user;

      if (password.length == 0) {
        _snackbar.default.error(gettext("Enter your password to confirm account deletion."));

        return false;
      }

      if (isLoading) return false;

      _this.setState({
        isLoading: true
      });

      _ajax.default.post(user.api.delete, {
        password: password
      }).then(function (success) {
        window.location.href = _.default.get("MISAGO_PATH");
      }, function (rejection) {
        _this.setState({
          isLoading: false
        });

        if (rejection.password) {
          _snackbar.default.error(rejection.password[0]);
        } else {
          _snackbar.default.apiError(rejection);
        }
      });
    });

    _this.state = {
      isLoading: false,
      password: ""
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Delete account"),
        parent: gettext("Change your options")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-danger panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Delete account"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, gettext("You are going to delete your account. This action is nonreversible, and will result in following data being deleted:")), /*#__PURE__*/_react.default.createElement("p", null, "-", " ", gettext("Stored IP addresses associated with content that you have posted will be deleted.")), /*#__PURE__*/_react.default.createElement("p", null, "-", " ", gettext("Your username will become available for other user to rename to or for new user to register their account with.")), /*#__PURE__*/_react.default.createElement("p", null, "-", " ", gettext("Your e-mail will become available for use in new account registration.")), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", null, gettext("All your posted content will NOT be deleted, but username associated with it will be changed to one shared by all deleted accounts."))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        name: "password-confirmation",
        type: "password",
        placeholder: gettext("Enter your password to confirm account deletion."),
        value: this.state.password,
        onChange: this.onPasswordChange
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "input-group-btn"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-danger",
        loading: this.state.isLoading
      }, gettext("Delete my account")))))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../services/ajax":365,"../../services/page-title":373,"../../services/snackbar":376,"../../services/store":377,"../button":8,"react":"react"}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _button = _interopRequireDefault(require("../button"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DownloadData = /*#__PURE__*/function (_React$Component) {
  _inherits(DownloadData, _React$Component);

  var _super = _createSuper(DownloadData);

  function DownloadData(props) {
    var _this;

    _classCallCheck(this, DownloadData);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleLoadDownloads", function () {
      _ajax.default.get(_this.props.user.api.data_downloads).then(function (data) {
        _this.setState({
          isLoading: false,
          downloads: data
        });
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestDataDownload", function () {
      _this.setState({
        isSubmiting: true
      });

      _ajax.default.post(_this.props.user.api.request_data_download).then(function () {
        _this.handleLoadDownloads();

        _snackbar.default.success(gettext("Your request for data download has been registered."));

        _this.setState({
          isSubmiting: false
        });
      }, function (rejection) {
        console.log(rejection);

        _snackbar.default.apiError(rejection);

        _this.setState({
          isSubmiting: false
        });
      });
    });

    _this.state = {
      isLoading: false,
      isSubmiting: false,
      downloads: []
    };
    return _this;
  }

  _createClass(DownloadData, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Download your data"),
        parent: gettext("Change your options")
      });

      this.handleLoadDownloads();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Download your data"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("p", null, gettext('To download your data from the site, click the "Request data download" button. Depending on amount of data to be archived and number of users wanting to download their data at same time it may take up to few days for your download to be prepared. An e-mail with notification will be sent to you when your data is ready to be downloaded.')), /*#__PURE__*/_react.default.createElement("p", null, gettext("The download will only be available for limited amount of time, after which it will be deleted from the site and marked as expired."))), /*#__PURE__*/_react.default.createElement("table", {
        className: "table"
      }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, gettext("Requested on")), /*#__PURE__*/_react.default.createElement("th", {
        className: "col-md-4"
      }, gettext("Download")))), /*#__PURE__*/_react.default.createElement("tbody", null, this.state.downloads.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: item.id
        }, /*#__PURE__*/_react.default.createElement("td", {
          style: rowStyle
        }, (0, _moment.default)(item.requested_on).fromNow()), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(DownloadButton, {
          exportFile: item.file,
          status: item.status
        })));
      }), this.state.downloads.length == 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: "2"
      }, gettext("You have no data downloads."))) : null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer text-right"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isSubmiting,
        type: "button",
        onClick: this.handleRequestDataDownload
      }, gettext("Request data download")))));
    }
  }]);

  return DownloadData;
}(_react.default.Component);

exports.default = DownloadData;
var rowStyle = {
  verticalAlign: "middle"
};
var STATUS_PENDING = 0;
var STATUS_PROCESSING = 1;

var DownloadButton = function DownloadButton(_ref) {
  var exportFile = _ref.exportFile,
      status = _ref.status;

  if (status === STATUS_PENDING || status === STATUS_PROCESSING) {
    return /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "btn-info btn-sm btn-block",
      disabled: true,
      type: "button"
    }, gettext("Download is being prepared"));
  }

  if (exportFile) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-success btn-sm btn-block",
      href: exportFile
    }, gettext("Download your data"));
  }

  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn-default btn-sm btn-block",
    disabled: true,
    type: "button"
  }, gettext("Download is expired"));
};

},{"../../services/ajax":365,"../../services/page-title":373,"../../services/snackbar":376,"../button":8,"moment":"moment","react":"react"}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _editDetails = _interopRequireDefault(require("../edit-details"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSuccess", function () {
      _snackbar.default.info(gettext("Your details have been updated."));
    });

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Edit details"),
        parent: gettext("Change your options")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_editDetails.default, {
        api: this.props.user.api.edit_details,
        onSuccess: this.onSuccess
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../services/page-title":373,"../../services/snackbar":376,"../edit-details":32,"react":"react"}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _form = _interopRequireDefault(require("../form"));

var _formGroup = _interopRequireDefault(require("../form-group"));

var _select = _interopRequireDefault(require("../select"));

var _yesNoSwitch = _interopRequireDefault(require("../yes-no-switch"));

var _auth = require("../../reducers/auth");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      is_hiding_presence: props.user.is_hiding_presence,
      limits_private_thread_invites_to: props.user.limits_private_thread_invites_to,
      subscribe_to_started_threads: props.user.subscribe_to_started_threads,
      subscribe_to_replied_threads: props.user.subscribe_to_replied_threads,
      errors: {}
    };
    _this.privateThreadInvitesChoices = [{
      value: 0,
      icon: "help_outline",
      label: gettext("Everybody")
    }, {
      value: 1,
      icon: "done_all",
      label: gettext("Users I follow")
    }, {
      value: 2,
      icon: "highlight_off",
      label: gettext("Nobody")
    }];
    _this.subscribeToChoices = [{
      value: 0,
      icon: "star_border",
      label: gettext("No")
    }, {
      value: 1,
      icon: "star_half",
      label: gettext("Notify")
    }, {
      value: 2,
      icon: "star",
      label: gettext("Notify with e-mail")
    }];
    return _this;
  }

  _createClass(_default, [{
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.user.api.options, {
        is_hiding_presence: this.state.is_hiding_presence,
        limits_private_thread_invites_to: this.state.limits_private_thread_invites_to,
        subscribe_to_started_threads: this.state.subscribe_to_started_threads,
        subscribe_to_replied_threads: this.state.subscribe_to_replied_threads
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      _store.default.dispatch((0, _auth.patch)({
        is_hiding_presence: this.state.is_hiding_presence,
        limits_private_thread_invites_to: this.state.limits_private_thread_invites_to,
        subscribe_to_started_threads: this.state.subscribe_to_started_threads,
        subscribe_to_replied_threads: this.state.subscribe_to_replied_threads
      }));

      _snackbar.default.success(gettext("Your forum options have been changed."));
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(gettext("Please reload page and try again."));
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Forum options"),
        parent: gettext("Change your options")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Change forum options"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", null, gettext("Privacy settings")), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Hide my presence"),
        helpText: gettext("If you hide your presence, only members with permission to see hidden users will see when you are online."),
        for: "id_is_hiding_presence"
      }, /*#__PURE__*/_react.default.createElement(_yesNoSwitch.default, {
        id: "id_is_hiding_presence",
        disabled: this.state.isLoading,
        iconOn: "visibility_off",
        iconOff: "visibility",
        labelOn: gettext("Hide my presence from other users"),
        labelOff: gettext("Show my presence to other users"),
        onChange: this.bindInput("is_hiding_presence"),
        value: this.state.is_hiding_presence
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Private thread invitations"),
        for: "id_limits_private_thread_invites_to"
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        id: "id_limits_private_thread_invites_to",
        disabled: this.state.isLoading,
        onChange: this.bindInput("limits_private_thread_invites_to"),
        value: this.state.limits_private_thread_invites_to,
        choices: this.privateThreadInvitesChoices
      }))), /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", null, gettext("Automatic subscriptions")), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Threads I start"),
        for: "id_subscribe_to_started_threads"
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        id: "id_subscribe_to_started_threads",
        disabled: this.state.isLoading,
        onChange: this.bindInput("subscribe_to_started_threads"),
        value: this.state.subscribe_to_started_threads,
        choices: this.subscribeToChoices
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Threads I reply to"),
        for: "id_subscribe_to_replied_threads"
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        id: "id_subscribe_to_replied_threads",
        disabled: this.state.isLoading,
        onChange: this.bindInput("subscribe_to_replied_threads"),
        value: this.state.subscribe_to_replied_threads,
        choices: this.subscribeToChoices
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Save changes")))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../reducers/auth":350,"../../services/ajax":365,"../../services/page-title":373,"../../services/snackbar":376,"../../services/store":377,"../button":8,"../form":56,"../form-group":55,"../select":210,"../yes-no-switch":300,"react":"react"}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideNav = SideNav;
exports.CompactNav = CompactNav;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _li = _interopRequireDefault(require("../li"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SideNav(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "list-group nav-side"
  }, props.options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      to: props.baseUrl + option.component + "/",
      className: "list-group-item",
      activeClassName: "active",
      key: option.component
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, option.icon), option.name);
  }));
}

function CompactNav(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: props.className || "dropdown-menu stick-to-bottom",
    role: "menu"
  }, props.options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_li.default, {
      path: props.baseUrl + option.component + "/",
      key: option.component
    }, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      to: props.baseUrl + option.component + "/",
      onClick: props.hideNav
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon hidden-sm"
    }, option.icon), option.name));
  }));
}

},{"../..":302,"../li":57,"react":"react","react-router":"react-router"}],87:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.paths = paths;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _dropdownToggle = _interopRequireDefault(require("../dropdown-toggle"));

var _navs = require("./navs");

var _deleteAccount = _interopRequireDefault(require("./delete-account"));

var _editDetails = _interopRequireDefault(require("./edit-details"));

var _downloadData = _interopRequireDefault(require("./download-data"));

var _forumOptions = _interopRequireDefault(require("./forum-options"));

var _root = _interopRequireDefault(require("./change-username/root"));

var _root2 = _interopRequireDefault(require("./sign-in-credentials/root"));

var _withDropdown = _interopRequireDefault(require("../with-dropdown"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_WithDropdown) {
  _inherits(_default, _WithDropdown);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-options"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("h1", null, gettext("Change your options"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-tabs visible-xs-block visible-sm-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(_navs.CompactNav, {
        className: "nav nav-pills",
        baseUrl: _.default.get("USERCP_URL"),
        options: _.default.get("USER_OPTIONS")
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-3 hidden-xs hidden-sm"
      }, /*#__PURE__*/_react.default.createElement(_navs.SideNav, {
        baseUrl: _.default.get("USERCP_URL"),
        options: _.default.get("USER_OPTIONS")
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-9"
      }, this.props.children))));
    }
  }]);

  return _default;
}(_withDropdown.default);

exports.default = _default;

function select(store) {
  return {
    tick: store.tick.tick,
    user: store.auth.user,
    "username-history": store["username-history"]
  };
}

function paths() {
  var SSO_ENABLED = _.default.get("SETTINGS").enable_sso;

  var paths = [{
    path: _.default.get("USERCP_URL") + "forum-options/",
    component: (0, _reactRedux.connect)(select)(_forumOptions.default)
  }, {
    path: _.default.get("USERCP_URL") + "edit-details/",
    component: (0, _reactRedux.connect)(select)(_editDetails.default)
  }];

  if (!SSO_ENABLED) {
    paths.push({
      path: _.default.get("USERCP_URL") + "change-username/",
      component: (0, _reactRedux.connect)(select)(_root.default)
    });
    paths.push({
      path: _.default.get("USERCP_URL") + "sign-in-credentials/",
      component: (0, _reactRedux.connect)(select)(_root2.default)
    });
  }

  if (_.default.get("ENABLE_DOWNLOAD_OWN_DATA")) {
    paths.push({
      path: _.default.get("USERCP_URL") + "download-data/",
      component: (0, _reactRedux.connect)(select)(_downloadData.default)
    });
  }

  if (!SSO_ENABLED && _.default.get("ENABLE_DELETE_OWN_ACCOUNT")) {
    paths.push({
      path: _.default.get("USERCP_URL") + "delete-account/",
      component: (0, _reactRedux.connect)(select)(_deleteAccount.default)
    });
  }

  return paths;
}

},{"../..":302,"../dropdown-toggle":27,"../with-dropdown":299,"./change-username/root":81,"./delete-account":82,"./download-data":83,"./edit-details":84,"./forum-options":85,"./navs":86,"./sign-in-credentials/root":91,"react":"react","react-redux":"react-redux"}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnusablePasswordMessage = function UnusablePasswordMessage() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "panel-title"
  }, gettext("Change email or password"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body panel-message-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("You need to set a password for your account to be able to change your username or email.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "help-block"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-primary",
    href: _.default.get("FORGOTTEN_PASSWORD_URL")
  }, gettext("Set password"))))));
};

var _default = UnusablePasswordMessage;
exports.default = _default;

},{"../../..":302,"react":"react"}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var validators = _interopRequireWildcard(require("../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      new_email: "",
      password: "",
      validators: {
        new_email: [validators.email()],
        password: []
      },
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      var errors = this.validate();
      var lengths = [this.state.new_email.trim().length, this.state.password.trim().length];

      if (lengths.indexOf(0) !== -1) {
        _snackbar.default.error(gettext("Fill out all fields."));

        return false;
      }

      if (errors.new_email) {
        _snackbar.default.error(errors.new_email[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.user.api.change_email, {
        new_email: this.state.new_email,
        password: this.state.password
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response) {
      this.setState({
        new_email: "",
        password: ""
      });

      _snackbar.default.success(response.detail);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        if (rejection.new_email) {
          _snackbar.default.error(rejection.new_email);
        } else {
          _snackbar.default.error(rejection.password);
        }
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "type",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Change e-mail address"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("New e-mail"),
        for: "id_new_email"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_new_email",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("new_email"),
        value: this.state.new_email
      })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Your current password"),
        for: "id_confirm_email"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        id: "id_confirm_email",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("password"),
        value: this.state.password
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Change e-mail")))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../services/ajax":365,"../../../services/snackbar":376,"../../../utils/validators":393,"../../button":8,"../../form":56,"../../form-group":55,"react":"react"}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      new_password: "",
      repeat_password: "",
      password: "",
      validators: {
        new_password: [],
        repeat_password: [],
        password: []
      },
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      var errors = this.validate();
      var lengths = [this.state.new_password.trim().length, this.state.repeat_password.trim().length, this.state.password.trim().length];

      if (lengths.indexOf(0) !== -1) {
        _snackbar.default.error(gettext("Fill out all fields."));

        return false;
      }

      if (errors.new_password) {
        _snackbar.default.error(errors.new_password[0]);

        return false;
      }

      if (this.state.new_password !== this.state.repeat_password) {
        _snackbar.default.error(gettext("New passwords are different."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.user.api.change_password, {
        new_password: this.state.new_password,
        password: this.state.password
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response) {
      this.setState({
        new_password: "",
        repeat_password: "",
        password: ""
      });

      _snackbar.default.success(response.detail);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        if (rejection.new_password) {
          _snackbar.default.error(rejection.new_password);
        } else {
          _snackbar.default.error(rejection.password);
        }
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "type",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Change password"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("New password"),
        for: "id_new_password"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        id: "id_new_password",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("new_password"),
        value: this.state.new_password
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Repeat password"),
        for: "id_repeat_password"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        id: "id_repeat_password",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("repeat_password"),
        value: this.state.repeat_password
      })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Your current password"),
        for: "id_confirm_password"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        id: "id_confirm_password",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("password"),
        value: this.state.password
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Change password")))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../services/ajax":365,"../../../services/snackbar":376,"../../button":8,"../../form":56,"../../form-group":55,"react":"react"}],91:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _changeEmail = _interopRequireDefault(require("./change-email"));

var _changePassword = _interopRequireDefault(require("./change-password"));

var _ = _interopRequireDefault(require("../../.."));

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

var _UnusablePasswordMessage = _interopRequireDefault(require("./UnusablePasswordMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Change email or password"),
        parent: gettext("Change your options")
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.user.has_usable_password) {
        return /*#__PURE__*/_react.default.createElement(_UnusablePasswordMessage.default, null);
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_changeEmail.default, {
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement(_changePassword.default, {
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement("p", {
        className: "message-line"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "warning"), /*#__PURE__*/_react.default.createElement("a", {
        href: _.default.get("FORGOTTEN_PASSWORD_URL")
      }, gettext("Change forgotten password"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"../../../services/page-title":373,"./UnusablePasswordMessage":88,"./change-email":89,"./change-password":90,"react":"react"}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stringCount = _interopRequireDefault(require("../utils/string-count"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.copy && this.props.copy.length) {
        if ((0, _stringCount.default)(this.props.copy, "<p") === 1 && this.props.copy.indexOf("<br") === -1) {
          return "page-lead lead";
        }
      }

      return "page-lead";
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.copy && this.props.copy.length) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: this.getClassName(),
          dangerouslySetInnerHTML: {
            __html: this.props.copy
          }
        });
      } else {
        return null;
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../utils/string-count":392,"react":"react"}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body panel-body-loading"
      }, /*#__PURE__*/_react.default.createElement(_loader.default, {
        className: "loader loader-spaced"
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./loader":58,"react":"react"}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getHelpText",
    value: function getHelpText() {
      if (this.props.helpText) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "help-block"
        }, this.props.helpText);
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body panel-message-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.props.icon || "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.props.message), this.getHelpText()));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _addParticipant = _interopRequireDefault(require("../add-participant"));

var _modal = _interopRequireDefault(require("../../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_addParticipant.default, {
        thread: _this.props.thread
      }));
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (!this.props.thread.acl.can_add_participants) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-3"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "person_add"), gettext("Add participant")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../services/modal":371,"../add-participant":4,"react":"react"}],96:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leave = leave;
exports.remove = remove;
exports.changeOwner = changeOwner;

var participants = _interopRequireWildcard(require("../../../reducers/participants"));

var _thread = require("../../../reducers/thread");

var _ = _interopRequireDefault(require("../../.."));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function leave(thread, participant) {
  _ajax.default.patch(thread.api.index, [{
    op: "remove",
    path: "participants",
    value: participant.id
  }]).then(function () {
    _snackbar.default.success(gettext("You have left this thread."));

    window.setTimeout(function () {
      window.location = _.default.get("PRIVATE_THREADS_URL");
    }, 3 * 1000);
  }, function (rejection) {
    _snackbar.default.apiError(rejection);
  });
}

function remove(thread, participant) {
  _ajax.default.patch(thread.api.index, [{
    op: "remove",
    path: "participants",
    value: participant.id
  }, {
    op: "add",
    path: "acl",
    value: 1
  }]).then(function (data) {
    _store.default.dispatch((0, _thread.updateAcl)(data));

    _store.default.dispatch(participants.replace(data.participants));

    var message = gettext("%(user)s has been removed from this thread.");

    _snackbar.default.success(interpolate(message, {
      user: participant.username
    }, true));
  }, function (rejection) {
    _snackbar.default.apiError(rejection);
  });
}

function changeOwner(thread, participant) {
  _ajax.default.patch(thread.api.index, [{
    op: "replace",
    path: "owner",
    value: participant.id
  }, {
    op: "add",
    path: "acl",
    value: 1
  }]).then(function (data) {
    _store.default.dispatch((0, _thread.updateAcl)(data));

    _store.default.dispatch(participants.replace(data.participants));

    var message = gettext("%(user)s has been made new thread owner.");

    _snackbar.default.success(interpolate(message, {
      user: participant.username
    }, true));
  }, function (rejection) {
    _snackbar.default.apiError(rejection);
  });
}

},{"../../..":302,"../../../reducers/participants":351,"../../../reducers/thread":360,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.UserStatus = UserStatus;

var _react = _interopRequireDefault(require("react"));

var _makeOwner = _interopRequireDefault(require("./make-owner"));

var _remove = _interopRequireDefault(require("./remove"));

var _avatar = _interopRequireDefault(require("../../avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var participant = props.participant;
  var className = "btn btn-default";

  if (participant.is_owner) {
    className = "btn btn-primary";
  }

  className += " btn-user btn-block";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-3 col-md-2 participant-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": "false",
    className: className,
    "data-toggle": "dropdown",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: "34",
    user: participant
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-text"
  }, participant.username)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu stick-to-bottom"
  }, /*#__PURE__*/_react.default.createElement(UserStatus, {
    isOwner: participant.is_owner
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-header"
  }), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: participant.url
  }, gettext("See profile"))), /*#__PURE__*/_react.default.createElement("li", {
    role: "separator",
    className: "divider"
  }), /*#__PURE__*/_react.default.createElement(_makeOwner.default, props), /*#__PURE__*/_react.default.createElement(_remove.default, props))));
}

function UserStatus(_ref) {
  var isOwner = _ref.isOwner;
  if (!isOwner) return null;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-header dropdown-header-owner"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "start"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-text"
  }, gettext("Thread owner")));
}

},{"../../avatar":6,"./make-owner":99,"./remove":100,"react":"react"}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _card = _interopRequireDefault(require("./card"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var participants = _ref.participants,
      thread = _ref.thread,
      user = _ref.user,
      userIsOwner = _ref.userIsOwner;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "participants-cards"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, participants.map(function (participant) {
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      key: participant.id,
      participant: participant,
      thread: thread,
      user: user,
      userIsOwner: userIsOwner
    });
  })));
}

},{"./card":97,"react":"react"}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _actions = require("./actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var confirmed = false;

      if (_this.isUser) {
        confirmed = confirm(gettext("Are you sure you want to take over this thread?"));
      } else {
        var message = gettext("Are you sure you want to change thread owner to %(user)s?");
        confirmed = confirm(interpolate(message, {
          user: _this.props.participant.username
        }, true));
      }

      if (!confirmed) return;
      (0, _actions.changeOwner)(_this.props.thread, _this.props.participant);
    });

    _this.isUser = props.participant.id === props.user.id;
    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.props.participant.is_owner) return null;
      if (!this.props.thread.acl.can_change_owner) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, gettext("Make owner")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./actions":96,"react":"react"}],100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _actions = require("./actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var confirmed = false;

      if (_this.isUser) {
        confirmed = confirm(gettext("Are you sure you want to leave this thread?"));
      } else {
        var message = gettext("Are you sure you want to remove %(user)s from this thread?");
        confirmed = confirm(interpolate(message, {
          user: _this.props.participant.username
        }, true));
      }

      if (!confirmed) return;

      if (_this.isUser) {
        (0, _actions.leave)(_this.props.thread, _this.props.participant);
      } else {
        (0, _actions.remove)(_this.props.thread, _this.props.participant);
      }
    });

    _this.isUser = props.participant.id === props.user.id;
    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var isModerator = this.props.user.acl.can_moderate_private_threads;
      if (!(this.props.userIsOwner || this.isUser || isModerator)) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, this.isUser ? gettext("Leave thread") : gettext("Remove")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./actions":96,"react":"react"}],101:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getUserIsOwner = getUserIsOwner;

var _react = _interopRequireDefault(require("react"));

var _addParticipant = _interopRequireDefault(require("./add-participant"));

var _cardsList = _interopRequireDefault(require("./cards-list"));

var utils = _interopRequireWildcard(require("./utils"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  if (!props.participants.length) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-participants"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement(_cardsList.default, _extends({
    userIsOwner: getUserIsOwner(props.user, props.participants)
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(_addParticipant.default, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-9"
  }, /*#__PURE__*/_react.default.createElement("p", null, utils.getParticipantsCopy(props.participants))))));
}

function getUserIsOwner(user, participants) {
  return participants[0].id === user.id;
}

},{"./add-participant":95,"./cards-list":98,"./utils":102,"react":"react"}],102:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParticipantsCopy = getParticipantsCopy;

function getParticipantsCopy(participants) {
  var count = participants.length;
  var message = ngettext("This thread has %(users)s participant.", "This thread has %(users)s participants.", count);
  return interpolate(message, {
    users: count
  }, true);
}

},{}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LABELS = exports.STYLES = void 0;

var _react = _interopRequireDefault(require("react"));

var _zxcvbn = _interopRequireDefault(require("../services/zxcvbn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var STYLES = ["progress-bar-danger", "progress-bar-warning", "progress-bar-warning", "progress-bar-primary", "progress-bar-success"];
exports.STYLES = STYLES;
var LABELS = [gettext("Entered password is very weak."), gettext("Entered password is weak."), gettext("Entered password is average."), gettext("Entered password is strong."), gettext("Entered password is very strong.")];
exports.LABELS = LABELS;

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._score = 0;
    _this._password = null;
    _this._inputs = [];
    _this.state = {
      loaded: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _zxcvbn.default.load().then(function () {
        _this2.setState({
          loaded: true
        });
      });
    }
  }, {
    key: "getScore",
    value: function getScore(password, inputs) {
      var _this3 = this;

      var cacheStale = false;

      if (password !== this._password) {
        cacheStale = true;
      }

      if (inputs.length !== this._inputs.length) {
        cacheStale = true;
      } else {
        inputs.map(function (value, i) {
          if (value.trim() !== _this3._inputs[i]) {
            cacheStale = true;
          }
        });
      }

      if (cacheStale) {
        this._score = _zxcvbn.default.scorePassword(password, inputs);
        this._password = password;
        this._inputs = inputs.map(function (value) {
          return value.trim();
        });
      }

      return this._score;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.loaded) return null;
      var score = this.getScore(this.props.password, this.props.inputs);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "help-block password-strength"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-bar " + STYLES[score],
        style: {
          width: 20 + 20 * score + "%"
        },
        role: "progress-bar",
        "aria-valuenow": score,
        "aria-valuemin": "0",
        "aria-valuemax": "4"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, LABELS[score]))), /*#__PURE__*/_react.default.createElement("p", {
        className: "text-small"
      }, LABELS[score]));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/zxcvbn":378,"react":"react"}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateRandomHash = generateRandomHash;
exports.PollChoice = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onAdd", function () {
      var choices = _this.props.choices.slice();

      choices.push({
        hash: generateRandomHash(),
        label: ""
      });

      _this.props.setChoices(choices);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (hash, label) {
      var choices = _this.props.choices.map(function (choice) {
        if (choice.hash === hash) {
          choice.label = label;
        }

        return choice;
      });

      _this.props.setChoices(choices);
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (hash) {
      var choices = _this.props.choices.filter(function (choice) {
        return choice.hash !== hash;
      });

      _this.props.setChoices(choices);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "poll-choices-control"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, this.props.choices.map(function (choice) {
        return /*#__PURE__*/_react.default.createElement(PollChoice, {
          canDelete: _this2.props.choices.length > 2,
          choice: choice,
          disabled: _this2.props.disabled,
          key: choice.hash,
          onChange: _this2.onChange,
          onDelete: _this2.onDelete
        });
      })), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-sm",
        disabled: this.props.disabled,
        onClick: this.onAdd,
        type: "button"
      }, gettext("Add choice")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

var PollChoice = /*#__PURE__*/function (_React$Component2) {
  _inherits(PollChoice, _React$Component2);

  var _super2 = _createSuper(PollChoice);

  function PollChoice() {
    var _this3;

    _classCallCheck(this, PollChoice);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onChange", function (event) {
      _this3.props.onChange(_this3.props.choice.hash, event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this3), "onDelete", function () {
      var deleteItem = confirm(gettext("Are you sure you want to delete this choice?"));

      if (deleteItem) {
        _this3.props.onDelete(_this3.props.choice.hash);
      }
    });

    return _this3;
  }

  _createClass(PollChoice, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "list-group-item"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        disabled: !this.props.canDelete || this.props.disabled,
        onClick: this.onDelete,
        title: gettext("Delete this choice"),
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "close")), /*#__PURE__*/_react.default.createElement("input", {
        disabled: this.props.disabled,
        maxLength: "255",
        placeholder: gettext("choice label"),
        type: "text",
        onChange: this.onChange,
        value: this.props.choice.label
      }));
    }
  }]);

  return PollChoice;
}(_react.default.Component);

exports.PollChoice = PollChoice;

function generateRandomHash() {
  var randomHash = "";

  while (randomHash.length != 12) {
    randomHash = Math.random().toString(36).replace(/[^a-zA-Z0-9]+/g, "").substr(1, 12);
  }

  return randomHash;
}

},{"react":"react"}],105:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollPublicSwitch = PollPublicSwitch;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _choicesControl = _interopRequireDefault(require("./choices-control"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _yesNoSwitch = _interopRequireDefault(require("../../yes-no-switch"));

var poll = _interopRequireWildcard(require("../../../reducers/poll"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _posting = _interopRequireDefault(require("../../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setChoices", function (choices) {
      var errors = Object.assign({}, errors, {
        choices: null
      });

      _this.setState({
        choices: choices,
        errors: errors
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var cancel = confirm(gettext("Are you sure you want to discard poll?"));

      if (cancel) {
        _posting.default.close();
      }
    });

    var poll = props.poll || {
      question: "",
      choices: [{
        hash: "choice-10000",
        label: ""
      }, {
        hash: "choice-20000",
        label: ""
      }],
      length: 0,
      allowed_choices: 1,
      allow_revotes: 0,
      is_public: 0
    };
    _this.state = {
      isLoading: false,
      isEdit: !!poll.question,
      question: poll.question,
      choices: poll.choices,
      length: poll.length,
      allowed_choices: poll.allowed_choices,
      allow_revotes: poll.allow_revotes,
      is_public: poll.is_public,
      validators: {
        question: [],
        choices: [],
        length: [],
        allowed_choices: []
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "send",
    value: function send() {
      var data = {
        question: this.state.question,
        choices: this.state.choices,
        length: this.state.length,
        allowed_choices: this.state.allowed_choices,
        allow_revotes: this.state.allow_revotes,
        is_public: this.state.is_public
      };

      if (this.state.isEdit) {
        return _ajax.default.put(this.props.poll.api.index, data);
      } else {
        return _ajax.default.post(this.props.thread.api.poll, data);
      }
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      _store.default.dispatch(poll.replace(data));

      if (this.state.isEdit) {
        _snackbar.default.success(gettext("Poll has been edited."));
      } else {
        _snackbar.default.success(gettext("Poll has been posted."));
      }

      _posting.default.close();
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        if (rejection.non_field_errors) {
          rejection.allowed_choices = rejection.non_field_errors;
        }

        this.setState({
          errors: Object.assign({}, rejection)
        });

        _snackbar.default.error(gettext("Form contains errors."));
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "poll-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", null, gettext("Question and choices")), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Poll question"),
        for: "id_questions",
        validation: this.state.errors.question
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        id: "id_questions",
        onChange: this.bindInput("question"),
        type: "text",
        maxLength: "255",
        value: this.state.question
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Available choices"),
        validation: this.state.errors.choices
      }, /*#__PURE__*/_react.default.createElement(_choicesControl.default, {
        choices: this.state.choices,
        disabled: this.state.isLoading,
        setChoices: this.setChoices
      }))), /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", null, gettext("Voting")), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Poll length"),
        helpText: gettext("Enter number of days for which voting in this poll should be possible or zero to run this poll indefinitely."),
        for: "id_length",
        validation: this.state.errors.length
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        id: "id_length",
        onChange: this.bindInput("length"),
        type: "text",
        value: this.state.length
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Allowed choices"),
        for: "id_allowed_choices",
        validation: this.state.errors.allowed_choices
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        id: "id_allowed_choices",
        onChange: this.bindInput("allowed_choices"),
        type: "text",
        maxLength: "255",
        value: this.state.allowed_choices
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement(PollPublicSwitch, {
        bindInput: this.bindInput,
        disabled: this.state.isLoading,
        isEdit: this.state.isEdit,
        value: this.state.is_public
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Allow vote changes"),
        for: "id_allow_revotes"
      }, /*#__PURE__*/_react.default.createElement(_yesNoSwitch.default, {
        id: "id_allow_revotes",
        disabled: this.state.isLoading,
        iconOn: "check",
        iconOff: "close",
        labelOn: gettext("Allow participants to change their vote"),
        labelOff: gettext("Don't allow participants to change their vote"),
        onChange: this.bindInput("allow_revotes"),
        value: this.state.allow_revotes
      })))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer text-right"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        disabled: this.state.isLoading,
        onClick: this.onCancel,
        type: "button"
      }, gettext("Cancel")), " ", /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, this.state.isEdit ? gettext("Save changes") : gettext("Post poll")))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function PollPublicSwitch(props) {
  if (props.isEdit) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
    label: gettext("Make voting public"),
    helpText: gettext("Making voting public will allow everyone to access detailed list of votes, showing which users voted for which choices and at which times. This option can't be changed after poll's creation. Moderators may see voting details for all polls."),
    for: "id_is_public"
  }, /*#__PURE__*/_react.default.createElement(_yesNoSwitch.default, {
    id: "id_is_public",
    disabled: props.disabled,
    iconOn: "visibility",
    iconOff: "visibility_off",
    labelOn: gettext("Votes are public"),
    labelOff: gettext("Votes are hidden"),
    onChange: props.bindInput("is_public"),
    value: props.value
  })));
}

},{"../../../reducers/poll":352,"../../../services/ajax":365,"../../../services/posting":375,"../../../services/snackbar":376,"../../../services/store":377,"../../button":8,"../../form":56,"../../form-group":55,"../../yes-no-switch":300,"./choices-control":104,"react":"react"}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Poll", {
  enumerable: true,
  get: function get() {
    return _poll.default;
  }
});
Object.defineProperty(exports, "PollForm", {
  enumerable: true,
  get: function get() {
    return _form.default;
  }
});

var _poll = _interopRequireDefault(require("./poll"));

var _form = _interopRequireDefault(require("./form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./form":105,"./poll":108}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.PollCreation = PollCreation;
exports.getPoster = getPoster;
exports.getPostedOn = getPostedOn;
exports.PollLength = PollLength;
exports.getEndsOn = getEndsOn;
exports.PollVotes = PollVotes;
exports.PollIsPublic = PollIsPublic;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled list-inline poll-details"
  }, /*#__PURE__*/_react.default.createElement(PollVotes, {
    votes: props.poll.votes
  }), /*#__PURE__*/_react.default.createElement(PollLength, {
    poll: props.poll
  }), /*#__PURE__*/_react.default.createElement(PollIsPublic, {
    poll: props.poll
  }), /*#__PURE__*/_react.default.createElement(PollCreation, {
    poll: props.poll
  }));
}

function PollCreation(props) {
  var message = interpolate((0, _escapeHtml.default)(gettext("Posted by %(poster)s %(posted_on)s.")), {
    poster: getPoster(props.poll),
    posted_on: getPostedOn(props.poll)
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-info-creation",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function getPoster(poll) {
  if (poll.url.poster) {
    return interpolate(USER_URL, {
      url: (0, _escapeHtml.default)(poll.url.poster),
      user: (0, _escapeHtml.default)(poll.poster_name)
    }, true);
  }

  return interpolate(USER_SPAN, {
    user: (0, _escapeHtml.default)(poll.poster_name)
  }, true);
}

function getPostedOn(poll) {
  return interpolate(DATE_ABBR, {
    absolute: (0, _escapeHtml.default)(poll.posted_on.format("LLL")),
    relative: (0, _escapeHtml.default)(poll.posted_on.fromNow())
  }, true);
}

function PollLength(props) {
  if (!props.poll.length) {
    return null;
  }

  var message = interpolate((0, _escapeHtml.default)(gettext("Voting ends %(ends_on)s.")), {
    ends_on: getEndsOn(props.poll)
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-info-ends-on",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function getEndsOn(poll) {
  return interpolate(DATE_ABBR, {
    absolute: (0, _escapeHtml.default)(poll.endsOn.format("LLL")),
    relative: (0, _escapeHtml.default)(poll.endsOn.fromNow())
  }, true);
}

function PollVotes(props) {
  var message = ngettext("%(votes)s vote.", "%(votes)s votes.", props.votes);
  var label = interpolate(message, {
    votes: props.votes
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-info-votes"
  }, label);
}

function PollIsPublic(props) {
  if (!props.poll.is_public) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-info-public"
  }, gettext("Votes are public."));
}

},{"../../utils/escape-html":383,"react":"react"}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsPollOver = getIsPollOver;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _results = _interopRequireDefault(require("./results"));

var _voting = _interopRequireDefault(require("./voting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showResults", function () {
      _this.setState({
        showResults: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showVoting", function () {
      _this.setState({
        showResults: false
      });
    });

    var showResults = true;

    if (props.user.id && !props.poll.hasSelectedChoices) {
      showResults = false;
    }

    _this.state = {
      showResults: showResults
    };
    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (!this.props.thread.poll) return null;
      var isPollOver = getIsPollOver(this.props.poll);

      if (!isPollOver && this.props.poll.acl.can_vote && !this.state.showResults) {
        return /*#__PURE__*/_react.default.createElement(_voting.default, _extends({
          showResults: this.showResults
        }, this.props));
      } else {
        return /*#__PURE__*/_react.default.createElement(_results.default, _extends({
          isPollOver: isPollOver,
          showVoting: this.showVoting
        }, this.props));
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function getIsPollOver(poll) {
  if (poll.length) {
    return (0, _moment.default)().isAfter(poll.endsOn);
  }

  return false;
}

},{"./results":110,"./voting":114,"moment":"moment","react":"react"}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.PollChoice = PollChoice;
exports.ChoiceVotes = ChoiceVotes;
exports.getVotesLabel = getVotesLabel;
exports.UserChoice = UserChoice;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "poll-choices-bars"
  }, props.poll.choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(PollChoice, {
      choice: choice,
      key: choice.hash,
      poll: props.poll
    });
  }));
}

function PollChoice(props) {
  var proc = 0;

  if (props.choice.votes && props.poll.votes) {
    proc = Math.ceil(props.choice.votes * 100 / props.poll.votes);
  }

  return /*#__PURE__*/_react.default.createElement("dl", {
    className: "dl-horizontal"
  }, /*#__PURE__*/_react.default.createElement("dt", null, props.choice.label), /*#__PURE__*/_react.default.createElement("dd", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar",
    role: "progressbar",
    "aria-valuenow": proc,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: {
      width: proc + "%"
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, getVotesLabel(props.votes, props.proc)))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled list-inline poll-chart"
  }, /*#__PURE__*/_react.default.createElement(ChoiceVotes, {
    proc: proc,
    votes: props.choice.votes
  }), /*#__PURE__*/_react.default.createElement(UserChoice, {
    selected: props.choice.selected
  }))));
}

function ChoiceVotes(props) {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-chart-votes"
  }, getVotesLabel(props.votes, props.proc));
}

function getVotesLabel(votes, proc) {
  var message = ngettext("%(votes)s vote, %(proc)s% of total.", "%(votes)s votes, %(proc)s% of total.", votes);
  return interpolate(message, {
    votes: votes,
    proc: proc
  }, true);
}

function UserChoice(props) {
  if (!props.selected) return null;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-chart-selected"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "check_box"), gettext("Your choice."));
}

},{"react":"react"}],110:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _chart = _interopRequireDefault(require("./chart"));

var _options = _interopRequireDefault(require("./options"));

var _info = _interopRequireDefault(require("../info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-poll"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("h2", null, props.poll.question), /*#__PURE__*/_react.default.createElement(_info.default, {
    poll: props.poll
  }), /*#__PURE__*/_react.default.createElement(_chart.default, {
    poll: props.poll
  }), /*#__PURE__*/_react.default.createElement(_options.default, {
    isPollOver: props.isPollOver,
    poll: props.poll,
    showVoting: props.showVoting,
    thread: props.thread
  })));
}

},{"../info":107,"./chart":109,"./options":112,"react":"react"}],111:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBody = ModalBody;
exports.ChoicesList = ChoicesList;
exports.ChoiceDetails = ChoiceDetails;
exports.VotesCount = VotesCount;
exports.VotesList = VotesList;
exports.Voter = Voter;
exports.VoteDate = VoteDate;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _modalMessage = _interopRequireDefault(require("../../modal-message"));

var _modalLoader = _interopRequireDefault(require("../../modal-loader"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: true,
      error: null,
      data: []
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.poll.api.votes).then(function (data) {
        var hydratedData = data.map(function (choice) {
          return Object.assign({}, choice, {
            voters: choice.voters.map(function (voter) {
              return Object.assign({}, voter, {
                voted_on: (0, _moment.default)(voter.voted_on)
              });
            })
          });
        });

        _this2.setState({
          isLoading: false,
          data: hydratedData
        });
      }, function (rejection) {
        _this2.setState({
          isLoading: false,
          error: rejection.detail
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog" + (this.state.error ? " modal-message" : " modal-sm"),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Poll votes"))), /*#__PURE__*/_react.default.createElement(ModalBody, {
        data: this.state.data,
        error: this.state.error,
        isLoading: this.state.isLoading
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function ModalBody(props) {
  if (props.isLoading) {
    return /*#__PURE__*/_react.default.createElement(_modalLoader.default, null);
  } else if (props.error) {
    return /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
      icon: "error_outline",
      message: props.error
    });
  }

  return /*#__PURE__*/_react.default.createElement(ChoicesList, {
    data: props.data
  });
}

function ChoicesList(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body modal-poll-votes"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled votes-details"
  }, props.data.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(ChoiceDetails, _extends({
      key: choice.hash
    }, choice));
  })));
}

function ChoiceDetails(props) {
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h4", null, props.label), /*#__PURE__*/_react.default.createElement(VotesCount, {
    votes: props.votes
  }), /*#__PURE__*/_react.default.createElement(VotesList, {
    voters: props.voters
  }), /*#__PURE__*/_react.default.createElement("hr", null));
}

function VotesCount(props) {
  var message = ngettext("%(votes)s user has voted for this choice.", "%(votes)s users have voted for this choice.", props.votes);
  var label = interpolate(message, {
    votes: props.votes
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", null, label);
}

function VotesList(props) {
  if (!props.voters.length) return null;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, props.voters.map(function (user) {
    return /*#__PURE__*/_react.default.createElement(Voter, _extends({
      key: user.username
    }, user));
  }));
}

function Voter(props) {
  if (props.url) {
    return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      className: "item-title",
      href: props.url
    }, props.username), " ", /*#__PURE__*/_react.default.createElement(VoteDate, {
      voted_on: props.voted_on
    }));
  }

  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, props.username), " ", /*#__PURE__*/_react.default.createElement(VoteDate, {
    voted_on: props.voted_on
  }));
}

function VoteDate(props) {
  return /*#__PURE__*/_react.default.createElement("abbr", {
    className: "text-muted",
    title: props.voted_on.format("LLL")
  }, props.voted_on.fromNow());
}

},{"../../../services/ajax":365,"../../modal-loader":61,"../../modal-message":62,"moment":"moment","react":"react"}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.isVisible = isVisible;
exports.getClassName = getClassName;
exports.ChangeVote = ChangeVote;
exports.Delete = exports.Edit = exports.SeeVotes = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = _interopRequireDefault(require("./modal"));

var poll = _interopRequireWildcard(require("../../../reducers/poll"));

var thread = _interopRequireWildcard(require("../../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _modal2 = _interopRequireDefault(require("../../../services/modal"));

var _posting = _interopRequireDefault(require("../../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  var isPollOver = props.isPollOver,
      poll = props.poll,
      showVoting = props.showVoting,
      thread = props.thread;
  if (!isVisible(isPollOver, poll.acl, poll)) return null;
  var controls = [];
  var canVote = poll.acl.can_vote;
  var canChangeVote = !poll.hasSelectedChoices || poll.allow_revotes;
  if (canVote && canChangeVote) controls.push(0);
  if (poll.is_public || poll.acl.can_see_votes) controls.push(1);
  if (poll.acl.can_edit) controls.push(2);
  if (poll.acl.can_delete) controls.push(3);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row poll-options"
  }, /*#__PURE__*/_react.default.createElement(ChangeVote, {
    controls: controls,
    isPollOver: isPollOver,
    poll: poll,
    showVoting: showVoting
  }), /*#__PURE__*/_react.default.createElement(SeeVotes, {
    controls: controls,
    poll: poll
  }), /*#__PURE__*/_react.default.createElement(Edit, {
    controls: controls,
    poll: poll,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement(Delete, {
    controls: controls,
    poll: poll
  }));
}

function isVisible(isPollOver, acl, poll) {
  return poll.is_public || acl.can_delete || acl.can_edit || acl.can_see_votes || acl.can_vote && !isPollOver && (!poll.hasSelectedChoices || poll.allow_revotes);
}

function getClassName(controls, control) {
  var className = "col-xs-6";

  if (controls.length === 1) {
    className = "col-xs-12";
  }

  if (controls.length === 3 && controls[0] === control) {
    className = "col-xs-12";
  }

  return className + " col-sm-3 col-md-2";
}

function ChangeVote(props) {
  var canVote = props.poll.acl.can_vote;
  var canChangeVote = !props.poll.hasSelectedChoices || props.poll.allow_revotes;
  if (!(canVote && canChangeVote)) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: getClassName(props.controls, 0)
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-block btn-sm",
    disabled: props.poll.isBusy,
    onClick: props.showVoting,
    type: "button"
  }, gettext("Vote")));
}

var SeeVotes = /*#__PURE__*/function (_React$Component) {
  _inherits(SeeVotes, _React$Component);

  var _super = _createSuper(SeeVotes);

  function SeeVotes() {
    var _this;

    _classCallCheck(this, SeeVotes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _modal2.default.show( /*#__PURE__*/_react.default.createElement(_modal.default, {
        poll: _this.props.poll
      }));
    });

    return _this;
  }

  _createClass(SeeVotes, [{
    key: "render",
    value: function render() {
      var seeVotes = this.props.poll.is_public || this.props.poll.acl.can_see_votes;
      if (!seeVotes) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: getClassName(this.props.controls, 1)
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block btn-sm",
        disabled: this.props.poll.isBusy,
        onClick: this.onClick,
        type: "button"
      }, gettext("See votes")));
    }
  }]);

  return SeeVotes;
}(_react.default.Component);

exports.SeeVotes = SeeVotes;

var Edit = /*#__PURE__*/function (_React$Component2) {
  _inherits(Edit, _React$Component2);

  var _super2 = _createSuper(Edit);

  function Edit() {
    var _this2;

    _classCallCheck(this, Edit);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      _posting.default.open({
        submit: _this2.props.poll.api.index,
        thread: _this2.props.thread,
        poll: _this2.props.poll,
        mode: "POLL"
      });
    });

    return _this2;
  }

  _createClass(Edit, [{
    key: "render",
    value: function render() {
      if (!this.props.poll.acl.can_edit) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: getClassName(this.props.controls, 2)
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block btn-sm",
        disabled: this.props.poll.isBusy,
        onClick: this.onClick,
        type: "button"
      }, gettext("Edit")));
    }
  }]);

  return Edit;
}(_react.default.Component);

exports.Edit = Edit;

var Delete = /*#__PURE__*/function (_React$Component3) {
  _inherits(Delete, _React$Component3);

  var _super3 = _createSuper(Delete);

  function Delete() {
    var _this3;

    _classCallCheck(this, Delete);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      var deletePoll = confirm(gettext("Are you sure you want to delete this poll? This action is not reversible."));
      if (!deletePoll) return false;

      _store.default.dispatch(poll.busy());

      _ajax.default.delete(_this3.props.poll.api.index).then(_this3.handleSuccess, _this3.handleError);
    });

    _defineProperty(_assertThisInitialized(_this3), "handleSuccess", function (newThreadAcl) {
      _snackbar.default.success("Poll has been deleted");

      _store.default.dispatch(poll.remove());

      _store.default.dispatch(thread.updateAcl(newThreadAcl));
    });

    _defineProperty(_assertThisInitialized(_this3), "handleError", function (rejection) {
      _snackbar.default.apiError(rejection);

      _store.default.dispatch(poll.release());
    });

    return _this3;
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      if (!this.props.poll.acl.can_delete) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: getClassName(this.props.controls, 3)
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block btn-sm",
        disabled: this.props.poll.isBusy,
        onClick: this.onClick,
        type: "button"
      }, gettext("Delete")));
    }
  }]);

  return Delete;
}(_react.default.Component);

exports.Delete = Delete;

},{"../../../reducers/poll":352,"../../../reducers/thread":360,"../../../services/ajax":365,"../../../services/modal":371,"../../../services/posting":375,"../../../services/snackbar":376,"../../../services/store":377,"./modal":111,"react":"react"}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.PollChoicesLeft = PollChoicesLeft;
exports.PollAllowRevote = PollAllowRevote;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled list-inline poll-help"
  }, /*#__PURE__*/_react.default.createElement(PollChoicesLeft, {
    choicesLeft: props.choicesLeft
  }), /*#__PURE__*/_react.default.createElement(PollAllowRevote, {
    poll: props.poll
  }));
}

function PollChoicesLeft(_ref) {
  var choicesLeft = _ref.choicesLeft;

  if (choicesLeft === 0) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "poll-help-choices-left"
    }, gettext("You can't select any more choices."));
  }

  var message = ngettext("You can select %(choices)s more choice.", "You can select %(choices)s more choices.", choicesLeft);
  var label = interpolate(message, {
    choices: choicesLeft
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-help-choices-left"
  }, label);
}

function PollAllowRevote(props) {
  if (props.poll.allow_revotes) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "poll-help-allow-revotes"
    }, gettext("You can change your vote later."));
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: "poll-help-no-revotes"
  }, gettext("Votes are final."));
}

},{"../../../utils/escape-html":383,"react":"react"}],114:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help = _interopRequireDefault(require("./help"));

var _select = _interopRequireDefault(require("./select"));

var _utils = require("./utils");

var _info = _interopRequireDefault(require("../info"));

var _options = require("../results/options");

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var poll = _interopRequireWildcard(require("../../../reducers/poll"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleChoice", function (hash) {
      var choice = (0, _utils.getChoiceFromHash)(_this.state.choices, hash);
      var choices = null;

      if (!choice.selected) {
        choices = _this.selectChoice(choice, hash);
      } else {
        choices = _this.deselectChoice(choice, hash);
      }

      _this.setState({
        choices: choices,
        choicesLeft: (0, _utils.getChoicesLeft)(_this.props.poll, choices)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectChoice", function (choice, hash) {
      var choicesLeft = (0, _utils.getChoicesLeft)(_this.props.poll, _this.state.choices);

      if (!choicesLeft) {
        for (var i in _this.state.choices.slice()) {
          var item = _this.state.choices[i];

          if (item.selected && item.hash != hash) {
            item.selected = false;
            break;
          }
        }
      }

      return _this.state.choices.map(function (choice) {
        return Object.assign({}, choice, {
          selected: choice.hash == hash ? true : choice.selected
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deselectChoice", function (choice, hash) {
      return _this.state.choices.map(function (choice) {
        return Object.assign({}, choice, {
          selected: choice.hash == hash ? false : choice.selected
        });
      });
    });

    _this.state = {
      isLoading: false,
      choices: props.poll.choices,
      choicesLeft: (0, _utils.getChoicesLeft)(props.poll, props.poll.choices)
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (this.state.choicesLeft === this.props.poll.allowed_choices) {
        _snackbar.default.error(gettext("You need to select at least one choice"));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      var data = [];

      for (var i in this.state.choices.slice()) {
        var item = this.state.choices[i];

        if (item.selected) {
          data.push(item.hash);
        }
      }

      return _ajax.default.post(this.props.poll.api.votes, data);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      _store.default.dispatch(poll.replace(data));

      _snackbar.default.success(gettext("Your vote has been saved."));

      this.props.showResults();
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(rejection.detail);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var controls = [];
      if (this.props.poll.acl.can_vote) controls.push(0);
      if (this.props.poll.is_public || this.props.poll.acl.can_see_votes) controls.push(1);
      if (this.props.poll.acl.can_edit) controls.push(2);
      if (this.props.poll.acl.can_delete) controls.push(3);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-poll"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("h2", null, this.props.poll.question), /*#__PURE__*/_react.default.createElement(_info.default, {
        poll: this.props.poll
      }), /*#__PURE__*/_react.default.createElement(_select.default, {
        choices: this.state.choices,
        toggleChoice: this.toggleChoice
      }), /*#__PURE__*/_react.default.createElement(_help.default, {
        choicesLeft: this.state.choicesLeft,
        poll: this.props.poll
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _options.getClassName)(controls, 0)
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block btn-sm",
        loading: this.state.isLoading
      }, gettext("Save your vote"))), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _options.getClassName)(controls, 1)
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block btn-sm",
        disabled: this.state.isLoading,
        onClick: this.props.showResults,
        type: "button"
      }, gettext("See results"))), /*#__PURE__*/_react.default.createElement(_options.Edit, {
        controls: controls,
        poll: this.props.poll,
        thread: this.props.thread
      }), /*#__PURE__*/_react.default.createElement(_options.Delete, {
        controls: controls,
        poll: this.props.poll
      })))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../reducers/poll":352,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"../../button":8,"../../form":56,"../info":107,"../results/options":112,"./help":113,"./select":115,"./utils":116,"react":"react"}],115:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.ChoiceSelect = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled poll-select-choices"
  }, props.choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(ChoiceSelect, {
      choice: choice,
      key: choice.hash,
      toggleChoice: props.toggleChoice
    });
  }));
}

var ChoiceSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(ChoiceSelect, _React$Component);

  var _super = _createSuper(ChoiceSelect);

  function ChoiceSelect() {
    var _this;

    _classCallCheck(this, ChoiceSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.props.toggleChoice(_this.props.choice.hash);
    });

    return _this;
  }

  _createClass(ChoiceSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "poll-select-choice"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: this.props.choice.selected ? "btn btn-selected" : "btn",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.props.choice.selected ? "check_box" : "check_box_outline_blank"), /*#__PURE__*/_react.default.createElement("strong", null, this.props.choice.label)));
    }
  }]);

  return ChoiceSelect;
}(_react.default.Component);

exports.ChoiceSelect = ChoiceSelect;

},{"react":"react"}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChoiceFromHash = getChoiceFromHash;
exports.getChoicesLeft = getChoicesLeft;

function getChoiceFromHash(choices, hash) {
  for (var i in choices) {
    var choice = choices[i];

    if (choice.hash === hash) {
      return choice;
    }
  }

  return null;
}

function getChoicesLeft(poll, choices) {
  var selection = [];

  for (var i in choices) {
    var choice = choices[i];

    if (choice.selected) {
      selection.push(choice);
    }
  }

  return poll.allowed_choices - selection.length;
}

},{}],117:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.DiffItem = DiffItem;
exports.getItemClassName = getItemClassName;
exports.cleanItem = cleanItem;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body post-changelog-diff"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, props.diff.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(DiffItem, {
      item: item,
      key: i
    });
  })));
}

function DiffItem(props) {
  if (props.item[0] === "?") return null;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: getItemClassName(props.item)
  }, cleanItem(props.item));
}

function getItemClassName(item) {
  var className = "diff-item";

  if (item[0] === "-") {
    className += " diff-item-sub";
  } else if (item[0] === "+") {
    className += " diff-item-add";
  }

  return className;
}

function cleanItem(item) {
  return item.substr(2);
}

},{"react":"react"}],118:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.props.revertEdit(_this.props.edit.id);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (!this.props.canRevert) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer visible-xs-block"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-default btn-sm btn-block",
        disabled: this.props.disabled,
        onClick: this.onClick,
        title: gettext("Revert post to state from before this edit.")
      }, gettext("Revert")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../button":8,"react":"react"}],119:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialog = ModalDialog;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _diff = _interopRequireDefault(require("./diff"));

var _footer = _interopRequireDefault(require("./footer"));

var _toolbar = _interopRequireDefault(require("./toolbar"));

var _utils = require("./utils");

var _modalMessage = _interopRequireDefault(require("../modal-message"));

var _modalLoader = _interopRequireDefault(require("../modal-loader"));

var post = _interopRequireWildcard(require("../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _modal = _interopRequireDefault(require("../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goToEdit", function () {
      var edit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _this.setState({
        isBusy: true
      });

      var url = _this.props.post.api.edits;

      if (edit !== null) {
        url += "?edit=" + edit;
      }

      _ajax.default.get(url).then(function (data) {
        _this.setState({
          isReady: true,
          isBusy: false,
          edit: (0, _utils.hydrateEdit)(data)
        });
      }, function (rejection) {
        _this.setState({
          isReady: true,
          isBusy: false,
          error: rejection.detail
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "revertEdit", function (edit) {
      if (_this.state.isBusy) return;
      var confirmation = confirm(gettext("Are you sure you with to revert this post to the state from before this edit?"));
      if (!confirmation) return;

      _this.setState({
        isBusy: true
      });

      var url = _this.props.post.api.edits + "?edit=" + edit;

      _ajax.default.post(url).then(function (data) {
        var hydratedPost = post.hydrate(data);

        _store.default.dispatch(post.patch(data, hydratedPost));

        _snackbar.default.success(gettext("Post has been reverted to previous state."));

        _modal.default.hide();
      }, function (rejection) {
        _snackbar.default.apiError(rejection);

        _this.setState({
          isBusy: false
        });
      });
    });

    _this.state = {
      isReady: false,
      isBusy: true,
      canRevert: props.post.acl.can_edit,
      error: null,
      edit: null
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.goToEdit();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement(ModalDialog, {
          className: "modal-dialog modal-message"
        }, /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          message: this.state.error
        }));
      } else if (this.state.isReady) {
        return /*#__PURE__*/_react.default.createElement(ModalDialog, null, /*#__PURE__*/_react.default.createElement(_toolbar.default, {
          canRevert: this.state.canRevert,
          disabled: this.state.isBusy,
          edit: this.state.edit,
          goToEdit: this.goToEdit,
          revertEdit: this.revertEdit
        }), /*#__PURE__*/_react.default.createElement(_diff.default, {
          diff: this.state.edit.diff
        }), /*#__PURE__*/_react.default.createElement(_footer.default, {
          canRevert: this.state.canRevert,
          disabled: this.state.isBusy,
          edit: this.state.edit,
          revertEdit: this.revertEdit
        }));
      }

      return /*#__PURE__*/_react.default.createElement(ModalDialog, null, /*#__PURE__*/_react.default.createElement(_modalLoader.default, null));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function ModalDialog(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className || "modal-dialog",
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Post edits history"))), props.children));
}

},{"../../reducers/post":353,"../../services/ajax":365,"../../services/modal":371,"../../services/snackbar":376,"../../services/store":377,"../modal-loader":61,"../modal-message":62,"./diff":117,"./footer":118,"./toolbar":120,"./utils":121,"react":"react"}],120:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoBackBtn = GoBackBtn;
exports.GoForwardBtn = GoForwardBtn;
exports.GoLastBtn = GoLastBtn;
exports.RevertBtn = RevertBtn;
exports.Label = Label;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _escapeHtml = _interopRequireDefault(require("../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "goLast", function () {
      _this.props.goToEdit();
    });

    _defineProperty(_assertThisInitialized(_this), "goForward", function () {
      _this.props.goToEdit(_this.props.edit.next);
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      _this.props.goToEdit(_this.props.edit.previous);
    });

    _defineProperty(_assertThisInitialized(_this), "revertEdit", function () {
      _this.props.revertEdit(_this.props.edit.id);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-toolbar post-changelog-toolbar"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react.default.createElement(GoBackBtn, {
        disabled: this.props.disabled,
        edit: this.props.edit,
        onClick: this.goBack
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react.default.createElement(GoForwardBtn, {
        disabled: this.props.disabled,
        edit: this.props.edit,
        onClick: this.goForward
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react.default.createElement(GoLastBtn, {
        disabled: this.props.disabled,
        edit: this.props.edit,
        onClick: this.goLast
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-5 xs-margin-top-half post-change-label"
      }, /*#__PURE__*/_react.default.createElement(Label, {
        edit: this.props.edit
      })), /*#__PURE__*/_react.default.createElement(RevertBtn, {
        canRevert: this.props.canRevert,
        disabled: this.props.disabled,
        onClick: this.revertEdit
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function GoBackBtn(props) {
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn-default btn-block btn-icon btn-sm",
    disabled: props.disabled || !props.edit.previous,
    onClick: props.onClick,
    title: gettext("See previous change")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chevron_left"));
}

function GoForwardBtn(props) {
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn-default btn-block btn-icon btn-sm",
    disabled: props.disabled || !props.edit.next,
    onClick: props.onClick,
    title: gettext("See next change")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chevron_right"));
}

function GoLastBtn(props) {
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn-default btn-block btn-icon btn-sm",
    disabled: props.disabled || !props.edit.next,
    onClick: props.onClick,
    title: gettext("See previous change")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "last_page"));
}

function RevertBtn(props) {
  if (!props.canRevert) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-3 hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn-default btn-sm btn-block",
    disabled: props.disabled,
    onClick: props.onClick,
    title: gettext("Revert post to state from before this edit.")
  }, gettext("Revert")));
}

function Label(props) {
  var user = null;

  if (props.edit.url.editor) {
    user = interpolate(USER_URL, {
      url: (0, _escapeHtml.default)(props.edit.url.editor),
      user: (0, _escapeHtml.default)(props.edit.editor_name)
    }, true);
  } else {
    user = interpolate(USER_SPAN, {
      user: (0, _escapeHtml.default)(props.edit.editor_name)
    }, true);
  }

  var date = interpolate(DATE_ABBR, {
    absolute: (0, _escapeHtml.default)(props.edit.edited_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.edit.edited_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("By %(edited_by)s %(edited_on)s.")), {
    edited_by: user,
    edited_on: date
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

},{"../../utils/escape-html":383,"../button":8,"react":"react"}],121:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrateEdit = hydrateEdit;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hydrateEdit(json) {
  return Object.assign({}, json, {
    edited_on: (0, _moment.default)(json.edited_on)
  });
}

},{"moment":"moment"}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _post = _interopRequireDefault(require("./post"));

var _preview = _interopRequireDefault(require("./preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var isReady = _ref.isReady,
      posts = _ref.posts,
      poster = _ref.poster;

  if (!isReady) {
    return /*#__PURE__*/_react.default.createElement(_preview.default, null);
  }

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "posts-list post-feed ui-ready"
  }, posts.map(function (post) {
    return /*#__PURE__*/_react.default.createElement(_post.default, {
      key: post.id,
      post: post,
      poster: poster
    });
  }));
}

},{"./post":125,"./preview":131,"react":"react"}],123:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Default = Default;
exports.Invalid = Invalid;

var _react = _interopRequireDefault(require("react"));

var _misagoMarkup = _interopRequireDefault(require("../../misago-markup"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (props.post.content) {
    return /*#__PURE__*/_react.default.createElement(Default, props);
  } else {
    return /*#__PURE__*/_react.default.createElement(Invalid, props);
  }
}

function Default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-body"
  }, /*#__PURE__*/_react.default.createElement(_misagoMarkup.default, {
    markup: props.post.content
  }));
}

function Invalid(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-body post-body-invalid"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("This post's contents cannot be displayed.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-muted"
  }, gettext("This error is caused by invalid post content manipulation.")));
}

},{"../../../utils/escape-html":383,"../../misago-markup":60,"react":"react"}],124:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post;
  var category = post.category,
      thread = post.thread;
  var tooltip = interpolate(gettext("posted %(posted_on)s"), {
    posted_on: post.posted_on.format("LL, LT")
  }, true);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-heading"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-link item-title",
    href: thread.url
  }, thread.title), /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-link post-category",
    href: category.url.index
  }, category.name), /*#__PURE__*/_react.default.createElement("a", {
    href: post.url.index,
    className: "btn btn-link posted-on",
    title: tooltip
  }, post.posted_on.fromNow()));
}

},{"react":"react"}],125:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _body = _interopRequireDefault(require("./body"));

var _header = _interopRequireDefault(require("./header"));

var _postSide = _interopRequireDefault(require("./post-side"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post,
      poster = _ref.poster;
  var user = poster || post.poster;
  var className = "post";

  if (user && user.rank.css_class) {
    className += " post-" + user.rank.css_class;
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: className,
    id: "post-" + post.id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement(_postSide.default, {
    post: post,
    poster: user
  }), /*#__PURE__*/_react.default.createElement(_header.default, {
    post: post
  }), /*#__PURE__*/_react.default.createElement(_body.default, {
    post: post
  }))));
}

},{"./body":123,"./header":124,"./post-side":128,"react":"react"}],126:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

var _button = _interopRequireDefault(require("./button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-side post-side-anonymous"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    post: post
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "poster-avatar",
    size: 50
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "item-title"
  }, post.poster_name)), /*#__PURE__*/_react.default.createElement("span", {
    className: "user-title user-title-anonymous"
  }, gettext("Removed user")))));
}

},{"../../../avatar":6,"./button":127,"react":"react"}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-default btn-icon pull-right",
    href: post.url.index
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-text-left hidden-xs"
  }, gettext("See post")), /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chevron_right"));
}

},{"react":"react"}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _anonymous = _interopRequireDefault(require("./anonymous"));

var _registered = _interopRequireDefault(require("./registered"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post,
      poster = _ref.poster;

  if (poster.id) {
    return /*#__PURE__*/_react.default.createElement(_registered.default, {
      post: post,
      poster: poster
    });
  }

  return /*#__PURE__*/_react.default.createElement(_anonymous.default, {
    post: post
  });
}

},{"./anonymous":126,"./registered":129,"react":"react"}],129:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

var _button = _interopRequireDefault(require("./button"));

var _userTitle = _interopRequireDefault(require("./user-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post,
      poster = _ref.poster;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-side post-side-registered"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    post: post
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: poster.url
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "poster-avatar",
    size: 50,
    user: poster
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "item-title",
    href: poster.url
  }, poster.username)), /*#__PURE__*/_react.default.createElement(_userTitle.default, {
    title: poster.title,
    rank: poster.rank
  }))));
}

},{"../../../avatar":6,"./button":127,"./user-title":130,"react":"react"}],130:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var rank = _ref.rank,
      title = _ref.title;
  var userTitle = title || rank.title || rank.name;
  var className = "user-title";

  if (rank.css_class) {
    className += " user-title-" + rank.css_class;
  }

  if (rank.is_tab) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: className,
      href: rank.url
    }, userTitle);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, userTitle);
}

},{"react":"react"}],131:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var random = _interopRequireWildcard(require("../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default() {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "posts-list post-feed ui-preview"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "post-side post-side-anonymous"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "poster-avatar",
    size: 50
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "item-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0"))), /*#__PURE__*/_react.default.createElement("span", {
    className: "user-title user-title-anonymous"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "post-heading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
    className: "post-body"
  }, /*#__PURE__*/_react.default.createElement("article", {
    className: "misago-markup"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0"), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0"), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 200) + "px"
    }
  }, "\xA0"))))))));
}

},{"../../utils/random":388,"../avatar":6,"react":"react"}],132:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrateLike = hydrateLike;
exports.ModalDialog = ModalDialog;
exports.LikesList = LikesList;
exports.LikeDetails = LikeDetails;
exports.LikeDate = LikeDate;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _avatar = _interopRequireDefault(require("./avatar"));

var _modalMessage = _interopRequireDefault(require("./modal-message"));

var _modalLoader = _interopRequireDefault(require("./modal-loader"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isReady: false,
      error: null,
      likes: []
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.post.api.likes).then(function (data) {
        _this2.setState({
          isReady: true,
          likes: data.map(hydrateLike)
        });
      }, function (rejection) {
        _this2.setState({
          isReady: true,
          error: rejection.detail
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement(ModalDialog, {
          className: "modal-message"
        }, /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          message: this.state.error
        }));
      } else if (this.state.isReady) {
        if (this.state.likes.length) {
          return /*#__PURE__*/_react.default.createElement(ModalDialog, {
            className: "modal-sm",
            likes: this.state.likes
          }, /*#__PURE__*/_react.default.createElement(LikesList, {
            likes: this.state.likes
          }));
        }

        return /*#__PURE__*/_react.default.createElement(ModalDialog, {
          className: "modal-message"
        }, /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          message: gettext("No users have liked this post.")
        }));
      }

      return /*#__PURE__*/_react.default.createElement(ModalDialog, {
        className: "modal-sm"
      }, /*#__PURE__*/_react.default.createElement(_modalLoader.default, null));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function hydrateLike(data) {
  return Object.assign({}, data, {
    liked_on: (0, _moment.default)(data.liked_on)
  });
}

function ModalDialog(_ref) {
  var className = _ref.className,
      children = _ref.children,
      likes = _ref.likes;
  var title = gettext("Post Likes");

  if (likes) {
    var likesCount = likes.length;
    var message = ngettext("%(likes)s like", "%(likes)s likes", likesCount);
    title = interpolate(message, {
      likes: likesCount
    }, true);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog " + (className || ""),
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, title)), children));
}

function LikesList(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body modal-post-likers"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "media-list"
  }, props.likes.map(function (like) {
    return /*#__PURE__*/_react.default.createElement(LikeDetails, _extends({
      key: like.id
    }, like));
  })));
}

function LikeDetails(props) {
  if (props.url) {
    var user = {
      id: props.liker_id,
      avatars: props.avatars
    };
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "media"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "media-left"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "user-avatar",
      href: props.url
    }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
      size: "50",
      user: user
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "media-body"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "item-title",
      href: props.url
    }, props.username), " ", /*#__PURE__*/_react.default.createElement(LikeDate, {
      likedOn: props.liked_on
    })));
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "user-avatar"
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: "50"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.username), " ", /*#__PURE__*/_react.default.createElement(LikeDate, {
    likedOn: props.liked_on
  })));
}

function LikeDate(props) {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "text-muted",
    title: props.likedOn.format("LLL")
  }, props.likedOn.fromNow());
}

},{"../services/ajax":365,"./avatar":6,"./modal-loader":61,"./modal-message":62,"moment":"moment","react":"react"}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _editor = _interopRequireDefault(require("../editor"));

var _form = _interopRequireDefault(require("../form"));

var _container = _interopRequireDefault(require("./utils/container"));

var _loader = _interopRequireDefault(require("./utils/loader"));

var _message = _interopRequireDefault(require("./utils/message"));

var attachments = _interopRequireWildcard(require("./utils/attachments"));

var _validators = require("./utils/validators");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadSuccess", function (data) {
      _this.setState({
        isReady: true,
        post: data.post,
        attachments: attachments.hydrate(data.attachments),
        protect: data.is_protected,
        canProtect: data.can_protect
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadError", function (rejection) {
      _this.setState({
        isErrored: rejection.detail
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var cancel = confirm(gettext("Are you sure you want to discard changes?"));

      if (cancel) {
        _posting.default.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onProtect", function () {
      _this.setState({
        protect: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUnprotect", function () {
      _this.setState({
        protect: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPostChange", function (event) {
      _this.changeValue("post", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAttachmentsChange", function (attachments) {
      _this.setState({
        attachments: attachments
      });
    });

    _this.state = {
      isReady: false,
      isLoading: false,
      isErrored: false,
      post: "",
      attachments: [],
      protect: false,
      canProtect: false,
      validators: {
        post: (0, _validators.getPostValidators)()
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _ajax.default.get(this.props.config).then(this.loadSuccess, this.loadError);
    }
  }, {
    key: "clean",
    value: function clean() {
      if (!this.state.post.trim().length) {
        _snackbar.default.error(gettext("You have to enter a message."));

        return false;
      }

      var errors = this.validate();

      if (errors.post) {
        _snackbar.default.error(errors.post[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.put(this.props.submit, {
        post: this.state.post,
        attachments: attachments.clean(this.state.attachments),
        protect: this.state.protect
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      _snackbar.default.success(gettext("Reply has been edited."));

      window.location = success.url.index; // keep form loading

      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        var errors = [].concat(rejection.non_field_errors || [], rejection.category || [], rejection.title || [], rejection.post || [], rejection.attachments || []);

        _snackbar.default.error(errors[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isReady) {
        return /*#__PURE__*/_react.default.createElement(_container.default, {
          className: "posting-form"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.handleSubmit,
          method: "POST"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-12"
        }, /*#__PURE__*/_react.default.createElement(_editor.default, {
          attachments: this.state.attachments,
          canProtect: this.state.canProtect,
          loading: this.state.isLoading,
          onAttachmentsChange: this.onAttachmentsChange,
          onCancel: this.onCancel,
          onChange: this.onPostChange,
          onProtect: this.onProtect,
          onUnprotect: this.onUnprotect,
          protect: this.state.protect,
          submitLabel: gettext("Edit reply"),
          value: this.state.post
        })))));
      } else if (this.state.isErrored) {
        return /*#__PURE__*/_react.default.createElement(_message.default, {
          message: this.state.isErrored
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_loader.default, null);
      }
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../services/ajax":365,"../../services/posting":375,"../../services/snackbar":376,"../editor":52,"../form":56,"./utils/attachments":138,"./utils/container":139,"./utils/loader":140,"./utils/message":141,"./utils/validators":144,"react":"react"}],134:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _start = _interopRequireDefault(require("./start"));

var _startPrivate = _interopRequireDefault(require("./start-private"));

var _reply = _interopRequireDefault(require("./reply"));

var _edit = _interopRequireDefault(require("./edit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (props.mode === "START") {
    return /*#__PURE__*/_react.default.createElement(_start.default, props);
  } else if (props.mode === "START_PRIVATE") {
    return /*#__PURE__*/_react.default.createElement(_startPrivate.default, props);
  } else if (props.mode === "REPLY") {
    return /*#__PURE__*/_react.default.createElement(_reply.default, props);
  } else if (props.mode === "EDIT") {
    return /*#__PURE__*/_react.default.createElement(_edit.default, props);
  } else {
    return null;
  }
}

},{"./edit":133,"./reply":135,"./start":137,"./start-private":136,"react":"react"}],135:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _editor = _interopRequireDefault(require("../editor"));

var _form = _interopRequireDefault(require("../form"));

var _container = _interopRequireDefault(require("./utils/container"));

var _loader = _interopRequireDefault(require("./utils/loader"));

var _message = _interopRequireDefault(require("./utils/message"));

var attachments = _interopRequireWildcard(require("./utils/attachments"));

var _validators = require("./utils/validators");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadSuccess", function (data) {
      _this.setState({
        isReady: true,
        post: data.post ? '[quote="@' + data.poster + '"]\n' + data.post + "\n[/quote]" : ""
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadError", function (rejection) {
      _this.setState({
        isErrored: rejection.detail
      });
    });

    _defineProperty(_assertThisInitialized(_this), "appendData", function (data) {
      var newPost = data.post ? '[quote="@' + data.poster + '"]\n' + data.post + "\n[/quote]\n\n" : "";

      _this.setState(function (prevState, props) {
        if (prevState.post.length > 0) {
          return {
            post: prevState.post + "\n\n" + newPost
          };
        }

        return {
          post: newPost
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var cancel = confirm(gettext("Are you sure you want to discard your reply?"));

      if (cancel) {
        _posting.default.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPostChange", function (event) {
      _this.changeValue("post", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAttachmentsChange", function (attachments) {
      _this.setState({
        attachments: attachments
      });
    });

    _this.state = {
      isReady: false,
      isLoading: false,
      isErrored: false,
      post: "",
      attachments: [],
      validators: {
        post: (0, _validators.getPostValidators)()
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _ajax.default.get(this.props.config, this.props.context || null).then(this.loadSuccess, this.loadError);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var context = this.props.context;
      var newContext = nextProps.context;
      if (context && newContext && context.reply === newContext.reply) return;

      _ajax.default.get(nextProps.config, nextProps.context || null).then(this.appendData, _snackbar.default.apiError);
    }
  }, {
    key: "clean",
    value: function clean() {
      if (!this.state.post.trim().length) {
        _snackbar.default.error(gettext("You have to enter a message."));

        return false;
      }

      var errors = this.validate();

      if (errors.post) {
        _snackbar.default.error(errors.post[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.submit, {
        post: this.state.post,
        attachments: attachments.clean(this.state.attachments)
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      _snackbar.default.success(gettext("Your reply has been posted."));

      window.location = success.url.index; // keep form loading

      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        var errors = [].concat(rejection.non_field_errors || [], rejection.post || [], rejection.attachments || []);

        _snackbar.default.error(errors[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isReady) {
        return /*#__PURE__*/_react.default.createElement(_container.default, {
          className: "posting-form"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.handleSubmit,
          method: "POST"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-12"
        }, /*#__PURE__*/_react.default.createElement(_editor.default, {
          attachments: this.state.attachments,
          loading: this.state.isLoading,
          onAttachmentsChange: this.onAttachmentsChange,
          onCancel: this.onCancel,
          onChange: this.onPostChange,
          submitLabel: gettext("Post reply"),
          value: this.state.post
        })))));
      } else if (this.state.isErrored) {
        return /*#__PURE__*/_react.default.createElement(_message.default, {
          message: this.state.isErrored
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_loader.default, null);
      }
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../services/ajax":365,"../../services/posting":375,"../../services/snackbar":376,"../editor":52,"../form":56,"./utils/attachments":138,"./utils/container":139,"./utils/loader":140,"./utils/message":141,"./utils/validators":144,"react":"react"}],136:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _editor = _interopRequireDefault(require("../editor"));

var _form = _interopRequireDefault(require("../form"));

var _container = _interopRequireDefault(require("./utils/container"));

var _message = _interopRequireDefault(require("./utils/message"));

var attachments = _interopRequireWildcard(require("./utils/attachments"));

var _usernames = _interopRequireDefault(require("./utils/usernames"));

var _validators = require("./utils/validators");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var cancel = confirm(gettext("Are you sure you want to discard private thread?"));

      if (cancel) {
        _posting.default.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onToChange", function (event) {
      _this.changeValue("to", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onTitleChange", function (event) {
      _this.changeValue("title", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onPostChange", function (event) {
      _this.changeValue("post", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAttachmentsChange", function (attachments) {
      _this.setState({
        attachments: attachments
      });
    });

    var to = (props.to || []).map(function (user) {
      return user.username;
    }).join(", ");
    _this.state = {
      isLoading: false,
      to: to,
      title: "",
      post: "",
      attachments: [],
      validators: {
        title: (0, _validators.getTitleValidators)(),
        post: (0, _validators.getPostValidators)()
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!(0, _usernames.default)(this.state.to).length) {
        _snackbar.default.error(gettext("You have to enter at least one recipient."));

        return false;
      }

      if (!this.state.title.trim().length) {
        _snackbar.default.error(gettext("You have to enter thread title."));

        return false;
      }

      if (!this.state.post.trim().length) {
        _snackbar.default.error(gettext("You have to enter a message."));

        return false;
      }

      var errors = this.validate();

      if (errors.title) {
        _snackbar.default.error(errors.title[0]);

        return false;
      }

      if (errors.post) {
        _snackbar.default.error(errors.post[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.submit, {
        to: (0, _usernames.default)(this.state.to),
        title: this.state.title,
        post: this.state.post,
        attachments: attachments.clean(this.state.attachments)
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      _snackbar.default.success(gettext("Your thread has been posted."));

      window.location = success.url; // keep form loading

      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        var errors = [].concat(rejection.non_field_errors || [], rejection.to || [], rejection.title || [], rejection.post || [], rejection.attachments || []);

        _snackbar.default.error(errors[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_container.default, {
        className: "posting-form",
        withFirstRow: true
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row first-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.onToChange,
        placeholder: gettext("Comma separated list of user names, eg.: Danny, Lisa"),
        type: "text",
        value: this.state.to
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row first-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.onTitleChange,
        placeholder: gettext("Thread title"),
        type: "text",
        value: this.state.title
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_editor.default, {
        attachments: this.state.attachments,
        loading: this.state.isLoading,
        onAttachmentsChange: this.onAttachmentsChange,
        onCancel: this.onCancel,
        onChange: this.onPostChange,
        submitLabel: gettext("Post thread"),
        value: this.state.post
      })))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../services/ajax":365,"../../services/posting":375,"../../services/snackbar":376,"../editor":52,"../form":56,"./utils/attachments":138,"./utils/container":139,"./utils/message":141,"./utils/usernames":143,"./utils/validators":144,"react":"react"}],137:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _categorySelect = _interopRequireDefault(require("../category-select"));

var _editor = _interopRequireDefault(require("../editor"));

var _form = _interopRequireDefault(require("../form"));

var _container = _interopRequireDefault(require("./utils/container"));

var _loader = _interopRequireDefault(require("./utils/loader"));

var _message = _interopRequireDefault(require("./utils/message"));

var _options = _interopRequireDefault(require("./utils/options"));

var attachments = _interopRequireWildcard(require("./utils/attachments"));

var _validators = require("./utils/validators");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadSuccess", function (data) {
      var category = null;
      var showOptions = false;
      var categoryOptions = null; // hydrate categories, extract posting options

      var categories = data.map(function (item) {
        // pick first category that allows posting and if it may, override it with initial one
        if (item.post !== false && (!category || item.id == _this.state.category)) {
          category = item.id;
          categoryOptions = item.post;
        }

        if (item.post && (item.post.close || item.post.hide || item.post.pin)) {
          showOptions = true;
        }

        return Object.assign(item, {
          disabled: item.post === false,
          label: item.name,
          value: item.id
        });
      });

      _this.setState({
        isReady: true,
        showOptions: showOptions,
        categories: categories,
        category: category,
        categoryOptions: categoryOptions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadError", function (rejection) {
      _this.setState({
        isErrored: rejection.detail
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var cancel = confirm(gettext("Are you sure you want to discard thread?"));

      if (cancel) {
        _posting.default.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTitleChange", function (event) {
      _this.changeValue("title", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onCategoryChange", function (event) {
      var category = _this.state.categories.find(function (item) {
        return event.target.value == item.value;
      }); // if selected pin is greater than allowed, reduce it


      var pin = _this.state.pin;

      if (category.post.pin && category.post.pin < pin) {
        pin = category.post.pin;
      }

      _this.setState({
        category: category.id,
        categoryOptions: category.post,
        pin: pin
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPostChange", function (event) {
      _this.changeValue("post", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAttachmentsChange", function (attachments) {
      _this.setState({
        attachments: attachments
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.changeValue("close", true);
    });

    _defineProperty(_assertThisInitialized(_this), "onOpen", function () {
      _this.changeValue("close", false);
    });

    _defineProperty(_assertThisInitialized(_this), "onPinGlobally", function () {
      _this.changeValue("pin", 2);
    });

    _defineProperty(_assertThisInitialized(_this), "onPinLocally", function () {
      _this.changeValue("pin", 1);
    });

    _defineProperty(_assertThisInitialized(_this), "onUnpin", function () {
      _this.changeValue("pin", 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onHide", function () {
      _this.changeValue("hide", true);
    });

    _defineProperty(_assertThisInitialized(_this), "onUnhide", function () {
      _this.changeValue("hide", false);
    });

    _this.state = {
      isReady: false,
      isLoading: false,
      isErrored: false,
      showOptions: false,
      categoryOptions: null,
      title: "",
      category: props.category || null,
      categories: [],
      post: "",
      attachments: [],
      close: false,
      hide: false,
      pin: 0,
      validators: {
        title: (0, _validators.getTitleValidators)(),
        post: (0, _validators.getPostValidators)()
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _ajax.default.get(this.props.config).then(this.loadSuccess, this.loadError);
    }
  }, {
    key: "clean",
    value: function clean() {
      if (!this.state.title.trim().length) {
        _snackbar.default.error(gettext("You have to enter thread title."));

        return false;
      }

      if (!this.state.post.trim().length) {
        _snackbar.default.error(gettext("You have to enter a message."));

        return false;
      }

      var errors = this.validate();

      if (errors.title) {
        _snackbar.default.error(errors.title[0]);

        return false;
      }

      if (errors.post) {
        _snackbar.default.error(errors.post[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.submit, {
        title: this.state.title,
        category: this.state.category,
        post: this.state.post,
        attachments: attachments.clean(this.state.attachments),
        close: this.state.close,
        hide: this.state.hide,
        pin: this.state.pin
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      _snackbar.default.success(gettext("Your thread has been posted."));

      window.location = success.url; // keep form loading

      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        var errors = [].concat(rejection.non_field_errors || [], rejection.category || [], rejection.title || [], rejection.post || [], rejection.attachments || []);

        _snackbar.default.error(errors[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isErrored) {
        return /*#__PURE__*/_react.default.createElement(_message.default, {
          message: this.state.isErrored
        });
      }

      if (!this.state.isReady) {
        return /*#__PURE__*/_react.default.createElement(_loader.default, null);
      }

      var columns = 0;
      if (this.state.categoryOptions.close) columns += 1;
      if (this.state.categoryOptions.hide) columns += 1;
      if (this.state.categoryOptions.pin) columns += 1;
      var titleStyle = null;

      if (columns === 1) {
        titleStyle = "col-sm-6";
      } else {
        titleStyle = "col-sm-8";
      }

      if (columns === 3) {
        titleStyle += " col-md-6";
      } else if (columns) {
        titleStyle += " col-md-7";
      } else {
        titleStyle += " col-md-9";
      }

      return /*#__PURE__*/_react.default.createElement(_container.default, {
        className: "posting-form",
        withFirstRow: true
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row first-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: titleStyle
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.onTitleChange,
        placeholder: gettext("Thread title"),
        type: "text",
        value: this.state.title
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-4 col-md-3 xs-margin-top"
      }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
        choices: this.state.categories,
        disabled: this.state.isLoading,
        onChange: this.onCategoryChange,
        value: this.state.category
      })), /*#__PURE__*/_react.default.createElement(_options.default, {
        close: this.state.close,
        columns: columns,
        disabled: this.state.isLoading,
        hide: this.state.hide,
        onClose: this.onClose,
        onHide: this.onHide,
        onOpen: this.onOpen,
        onPinGlobally: this.onPinGlobally,
        onPinLocally: this.onPinLocally,
        onUnhide: this.onUnhide,
        onUnpin: this.onUnpin,
        options: this.state.categoryOptions,
        pin: this.state.pin,
        showOptions: this.state.showOptions
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-12"
      }, /*#__PURE__*/_react.default.createElement(_editor.default, {
        attachments: this.state.attachments,
        loading: this.state.isLoading,
        onAttachmentsChange: this.onAttachmentsChange,
        onCancel: this.onCancel,
        onChange: this.onPostChange,
        submitLabel: gettext("Post thread"),
        value: this.state.post
      })))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../services/ajax":365,"../../services/posting":375,"../../services/snackbar":376,"../category-select":21,"../editor":52,"../form":56,"./utils/attachments":138,"./utils/container":139,"./utils/loader":140,"./utils/message":141,"./utils/options":142,"./utils/validators":144,"react":"react"}],138:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clean = clean;
exports.hydrate = hydrate;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clean(attachments) {
  var completedAttachments = attachments.filter(function (attachment) {
    return attachment.id && !attachment.isRemoved;
  });
  return completedAttachments.map(function (a) {
    return a.id;
  });
}

function hydrate(attachments) {
  return attachments.map(function (attachment) {
    return Object.assign({}, attachment, {
      uploaded_on: (0, _moment.default)(attachment.uploaded_on)
    });
  });
}

},{"moment":"moment"}],139:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, props.children));
}

},{"react":"react"}],140:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _container = _interopRequireDefault(require("./container"));

var _loader = _interopRequireDefault(require("../../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_container.default, {
    className: "posting-loader"
  }, /*#__PURE__*/_react.default.createElement(_loader.default, null));
}

},{"../../loader":58,"./container":139,"react":"react"}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _container = _interopRequireDefault(require("./container"));

var _posting = _interopRequireDefault(require("../../../services/posting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_container.default, {
    className: "posting-message"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "error_outline"), props.message), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: _posting.default.close
  }, gettext("Dismiss"))));
}

},{"../../../services/posting":375,"./container":139,"react":"react"}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.CloseOptions = CloseOptions;
exports.HideOptions = HideOptions;
exports.PinOptions = PinOptions;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (!props.showOptions) return null;
  var columns = props.columns;
  var className = "col-xs-12 xs-margin-top";

  if (columns === 1) {
    className += " col-sm-2";
  } else {
    className += " sm-margin-top";
  }

  if (columns === 3) {
    className += " col-md-3";
  } else {
    className += " col-md-2";
  }

  className += " posting-options";
  var columnClassName = "col-xs-" + 12 / columns;
  var textClassName = "btn-text";

  if (columns === 3) {
    textClassName += " visible-sm-inline-block";
  } else if (columns === 2) {
    textClassName += " hidden-md hidden-lg";
  } else {
    textClassName += " hidden-sm";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(PinOptions, {
    className: columnClassName,
    disabled: props.disabled,
    onPinGlobally: props.onPinGlobally,
    onPinLocally: props.onPinLocally,
    onUnpin: props.onUnpin,
    pin: props.pin,
    show: props.options.pin,
    textClassName: textClassName
  }), /*#__PURE__*/_react.default.createElement(HideOptions, {
    className: columnClassName,
    disabled: props.disabled,
    hide: props.hide,
    onHide: props.onHide,
    onUnhide: props.onUnhide,
    show: props.options.hide,
    textClassName: textClassName
  }), /*#__PURE__*/_react.default.createElement(CloseOptions, {
    className: columnClassName,
    close: props.close,
    disabled: props.disabled,
    onClose: props.onClose,
    onOpen: props.onOpen,
    show: props.options.close,
    textClassName: textClassName
  })));
}

function CloseOptions(props) {
  if (!props.show) return null;
  var label = props.close ? gettext("Closed") : gettext("Open");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-block",
    disabled: props.disabled,
    onClick: props.close ? props.onOpen : props.onClose,
    title: label,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, props.close ? "lock" : "lock_outline"), /*#__PURE__*/_react.default.createElement("span", {
    className: props.textClassName
  }, label)));
}

function HideOptions(props) {
  if (!props.show) return null;
  var label = props.hide ? gettext("Hidden") : gettext("Not hidden");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-block",
    disabled: props.disabled,
    onClick: props.hide ? props.onUnhide : props.onHide,
    title: label,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, props.hide ? "visibility_off" : "visibility"), /*#__PURE__*/_react.default.createElement("span", {
    className: props.textClassName
  }, label)));
}

function PinOptions(props) {
  if (!props.show) return null;
  var icon = null;
  var onClick = null;
  var label = null;

  switch (props.pin) {
    case 0:
      icon = "radio_button_unchecked";
      onClick = props.onPinLocally;
      label = gettext("Unpinned");
      break;

    case 1:
      icon = "bookmark_outline";
      onClick = props.onPinGlobally;
      label = gettext("Pinned locally");

      if (props.show == 2) {
        onClick = props.onPinGlobally;
      } else {
        onClick = props.onUnpin;
      }

      break;

    case 2:
      icon = "bookmark";
      onClick = props.onUnpin;
      label = gettext("Pinned globally");
      break;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-block",
    disabled: props.disabled,
    onClick: onClick,
    title: label,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: props.textClassName
  }, label)));
}

},{"react":"react"}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(usernames) {
  var normalisedNames = usernames.split(",").map(function (i) {
    return i.trim().toLowerCase();
  });
  var removedBlanks = normalisedNames.filter(function (i) {
    return i.length > 0;
  });
  var removedDuplicates = removedBlanks.filter(function (name, pos) {
    return removedBlanks.indexOf(name) == pos;
  });
  return removedDuplicates;
}

},{}],144:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitleValidators = getTitleValidators;
exports.getPostValidators = getPostValidators;
exports.getTitleLengthMin = getTitleLengthMin;
exports.getTitleLengthMax = getTitleLengthMax;
exports.validatePostLengthMin = validatePostLengthMin;
exports.validatePostLengthMax = validatePostLengthMax;

var _validators = require("../../../utils/validators");

var _ = _interopRequireDefault(require("../../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTitleValidators() {
  return [getTitleLengthMin(), getTitleLengthMax()];
}

function getPostValidators() {
  if (_.default.get("SETTINGS").post_length_max) {
    return [validatePostLengthMin(), validatePostLengthMax()];
  } else {
    return [validatePostLengthMin()];
  }
}

function getTitleLengthMin() {
  return (0, _validators.minLength)(_.default.get("SETTINGS").thread_title_length_min, function (limitValue, length) {
    var message = ngettext("Thread title should be at least %(limit_value)s character long (it has %(show_value)s).", "Thread title should be at least %(limit_value)s characters long (it has %(show_value)s).", limitValue);
    return interpolate(message, {
      limit_value: limitValue,
      show_value: length
    }, true);
  });
}

function getTitleLengthMax() {
  return (0, _validators.maxLength)(_.default.get("SETTINGS").thread_title_length_max, function (limitValue, length) {
    var message = ngettext("Thread title cannot be longer than %(limit_value)s character (it has %(show_value)s).", "Thread title cannot be longer than %(limit_value)s characters (it has %(show_value)s).", limitValue);
    return interpolate(message, {
      limit_value: limitValue,
      show_value: length
    }, true);
  });
}

function validatePostLengthMin() {
  return (0, _validators.minLength)(_.default.get("SETTINGS").post_length_min, function (limitValue, length) {
    var message = ngettext("Posted message should be at least %(limit_value)s character long (it has %(show_value)s).", "Posted message should be at least %(limit_value)s characters long (it has %(show_value)s).", limitValue);
    return interpolate(message, {
      limit_value: limitValue,
      show_value: length
    }, true);
  });
}

function validatePostLengthMax() {
  return (0, _validators.maxLength)(_.default.get("SETTINGS").post_length_max || 1000000, function (limitValue, length) {
    var message = ngettext("Posted message cannot be longer than %(limit_value)s character (it has %(show_value)s).", "Posted message cannot be longer than %(limit_value)s characters (it has %(show_value)s).", limitValue);
    return interpolate(message, {
      limit_value: limitValue,
      show_value: length
    }, true);
  });
}

},{"../../..":302,"../../../utils/validators":393}],145:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.isVisible = isVisible;
exports.Delete = exports.Unhide = exports.Hide = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var post = _interopRequireWildcard(require("../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  if (isVisible(props.post.acl)) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "event-controls"
    }, /*#__PURE__*/_react.default.createElement(Hide, props), /*#__PURE__*/_react.default.createElement(Unhide, props), /*#__PURE__*/_react.default.createElement(Delete, props));
  } else {
    return null;
  }
}

function isVisible(acl) {
  return acl.can_hide;
}

var Hide = /*#__PURE__*/function (_React$Component) {
  _inherits(Hide, _React$Component);

  var _super = _createSuper(Hide);

  function Hide() {
    var _this;

    _classCallCheck(this, Hide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _store.default.dispatch(post.patch(_this.props.post, {
        is_hidden: true,
        hidden_on: (0, _moment.default)(),
        hidden_by_name: _this.props.user.username,
        url: Object.assign(_this.props.post.url, {
          hidden_by: _this.props.user.url
        })
      }));

      var op = {
        op: "replace",
        path: "is-hidden",
        value: true
      };

      _ajax.default.patch(_this.props.post.api.index, [op]).then(function (patch) {
        _store.default.dispatch(post.patch(_this.props.post, patch));
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail[0]);
        } else {
          _snackbar.default.apiError(rejection);
        }

        _store.default.dispatch(post.patch(_this.props.post, {
          is_hidden: false
        }));
      });
    });

    return _this;
  }

  _createClass(Hide, [{
    key: "render",
    value: function render() {
      if (!this.props.post.is_hidden) {
        return /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn-link",
          onClick: this.onClick
        }, gettext("Hide"));
      } else {
        return null;
      }
    }
  }]);

  return Hide;
}(_react.default.Component);

exports.Hide = Hide;

var Unhide = /*#__PURE__*/function (_React$Component2) {
  _inherits(Unhide, _React$Component2);

  var _super2 = _createSuper(Unhide);

  function Unhide() {
    var _this2;

    _classCallCheck(this, Unhide);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      _store.default.dispatch(post.patch(_this2.props.post, {
        is_hidden: false
      }));

      var op = {
        op: "replace",
        path: "is-hidden",
        value: false
      };

      _ajax.default.patch(_this2.props.post.api.index, [op]).then(function (patch) {
        _store.default.dispatch(post.patch(_this2.props.post, patch));
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail[0]);
        } else {
          _snackbar.default.apiError(rejection);
        }

        _store.default.dispatch(post.patch(_this2.props.post, {
          is_hidden: true
        }));
      });
    });

    return _this2;
  }

  _createClass(Unhide, [{
    key: "render",
    value: function render() {
      if (this.props.post.is_hidden) {
        return /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn-link",
          onClick: this.onClick
        }, gettext("Unhide"));
      } else {
        return null;
      }
    }
  }]);

  return Unhide;
}(_react.default.Component);

exports.Unhide = Unhide;

var Delete = /*#__PURE__*/function (_React$Component3) {
  _inherits(Delete, _React$Component3);

  var _super3 = _createSuper(Delete);

  function Delete() {
    var _this3;

    _classCallCheck(this, Delete);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      var decision = confirm(gettext("Are you sure you wish to delete this event? This action is not reversible!"));

      if (decision) {
        _this3.delete();
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "delete", function () {
      _store.default.dispatch(post.patch(_this3.props.post, {
        isDeleted: true
      }));

      _ajax.default.delete(_this3.props.post.api.index).then(function () {
        _snackbar.default.success(gettext("Event has been deleted."));
      }, function (rejection) {
        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail[0]);
        } else {
          _snackbar.default.apiError(rejection);
        }

        _store.default.dispatch(post.patch(_this3.props.post, {
          isDeleted: false
        }));
      });
    });

    return _this3;
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, gettext("Delete"));
    }
  }]);

  return Delete;
}(_react.default.Component);

exports.Delete = Delete;

},{"../../../reducers/post":353,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"moment":"moment","react":"react"}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON = {
  changed_title: "edit",
  pinned_globally: "bookmark",
  pinned_locally: "bookmark_border",
  unpinned: "panorama_fish_eye",
  moved: "arrow_forward",
  merged: "call_merge",
  approved: "done",
  opened: "lock_open",
  closed: "lock_outline",
  unhid: "visibility",
  hid: "visibility_off",
  changed_owner: "grade",
  tookover: "grade",
  added_participant: "person_add",
  owner_left: "person_outline",
  participant_left: "person_outline",
  removed_participant: "remove_circle_outline"
};

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-avatar"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, ICON[props.post.event_type]));
}

},{"react":"react"}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("./icon"));

var _info = _interopRequireDefault(require("./info"));

var _message = _interopRequireDefault(require("./message"));

var _unreadLabel = _interopRequireDefault(require("./unread-label"));

var _waypoint = _interopRequireDefault(require("../waypoint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var className = "event";

  if (props.post.isDeleted) {
    className = "hide";
  } else if (props.post.is_hidden) {
    className = "event post-hidden";
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    id: "post-" + props.post.id,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_unreadLabel.default, {
    post: props.post
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-2 col-sm-3 text-right"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-10 col-sm-9 text-left"
  }, /*#__PURE__*/_react.default.createElement(_waypoint.default, {
    post: props.post
  }, /*#__PURE__*/_react.default.createElement(_message.default, props), /*#__PURE__*/_react.default.createElement(_info.default, props)))));
}

},{"../waypoint":173,"./icon":146,"./info":148,"./message":149,"./unread-label":150,"react":"react"}],148:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Hidden = Hidden;
exports.Poster = Poster;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

var _controls = _interopRequireDefault(require("./controls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var DATE_URL = '<a href="%(url)s" title="%(absolute)s">%(relative)s</a>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline event-info"
  }, /*#__PURE__*/_react.default.createElement(Hidden, props), /*#__PURE__*/_react.default.createElement(Poster, props), /*#__PURE__*/_react.default.createElement(_controls.default, props));
}

function Hidden(props) {
  if (props.post.is_hidden) {
    var user = null;

    if (props.post.url.hidden_by) {
      user = interpolate(USER_URL, {
        url: (0, _escapeHtml.default)(props.post.url.hidden_by),
        user: (0, _escapeHtml.default)(props.post.hidden_by_name)
      }, true);
    } else {
      user = interpolate(USER_SPAN, {
        user: (0, _escapeHtml.default)(props.post.hidden_by_name)
      }, true);
    }

    var date = interpolate(DATE_ABBR, {
      absolute: (0, _escapeHtml.default)(props.post.hidden_on.format("LLL")),
      relative: (0, _escapeHtml.default)(props.post.hidden_on.fromNow())
    }, true);
    var message = interpolate((0, _escapeHtml.default)(gettext("Hidden by %(event_by)s %(event_on)s.")), {
      event_by: user,
      event_on: date
    }, true);
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "event-hidden-message",
      dangerouslySetInnerHTML: {
        __html: message
      }
    });
  } else {
    return null;
  }
}

function Poster(props) {
  var user = null;

  if (props.post.poster) {
    user = interpolate(USER_URL, {
      url: (0, _escapeHtml.default)(props.post.poster.url),
      user: (0, _escapeHtml.default)(props.post.poster_name)
    }, true);
  } else {
    user = interpolate(USER_SPAN, {
      user: (0, _escapeHtml.default)(props.post.poster_name)
    }, true);
  }

  var date = interpolate(DATE_URL, {
    url: (0, _escapeHtml.default)(props.post.url.index),
    absolute: (0, _escapeHtml.default)(props.post.posted_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.post.posted_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("By %(event_by)s %(event_on)s.")), {
    event_by: user,
    event_on: date
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "event-posters",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

},{"../../../utils/escape-html":383,"./controls":145,"react":"react"}],149:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.ChangedTitle = ChangedTitle;
exports.Moved = Moved;
exports.Merged = Merged;
exports.ChangedOwner = ChangedOwner;
exports.AddedParticipant = AddedParticipant;
exports.RemovedParticipant = RemovedParticipant;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = {
  pinned_globally: gettext("Thread has been pinned globally."),
  pinned_locally: gettext("Thread has been pinned locally."),
  unpinned: gettext("Thread has been unpinned."),
  approved: gettext("Thread has been approved."),
  opened: gettext("Thread has been opened."),
  closed: gettext("Thread has been closed."),
  unhid: gettext("Thread has been revealed."),
  hid: gettext("Thread has been made hidden."),
  tookover: gettext("Took thread over."),
  owner_left: gettext("Owner has left thread. This thread is now closed."),
  participant_left: gettext("Participant has left thread.")
};
var ITEM_LINK = '<a href="%(url)s" class="item-title">%(name)s</a>';
var ITEM_SPAN = '<span class="item-title">%(name)s</span>';

function _default(props) {
  if (MESSAGE[props.post.event_type]) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "event-message"
    }, MESSAGE[props.post.event_type]);
  } else if (props.post.event_type === "changed_title") {
    return /*#__PURE__*/_react.default.createElement(ChangedTitle, props);
  } else if (props.post.event_type === "moved") {
    return /*#__PURE__*/_react.default.createElement(Moved, props);
  } else if (props.post.event_type === "merged") {
    return /*#__PURE__*/_react.default.createElement(Merged, props);
  } else if (props.post.event_type === "changed_owner") {
    return /*#__PURE__*/_react.default.createElement(ChangedOwner, props);
  } else if (props.post.event_type === "added_participant") {
    return /*#__PURE__*/_react.default.createElement(AddedParticipant, props);
  } else if (props.post.event_type === "removed_participant") {
    return /*#__PURE__*/_react.default.createElement(RemovedParticipant, props);
  } else {
    return null;
  }
}

function ChangedTitle(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("Thread title has been changed from %(old_title)s."));
  var oldTitle = interpolate(ITEM_SPAN, {
    name: (0, _escapeHtml.default)(props.post.event_context.old_title)
  }, true);
  var message = interpolate(msgstring, {
    old_title: oldTitle
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function Moved(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("Thread has been moved from %(from_category)s."));
  var fromCategory = interpolate(ITEM_LINK, {
    url: (0, _escapeHtml.default)(props.post.event_context.from_category.url),
    name: (0, _escapeHtml.default)(props.post.event_context.from_category.name)
  }, true);
  var message = interpolate(msgstring, {
    from_category: fromCategory
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function Merged(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("The %(merged_thread)s thread has been merged into this thread."));
  var mergedThread = interpolate(ITEM_SPAN, {
    name: (0, _escapeHtml.default)(props.post.event_context.merged_thread)
  }, true);
  var message = interpolate(msgstring, {
    merged_thread: mergedThread
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function ChangedOwner(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("Changed thread owner to %(user)s."));
  var newOwner = interpolate(ITEM_LINK, {
    url: (0, _escapeHtml.default)(props.post.event_context.user.url),
    name: (0, _escapeHtml.default)(props.post.event_context.user.username)
  }, true);
  var message = interpolate(msgstring, {
    user: newOwner
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function AddedParticipant(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("Added %(user)s to thread."));
  var newOwner = interpolate(ITEM_LINK, {
    url: (0, _escapeHtml.default)(props.post.event_context.user.url),
    name: (0, _escapeHtml.default)(props.post.event_context.user.username)
  }, true);
  var message = interpolate(msgstring, {
    user: newOwner
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function RemovedParticipant(props) {
  var msgstring = (0, _escapeHtml.default)(gettext("Removed %(user)s from thread."));
  var newOwner = interpolate(ITEM_LINK, {
    url: (0, _escapeHtml.default)(props.post.event_context.user.url),
    name: (0, _escapeHtml.default)(props.post.event_context.user.username)
  }, true);
  var message = interpolate(msgstring, {
    user: newOwner
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "event-message",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

},{"../../../utils/escape-html":383,"react":"react"}],150:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post;
  if (post.is_read) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-10 col-xs-offset-2 col-sm-9 col-sm-offset-3 text-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "event-label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label label-unread"
  }, gettext("New event")))));
}

},{"react":"react"}],151:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.ListItem = ListItem;

var _react = _interopRequireDefault(require("react"));

var _event = _interopRequireDefault(require("./event"));

var _post = _interopRequireDefault(require("./post"));

var _preview = _interopRequireDefault(require("./post/preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  if (!props.posts.isLoaded) {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "posts-list ui-preview"
    }, /*#__PURE__*/_react.default.createElement(_preview.default, null));
  }

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "posts-list ui-ready"
  }, props.posts.results.map(function (post) {
    return /*#__PURE__*/_react.default.createElement(ListItem, _extends({
      key: post.id,
      post: post
    }, props));
  }));
}

function ListItem(props) {
  if (props.post.is_event) {
    return /*#__PURE__*/_react.default.createElement(_event.default, props);
  }

  return /*#__PURE__*/_react.default.createElement(_post.default, props);
}

},{"./event":147,"./post":163,"./post/preview":171,"react":"react"}],152:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.AttachmentPreview = AttachmentPreview;
exports.AttachmentIcon = AttachmentIcon;
exports.AttachmentThumbnail = AttachmentThumbnail;
exports.AttachmentDetails = AttachmentDetails;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../../../.."));

var _escapeHtml = _interopRequireDefault(require("../../../../utils/escape-html"));

var _fileSize = _interopRequireDefault(require("../../../../utils/file-size"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_ABBR = '<abbr title="%(absolute)s">%(relative)s</abbr>';
var USER_SPAN = '<span class="item-title">%(user)s</span>';
var USER_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-6"
  }, /*#__PURE__*/_react.default.createElement(AttachmentPreview, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "post-attachment"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.attachment.url.index,
    className: "attachment-name item-title"
  }, props.attachment.filename), /*#__PURE__*/_react.default.createElement(AttachmentDetails, props)));
}

function AttachmentPreview(props) {
  if (props.attachment.is_image) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "post-attachment-preview"
    }, /*#__PURE__*/_react.default.createElement(AttachmentThumbnail, props));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "post-attachment-preview"
    }, /*#__PURE__*/_react.default.createElement(AttachmentIcon, props));
  }
}

function AttachmentIcon(props) {
  return /*#__PURE__*/_react.default.createElement("a", {
    href: props.attachment.url.index,
    className: "material-icon"
  }, "insert_drive_file");
}

function AttachmentThumbnail(props) {
  var url = props.attachment.url.thumb || props.attachment.url.index;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "post-thumbnail",
    href: props.attachment.url.index,
    style: {
      backgroundImage: 'url("' + (0, _escapeHtml.default)(url) + '")'
    }
  });
}

function AttachmentDetails(props) {
  var user = null;

  if (props.attachment.url.uploader) {
    user = interpolate(USER_URL, {
      url: (0, _escapeHtml.default)(props.attachment.url.uploader),
      user: (0, _escapeHtml.default)(props.attachment.uploader_name)
    }, true);
  } else {
    user = interpolate(USER_SPAN, {
      user: (0, _escapeHtml.default)(props.attachment.uploader_name)
    }, true);
  }

  var date = interpolate(DATE_ABBR, {
    absolute: (0, _escapeHtml.default)(props.attachment.uploaded_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.attachment.uploaded_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("%(filetype)s, %(size)s, uploaded by %(uploader)s %(uploaded_on)s.")), {
    filetype: props.attachment.filetype,
    size: (0, _fileSize.default)(props.attachment.size),
    uploader: user,
    uploaded_on: date
  }, true);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "post-attachment-description",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

},{"../../../..":302,"../../../../utils/escape-html":383,"../../../../utils/file-size":384,"react":"react"}],153:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.isVisible = isVisible;
exports.Row = Row;

var _react = _interopRequireDefault(require("react"));

var _batch = _interopRequireDefault(require("../../../../utils/batch"));

var _attachment = _interopRequireDefault(require("./attachment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (!isVisible(props.post)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-attachments"
  }, (0, _batch.default)(props.post.attachments, 2).map(function (row) {
    var key = row.map(function (a) {
      return a ? a.id : 0;
    }).join("_");
    return /*#__PURE__*/_react.default.createElement(Row, {
      key: key,
      row: row
    });
  }));
}

function isVisible(post) {
  return (!post.is_hidden || post.acl.can_see_hidden) && post.attachments;
}

function Row(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, props.row.map(function (attachment) {
    return /*#__PURE__*/_react.default.createElement(_attachment.default, {
      attachment: attachment,
      key: attachment ? attachment.id : 0
    });
  }));
}

},{"../../../../utils/batch":380,"./attachment":152,"react":"react"}],154:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Default = Default;
exports.Hidden = Hidden;
exports.Invalid = Invalid;

var _react = _interopRequireDefault(require("react"));

var _waypoint = _interopRequireDefault(require("../waypoint"));

var _misagoMarkup = _interopRequireDefault(require("../../misago-markup"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HIDDEN_BY_URL = '<a href="%(url)s" class="item-title">%(user)s</a>';
var HIDDEN_BY_SPAN = '<span class="item-title">%(user)s</span>';
var HIDDEN_ON = '<abbr class="last-title" title="%(absolute)s">%(relative)s</abbr>';

function _default(props) {
  if (props.post.is_hidden && !props.post.acl.can_see_hidden) {
    return /*#__PURE__*/_react.default.createElement(Hidden, props);
  } else if (props.post.content) {
    return /*#__PURE__*/_react.default.createElement(Default, props);
  } else {
    return /*#__PURE__*/_react.default.createElement(Invalid, props);
  }
}

function Default(props) {
  return /*#__PURE__*/_react.default.createElement(_waypoint.default, {
    className: "post-body",
    post: props.post
  }, /*#__PURE__*/_react.default.createElement(_misagoMarkup.default, {
    markup: props.post.content
  }));
}

function Hidden(props) {
  var user = null;

  if (props.post.hidden_by) {
    user = interpolate(HIDDEN_BY_URL, {
      url: (0, _escapeHtml.default)(props.post.url.hidden_by),
      user: (0, _escapeHtml.default)(props.post.hidden_by_name)
    }, true);
  } else {
    user = interpolate(HIDDEN_BY_SPAN, {
      user: (0, _escapeHtml.default)(props.post.hidden_by_name)
    }, true);
  }

  var date = interpolate(HIDDEN_ON, {
    absolute: (0, _escapeHtml.default)(props.post.hidden_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.post.hidden_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("Hidden by %(hidden_by)s %(hidden_on)s.")), {
    hidden_by: user,
    hidden_on: date
  }, true);
  return /*#__PURE__*/_react.default.createElement(_waypoint.default, {
    className: "post-body post-body-hidden",
    post: props.post
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("This post is hidden. You cannot see its contents.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-muted",
    dangerouslySetInnerHTML: {
      __html: message
    }
  }));
}

function Invalid(props) {
  return /*#__PURE__*/_react.default.createElement(_waypoint.default, {
    className: "post-body post-body-invalid",
    post: props.post
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("This post's contents cannot be displayed.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-muted"
  }, gettext("This error is caused by invalid post content manipulation.")));
}

},{"../../../utils/escape-html":383,"../../misago-markup":60,"../waypoint":173,"react":"react"}],155:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approve = approve;
exports.protect = protect;
exports.unprotect = unprotect;
exports.hide = hide;
exports.unhide = unhide;
exports.like = like;
exports.unlike = unlike;
exports.patch = patch;
exports.remove = remove;
exports.markAsBestAnswer = markAsBestAnswer;
exports.unmarkBestAnswer = unmarkBestAnswer;
exports.patchThread = patchThread;

var _moment = _interopRequireDefault(require("moment"));

var thread = _interopRequireWildcard(require("../../../../reducers/thread"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function approve(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_unapproved: false
  }));

  var ops = [{
    op: "replace",
    path: "is-unapproved",
    value: false
  }];
  var previousState = {
    is_unapproved: props.post.is_unapproved
  };
  patch(props, ops, previousState);
}

function protect(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_protected: true
  }));

  var ops = [{
    op: "replace",
    path: "is-protected",
    value: true
  }];
  var previousState = {
    is_protected: props.post.is_protected
  };
  patch(props, ops, previousState);
}

function unprotect(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_protected: false
  }));

  var ops = [{
    op: "replace",
    path: "is-protected",
    value: false
  }];
  var previousState = {
    is_protected: props.post.is_protected
  };
  patch(props, ops, previousState);
}

function hide(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_hidden: true,
    hidden_on: (0, _moment.default)(),
    hidden_by_name: props.user.username,
    url: Object.assign(props.post.url, {
      hidden_by: props.user.url
    })
  }));

  var ops = [{
    op: "replace",
    path: "is-hidden",
    value: true
  }];
  var previousState = {
    is_hidden: props.post.is_hidden,
    hidden_on: props.post.hidden_on,
    hidden_by_name: props.post.hidden_by_name,
    url: props.post.url
  };
  patch(props, ops, previousState);
}

function unhide(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_hidden: false
  }));

  var ops = [{
    op: "replace",
    path: "is-hidden",
    value: false
  }];
  var previousState = {
    is_hidden: props.post.is_hidden
  };
  patch(props, ops, previousState);
}

function like(props) {
  var lastLikes = props.post.last_likes || [];
  var concatedLikes = [props.user].concat(lastLikes);
  var finalLikes = concatedLikes.length > 3 ? concatedLikes.slice(0, -1) : concatedLikes;

  _store.default.dispatch(post.patch(props.post, {
    is_liked: true,
    likes: props.post.likes + 1,
    last_likes: finalLikes
  }));

  var ops = [{
    op: "replace",
    path: "is-liked",
    value: true
  }];
  var previousState = {
    is_liked: props.post.is_liked,
    likes: props.post.likes,
    last_likes: props.post.last_likes
  };
  patch(props, ops, previousState);
}

function unlike(props) {
  _store.default.dispatch(post.patch(props.post, {
    is_liked: false,
    likes: props.post.likes - 1,
    last_likes: props.post.last_likes.filter(function (user) {
      return !user.id || user.id !== props.user.id;
    })
  }));

  var ops = [{
    op: "replace",
    path: "is-liked",
    value: false
  }];
  var previousState = {
    is_liked: props.post.is_liked,
    likes: props.post.likes,
    last_likes: props.post.last_likes
  };
  patch(props, ops, previousState);
}

function patch(props, ops, previousState) {
  _ajax.default.patch(props.post.api.index, ops).then(function (newState) {
    _store.default.dispatch(post.patch(props.post, newState));
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail[0]);
    } else {
      _snackbar.default.apiError(rejection);
    }

    _store.default.dispatch(post.patch(props.post, previousState));
  });
}

function remove(props) {
  var confirmed = confirm(gettext("Are you sure you want to delete this post? This action is not reversible!"));

  if (!confirmed) {
    return;
  }

  _store.default.dispatch(post.patch(props.post, {
    isDeleted: true
  }));

  _ajax.default.delete(props.post.api.index).then(function () {
    _snackbar.default.success(gettext("Post has been deleted."));
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail);
    } else {
      _snackbar.default.apiError(rejection);
    }

    _store.default.dispatch(post.patch(props.post, {
      isDeleted: false
    }));
  });
}

function markAsBestAnswer(props) {
  var post = props.post,
      user = props.user;

  _store.default.dispatch(thread.update({
    best_answer: post.id,
    best_answer_is_protected: post.is_protected,
    best_answer_marked_on: (0, _moment.default)(),
    best_answer_marked_by: user.id,
    best_answer_marked_by_name: user.username,
    best_answer_marked_by_slug: user.slug
  }));

  var ops = [{
    op: "replace",
    path: "best-answer",
    value: post.id
  }, {
    op: "add",
    path: "acl",
    value: true
  }];
  var previousState = {
    best_answer: props.thread.best_answer,
    best_answer_is_protected: props.thread.best_answer_is_protected,
    best_answer_marked_on: props.thread.best_answer_marked_on,
    best_answer_marked_by: props.thread.best_answer_marked_by,
    best_answer_marked_by_name: props.thread.best_answer_marked_by_name,
    best_answer_marked_by_slug: props.thread.best_answer_marked_by_slug
  };
  patchThread(props, ops, previousState);
}

function unmarkBestAnswer(props) {
  var post = props.post;

  _store.default.dispatch(thread.update({
    best_answer: null,
    best_answer_is_protected: false,
    best_answer_marked_on: null,
    best_answer_marked_by: null,
    best_answer_marked_by_name: null,
    best_answer_marked_by_slug: null
  }));

  var ops = [{
    op: "remove",
    path: "best-answer",
    value: post.id
  }, {
    op: "add",
    path: "acl",
    value: true
  }];
  var previousState = {
    best_answer: props.thread.best_answer,
    best_answer_is_protected: props.thread.best_answer_is_protected,
    best_answer_marked_on: props.thread.best_answer_marked_on,
    best_answer_marked_by: props.thread.best_answer_marked_by,
    best_answer_marked_by_name: props.thread.best_answer_marked_by_name,
    best_answer_marked_by_slug: props.thread.best_answer_marked_by_slug
  };
  patchThread(props, ops, previousState);
}

function patchThread(props, ops, previousState) {
  _ajax.default.patch(props.thread.api.index, ops).then(function (newState) {
    if (newState.best_answer_marked_on) {
      newState.best_answer_marked_on = (0, _moment.default)(newState.best_answer_marked_on);
    }

    _store.default.dispatch(thread.update(newState));
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail[0]);
    } else {
      _snackbar.default.apiError(rejection);
    }

    _store.default.dispatch(thread.update(previousState));
  });
}

},{"../../../../reducers/post":353,"../../../../reducers/thread":360,"../../../../services/ajax":365,"../../../../services/snackbar":376,"../../../../services/store":377,"moment":"moment"}],156:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Delete = exports.Unhide = exports.Hide = exports.Unprotect = exports.Protect = exports.Split = exports.Move = exports.Approve = exports.PostEdits = exports.UnmarkMarkBestAnswer = exports.MarkAsBestAnswer = exports.Edit = exports.Permalink = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _posting = _interopRequireDefault(require("../../../../services/posting"));

var moderation = _interopRequireWildcard(require("./actions"));

var _move = _interopRequireDefault(require("./move"));

var _postChangelog = _interopRequireDefault(require("../../../post-changelog"));

var _split = _interopRequireDefault(require("./split"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu dropdown-menu-right stick-to-bottom"
  }, /*#__PURE__*/_react.default.createElement(Permalink, props), /*#__PURE__*/_react.default.createElement(Edit, props), /*#__PURE__*/_react.default.createElement(MarkAsBestAnswer, props), /*#__PURE__*/_react.default.createElement(UnmarkMarkBestAnswer, props), /*#__PURE__*/_react.default.createElement(PostEdits, props), /*#__PURE__*/_react.default.createElement(Approve, props), /*#__PURE__*/_react.default.createElement(Move, props), /*#__PURE__*/_react.default.createElement(Split, props), /*#__PURE__*/_react.default.createElement(Protect, props), /*#__PURE__*/_react.default.createElement(Unprotect, props), /*#__PURE__*/_react.default.createElement(Hide, props), /*#__PURE__*/_react.default.createElement(Unhide, props), /*#__PURE__*/_react.default.createElement(Delete, props));
}

var Permalink = /*#__PURE__*/function (_React$Component) {
  _inherits(Permalink, _React$Component);

  var _super = _createSuper(Permalink);

  function Permalink() {
    var _this;

    _classCallCheck(this, Permalink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var permaUrl = window.location.protocol + "//";
      permaUrl += window.location.host;
      permaUrl += _this.props.post.url.index;
      prompt(gettext("Permament link to this post:"), permaUrl);
    });

    return _this;
  }

  _createClass(Permalink, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "link"), gettext("Permament link")));
    }
  }]);

  return Permalink;
}(_react.default.Component);

exports.Permalink = Permalink;

var Edit = /*#__PURE__*/function (_React$Component2) {
  _inherits(Edit, _React$Component2);

  var _super2 = _createSuper(Edit);

  function Edit() {
    var _this2;

    _classCallCheck(this, Edit);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      _posting.default.open({
        mode: "EDIT",
        config: _this2.props.post.api.editor,
        submit: _this2.props.post.api.index
      });
    });

    return _this2;
  }

  _createClass(Edit, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_edit) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "edit"), gettext("Edit")));
    }
  }]);

  return Edit;
}(_react.default.Component);

exports.Edit = Edit;

var MarkAsBestAnswer = /*#__PURE__*/function (_React$Component3) {
  _inherits(MarkAsBestAnswer, _React$Component3);

  var _super3 = _createSuper(MarkAsBestAnswer);

  function MarkAsBestAnswer() {
    var _this3;

    _classCallCheck(this, MarkAsBestAnswer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      moderation.markAsBestAnswer(_this3.props);
    });

    return _this3;
  }

  _createClass(MarkAsBestAnswer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          post = _this$props.post,
          thread = _this$props.thread;
      if (!thread.acl.can_mark_best_answer) return null;
      if (!post.acl.can_mark_as_best_answer) return null;
      if (post.id === thread.best_answer) return null;
      if (thread.best_answer && !thread.acl.can_change_best_answer) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box"), gettext("Mark as best answer")));
    }
  }]);

  return MarkAsBestAnswer;
}(_react.default.Component);

exports.MarkAsBestAnswer = MarkAsBestAnswer;

var UnmarkMarkBestAnswer = /*#__PURE__*/function (_React$Component4) {
  _inherits(UnmarkMarkBestAnswer, _React$Component4);

  var _super4 = _createSuper(UnmarkMarkBestAnswer);

  function UnmarkMarkBestAnswer() {
    var _this4;

    _classCallCheck(this, UnmarkMarkBestAnswer);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "onClick", function () {
      moderation.unmarkBestAnswer(_this4.props);
    });

    return _this4;
  }

  _createClass(UnmarkMarkBestAnswer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          post = _this$props2.post,
          thread = _this$props2.thread;
      if (post.id !== thread.best_answer) return null;
      if (!thread.acl.can_unmark_best_answer) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box_outline_blank"), gettext("Unmark best answer")));
    }
  }]);

  return UnmarkMarkBestAnswer;
}(_react.default.Component);

exports.UnmarkMarkBestAnswer = UnmarkMarkBestAnswer;

var PostEdits = /*#__PURE__*/function (_React$Component5) {
  _inherits(PostEdits, _React$Component5);

  var _super5 = _createSuper(PostEdits);

  function PostEdits() {
    var _this5;

    _classCallCheck(this, PostEdits);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this5), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_postChangelog.default, {
        post: _this5.props.post
      }));
    });

    return _this5;
  }

  _createClass(PostEdits, [{
    key: "render",
    value: function render() {
      var isHidden = this.props.post.is_hidden && !this.props.post.acl.can_see_hidden;
      var isUnedited = this.props.post.edits === 0;
      if (isHidden || isUnedited) return null;
      var message = ngettext("This post was edited %(edits)s time.", "This post was edited %(edits)s times.", this.props.post.edits);
      var title = interpolate(message, {
        edits: this.props.post.edits
      }, true);
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "edit"), gettext("Changes history")));
    }
  }]);

  return PostEdits;
}(_react.default.Component);

exports.PostEdits = PostEdits;

var Approve = /*#__PURE__*/function (_React$Component6) {
  _inherits(Approve, _React$Component6);

  var _super6 = _createSuper(Approve);

  function Approve() {
    var _this6;

    _classCallCheck(this, Approve);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this6), "onClick", function () {
      moderation.approve(_this6.props);
    });

    return _this6;
  }

  _createClass(Approve, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_approve) return null;
      if (!this.props.post.is_unapproved) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "done"), gettext("Approve")));
    }
  }]);

  return Approve;
}(_react.default.Component);

exports.Approve = Approve;

var Move = /*#__PURE__*/function (_React$Component7) {
  _inherits(Move, _React$Component7);

  var _super7 = _createSuper(Move);

  function Move() {
    var _this7;

    _classCallCheck(this, Move);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this7), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_move.default, _this7.props));
    });

    return _this7;
  }

  _createClass(Move, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_move) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), gettext("Move")));
    }
  }]);

  return Move;
}(_react.default.Component);

exports.Move = Move;

var Split = /*#__PURE__*/function (_React$Component8) {
  _inherits(Split, _React$Component8);

  var _super8 = _createSuper(Split);

  function Split() {
    var _this8;

    _classCallCheck(this, Split);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this8), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_split.default, _this8.props));
    });

    return _this8;
  }

  _createClass(Split, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_move) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "call_split"), gettext("Split")));
    }
  }]);

  return Split;
}(_react.default.Component);

exports.Split = Split;

var Protect = /*#__PURE__*/function (_React$Component9) {
  _inherits(Protect, _React$Component9);

  var _super9 = _createSuper(Protect);

  function Protect() {
    var _this9;

    _classCallCheck(this, Protect);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this9), "onClick", function () {
      moderation.protect(_this9.props);
    });

    return _this9;
  }

  _createClass(Protect, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_protect) return null;
      if (this.props.post.is_protected) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_outline"), gettext("Protect")));
    }
  }]);

  return Protect;
}(_react.default.Component);

exports.Protect = Protect;

var Unprotect = /*#__PURE__*/function (_React$Component10) {
  _inherits(Unprotect, _React$Component10);

  var _super10 = _createSuper(Unprotect);

  function Unprotect() {
    var _this10;

    _classCallCheck(this, Unprotect);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this10 = _super10.call.apply(_super10, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this10), "onClick", function () {
      moderation.unprotect(_this10.props);
    });

    return _this10;
  }

  _createClass(Unprotect, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_protect) return null;
      if (!this.props.post.is_protected) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_open"), gettext("Remove protection")));
    }
  }]);

  return Unprotect;
}(_react.default.Component);

exports.Unprotect = Unprotect;

var Hide = /*#__PURE__*/function (_React$Component11) {
  _inherits(Hide, _React$Component11);

  var _super11 = _createSuper(Hide);

  function Hide() {
    var _this11;

    _classCallCheck(this, Hide);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this11 = _super11.call.apply(_super11, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this11), "onClick", function () {
      moderation.hide(_this11.props);
    });

    return _this11;
  }

  _createClass(Hide, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          post = _this$props3.post,
          thread = _this$props3.thread;
      if (post.id === thread.best_answer) return null;
      if (!post.acl.can_hide) return null;
      if (post.is_hidden) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility_off"), gettext("Hide")));
    }
  }]);

  return Hide;
}(_react.default.Component);

exports.Hide = Hide;

var Unhide = /*#__PURE__*/function (_React$Component12) {
  _inherits(Unhide, _React$Component12);

  var _super12 = _createSuper(Unhide);

  function Unhide() {
    var _this12;

    _classCallCheck(this, Unhide);

    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _this12 = _super12.call.apply(_super12, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this12), "onClick", function () {
      moderation.unhide(_this12.props);
    });

    return _this12;
  }

  _createClass(Unhide, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_unhide) return null;
      if (!this.props.post.is_hidden) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility"), gettext("Unhide")));
    }
  }]);

  return Unhide;
}(_react.default.Component);

exports.Unhide = Unhide;

var Delete = /*#__PURE__*/function (_React$Component13) {
  _inherits(Delete, _React$Component13);

  var _super13 = _createSuper(Delete);

  function Delete() {
    var _this13;

    _classCallCheck(this, Delete);

    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }

    _this13 = _super13.call.apply(_super13, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this13), "onClick", function () {
      moderation.remove(_this13.props);
    });

    return _this13;
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          post = _this$props4.post,
          thread = _this$props4.thread;
      if (post.id === thread.best_answer) return null;
      if (!post.acl.can_delete) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "clear"), gettext("Delete")));
    }
  }]);

  return Delete;
}(_react.default.Component);

exports.Delete = Delete;

},{"../../../../services/modal":371,"../../../../services/posting":375,"../../../post-changelog":119,"./actions":155,"./move":158,"./split":159,"react":"react"}],157:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-right dropdown"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": "true",
    "aria-haspopup": "true",
    className: "btn btn-default btn-icon dropdown-toggle",
    "data-toggle": "dropdown",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "expand_more")), /*#__PURE__*/_react.default.createElement(_dropdown.default, props));
}

},{"./dropdown":156,"react":"react"}],158:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../../button"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUrlChange", function (event) {
      _this.changeValue("url", event.target.value);
    });

    _this.state = {
      isLoading: false,
      url: "",
      validators: {
        url: []
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.state.url.trim().length) {
        _snackbar.default.error(gettext("You have to enter link to the other thread."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.thread.api.posts.move, {
        new_thread: this.state.url,
        posts: [this.props.post.id]
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      _store.default.dispatch(post.patch(this.props.post, {
        isDeleted: true
      }));

      _modal.default.hide();

      _snackbar.default.success(gettext("Selected post was moved to the other thread."));
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(rejection.detail);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_url",
        label: gettext("Link to thread you want to move post to")
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        id: "id_url",
        onChange: this.onUrlChange,
        value: this.state.url
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary",
        loading: this.state.isLoading
      }, gettext("Move post"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function ModalHeader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Move post")));
}

},{"../../../../reducers/post":353,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../button":8,"../../../form":56,"../../../form-group":55,"react":"react"}],159:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Loader = Loader;
exports.Error = Error;
exports.Modal = Modal;
exports.ModerationForm = exports.PostingConfig = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../../button"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var _categorySelect = _interopRequireDefault(require("../../../category-select"));

var _modalLoader = _interopRequireDefault(require("../../../modal-loader"));

var _select = _interopRequireDefault(require("../../../select"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

var validators = _interopRequireWildcard(require("../../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(PostingConfig, _extends({}, props, {
    Form: ModerationForm
  }));
}

var PostingConfig = /*#__PURE__*/function (_React$Component) {
  _inherits(PostingConfig, _React$Component);

  var _super = _createSuper(PostingConfig);

  function PostingConfig(props) {
    var _this;

    _classCallCheck(this, PostingConfig);

    _this = _super.call(this, props);
    _this.state = {
      isLoaded: false,
      isError: false,
      categories: []
    };
    return _this;
  }

  _createClass(PostingConfig, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(misago.get("THREAD_EDITOR_API")).then(function (data) {
        // hydrate categories, extract posting options
        var categories = data.map(function (item) {
          return Object.assign(item, {
            disabled: item.post === false,
            label: item.name,
            value: item.id,
            post: item.post
          });
        });

        _this2.setState({
          isLoaded: true,
          categories: categories
        });
      }, function (rejection) {
        _this2.setState({
          isError: rejection.detail
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isError) {
        return /*#__PURE__*/_react.default.createElement(Error, {
          message: this.state.isError
        });
      } else if (this.state.isLoaded) {
        return /*#__PURE__*/_react.default.createElement(ModerationForm, _extends({}, this.props, {
          categories: this.state.categories
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement(Loader, null);
      }
    }
  }]);

  return PostingConfig;
}(_react.default.Component);

exports.PostingConfig = PostingConfig;

var ModerationForm = /*#__PURE__*/function (_Form) {
  _inherits(ModerationForm, _Form);

  var _super2 = _createSuper(ModerationForm);

  function ModerationForm(props) {
    var _this3;

    _classCallCheck(this, ModerationForm);

    _this3 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this3), "onCategoryChange", function (ev) {
      var categoryId = ev.target.value;
      var newState = {
        category: categoryId
      };

      if (_this3.acl[categoryId].can_pin_threads < newState.weight) {
        newState.weight = 0;
      }

      if (!_this3.acl[categoryId].can_hide_threads) {
        newState.is_hidden = 0;
      }

      if (!_this3.acl[categoryId].can_close_threads) {
        newState.is_closed = false;
      }

      _this3.setState(newState);
    });

    _this3.state = {
      isLoading: false,
      title: "",
      category: null,
      categories: props.categories,
      weight: 0,
      is_hidden: 0,
      is_closed: false,
      validators: {
        title: [validators.required()]
      },
      errors: {}
    };
    _this3.isHiddenChoices = [{
      value: 0,
      icon: "visibility",
      label: gettext("No")
    }, {
      value: 1,
      icon: "visibility_off",
      label: gettext("Yes")
    }];
    _this3.isClosedChoices = [{
      value: false,
      icon: "lock_outline",
      label: gettext("No")
    }, {
      value: true,
      icon: "lock",
      label: gettext("Yes")
    }];
    _this3.acl = {};

    _this3.props.categories.forEach(function (category) {
      if (category.post) {
        if (!_this3.state.category) {
          _this3.state.category = category.id;
        }

        _this3.acl[category.id] = {
          can_pin_threads: category.post.pin,
          can_close_threads: category.post.close,
          can_hide_threads: category.post.hide
        };
      }
    });

    return _this3;
  }

  _createClass(ModerationForm, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Form contains errors."));

        this.setState({
          errors: this.validate()
        });
        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.thread.api.posts.split, {
        title: this.state.title,
        category: this.state.category,
        weight: this.state.weight,
        is_hidden: this.state.is_hidden,
        is_closed: this.state.is_closed,
        posts: [this.props.post.id]
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      _store.default.dispatch(post.patch(this.props.post, {
        isDeleted: true
      }));

      _modal.default.hide();

      _snackbar.default.success(gettext("Selected post was split into new thread."));
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        this.setState({
          errors: Object.assign({}, this.state.errors, rejection)
        });

        _snackbar.default.error(gettext("Form contains errors."));
      } else if (rejection.status === 403 && Array.isArray(rejection)) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(ErrorsModal, {
          errors: rejection
        }));
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "getWeightChoices",
    value: function getWeightChoices() {
      var choices = [{
        value: 0,
        icon: "remove",
        label: gettext("Not pinned")
      }, {
        value: 1,
        icon: "bookmark_border",
        label: gettext("Pinned locally")
      }];

      if (this.acl[this.state.category].can_pin_threads == 2) {
        choices.push({
          value: 2,
          icon: "bookmark",
          label: gettext("Pinned globally")
        });
      }

      return choices;
    }
  }, {
    key: "renderWeightField",
    value: function renderWeightField() {
      if (this.acl[this.state.category].can_pin_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Thread weight"),
          for: "id_weight",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_weight",
          onChange: this.bindInput("weight"),
          value: this.state.weight,
          choices: this.getWeightChoices()
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderHiddenField",
    value: function renderHiddenField() {
      if (this.acl[this.state.category].can_hide_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Hide thread"),
          for: "id_is_hidden",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_hidden"),
          value: this.state.is_hidden,
          choices: this.isHiddenChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderClosedField",
    value: function renderClosedField() {
      if (this.acl[this.state.category].can_close_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Close thread"),
          for: "id_is_closed",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_closed"),
          value: this.state.is_closed,
          choices: this.isClosedChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(Modal, {
        className: "modal-dialog"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Thread title"),
        for: "id_title",
        labelClass: "col-sm-4",
        controlClass: "col-sm-8",
        validation: this.state.errors.title
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "id_title",
        className: "form-control",
        type: "text",
        onChange: this.bindInput("title"),
        value: this.state.title
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Category"),
        for: "id_category",
        labelClass: "col-sm-4",
        controlClass: "col-sm-8",
        validation: this.state.errors.category
      }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
        id: "id_category",
        onChange: this.onCategoryChange,
        value: this.state.category,
        choices: this.state.categories
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), this.renderWeightField(), this.renderHiddenField(), this.renderClosedField()), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Split post")))));
    }
  }]);

  return ModerationForm;
}(_form.default);

exports.ModerationForm = ModerationForm;

function Loader() {
  return /*#__PURE__*/_react.default.createElement(Modal, {
    className: "modal-dialog"
  }, /*#__PURE__*/_react.default.createElement(_modalLoader.default, null));
}

function Error(props) {
  return /*#__PURE__*/_react.default.createElement(Modal, {
    className: "modal-dialog modal-message"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("You can't move this post at the moment.")), /*#__PURE__*/_react.default.createElement("p", null, props.message)));
}

function Modal(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className,
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Split post into new thread"))), props.children));
}

},{"../../../../reducers/post":353,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../../utils/validators":393,"../../../button":8,"../../../category-select":21,"../../../form":56,"../../../form-group":55,"../../../modal-loader":61,"../../../select":210,"react":"react"}],160:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlagBestAnswer = FlagBestAnswer;
exports.FlagHidden = FlagHidden;
exports.FlagUnapproved = FlagUnapproved;
exports.FlagProtected = FlagProtected;
exports.isVisible = isVisible;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FlagBestAnswer(_ref) {
  var post = _ref.post,
      thread = _ref.thread,
      user = _ref.user;

  if (!(isVisible(post) && post.id === thread.best_answer)) {
    return null;
  }

  var message = null;

  if (user.id && thread.best_answer_marked_by === user.id) {
    message = interpolate(gettext("Marked as best answer by you %(marked_on)s."), {
      marked_on: thread.best_answer_marked_on.fromNow()
    }, true);
  } else {
    message = interpolate(gettext("Marked as best answer by %(marked_by)s %(marked_on)s."), {
      marked_by: thread.best_answer_marked_by_name,
      marked_on: thread.best_answer_marked_on.fromNow()
    }, true);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-status-message post-status-best-answer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "check_box"), /*#__PURE__*/_react.default.createElement("p", null, message));
}

function FlagHidden(props) {
  if (!(isVisible(props.post) && props.post.is_hidden)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-status-message post-status-hidden"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "visibility_off"), /*#__PURE__*/_react.default.createElement("p", null, gettext("This post is hidden. Only users with permission may see its contents.")));
}

function FlagUnapproved(props) {
  if (!(isVisible(props.post) && props.post.is_unapproved)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-status-message post-status-unapproved"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "remove_circle_outline"), /*#__PURE__*/_react.default.createElement("p", null, gettext("This post is unapproved. Only users with permission to approve posts and its author may see its contents.")));
}

function FlagProtected(props) {
  if (!(isVisible(props.post) && props.post.is_protected)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-status-message post-status-protected visible-xs-block"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "lock_outline"), /*#__PURE__*/_react.default.createElement("p", null, gettext("This post is protected. Only moderators may change it.")));
}

function isVisible(post) {
  return !post.is_hidden || post.acl.can_see_hidden;
}

},{"react":"react"}],161:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.isVisible = isVisible;
exports.getLikesMessage = getLikesMessage;
exports.Edit = exports.Reply = exports.LikesCompact = exports.Likes = exports.Like = exports.MarkAsBestAnswerCompact = exports.MarkAsBestAnswer = void 0;

var _react = _interopRequireDefault(require("react"));

var actions = _interopRequireWildcard(require("./controls/actions"));

var _postLikes = _interopRequireDefault(require("../../post-likes"));

var _modal = _interopRequireDefault(require("../../../services/modal"));

var _posting = _interopRequireDefault(require("../../../services/posting"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  if (!isVisible(props.post)) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-footer"
  }, /*#__PURE__*/_react.default.createElement(MarkAsBestAnswer, props), /*#__PURE__*/_react.default.createElement(MarkAsBestAnswerCompact, props), /*#__PURE__*/_react.default.createElement(Like, props), /*#__PURE__*/_react.default.createElement(Likes, _extends({
    lastLikes: props.post.last_likes,
    likes: props.post.likes
  }, props)), /*#__PURE__*/_react.default.createElement(LikesCompact, _extends({
    likes: props.post.likes
  }, props)), /*#__PURE__*/_react.default.createElement(Reply, props), /*#__PURE__*/_react.default.createElement(Edit, props));
}

function isVisible(post) {
  return (!post.is_hidden || post.acl.can_see_hidden) && (post.acl.can_reply || post.acl.can_edit || post.acl.can_see_likes && (post.last_likes || []).length || post.acl.can_like);
}

var MarkAsBestAnswer = /*#__PURE__*/function (_React$Component) {
  _inherits(MarkAsBestAnswer, _React$Component);

  var _super = _createSuper(MarkAsBestAnswer);

  function MarkAsBestAnswer() {
    var _this;

    _classCallCheck(this, MarkAsBestAnswer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      actions.markAsBestAnswer(_this.props);
    });

    return _this;
  }

  _createClass(MarkAsBestAnswer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          post = _this$props.post,
          thread = _this$props.thread;
      if (!thread.acl.can_mark_best_answer) return null;
      if (!post.acl.can_mark_as_best_answer) return null;
      if (thread.best_answer && !thread.acl.can_change_best_answer) return null;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "hidden-xs btn btn-default btn-sm pull-left",
        disabled: this.props.post.isBusy || post.id === thread.best_answer,
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box"), gettext("Best answer"));
    }
  }]);

  return MarkAsBestAnswer;
}(_react.default.Component);

exports.MarkAsBestAnswer = MarkAsBestAnswer;

var MarkAsBestAnswerCompact = /*#__PURE__*/function (_React$Component2) {
  _inherits(MarkAsBestAnswerCompact, _React$Component2);

  var _super2 = _createSuper(MarkAsBestAnswerCompact);

  function MarkAsBestAnswerCompact() {
    var _this2;

    _classCallCheck(this, MarkAsBestAnswerCompact);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      actions.markAsBestAnswer(_this2.props);
    });

    return _this2;
  }

  _createClass(MarkAsBestAnswerCompact, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          post = _this$props2.post,
          thread = _this$props2.thread;
      if (!thread.acl.can_mark_best_answer) return null;
      if (!post.acl.can_mark_as_best_answer) return null;
      if (thread.best_answer && !thread.acl.can_change_best_answer) return null;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "visible-xs-inline-block btn btn-default btn-sm pull-left",
        disabled: this.props.post.isBusy || post.id === thread.best_answer,
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box"));
    }
  }]);

  return MarkAsBestAnswerCompact;
}(_react.default.Component);

exports.MarkAsBestAnswerCompact = MarkAsBestAnswerCompact;

var Like = /*#__PURE__*/function (_React$Component3) {
  _inherits(Like, _React$Component3);

  var _super3 = _createSuper(Like);

  function Like() {
    var _this3;

    _classCallCheck(this, Like);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      if (_this3.props.post.is_liked) {
        actions.unlike(_this3.props);
      } else {
        actions.like(_this3.props);
      }
    });

    return _this3;
  }

  _createClass(Like, [{
    key: "render",
    value: function render() {
      if (!this.props.post.acl.can_like) return null;
      var className = "btn btn-default btn-sm pull-left";

      if (this.props.post.is_liked) {
        className = "btn btn-success btn-sm pull-left";
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        className: className,
        disabled: this.props.post.isBusy,
        onClick: this.onClick,
        type: "button"
      }, this.props.post.is_liked ? gettext("Liked") : gettext("Like"));
    }
  }]);

  return Like;
}(_react.default.Component);

exports.Like = Like;

var Likes = /*#__PURE__*/function (_React$Component4) {
  _inherits(Likes, _React$Component4);

  var _super4 = _createSuper(Likes);

  function Likes() {
    var _this4;

    _classCallCheck(this, Likes);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_postLikes.default, {
        post: _this4.props.post
      }));
    });

    return _this4;
  }

  _createClass(Likes, [{
    key: "render",
    value: function render() {
      var hasLikes = (this.props.post.last_likes || []).length > 0;
      if (!this.props.post.acl.can_see_likes || !hasLikes) return null;

      if (this.props.post.acl.can_see_likes === 2) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-link btn-sm pull-left hidden-xs",
          onClick: this.onClick,
          type: "button"
        }, getLikesMessage(this.props.likes, this.props.lastLikes));
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "pull-left hidden-xs"
      }, getLikesMessage(this.props.likes, this.props.lastLikes));
    }
  }]);

  return Likes;
}(_react.default.Component);

exports.Likes = Likes;

var LikesCompact = /*#__PURE__*/function (_Likes) {
  _inherits(LikesCompact, _Likes);

  var _super5 = _createSuper(LikesCompact);

  function LikesCompact() {
    _classCallCheck(this, LikesCompact);

    return _super5.apply(this, arguments);
  }

  _createClass(LikesCompact, [{
    key: "render",
    value: function render() {
      var hasLikes = (this.props.post.last_likes || []).length > 0;
      if (!this.props.post.acl.can_see_likes || !hasLikes) return null;

      if (this.props.post.acl.can_see_likes === 2) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-link btn-sm likes-compact pull-left visible-xs-block",
          onClick: this.onClick,
          type: "button"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "favorite"), this.props.likes);
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "likes-compact pull-left visible-xs-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "favorite"), this.props.likes);
    }
  }]);

  return LikesCompact;
}(Likes);

exports.LikesCompact = LikesCompact;

function getLikesMessage(likes, users) {
  var usernames = users.slice(0, 3).map(function (u) {
    return u.username;
  });

  if (usernames.length == 1) {
    return interpolate(gettext("%(user)s likes this."), {
      user: usernames[0]
    }, true);
  }

  var hiddenLikes = likes - usernames.length;
  var otherUsers = usernames.slice(0, -1).join(", ");
  var lastUser = usernames.slice(-1)[0];
  var usernamesList = interpolate(gettext("%(users)s and %(last_user)s"), {
    users: otherUsers,
    last_user: lastUser
  }, true);

  if (hiddenLikes === 0) {
    return interpolate(gettext("%(users)s like this."), {
      users: usernamesList
    }, true);
  }

  var message = ngettext("%(users)s and %(likes)s other user like this.", "%(users)s and %(likes)s other users like this.", hiddenLikes);
  return interpolate(message, {
    users: usernames.join(", "),
    likes: hiddenLikes
  }, true);
}

var Reply = /*#__PURE__*/function (_React$Component5) {
  _inherits(Reply, _React$Component5);

  var _super6 = _createSuper(Reply);

  function Reply() {
    var _this5;

    _classCallCheck(this, Reply);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this5), "onClick", function () {
      _posting.default.open({
        mode: "REPLY",
        config: _this5.props.thread.api.editor,
        submit: _this5.props.thread.api.posts.index,
        context: {
          reply: _this5.props.post.id
        }
      });
    });

    return _this5;
  }

  _createClass(Reply, [{
    key: "render",
    value: function render() {
      if (this.props.post.acl.can_reply) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-primary btn-sm pull-right",
          type: "button",
          onClick: this.onClick
        }, gettext("Reply"));
      } else {
        return null;
      }
    }
  }]);

  return Reply;
}(_react.default.Component);

exports.Reply = Reply;

var Edit = /*#__PURE__*/function (_React$Component6) {
  _inherits(Edit, _React$Component6);

  var _super7 = _createSuper(Edit);

  function Edit() {
    var _this6;

    _classCallCheck(this, Edit);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this6 = _super7.call.apply(_super7, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this6), "onClick", function () {
      _posting.default.open({
        mode: "EDIT",
        config: _this6.props.post.api.editor,
        submit: _this6.props.post.api.index
      });
    });

    return _this6;
  }

  _createClass(Edit, [{
    key: "render",
    value: function render() {
      if (this.props.post.acl.can_edit) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "hidden-xs btn btn-default btn-sm pull-right",
          type: "button",
          onClick: this.onClick
        }, gettext("Edit"));
      } else {
        return null;
      }
    }
  }]);

  return Edit;
}(_react.default.Component);

exports.Edit = Edit;

},{"../../../services/modal":371,"../../../services/posting":375,"../../post-likes":132,"./controls/actions":155,"react":"react"}],162:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.UnreadLabel = UnreadLabel;
exports.UnreadCompact = UnreadCompact;
exports.PostedOn = PostedOn;
exports.PostedOnCompact = PostedOnCompact;
exports.ProtectedLabel = ProtectedLabel;
exports.PostEditsCompacts = exports.PostEdits = void 0;

var _react = _interopRequireDefault(require("react"));

var _controls = _interopRequireDefault(require("./controls"));

var _select = _interopRequireDefault(require("./select"));

var _userStatus = require("../../user-status");

var _postChangelog = _interopRequireDefault(require("../../post-changelog"));

var _modal = _interopRequireDefault(require("../../../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "post-heading"
  }, /*#__PURE__*/_react.default.createElement(UnreadLabel, props), /*#__PURE__*/_react.default.createElement(UnreadCompact, props), /*#__PURE__*/_react.default.createElement(PostedOn, props), /*#__PURE__*/_react.default.createElement(PostedOnCompact, props), /*#__PURE__*/_react.default.createElement(PostEdits, props), /*#__PURE__*/_react.default.createElement(PostEditsCompacts, props), /*#__PURE__*/_react.default.createElement(ProtectedLabel, props), /*#__PURE__*/_react.default.createElement(_select.default, props), /*#__PURE__*/_react.default.createElement(_controls.default, props));
}

function UnreadLabel(props) {
  if (props.post.is_read) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "label label-unread hidden-xs"
  }, gettext("New post"));
}

function UnreadCompact(props) {
  if (props.post.is_read) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "label label-unread visible-xs-inline-block"
  }, gettext("New"));
}

function PostedOn(props) {
  var tooltip = interpolate(gettext("posted %(posted_on)s"), {
    posted_on: props.post.posted_on.format("LL, LT")
  }, true);
  return /*#__PURE__*/_react.default.createElement("a", {
    href: props.post.url.index,
    className: "btn btn-link posted-on hidden-xs",
    title: tooltip
  }, props.post.posted_on.fromNow());
}

function PostedOnCompact(props) {
  return /*#__PURE__*/_react.default.createElement("a", {
    href: props.post.url.index,
    className: "btn btn-link posted-on visible-xs-inline-block"
  }, props.post.posted_on.fromNow(true));
}

var PostEdits = /*#__PURE__*/function (_React$Component) {
  _inherits(PostEdits, _React$Component);

  var _super = _createSuper(PostEdits);

  function PostEdits() {
    var _this;

    _classCallCheck(this, PostEdits);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_postChangelog.default, {
        post: _this.props.post
      }));
    });

    return _this;
  }

  _createClass(PostEdits, [{
    key: "render",
    value: function render() {
      var isHidden = this.props.post.is_hidden && !this.props.post.acl.can_see_hidden;
      var isUnedited = this.props.post.edits === 0;
      if (isHidden || isUnedited) return null;
      var tooltip = ngettext("This post was edited %(edits)s time.", "This post was edited %(edits)s times.", this.props.post.edits);
      var title = interpolate(tooltip, {
        edits: this.props.post.edits
      }, true);
      var label = ngettext("edited %(edits)s time", "edited %(edits)s times", this.props.post.edits);
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link btn-see-edits hidden-xs",
        onClick: this.onClick,
        title: title,
        type: "button"
      }, interpolate(label, {
        edits: this.props.post.edits
      }, true));
    }
  }]);

  return PostEdits;
}(_react.default.Component);

exports.PostEdits = PostEdits;

var PostEditsCompacts = /*#__PURE__*/function (_PostEdits) {
  _inherits(PostEditsCompacts, _PostEdits);

  var _super2 = _createSuper(PostEditsCompacts);

  function PostEditsCompacts() {
    _classCallCheck(this, PostEditsCompacts);

    return _super2.apply(this, arguments);
  }

  _createClass(PostEditsCompacts, [{
    key: "render",
    value: function render() {
      var isHidden = this.props.post.is_hidden && !this.props.post.acl.can_see_hidden;
      var isUnedited = this.props.post.edits === 0;
      if (isHidden || isUnedited) return null;
      var label = ngettext("%(edits)s edit", "%(edits)s edits", this.props.post.edits);
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link btn-see-edits visible-xs-inline-block",
        onClick: this.onClick,
        type: "button"
      }, interpolate(label, {
        edits: this.props.post.edits
      }, true));
    }
  }]);

  return PostEditsCompacts;
}(PostEdits);

exports.PostEditsCompacts = PostEditsCompacts;

function ProtectedLabel(props) {
  var postAuthor = props.post.poster && props.post.poster.id === props.user.id;
  var hasAcl = props.post.acl.can_protect;
  var isVisible = props.user.id && props.post.is_protected && (postAuthor || hasAcl);

  if (!isVisible) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "label label-protected hidden-xs",
    title: gettext("This post is protected and may not be edited.")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "lock_outline"), gettext("protected"));
}

},{"../../../services/modal":371,"../../post-changelog":119,"../../user-status":274,"./controls":157,"./select":172,"react":"react"}],163:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _attachments = _interopRequireDefault(require("./attachments"));

var _body = _interopRequireDefault(require("./body"));

var _flags = require("./flags");

var _footer = _interopRequireDefault(require("./footer"));

var _header = _interopRequireDefault(require("./header"));

var _postSide = _interopRequireDefault(require("./post-side"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var className = "post";

  if (props.post.isDeleted) {
    className = "hide";
  } else if (props.post.is_hidden && !props.post.acl.can_see_hidden) {
    className = "post post-hidden";
  }

  if (props.post.poster && props.post.poster.rank.css_class) {
    className += " post-" + props.post.poster.rank.css_class;
  }

  if (!props.post.is_read) {
    className += " post-new";
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    id: "post-" + props.post.id,
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(_postSide.default, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-9"
  }, /*#__PURE__*/_react.default.createElement(_header.default, props), /*#__PURE__*/_react.default.createElement(_flags.FlagBestAnswer, props), /*#__PURE__*/_react.default.createElement(_flags.FlagUnapproved, props), /*#__PURE__*/_react.default.createElement(_flags.FlagProtected, props), /*#__PURE__*/_react.default.createElement(_flags.FlagHidden, props), /*#__PURE__*/_react.default.createElement(_body.default, props), /*#__PURE__*/_react.default.createElement(_attachments.default, props), /*#__PURE__*/_react.default.createElement(_footer.default, props))))));
}

},{"./attachments":153,"./body":154,"./flags":160,"./footer":161,"./header":162,"./post-side":166,"react":"react"}],164:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

var _controls = _interopRequireDefault(require("../controls"));

var _select = _interopRequireDefault(require("../select"));

var _userStatus = _interopRequireWildcard(require("../../../user-status"));

var _userPostcount = _interopRequireDefault(require("./user-postcount"));

var _userTitle = _interopRequireDefault(require("./user-title"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post,
      thread = _ref.thread;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-3 post-side post-side-anonymous"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    post: post,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement(_controls.default, {
    post: post,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "poster-avatar",
    size: 100
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "media-heading item-title"
  }, post.poster_name), /*#__PURE__*/_react.default.createElement("span", {
    className: "user-title user-title-anonymous"
  }, gettext("Removed user")))));
}

},{"../../../avatar":6,"../../../user-status":274,"../controls":157,"../select":172,"./user-postcount":168,"./user-title":170,"react":"react"}],165:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var title = _ref.title,
      rank = _ref.rank;
  return rank.is_tab || !!title || !!rank.title;
}

},{}],166:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _anonymous = _interopRequireDefault(require("./anonymous"));

var _registered = _interopRequireDefault(require("./registered"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (props.post.poster) {
    return /*#__PURE__*/_react.default.createElement(_registered.default, props);
  }

  return /*#__PURE__*/_react.default.createElement(_anonymous.default, props);
}

},{"./anonymous":164,"./registered":167,"react":"react"}],167:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../../avatar"));

var _controls = _interopRequireDefault(require("../controls"));

var _select = _interopRequireDefault(require("../select"));

var _userStatus = _interopRequireWildcard(require("../../../user-status"));

var _userPostcount = _interopRequireDefault(require("./user-postcount"));

var _userStatus2 = _interopRequireDefault(require("./user-status"));

var _userTitle = _interopRequireDefault(require("./user-title"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var post = _ref.post,
      thread = _ref.thread;
  var poster = post.poster;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-3 post-side post-side-registered"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    post: post,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement(_controls.default, {
    post: post,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: poster.url
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "poster-avatar",
    size: 100,
    user: poster
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-heading"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "item-title",
    href: poster.url
  }, poster.username), /*#__PURE__*/_react.default.createElement(_userStatus.default, {
    status: poster.status
  }, /*#__PURE__*/_react.default.createElement(_userStatus.StatusIcon, {
    status: poster.status
  }))), /*#__PURE__*/_react.default.createElement(_userTitle.default, {
    rank: poster.rank,
    title: poster.title
  }), /*#__PURE__*/_react.default.createElement(_userStatus2.default, {
    poster: poster
  }), /*#__PURE__*/_react.default.createElement(_userPostcount.default, {
    poster: poster
  }))));
}

},{"../../../avatar":6,"../../../user-status":274,"../controls":157,"../select":172,"./user-postcount":168,"./user-status":169,"./user-title":170,"react":"react"}],168:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _hasVisibleTitle = _interopRequireDefault(require("./has-visible-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var poster = _ref.poster;
  var message = ngettext("%(posts)s post", "%(posts)s posts", poster.posts);
  var className = "user-postcount";

  if ((0, _hasVisibleTitle.default)(poster)) {
    className += " hidden-xs hidden-sm";
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, interpolate(message, {
    posts: poster.posts
  }, true));
}

},{"./has-visible-title":165,"react":"react"}],169:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _userStatus = _interopRequireWildcard(require("../../../user-status"));

var _hasVisibleTitle = _interopRequireDefault(require("./has-visible-title"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var poster = _ref.poster;
  var className = "hidden-xs";

  if ((0, _hasVisibleTitle.default)(poster)) {
    className += " hidden-sm";
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_userStatus.default, {
    status: poster.status
  }, /*#__PURE__*/_react.default.createElement(_userStatus.StatusLabel, {
    status: poster.status,
    user: poster
  })));
}

},{"../../../user-status":274,"./has-visible-title":165,"react":"react"}],170:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var rank = _ref.rank,
      title = _ref.title;
  var userTitle = title || rank.title;

  if (!userTitle && rank.is_tab) {
    userTitle = rank.name;
  }

  if (!userTitle) return null;
  var className = "user-title";

  if (rank.css_class) {
    className += " user-title-" + rank.css_class;
  }

  if (rank.is_tab) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: rank.url
    }, userTitle));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, userTitle);
}

},{"react":"react"}],171:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "post-border"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "post-avatar"
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: "100"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "post-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-post"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-heading post-heading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 100) + "px"
    }
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-preview-text",
    style: {
      width: random.int(30, 100) + "px"
    }
  }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("article", {
    className: "misago-markup"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ui-preview-text",
    style: {
      width: random.int(50, 100) + "%"
    }
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("p", {
    className: "ui-preview-text",
    style: {
      width: random.int(50, 100) + "%"
    }
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("p", {
    className: "ui-preview-text",
    style: {
      width: random.int(50, 100) + "%"
    }
  }, "\xA0")))))));
}

},{"../../../utils/random":388,"../../avatar":6,"react":"react"}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisible = isVisible;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var posts = _interopRequireWildcard(require("../../../reducers/posts"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      if (_this.props.post.isSelected) {
        _store.default.dispatch(posts.deselect(_this.props.post));
      } else {
        _store.default.dispatch(posts.select(_this.props.post));
      }
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (!(this.props.thread.acl.can_merge_posts || isVisible(this.props.post.acl))) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pull-right hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-icon",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.props.post.isSelected ? "check_box" : "check_box_outline_blank")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function isVisible(acl) {
  return acl.can_approve || acl.can_hide || acl.can_protect || acl.can_unhide || acl.can_delete || acl.can_move;
}

},{"../../../reducers/posts":354,"../../../services/store":377,"react":"react"}],173:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var post = _interopRequireWildcard(require("../../reducers/post"));

var thread = _interopRequireWildcard(require("../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "componentDidMount",

    /*
    Super naive and de-facto placeholder implementation for reading posts on scroll
    */
    value: function componentDidMount() {
      var _this = this;

      if (this.props.post.is_read) return; // don't register read tracker

      $(this.documentNode).waypoint({
        handler: function handler(direction) {
          if (direction !== "down" || _this.props.post.is_read) return; // after 1500ms run flag post as read logic

          window.setTimeout(function () {
            // check if post's bottom edge is still in viewport
            var boundingClientRect = _this.documentNode.getBoundingClientRect();

            var offsetBottom = boundingClientRect.height + boundingClientRect.top;
            var clientHeight = document.documentElement.clientHeight;
            if (offsetBottom < 5) return; // scrolled past the post

            if (offsetBottom > clientHeight) return; // scrolled back up
            // mark post as read

            _store.default.dispatch(post.patch(_this.props.post, {
              is_read: true
            })); // call API to let it know we have unread post


            _ajax.default.post(_this.props.post.api.read).then(function (data) {
              _store.default.dispatch(thread.update(_this.props.thread, {
                is_read: data.thread_is_read
              }));
            }, function (rejection) {
              _snackbar.default.apiError(rejection);
            });
          }, 1000);
        },
        offset: "bottom-in-view"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.className,
        ref: function ref(node) {
          _this2.documentNode = node;
        }
      }, this.props.children);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../reducers/post":353,"../../reducers/thread":360,"../../services/ajax":365,"../../services/snackbar":376,"../../services/store":377,"react":"react"}],174:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _panelLoader = _interopRequireDefault(require("../panel-loader"));

var _panelMessage = _interopRequireDefault(require("../panel-message"));

var _ = _interopRequireDefault(require("../.."));

var _polls = _interopRequireDefault(require("../../services/polls"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (ban) {
      if (ban.expires_on) {
        ban.expires_on = (0, _moment.default)(ban.expires_on);
      }

      _this.setState({
        isLoaded: true,
        error: null,
        ban: ban
      });
    });

    _defineProperty(_assertThisInitialized(_this), "error", function (error) {
      _this.setState({
        isLoaded: true,
        error: error.detail,
        ban: null
      });
    });

    if (_.default.has("PROFILE_BAN")) {
      _this.initWithPreloadedData(_.default.pop("PROFILE_BAN"));
    } else {
      _this.initWithoutPreloadedData();
    }

    _this.startPolling(props.profile.api.ban);

    return _this;
  }

  _createClass(_default, [{
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(ban) {
      if (ban.expires_on) {
        ban.expires_on = (0, _moment.default)(ban.expires_on);
      }

      this.state = {
        isLoaded: true,
        ban: ban
      };
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData() {
      this.state = {
        isLoaded: false
      };
    }
  }, {
    key: "startPolling",
    value: function startPolling(api) {
      _polls.default.start({
        poll: "ban-details",
        url: api,
        frequency: 90 * 1000,
        update: this.update,
        error: this.error
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Ban details"),
        parent: this.props.profile.username
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _polls.default.stop("ban-details");
    }
  }, {
    key: "getUserMessage",
    value: function getUserMessage() {
      if (this.state.ban.user_message) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "panel-body ban-message ban-user-message"
        }, /*#__PURE__*/_react.default.createElement("h4", null, gettext("User-shown ban message")), /*#__PURE__*/_react.default.createElement("div", {
          className: "lead",
          dangerouslySetInnerHTML: {
            __html: this.state.ban.user_message.html
          }
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "getStaffMessage",
    value: function getStaffMessage() {
      if (this.state.ban.staff_message) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "panel-body ban-message ban-staff-message"
        }, /*#__PURE__*/_react.default.createElement("h4", null, gettext("Team-shown ban message")), /*#__PURE__*/_react.default.createElement("div", {
          className: "lead",
          dangerouslySetInnerHTML: {
            __html: this.state.ban.staff_message.html
          }
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "getExpirationMessage",
    value: function getExpirationMessage() {
      if (this.state.ban.expires_on) {
        if (this.state.ban.expires_on.isAfter((0, _moment.default)())) {
          var _title = interpolate(gettext("This ban expires on %(expires_on)s."), {
            expires_on: this.state.ban.expires_on.format("LL, LT")
          }, true);

          var message = interpolate(gettext("This ban expires %(expires_on)s."), {
            expires_on: this.state.ban.expires_on.fromNow()
          }, true);
          return /*#__PURE__*/_react.default.createElement("abbr", {
            title: _title
          }, message);
        } else {
          return gettext("This ban has expired.");
        }
      } else {
        return interpolate(gettext("%(username)s's ban is permanent."), {
          username: this.props.profile.username
        }, true);
      }
    }
  }, {
    key: "getPanelBody",
    value: function getPanelBody() {
      if (this.state.ban) {
        if (Object.keys(this.state.ban).length) {
          return /*#__PURE__*/_react.default.createElement("div", null, this.getUserMessage(), this.getStaffMessage(), /*#__PURE__*/_react.default.createElement("div", {
            className: "panel-body ban-expires"
          }, /*#__PURE__*/_react.default.createElement("h4", null, gettext("Ban expiration")), /*#__PURE__*/_react.default.createElement("p", {
            className: "lead"
          }, this.getExpirationMessage())));
        } else {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_panelMessage.default, {
            message: gettext("No ban is active at the moment.")
          }));
        }
      } else if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_panelMessage.default, {
          icon: "error_outline",
          message: this.state.error
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_panelLoader.default, null));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-ban-details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Ban details"))), this.getPanelBody()));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../services/page-title":373,"../../services/polls":374,"../panel-loader":93,"../panel-message":94,"moment":"moment","react":"react"}],175:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
      profile = _ref.profile;
  var message = null;

  if (isAuthenticated) {
    message = gettext("You are not sharing any details with others.");
  } else {
    message = interpolate(gettext("%(username)s is not sharing any details with others."), {
      username: profile.username
    }, true);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body text-center lead"
  }, message));
}

},{"react":"react"}],176:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.SafeValue = SafeValue;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var html = _ref.html,
      text = _ref.text,
      url = _ref.url;

  if (html) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-control-static col-md-9",
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control-static col-md-9"
  }, /*#__PURE__*/_react.default.createElement(SafeValue, {
    text: text,
    url: url
  }));
}

function SafeValue(_ref2) {
  var text = _ref2.text,
      url = _ref2.url;

  if (url) {
    return /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      target: "_blank",
      rel: "nofollow"
    }, text || url));
  }

  if (text) {
    return /*#__PURE__*/_react.default.createElement("p", null, text);
  }

  return null;
}

},{"react":"react"}],177:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _fieldValue = _interopRequireDefault(require("./field-value"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement("strong", {
    className: "control-label col-md-3"
  }, props.name, ":"), /*#__PURE__*/_react.default.createElement(_fieldValue.default, props));
}

},{"./field-value":176,"react":"react"}],178:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _editDetails = _interopRequireDefault(require("../../edit-details"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var api = _ref.api,
      display = _ref.display,
      onCancel = _ref.onCancel,
      onSuccess = _ref.onSuccess;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement(_editDetails.default, {
    api: api,
    onCancel: onCancel,
    onSuccess: onSuccess
  });
}

},{"../../edit-details":32,"react":"react"}],179:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _field = _interopRequireDefault(require("./field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var fields = _ref.fields,
      name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-profile-details-group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "panel-title"
  }, name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-horizontal"
  }, fields.map(function (_ref2) {
    var fieldname = _ref2.fieldname,
        html = _ref2.html,
        name = _ref2.name,
        text = _ref2.text,
        url = _ref2.url;
    return /*#__PURE__*/_react.default.createElement(_field.default, {
      key: fieldname,
      name: name,
      html: html,
      text: text,
      url: url
    });
  }))));
}

},{"./field":177,"react":"react"}],180:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _emptyMessage = _interopRequireDefault(require("./empty-message"));

var _group = _interopRequireDefault(require("./group"));

var _loader = _interopRequireDefault(require("../../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var display = _ref.display,
      groups = _ref.groups,
      isAuthenticated = _ref.isAuthenticated,
      loading = _ref.loading,
      profile = _ref.profile;
  if (!display) return null;

  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_loader.default, null);
  }

  if (!groups.length) {
    return /*#__PURE__*/_react.default.createElement(_emptyMessage.default, {
      isAuthenticated: isAuthenticated,
      profile: profile
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", null, groups.map(function (group, i) {
    return /*#__PURE__*/_react.default.createElement(_group.default, {
      fields: group.fields,
      key: i,
      name: group.name
    });
  }));
}

},{"../../loader":58,"./empty-message":175,"./group":179,"react":"react"}],181:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.EditButton = EditButton;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var onEdit = _ref.onEdit,
      showEditButton = _ref.showEditButton;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("nav", {
    className: "toolbar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-8 col-md-10"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "md-margin-top-no"
  }, gettext("Details"))), /*#__PURE__*/_react.default.createElement(EditButton, {
    onEdit: onEdit,
    showEditButton: showEditButton
  }))));
}

function EditButton(_ref2) {
  var onEdit = _ref2.onEdit,
      showEditButton = _ref2.showEditButton;
  if (!showEditButton) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 col-md-2"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default btn-outline btn-block",
    onClick: onEdit,
    type: "button"
  }, gettext("Edit")));
}

},{"react":"react"}],182:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("./form"));

var _groupsList = _interopRequireDefault(require("./groups-list"));

var _header = _interopRequireDefault(require("./header"));

var _profileDetails = _interopRequireDefault(require("../../../data/profile-details"));

var _profileDetails2 = require("../../../reducers/profile-details");

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      _this.setState({
        editing: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEdit", function () {
      _this.setState({
        editing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuccess", function (newDetails) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isAuthenticated = _this$props.isAuthenticated,
          profile = _this$props.profile;
      var message = null;

      if (isAuthenticated) {
        message = gettext("Your details have been updated.");
      } else {
        message = interpolate(gettext("%(username)s's details have been updated."), {
          username: profile.username
        }, true);
      }

      _snackbar.default.info(message);

      dispatch((0, _profileDetails2.load)(newDetails));

      _this.setState({
        editing: false
      });
    });

    _this.state = {
      editing: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Details"),
        parent: this.props.profile.username
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dispatch = _this$props2.dispatch,
          isAuthenticated = _this$props2.isAuthenticated,
          profile = _this$props2.profile,
          profileDetails = _this$props2.profileDetails;
      var loading = profileDetails.id !== profile.id;
      return /*#__PURE__*/_react.default.createElement(_profileDetails.default, {
        data: profileDetails,
        dispatch: dispatch,
        user: profile
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-details"
      }, /*#__PURE__*/_react.default.createElement(_header.default, {
        onEdit: this.onEdit,
        showEditButton: !!profileDetails.edit && !this.state.editing
      }), /*#__PURE__*/_react.default.createElement(_groupsList.default, {
        display: !this.state.editing,
        groups: profileDetails.groups,
        isAuthenticated: isAuthenticated,
        loading: loading,
        profile: profile
      }), /*#__PURE__*/_react.default.createElement(_form.default, {
        api: profile.api.edit_details,
        dispatch: dispatch,
        display: this.state.editing,
        onCancel: this.onCancel,
        onSuccess: this.onSuccess
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../data/profile-details":301,"../../../reducers/profile-details":355,"../../../services/page-title":373,"../../../services/snackbar":376,"./form":178,"./groups-list":180,"./header":181,"react":"react"}],183:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Threads = Threads;
exports.Posts = Posts;

var _react = _interopRequireDefault(require("react"));

var _route = _interopRequireDefault(require("./route"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Threads(props) {
  var emptyMessage = null;

  if (props.user.id === props.profile.id) {
    emptyMessage = gettext("You have no started threads.");
  } else {
    emptyMessage = interpolate(gettext("%(username)s started no threads."), {
      username: props.profile.username
    }, true);
  }

  var header = null;

  if (!props.posts.isLoaded) {
    header = gettext("Loading...");
  } else if (props.profile.id === props.user.id) {
    var message = ngettext("You have started %(threads)s thread.", "You have started %(threads)s threads.", props.profile.threads);
    header = interpolate(message, {
      threads: props.profile.threads
    }, true);
  } else {
    var _message = ngettext("%(username)s has started %(threads)s thread.", "%(username)s has started %(threads)s threads.", props.profile.threads);

    header = interpolate(_message, {
      username: props.profile.username,
      threads: props.profile.threads
    }, true);
  }

  return /*#__PURE__*/_react.default.createElement(_route.default, _extends({
    api: props.profile.api.threads,
    emptyMessage: emptyMessage,
    header: header,
    title: gettext("Threads")
  }, props));
}

function Posts(props) {
  var emptyMessage = null;

  if (props.user.id === props.profile.id) {
    emptyMessage = gettext("You have posted no messages.");
  } else {
    emptyMessage = interpolate(gettext("%(username)s posted no messages."), {
      username: props.profile.username
    }, true);
  }

  var header = null;

  if (!props.posts.isLoaded) {
    header = gettext("Loading...");
  } else if (props.profile.id === props.user.id) {
    var message = ngettext("You have posted %(posts)s message.", "You have posted %(posts)s messages.", props.profile.posts);
    header = interpolate(message, {
      posts: props.profile.posts
    }, true);
  } else {
    var _message2 = ngettext("%(username)s has posted %(posts)s message.", "%(username)s has posted %(posts)s messages.", props.profile.posts);

    header = interpolate(_message2, {
      username: props.profile.username,
      posts: props.profile.posts
    }, true);
  }

  return /*#__PURE__*/_react.default.createElement(_route.default, _extends({
    api: props.profile.api.posts,
    emptyMessage: emptyMessage,
    header: header,
    title: gettext("Posts")
  }, props));
}

},{"./route":184,"react":"react"}],184:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feed = Feed;
exports.LoadMoreButton = LoadMoreButton;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _postFeed = _interopRequireDefault(require("../../post-feed"));

var _button = _interopRequireDefault(require("../../button"));

var posts = _interopRequireWildcard(require("../../../reducers/posts"));

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      _this.setState({
        isLoading: true
      });

      _this.loadItems(_this.props.posts.next);
    });

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "loadItems",
    value: function loadItems() {
      var _this2 = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      _ajax.default.get(this.props.api, {
        start: start || 0
      }).then(function (data) {
        if (start === 0) {
          _store.default.dispatch(posts.load(data));
        } else {
          _store.default.dispatch(posts.append(data));
        }

        _this2.setState({
          isLoading: false
        });
      }, function (rejection) {
        _this2.setState({
          isLoading: false
        });

        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: this.props.title,
        parent: this.props.profile.username
      });

      this.loadItems();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-feed"
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: "toolbar"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "toolbar-left"
      }, this.props.header)), /*#__PURE__*/_react.default.createElement(Feed, _extends({
        isLoading: this.state.isLoading,
        loadMore: this.loadMore
      }, this.props)));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function Feed(props) {
  if (!props.posts.results.length) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, props.emptyMessage);
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_postFeed.default, {
    isReady: props.posts.isLoaded,
    posts: props.posts.results,
    poster: props.profile
  }), /*#__PURE__*/_react.default.createElement(LoadMoreButton, {
    isLoading: props.isLoading,
    loadMore: props.loadMore,
    next: props.posts.next
  }));
}

function LoadMoreButton(props) {
  if (!props.next) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pager-more"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "btn btn-default btn-outline",
    loading: props.isLoading,
    onClick: props.loadMore
  }, gettext("Show older activity")));
}

},{"../../../reducers/posts":354,"../../../services/ajax":365,"../../../services/page-title":373,"../../../services/snackbar":376,"../../../services/store":377,"../../button":8,"../../post-feed":122,"react":"react"}],185:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _profile = require("../../reducers/profile");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "action", function () {
      _this.setState({
        isLoading: true
      });

      if (_this.props.profile.is_followed) {
        _store.default.dispatch((0, _profile.patch)({
          is_followed: false,
          followers: _this.props.profile.followers - 1
        }));
      } else {
        _store.default.dispatch((0, _profile.patch)({
          is_followed: true,
          followers: _this.props.profile.followers + 1
        }));
      }

      _ajax.default.post(_this.props.profile.api.follow).then(function (data) {
        _this.setState({
          isLoading: false
        });

        _store.default.dispatch((0, _profile.patch)(data));
      }, function (rejection) {
        _this.setState({
          isLoading: false
        });

        _snackbar.default.apiError(rejection);
      });
    });

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.profile.is_followed) {
        return this.props.className + " btn-default btn-following";
      } else {
        return this.props.className + " btn-default btn-follow";
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      if (this.props.profile.is_followed) {
        return "favorite";
      } else {
        return "favorite_border";
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (this.props.profile.is_followed) {
        return gettext("Following");
      } else {
        return gettext("Follow");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        className: this.getClassName(),
        disabled: this.state.isLoading,
        onClick: this.action
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.getIcon()), this.getLabel());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../reducers/profile":356,"../../services/ajax":365,"../../services/snackbar":376,"../../services/store":377,"../button":8,"react":"react"}],186:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _quickSearch = _interopRequireDefault(require("../quick-search"));

var _usersList = _interopRequireDefault(require("../users-list"));

var _ = _interopRequireDefault(require("../.."));

var _users = require("../../reducers/users");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      _this.setState({
        isBusy: true
      });

      _this.loadUsers(_this.state.page + 1, _this.state.search);
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (ev) {
      _this.setState({
        isLoaded: false,
        isBusy: true,
        search: ev.target.value,
        count: 0,
        more: 0,
        page: 1,
        pages: 1
      });

      _this.loadUsers(1, ev.target.value);
    });

    _this.setSpecialProps();

    if (_.default.has(_this.PRELOADED_DATA_KEY)) {
      _this.initWithPreloadedData(_.default.pop(_this.PRELOADED_DATA_KEY));
    } else {
      _this.initWithoutPreloadedData();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "setSpecialProps",
    value: function setSpecialProps() {
      this.PRELOADED_DATA_KEY = "PROFILE_FOLLOWERS";
      this.TITLE = gettext("Followers");
      this.API_FILTER = "followers";
    }
  }, {
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(data) {
      this.state = {
        isLoaded: true,
        isBusy: false,
        search: "",
        count: data.count,
        more: data.more,
        page: data.page,
        pages: data.pages
      };

      _store.default.dispatch((0, _users.hydrate)(data.results));
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData() {
      this.state = {
        isLoaded: false,
        isBusy: false,
        search: "",
        count: 0,
        more: 0,
        page: 1,
        pages: 1
      };
      this.loadUsers();
    }
  }, {
    key: "loadUsers",
    value: function loadUsers() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var apiUrl = this.props.profile.api[this.API_FILTER];

      _ajax.default.get(apiUrl, {
        search: search,
        page: page || 1
      }, "user-" + this.API_FILTER).then(function (data) {
        if (page === 1) {
          _store.default.dispatch((0, _users.hydrate)(data.results));
        } else {
          _store.default.dispatch((0, _users.append)(data.results));
        }

        _this2.setState({
          isLoaded: true,
          isBusy: false,
          count: data.count,
          more: data.more,
          page: data.page,
          pages: data.pages
        });
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: this.TITLE,
        parent: this.props.profile.username
      });
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (!this.state.isLoaded) {
        return gettext("Loading...");
      } else if (this.state.search) {
        var message = ngettext("Found %(users)s user.", "Found %(users)s users.", this.state.count);
        return interpolate(message, {
          users: this.state.count
        }, true);
      } else if (this.props.profile.id === this.props.user.id) {
        var _message = ngettext("You have %(users)s follower.", "You have %(users)s followers.", this.state.count);

        return interpolate(_message, {
          users: this.state.count
        }, true);
      } else {
        var _message2 = ngettext("%(username)s has %(users)s follower.", "%(username)s has %(users)s followers.", this.state.count);

        return interpolate(_message2, {
          username: this.props.profile.username,
          users: this.state.count
        }, true);
      }
    }
  }, {
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      if (this.state.search) {
        return gettext("Search returned no users matching specified criteria.");
      } else if (this.props.user.id === this.props.profile.id) {
        return gettext("You have no followers.");
      } else {
        return interpolate(gettext("%(username)s has no followers."), {
          username: this.props.profile.username
        }, true);
      }
    }
  }, {
    key: "getMoreButton",
    value: function getMoreButton() {
      if (!this.state.more) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pager-more"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn btn-default btn-outline",
        loading: this.state.isBusy,
        onClick: this.loadMore
      }, interpolate(gettext("Show more (%(more)s)"), {
        more: this.state.more
      }, true)));
    }
  }, {
    key: "getListBody",
    value: function getListBody() {
      if (this.state.isLoaded && this.state.count === 0) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "lead"
        }, this.getEmptyMessage());
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_usersList.default, {
        cols: 3,
        isReady: this.state.isLoaded,
        users: this.props.users
      }), this.getMoreButton());
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      return "profile-" + this.API_FILTER;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: "toolbar"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "toolbar-left"
      }, this.getLabel()), /*#__PURE__*/_react.default.createElement(_quickSearch.default, {
        className: "toolbar-right",
        value: this.state.search,
        onChange: this.search,
        placeholder: gettext("Search users...")
      })), this.getListBody());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../reducers/users":364,"../../services/ajax":365,"../../services/page-title":373,"../../services/snackbar":376,"../../services/store":377,"../button":8,"../quick-search":197,"../users-list":284,"react":"react"}],187:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _followers = _interopRequireDefault(require("./followers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Followers) {
  _inherits(_default, _Followers);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "setSpecialProps",
    value: function setSpecialProps() {
      this.PRELOADED_DATA_KEY = "PROFILE_FOLLOWS";
      this.TITLE = gettext("Follows");
      this.API_FILTER = "follows";
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (!this.state.isLoaded) {
        return gettext("Loading...");
      } else if (this.state.search) {
        var message = ngettext("Found %(users)s user.", "Found %(users)s users.", this.state.count);
        return interpolate(message, {
          users: this.state.count
        }, true);
      } else if (this.props.profile.id === this.props.user.id) {
        var _message = ngettext("You are following %(users)s user.", "You are following %(users)s users.", this.state.count);

        return interpolate(_message, {
          users: this.state.count
        }, true);
      } else {
        var _message2 = ngettext("%(username)s is following %(users)s user.", "%(username)s is following %(users)s users.", this.state.count);

        return interpolate(_message2, {
          username: this.props.profile.username,
          users: this.state.count
        }, true);
      }
    }
  }, {
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      if (this.state.search) {
        return gettext("Search returned no users matching specified criteria.");
      } else if (this.props.user.id === this.props.profile.id) {
        return gettext("You are not following any users.");
      } else {
        return interpolate(gettext("%(username)s is not following any users."), {
          username: this.props.profile.username
        }, true);
      }
    }
  }]);

  return _default;
}(_followers.default);

exports.default = _default;

},{"./followers":186,"react":"react"}],188:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IsDisabledMessage = IsDisabledMessage;
exports.getColStyle = getColStyle;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _dropdownToggle = _interopRequireDefault(require("../dropdown-toggle"));

var _followButton = _interopRequireDefault(require("./follow-button"));

var _messageButton = _interopRequireDefault(require("./message-button"));

var _nav = _interopRequireDefault(require("./moderation/nav"));

var _navs = require("./navs");

var _userStatus = _interopRequireWildcard(require("../user-status"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getUserStatus",
    value: function getUserStatus() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "user-status-display"
      }, /*#__PURE__*/_react.default.createElement(_userStatus.default, {
        user: this.props.profile,
        status: this.props.profile.status
      }, /*#__PURE__*/_react.default.createElement(_userStatus.StatusIcon, {
        user: this.props.profile,
        status: this.props.profile.status
      }), /*#__PURE__*/_react.default.createElement(_userStatus.StatusLabel, {
        user: this.props.profile,
        status: this.props.profile.status,
        className: "status-label"
      })));
    }
  }, {
    key: "getUserRank",
    value: function getUserRank() {
      if (this.props.profile.rank.is_tab) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "user-rank"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: this.props.profile.rank.url,
          className: "item-title"
        }, this.props.profile.rank.name));
      } else {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "user-rank"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "item-title"
        }, this.props.profile.rank.name));
      }
    }
  }, {
    key: "getUserTitle",
    value: function getUserTitle() {
      if (this.props.profile.title) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "user-title"
        }, this.props.profile.title);
      } else if (this.props.profile.rank.title) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "user-title"
        }, this.props.profile.rank.title);
      } else {
        return null;
      }
    }
  }, {
    key: "getJoinedOn",
    value: function getJoinedOn() {
      var title = interpolate(gettext("Joined on %(joined_on)s"), {
        joined_on: this.props.profile.joined_on.format("LL, LT")
      }, true);
      var age = interpolate(gettext("Joined %(joined_on)s"), {
        joined_on: this.props.profile.joined_on.fromNow()
      }, true);
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "user-joined-on"
      }, /*#__PURE__*/_react.default.createElement("abbr", {
        title: title
      }, age));
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      if (this.props.profile.email) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "user-email"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:" + this.props.profile.email,
          className: "item-title"
        }, this.props.profile.email));
      } else {
        return null;
      }
    }
  }, {
    key: "getFollowButton",
    value: function getFollowButton() {
      if (this.props.profile.acl.can_follow) {
        return /*#__PURE__*/_react.default.createElement(_followButton.default, {
          className: "btn btn-block btn-outline",
          profile: this.props.profile
        });
      } else {
        return null;
      }
    }
  }, {
    key: "getModerationButton",
    value: function getModerationButton() {
      if (this.props.profile.acl.can_moderate) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "btn-group btn-group-justified"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "btn-group"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-default btn-moderate btn-outline dropdown-toggle",
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "tonality"), gettext("Moderation")), /*#__PURE__*/_react.default.createElement(_nav.default, {
          profile: this.props.profile
        })));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var canFollow = this.props.profile.acl.can_follow;
      var canModerate = this.props.profile.acl.can_moderate;
      var isProfileOwner = this.props.user.id === this.props.profile.id;
      var canMessage = !isProfileOwner && this.props.user.acl.can_start_private_threads;
      var cols = 0;
      if (canFollow) cols += 1;
      if (canModerate) cols += 1;
      if (canMessage) cols += 1;
      var colsWidth = cols ? 2 * cols + 1 : 0;
      var headerClassName = "page-header";

      if (this.props.profile.rank.css_class) {
        headerClassName += " page-header-rank-" + this.props.profile.rank.css_class;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(IsDisabledMessage, {
        isActive: this.props.profile.is_active,
        isDeletingAccount: this.props.profile.is_deleting_account
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-9 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-" + (12 - colsWidth)
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        className: "user-avatar user-avatar-sm",
        user: this.props.profile,
        size: "100",
        size2x: "200"
      }), /*#__PURE__*/_react.default.createElement("h1", null, this.props.profile.username)), !!cols && /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-" + colsWidth
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row xs-margin-top sm-margin-top"
      }, !!canMessage && /*#__PURE__*/_react.default.createElement("div", {
        className: getColStyle(cols, 0)
      }, /*#__PURE__*/_react.default.createElement(_messageButton.default, {
        className: "btn btn-default btn-block btn-outline",
        profile: this.props.profile,
        user: this.props.user
      })), !!canFollow && /*#__PURE__*/_react.default.createElement("div", {
        className: getColStyle(cols, 1)
      }, this.getFollowButton()), !!canModerate && /*#__PURE__*/_react.default.createElement("div", {
        className: getColStyle(cols, 2)
      }, this.getModerationButton()))))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-stats"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-9 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-inline"
      }, this.getUserStatus(), this.getUserRank(), this.getUserTitle(), this.getJoinedOn(), this.getEmail()))))), /*#__PURE__*/_react.default.createElement(_navs.CompactNav, {
        baseUrl: this.props.baseUrl,
        pages: this.props.pages,
        profile: this.props.profile
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function IsDisabledMessage(_ref) {
  var isActive = _ref.isActive,
      isDeletingAccount = _ref.isDeletingAccount;
  if (isActive !== false && isDeletingAccount !== true) return null;
  var message = null;

  if (isDeletingAccount) {
    message = gettext("This user is deleting their account.");
  } else {
    message = gettext("This user's account has been disabled by administrator.");
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "alert alert-danger"
  }, /*#__PURE__*/_react.default.createElement("p", null, message));
}

function getColStyle(cols, col) {
  var colStyle = "";

  if (cols == 1) {
    colStyle = "col-xs-12";
  }

  if (cols == 2) {
    colStyle = "col-xs-6 col-sm-6";
  }

  if (cols == 3) {
    if (col == 2) {
      colStyle = "col-xs-12 col-sm-4 xs-margin-top";
    } else {
      colStyle += "col-xs-6 col-sm-4";
    }
  }

  return colStyle;
}

},{"../avatar":6,"../dropdown-toggle":27,"../user-status":274,"./follow-button":185,"./message-button":189,"./moderation/nav":193,"./navs":194,"react":"react"}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _posting.default.open({
        mode: "START_PRIVATE",
        submit: _.default.get("PRIVATE_THREADS_API"),
        to: [_this.props.profile]
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var canMessage = this.props.user.acl.can_start_private_threads;
      var isProfileOwner = this.props.user.id === this.props.profile.id;
      if (!canMessage || isProfileOwner) return null;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: this.props.className,
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "comment"), gettext("Message"));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../services/posting":375,"react":"react"}],190:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _modalLoader = _interopRequireDefault(require("../../modal-loader"));

var _yesNoSwitch = _interopRequireDefault(require("../../yes-no-switch"));

var _modalMessage = _interopRequireDefault(require("../../modal-message"));

var _users = require("../../../reducers/users");

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isLoaded: false,
      isLoading: false,
      error: null,
      is_avatar_locked: "",
      avatar_lock_user_message: "",
      avatar_lock_staff_message: ""
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.profile.api.moderate_avatar).then(function (options) {
        _this2.setState({
          isLoaded: true,
          is_avatar_locked: options.is_avatar_locked,
          avatar_lock_user_message: options.avatar_lock_user_message || "",
          avatar_lock_staff_message: options.avatar_lock_staff_message || ""
        });
      }, function (rejection) {
        _this2.setState({
          isLoaded: true,
          error: rejection.detail
        });
      });
    }
  }, {
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(this.validate().username[0]);

        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.profile.api.moderate_avatar, {
        is_avatar_locked: this.state.is_avatar_locked,
        avatar_lock_user_message: this.state.avatar_lock_user_message,
        avatar_lock_staff_message: this.state.avatar_lock_staff_message
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      _store.default.dispatch((0, _users.updateAvatar)(this.props.profile, apiResponse.avatar_hash));

      _snackbar.default.success(gettext("Avatar controls have been changed."));
    }
  }, {
    key: "getFormBody",
    value: function getFormBody() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Lock avatar"),
        helpText: gettext("Locking user avatar will prohibit user from changing his avatar and will reset his/her avatar to default one."),
        for: "id_is_avatar_locked"
      }, /*#__PURE__*/_react.default.createElement(_yesNoSwitch.default, {
        id: "id_is_avatar_locked",
        disabled: this.state.isLoading,
        iconOn: "lock_outline",
        iconOff: "lock_open",
        labelOn: gettext("Disallow user from changing avatar"),
        labelOff: gettext("Allow user to change avatar"),
        onChange: this.bindInput("is_avatar_locked"),
        value: this.state.is_avatar_locked
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("User message"),
        helpText: gettext("Optional message for user explaining why he/she is prohibited form changing avatar."),
        for: "id_avatar_lock_user_message"
      }, /*#__PURE__*/_react.default.createElement("textarea", {
        id: "id_avatar_lock_user_message",
        className: "form-control",
        rows: "4",
        disabled: this.state.isLoading,
        onChange: this.bindInput("avatar_lock_user_message"),
        value: this.state.avatar_lock_user_message
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Staff message"),
        helpText: gettext("Optional message for forum team members explaining why user is prohibited form changing avatar."),
        for: "id_avatar_lock_staff_message"
      }, /*#__PURE__*/_react.default.createElement("textarea", {
        id: "id_avatar_lock_staff_message",
        className: "form-control",
        rows: "4",
        disabled: this.state.isLoading,
        onChange: this.bindInput("avatar_lock_staff_message"),
        value: this.state.avatar_lock_staff_message
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default",
        "data-dismiss": "modal"
      }, gettext("Close")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Save changes"))));
    }
  }, {
    key: "getModalBody",
    value: function getModalBody() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          icon: "remove_circle_outline",
          message: this.state.error
        });
      } else if (this.state.isLoaded) {
        return this.getFormBody();
      } else {
        return /*#__PURE__*/_react.default.createElement(_modalLoader.default, null);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.state.error) {
        return "modal-dialog modal-message modal-avatar-controls";
      } else {
        return "modal-dialog modal-avatar-controls";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Avatar controls"))), this.getModalBody()));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../reducers/users":364,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"../../button":8,"../../form":56,"../../form-group":55,"../../modal-loader":61,"../../modal-message":62,"../../yes-no-switch":300,"react":"react"}],191:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _modalLoader = _interopRequireDefault(require("../../modal-loader"));

var _modalMessage = _interopRequireDefault(require("../../modal-message"));

var _usernameHistory = require("../../../reducers/username-history");

var _users = require("../../../reducers/users");

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

var validators = _interopRequireWildcard(require("../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isLoaded: false,
      isLoading: false,
      error: null,
      username: "",
      validators: {
        username: [validators.usernameContent()]
      }
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.profile.api.moderate_username).then(function () {
        _this2.setState({
          isLoaded: true
        });
      }, function (rejection) {
        _this2.setState({
          isLoaded: true,
          error: rejection.detail
        });
      });
    }
  }, {
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(this.validate().username[0]);

        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.profile.api.moderate_username, {
        username: this.state.username
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.setState({
        username: ""
      });

      _store.default.dispatch((0, _usernameHistory.addNameChange)(apiResponse, this.props.profile, this.props.user));

      _store.default.dispatch((0, _users.updateUsername)(this.props.profile, apiResponse.username, apiResponse.slug));

      _snackbar.default.success(gettext("Username has been changed."));
    }
  }, {
    key: "getFormBody",
    value: function getFormBody() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("New username"),
        for: "id_username"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_username",
        className: "form-control",
        disabled: this.state.isLoading,
        onChange: this.bindInput("username"),
        value: this.state.username
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Change username"))));
    }
  }, {
    key: "getModalBody",
    value: function getModalBody() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          icon: "remove_circle_outline",
          message: this.state.error
        });
      } else if (this.state.isLoaded) {
        return this.getFormBody();
      } else {
        return /*#__PURE__*/_react.default.createElement(_modalLoader.default, null);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.state.error) {
        return "modal-dialog modal-message modal-rename-user";
      } else {
        return "modal-dialog modal-rename-user";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Change username"))), this.getModalBody()));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../reducers/username-history":363,"../../../reducers/users":364,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"../../../utils/validators":393,"../../button":8,"../../form":56,"../../form-group":55,"../../modal-loader":61,"../../modal-message":62,"react":"react"}],192:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _modalLoader = _interopRequireDefault(require("../../modal-loader"));

var _modalMessage = _interopRequireDefault(require("../../modal-message"));

var _yesNoSwitch = _interopRequireDefault(require("../../yes-no-switch"));

var _ = _interopRequireDefault(require("../../.."));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _polls = _interopRequireDefault(require("../../../services/polls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "countdown", function () {
      window.setTimeout(function () {
        if (_this.state.countdown > 1) {
          _this.setState({
            countdown: _this.state.countdown - 1
          });

          _this.countdown();
        } else if (!_this.state.confirm) {
          _this.setState({
            confirm: true
          });
        }
      }, 1000);
    });

    _this.state = {
      isLoaded: false,
      isLoading: false,
      isDeleted: false,
      error: null,
      countdown: 5,
      confirm: false,
      with_content: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(this.props.profile.api.delete).then(function () {
        _this2.setState({
          isLoaded: true
        });

        _this2.countdown();
      }, function (rejection) {
        _this2.setState({
          isLoaded: true,
          error: rejection.detail
        });
      });
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.profile.api.delete, {
        with_content: this.state.with_content
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      _polls.default.stop("user-profile");

      if (this.state.with_content) {
        this.setState({
          isDeleted: interpolate(gettext("%(username)s's account, threads, posts and other content has been deleted."), {
            username: this.props.profile.username
          }, true)
        });
      } else {
        this.setState({
          isDeleted: interpolate(gettext("%(username)s's account has been deleted and other content has been hidden."), {
            username: this.props.profile.username
          }, true)
        });
      }
    }
  }, {
    key: "getButtonLabel",
    value: function getButtonLabel() {
      if (this.state.confirm) {
        return interpolate(gettext("Delete %(username)s"), {
          username: this.props.profile.username
        }, true);
      } else {
        return interpolate(gettext("Please wait... (%(countdown)ss)"), {
          countdown: this.state.countdown
        }, true);
      }
    }
  }, {
    key: "getForm",
    value: function getForm() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("User content"),
        for: "id_with_content"
      }, /*#__PURE__*/_react.default.createElement(_yesNoSwitch.default, {
        id: "id_with_content",
        disabled: this.state.isLoading,
        labelOn: gettext("Delete together with user's account"),
        labelOff: gettext("Hide after deleting user's account"),
        onChange: this.bindInput("with_content"),
        value: this.state.with_content
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default",
        "data-dismiss": "modal"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-danger",
        loading: this.state.isLoading,
        disabled: !this.state.confirm
      }, this.getButtonLabel())));
    }
  }, {
    key: "getDeletedBody",
    value: function getDeletedBody() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.state.isDeleted), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _.default.get("USERS_LIST_URL")
      }, gettext("Return to users list")))));
    }
  }, {
    key: "getModalBody",
    value: function getModalBody() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement(_modalMessage.default, {
          icon: "remove_circle_outline",
          message: this.state.error
        });
      } else if (this.state.isLoaded) {
        if (this.state.isDeleted) {
          return this.getDeletedBody();
        } else {
          return this.getForm();
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_modalLoader.default, null);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.state.error || this.state.isDeleted) {
        return "modal-dialog modal-message modal-delete-account";
      } else {
        return "modal-dialog modal-delete-account";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Delete user account"))), this.getModalBody()));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../..":302,"../../../services/ajax":365,"../../../services/polls":374,"../../button":8,"../../form":56,"../../form-group":55,"../../modal-loader":61,"../../modal-message":62,"../../yes-no-switch":300,"react":"react"}],193:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _avatarControls = _interopRequireDefault(require("./avatar-controls"));

var _changeUsername = _interopRequireDefault(require("./change-username"));

var _deleteAccount = _interopRequireDefault(require("./delete-account"));

var _modal = _interopRequireDefault(require("../../../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var select = function select(store) {
  return {
    tick: store.tick,
    user: store.auth,
    profile: store.profile
  };
};

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "showAvatarDialog", function () {
      _modal.default.show((0, _reactRedux.connect)(select)(_avatarControls.default));
    });

    _defineProperty(_assertThisInitialized(_this), "showRenameDialog", function () {
      _modal.default.show((0, _reactRedux.connect)(select)(_changeUsername.default));
    });

    _defineProperty(_assertThisInitialized(_this), "showDeleteDialog", function () {
      _modal.default.show((0, _reactRedux.connect)(select)(_deleteAccount.default));
    });

    return _this;
  }

  _createClass(_default, [{
    key: "getAvatarButton",
    value: function getAvatarButton() {
      if (this.props.profile.acl.can_moderate_avatar) {
        return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn-link",
          onClick: this.showAvatarDialog
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "portrait"), gettext("Avatar controls")));
      } else {
        return null;
      }
    }
  }, {
    key: "getRenameButton",
    value: function getRenameButton() {
      if (this.props.profile.acl.can_rename) {
        return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn-link",
          onClick: this.showRenameDialog
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "credit_card"), gettext("Change username")));
      } else {
        return null;
      }
    }
  }, {
    key: "getDeleteButton",
    value: function getDeleteButton() {
      if (this.props.profile.acl.can_delete) {
        return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn-link",
          onClick: this.showDeleteDialog
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "clear"), gettext("Delete account")));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right stick-to-bottom",
        role: "menu"
      }, this.getAvatarButton(), this.getRenameButton(), this.getDeleteButton());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../services/modal":371,"./avatar-controls":190,"./change-username":191,"./delete-account":192,"react":"react","react-redux":"react-redux"}],194:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactNav = CompactNav;
exports.SideNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _li = _interopRequireDefault(require("../li"));

var _followButton = _interopRequireDefault(require("./follow-button"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SideNav = /*#__PURE__*/function (_React$Component) {
  _inherits(SideNav, _React$Component);

  var _super = _createSuper(SideNav);

  function SideNav() {
    _classCallCheck(this, SideNav);

    return _super.apply(this, arguments);
  }

  _createClass(SideNav, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "list-group nav-side"
      }, this.props.pages.map(function (page) {
        return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
          to: _this.props.baseUrl + page.component + "/",
          className: "list-group-item",
          activeClassName: "active",
          key: page.component
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, page.icon), page.name);
      }));
    }
  }]);

  return SideNav;
}(_react.default.Component);

exports.SideNav = SideNav;

function CompactNav(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-tabs hidden-md hidden-lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav nav-pills",
    role: "menu"
  }, props.pages.map(function (page) {
    return /*#__PURE__*/_react.default.createElement(_li.default, {
      path: props.baseUrl + page.component + "/",
      key: page.component
    }, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      to: props.baseUrl + page.component + "/",
      onClick: props.hideNav
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, page.icon), page.name));
  }))));
}

},{"../..":302,"../li":57,"./follow-button":185,"react":"react","react-router":"react-router"}],195:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.paths = paths;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _banDetails = _interopRequireDefault(require("./ban-details"));

var _details = _interopRequireDefault(require("./details"));

var _feed = require("./feed");

var _followers = _interopRequireDefault(require("./followers"));

var _follows = _interopRequireDefault(require("./follows"));

var _usernameHistory = _interopRequireDefault(require("./username-history"));

var _header = _interopRequireDefault(require("./header"));

var _nav = _interopRequireDefault(require("./moderation/nav"));

var _navs = require("./navs");

var _avatar = _interopRequireDefault(require("../avatar"));

var _withDropdown = _interopRequireDefault(require("../with-dropdown"));

var _ = _interopRequireDefault(require("../.."));

var _profile = require("../../reducers/profile");

var _polls = _interopRequireDefault(require("../../services/polls"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_WithDropdown) {
  _inherits(_default, _WithDropdown);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (data) {
      _store.default.dispatch((0, _profile.hydrate)(data));
    });

    _this.startPolling(props.profile.api.index);

    return _this;
  }

  _createClass(_default, [{
    key: "startPolling",
    value: function startPolling(api) {
      _polls.default.start({
        poll: "user-profile",
        url: api,
        frequency: 90 * 1000,
        update: this.update
      });
    }
  }, {
    key: "render",
    value: function render() {
      var baseUrl = _.default.get("PROFILE").url;

      var pages = _.default.get("PROFILE_PAGES");

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-user-profile"
      }, /*#__PURE__*/_react.default.createElement(_header.default, {
        baseUrl: baseUrl,
        pages: pages,
        profile: this.props.profile,
        toggleNav: this.toggleNav,
        toggleModeration: this.toggleModeration,
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-3 hidden-xs hidden-sm"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-side-avatar"
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        user: this.props.profile,
        size: "400"
      })), /*#__PURE__*/_react.default.createElement(_navs.SideNav, {
        baseUrl: baseUrl,
        pages: pages,
        profile: this.props.profile
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-9"
      }, this.props.children))));
    }
  }]);

  return _default;
}(_withDropdown.default);

exports.default = _default;

function select(store) {
  return {
    isAuthenticated: store.auth.user.id === store.profile.id,
    tick: store.tick.tick,
    user: store.auth.user,
    users: store.users,
    posts: store.posts,
    profile: store.profile,
    profileDetails: store["profile-details"],
    "username-history": store["username-history"]
  };
}

var COMPONENTS = {
  posts: _feed.Posts,
  threads: _feed.Threads,
  followers: _followers.default,
  follows: _follows.default,
  details: _details.default,
  "username-history": _usernameHistory.default,
  "ban-details": _banDetails.default
};

function paths() {
  var paths = [];

  _.default.get("PROFILE_PAGES").forEach(function (item) {
    paths.push(Object.assign({}, item, {
      path: _.default.get("PROFILE").url + item.component + "/",
      component: (0, _reactRedux.connect)(select)(COMPONENTS[item.component])
    }));
  });

  return paths;
}

},{"../..":302,"../../reducers/profile":356,"../../services/polls":374,"../../services/store":377,"../avatar":6,"../with-dropdown":299,"./ban-details":174,"./details":182,"./feed":183,"./followers":186,"./follows":187,"./header":188,"./moderation/nav":193,"./navs":194,"./username-history":196,"react":"react","react-redux":"react-redux"}],196:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _quickSearch = _interopRequireDefault(require("../quick-search"));

var _root = _interopRequireDefault(require("../username-history/root"));

var _ = _interopRequireDefault(require("../.."));

var _usernameHistory = require("../../reducers/username-history");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      _this.setState({
        isBusy: true
      });

      _this.loadChanges(_this.state.page + 1, _this.state.search);
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (ev) {
      _this.setState({
        isLoaded: false,
        isBusy: true,
        search: ev.target.value,
        count: 0,
        more: 0,
        page: 1,
        pages: 1
      });

      _this.loadChanges(1, ev.target.value);
    });

    if (_.default.has("PROFILE_NAME_HISTORY")) {
      _this.initWithPreloadedData(_.default.pop("PROFILE_NAME_HISTORY"));
    } else {
      _this.initWithoutPreloadedData();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(data) {
      this.state = {
        isLoaded: true,
        isBusy: false,
        search: "",
        count: data.count,
        more: data.more,
        page: data.page,
        pages: data.pages
      };

      _store.default.dispatch((0, _usernameHistory.hydrate)(data.results));
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData() {
      this.state = {
        isLoaded: false,
        isBusy: false,
        search: "",
        count: 0,
        more: 0,
        page: 1,
        pages: 1
      };
      this.loadChanges();
    }
  }, {
    key: "loadChanges",
    value: function loadChanges() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _ajax.default.get(_.default.get("USERNAME_CHANGES_API"), {
        user: this.props.profile.id,
        search: search,
        page: page || 1
      }, "search-username-history").then(function (data) {
        if (page === 1) {
          _store.default.dispatch((0, _usernameHistory.hydrate)(data.results));
        } else {
          _store.default.dispatch((0, _usernameHistory.append)(data.results));
        }

        _this2.setState({
          isLoaded: true,
          isBusy: false,
          count: data.count,
          more: data.more,
          page: data.page,
          pages: data.pages
        });
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: gettext("Username history"),
        parent: this.props.profile.username
      });
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (!this.state.isLoaded) {
        return gettext("Loading...");
      } else if (this.state.search) {
        var message = ngettext("Found %(changes)s username change.", "Found %(changes)s username changes.", this.state.count);
        return interpolate(message, {
          changes: this.state.count
        }, true);
      } else if (this.props.profile.id === this.props.user.id) {
        var _message = ngettext("Your username was changed %(changes)s time.", "Your username was changed %(changes)s times.", this.state.count);

        return interpolate(_message, {
          changes: this.state.count
        }, true);
      } else {
        var _message2 = ngettext("%(username)s's username was changed %(changes)s time.", "%(username)s's username was changed %(changes)s times.", this.state.count);

        return interpolate(_message2, {
          username: this.props.profile.username,
          changes: this.state.count
        }, true);
      }
    }
  }, {
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      if (this.state.search) {
        return gettext("Search returned no username changes matching specified criteria.");
      } else if (this.props.user.id === this.props.profile.id) {
        return gettext("No name changes have been recorded for your account.");
      } else {
        return interpolate(gettext("%(username)s's username was never changed."), {
          username: this.props.profile.username
        }, true);
      }
    }
  }, {
    key: "getMoreButton",
    value: function getMoreButton() {
      if (!this.state.more) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pager-more"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn btn-default btn-outline",
        loading: this.state.isBusy,
        onClick: this.loadMore
      }, interpolate(gettext("Show older (%(more)s)"), {
        more: this.state.more
      }, true)));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-username-history"
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: "toolbar"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "toolbar-left"
      }, this.getLabel()), /*#__PURE__*/_react.default.createElement(_quickSearch.default, {
        className: "toolbar-right",
        value: this.state.search,
        onChange: this.search,
        placeholder: gettext("Search history...")
      })), /*#__PURE__*/_react.default.createElement(_root.default, {
        isLoaded: this.state.isLoaded,
        emptyMessage: this.getEmptyMessage(),
        changes: this.props["username-history"]
      }), this.getMoreButton());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../..":302,"../../reducers/username-history":363,"../../services/ajax":365,"../../services/page-title":373,"../../services/snackbar":376,"../../services/store":377,"../button":8,"../quick-search":197,"../username-history/root":280,"react":"react"}],197:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.className) {
        return "form-search " + this.props.className;
      } else {
        return "form-search";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "form-control",
        value: this.props.value,
        onChange: this.props.onChange,
        placeholder: this.props.placeholder || gettext("Search...")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "search"));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],198:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loader = _interopRequireDefault(require("./loader"));

var _register = _interopRequireDefault(require("./register.js"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _captcha = _interopRequireDefault(require("../services/captcha"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showRegisterForm", function () {
      if (misago.get("SETTINGS").account_activation === "closed") {
        _snackbar.default.info(gettext("New registrations are currently disabled."));
      } else if (_this.state.isLoaded) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(_register.default, {
          criteria: _this.state.criteria
        }));
      } else {
        _this.setState({
          isLoading: true
        });

        Promise.all([_captcha.default.load(), _ajax.default.get(misago.get("AUTH_CRITERIA_API"))]).then(function (result) {
          _this.setState({
            isLoading: false,
            isLoaded: true,
            criteria: result[1]
          });

          _modal.default.show( /*#__PURE__*/_react.default.createElement(_register.default, {
            criteria: result[1]
          }));
        }, function () {
          _this.setState({
            isLoading: false
          });

          _snackbar.default.error(gettext("Registration is currently unavailable due to an error."));
        });
      }
    });

    _this.state = {
      isLoading: false,
      isLoaded: false,
      criteria: null
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      return this.props.className + (this.state.isLoading ? " btn-loading" : "");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn " + this.getClassName(),
        disabled: this.state.isLoading,
        onClick: this.showRegisterForm,
        type: "button"
      }, gettext("Register"), this.state.isLoading ? /*#__PURE__*/_react.default.createElement(_loader.default, null) : null);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/ajax":365,"../services/captcha":367,"../services/modal":371,"../services/snackbar":376,"./loader":58,"./register.js":199,"react":"react"}],199:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RegisterComplete = exports.RegisterForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _formGroup = _interopRequireDefault(require("./form-group"));

var _passwordStrength = _interopRequireDefault(require("./password-strength"));

var _RegisterLegalFootnote = _interopRequireDefault(require("./RegisterLegalFootnote"));

var _StartSocialAuth = _interopRequireDefault(require("./StartSocialAuth"));

var _ = _interopRequireDefault(require("./.."));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _auth = _interopRequireDefault(require("../services/auth"));

var _captcha = _interopRequireDefault(require("../services/captcha"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _bannedPage = _interopRequireDefault(require("../utils/banned-page"));

var validators = _interopRequireWildcard(require("../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RegisterForm = /*#__PURE__*/function (_Form) {
  _inherits(RegisterForm, _Form);

  var _super = _createSuper(RegisterForm);

  function RegisterForm(props) {
    var _this;

    _classCallCheck(this, RegisterForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePrivacyPolicyChange", function (event) {
      var value = event.target.value;

      _this.handleToggleAgreement("privacyPolicy", value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTermsOfServiceChange", function (event) {
      var value = event.target.value;

      _this.handleToggleAgreement("termsOfService", value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleAgreement", function (agreement, value) {
      _this.setState(function (prevState, props) {
        if (prevState[agreement] === null) {
          var _errors = _objectSpread(_objectSpread({}, prevState.errors), {}, _defineProperty({}, agreement, null));

          return _defineProperty({
            errors: _errors
          }, agreement, value);
        }

        var validator = _this.state.validators[agreement][0];

        var errors = _objectSpread(_objectSpread({}, prevState.errors), {}, _defineProperty({}, agreement, [validator(null)]));

        return _defineProperty({
          errors: errors
        }, agreement, null);
      });
    });

    var _this$props$criteria = _this.props.criteria,
        username = _this$props$criteria.username,
        password = _this$props$criteria.password;
    var passwordMinLength = 0;
    password.forEach(function (item) {
      if (item.name === "MinimumLengthValidator") {
        passwordMinLength = item.min_length;
      }
    });
    var formValidators = {
      username: [validators.usernameContent(), validators.usernameMinLength(username.min_length), validators.usernameMaxLength(username.max_length)],
      email: [validators.email()],
      password: [validators.passwordMinLength(passwordMinLength)],
      captcha: _captcha.default.validator()
    };

    if (!!_.default.get("TERMS_OF_SERVICE_ID")) {
      formValidators.termsOfService = [validators.requiredTermsOfService()];
    }

    if (!!_.default.get("PRIVACY_POLICY_ID")) {
      formValidators.privacyPolicy = [validators.requiredPrivacyPolicy()];
    }

    _this.state = {
      isLoading: false,
      username: "",
      email: "",
      password: "",
      captcha: "",
      termsOfService: null,
      privacyPolicy: null,
      validators: formValidators,
      errors: {}
    };
    return _this;
  }

  _createClass(RegisterForm, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Form contains errors."));

        this.setState({
          errors: this.validate()
        });
        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("USERS_API"), {
        username: this.state.username,
        email: this.state.email,
        password: this.state.password,
        captcha: this.state.captcha,
        terms_of_service: this.state.termsOfService,
        privacy_policy: this.state.privacyPolicy
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.props.callback(apiResponse);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        this.setState({
          errors: Object.assign({}, this.state.errors, rejection)
        });

        if (rejection.__all__ && rejection.__all__.length > 0) {
          _snackbar.default.error(rejection.__all__[0]);
        } else {
          _snackbar.default.error(gettext("Form contains errors."));
        }
      } else if (rejection.status === 403 && rejection.ban) {
        (0, _bannedPage.default)(rejection.ban);

        _modal.default.hide();
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog modal-register",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Register"))), /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "type",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        style: {
          display: "none"
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_StartSocialAuth.default, {
        buttonClassName: "col-xs-12 col-sm-6",
        buttonLabel: gettext("Join with %(site)s"),
        formLabel: gettext("Or create forum account:")
      }), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Username"),
        for: "id_username",
        validation: this.state.errors.username
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_username",
        className: "form-control",
        "aria-describedby": "id_username_status",
        disabled: this.state.isLoading,
        onChange: this.bindInput("username"),
        value: this.state.username
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("E-mail"),
        for: "id_email",
        validation: this.state.errors.email
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_email",
        className: "form-control",
        "aria-describedby": "id_email_status",
        disabled: this.state.isLoading,
        onChange: this.bindInput("email"),
        value: this.state.email
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Password"),
        for: "id_password",
        validation: this.state.errors.password,
        extra: /*#__PURE__*/_react.default.createElement(_passwordStrength.default, {
          password: this.state.password,
          inputs: [this.state.username, this.state.email]
        })
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        id: "id_password",
        className: "form-control",
        "aria-describedby": "id_password_status",
        disabled: this.state.isLoading,
        onChange: this.bindInput("password"),
        value: this.state.password
      })), _captcha.default.component({
        form: this
      }), /*#__PURE__*/_react.default.createElement(_RegisterLegalFootnote.default, {
        errors: this.state.errors,
        privacyPolicy: this.state.privacyPolicy,
        termsOfService: this.state.termsOfService,
        onPrivacyPolicyChange: this.handlePrivacyPolicyChange,
        onTermsOfServiceChange: this.handleTermsOfServiceChange
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Register account"))))));
    }
  }]);

  return RegisterForm;
}(_form.default);

exports.RegisterForm = RegisterForm;

var RegisterComplete = /*#__PURE__*/function (_React$Component) {
  _inherits(RegisterComplete, _React$Component);

  var _super2 = _createSuper(RegisterComplete);

  function RegisterComplete() {
    _classCallCheck(this, RegisterComplete);

    return _super2.apply(this, arguments);
  }

  _createClass(RegisterComplete, [{
    key: "getLead",
    value: function getLead() {
      if (this.props.activation === "user") {
        return gettext("%(username)s, your account has been created but you need to activate it before you will be able to sign in.");
      } else if (this.props.activation === "admin") {
        return gettext("%(username)s, your account has been created but board administrator will have to activate it before you will be able to sign in.");
      }
    }
  }, {
    key: "getSubscript",
    value: function getSubscript() {
      if (this.props.activation === "user") {
        return gettext("We have sent an e-mail to %(email)s with link that you have to click to activate your account.");
      } else if (this.props.activation === "admin") {
        return gettext("We will send an e-mail to %(email)s when this takes place.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog modal-message modal-register",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Registration complete"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, interpolate(this.getLead(), {
        username: this.props.username
      }, true)), /*#__PURE__*/_react.default.createElement("p", null, interpolate(this.getSubscript(), {
        email: this.props.email
      }, true)), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        type: "button"
      }, gettext("Ok"))))));
    }
  }]);

  return RegisterComplete;
}(_react.default.Component);

exports.RegisterComplete = RegisterComplete;

var _default = /*#__PURE__*/function (_React$Component2) {
  _inherits(_default, _React$Component2);

  var _super3 = _createSuper(_default);

  function _default(props) {
    var _this2;

    _classCallCheck(this, _default);

    _this2 = _super3.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "completeRegistration", function (apiResponse) {
      if (apiResponse.activation === "active") {
        _modal.default.hide();

        _auth.default.signIn(apiResponse);
      } else {
        _this2.setState({
          complete: apiResponse
        });
      }
    });

    _this2.state = {
      complete: false
    };
    return _this2;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.state.complete) {
        return /*#__PURE__*/_react.default.createElement(RegisterComplete, {
          activation: this.state.complete.activation,
          email: this.state.complete.email,
          username: this.state.complete.username
        });
      }

      return /*#__PURE__*/_react.default.createElement(RegisterForm, _extends({
        callback: this.completeRegistration
      }, this.props));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/ajax":365,"../services/auth":366,"../services/captcha":367,"../services/modal":371,"../services/snackbar":376,"../utils/banned-page":379,"../utils/validators":393,"./..":302,"./RegisterLegalFootnote":1,"./StartSocialAuth":2,"./button":8,"./form":56,"./form-group":55,"./password-strength":103,"react":"react"}],200:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LinkSent = exports.RequestLinkForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./.."));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var validators = _interopRequireWildcard(require("../utils/validators"));

var _bannedPage = _interopRequireDefault(require("../utils/banned-page"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RequestLinkForm = /*#__PURE__*/function (_Form) {
  _inherits(RequestLinkForm, _Form);

  var _super = _createSuper(RequestLinkForm);

  function RequestLinkForm(props) {
    var _this;

    _classCallCheck(this, RequestLinkForm);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      email: "",
      validators: {
        email: [validators.email()]
      }
    };
    return _this;
  }

  _createClass(RequestLinkForm, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Enter a valid email address."));

        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("SEND_ACTIVATION_API"), {
        email: this.state.email
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.props.callback(apiResponse);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (["already_active", "inactive_admin"].indexOf(rejection.code) > -1) {
        _snackbar.default.info(rejection.detail);
      } else if (rejection.status === 403 && rejection.ban) {
        (0, _bannedPage.default)(rejection.ban);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "well well-form well-form-request-activation-link"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control-input"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: gettext("Your e-mail address"),
        disabled: this.state.isLoading,
        onChange: this.bindInput("email"),
        value: this.state.email
      }))), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block",
        loading: this.state.isLoading
      }, gettext("Send link"))));
    }
  }]);

  return RequestLinkForm;
}(_form.default);

exports.RequestLinkForm = RequestLinkForm;

var LinkSent = /*#__PURE__*/function (_React$Component) {
  _inherits(LinkSent, _React$Component);

  var _super2 = _createSuper(LinkSent);

  function LinkSent() {
    _classCallCheck(this, LinkSent);

    return _super2.apply(this, arguments);
  }

  _createClass(LinkSent, [{
    key: "getMessage",
    value: function getMessage() {
      return interpolate(gettext("Activation link was sent to %(email)s"), {
        email: this.props.user.email
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "well well-form well-form-request-activation-link well-done"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "done-message"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.getMessage())), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary btn-block",
        type: "button",
        onClick: this.props.callback
      }, gettext("Request another link"))));
    }
  }]);

  return LinkSent;
}(_react.default.Component);

exports.LinkSent = LinkSent;

var _default = /*#__PURE__*/function (_React$Component2) {
  _inherits(_default, _React$Component2);

  var _super3 = _createSuper(_default);

  function _default(props) {
    var _this2;

    _classCallCheck(this, _default);

    _this2 = _super3.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "complete", function (apiResponse) {
      _this2.setState({
        complete: apiResponse
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "reset", function () {
      _this2.setState({
        complete: false
      });
    });

    _this2.state = {
      complete: false
    };
    return _this2;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.state.complete) {
        return /*#__PURE__*/_react.default.createElement(LinkSent, {
          user: this.state.complete,
          callback: this.reset
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(RequestLinkForm, {
          callback: this.complete
        });
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/ajax":365,"../services/snackbar":376,"../utils/banned-page":379,"../utils/validators":393,"./..":302,"./button":8,"./form":56,"react":"react"}],201:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccountInactivePage = exports.LinkSent = exports.RequestResetForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ = _interopRequireDefault(require("./.."));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var validators = _interopRequireWildcard(require("../utils/validators"));

var _bannedPage = _interopRequireDefault(require("../utils/banned-page"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RequestResetForm = /*#__PURE__*/function (_Form) {
  _inherits(RequestResetForm, _Form);

  var _super = _createSuper(RequestResetForm);

  function RequestResetForm(props) {
    var _this;

    _classCallCheck(this, RequestResetForm);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      email: "",
      validators: {
        email: [validators.email()]
      }
    };
    return _this;
  }

  _createClass(RequestResetForm, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Enter a valid email address."));

        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("SEND_PASSWORD_RESET_API"), {
        email: this.state.email
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.props.callback(apiResponse);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (["inactive_user", "inactive_admin"].indexOf(rejection.code) > -1) {
        this.props.showInactivePage(rejection);
      } else if (rejection.status === 403 && rejection.ban) {
        (0, _bannedPage.default)(rejection.ban);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "well well-form well-form-request-password-reset"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control-input"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: gettext("Your e-mail address"),
        disabled: this.state.isLoading,
        onChange: this.bindInput("email"),
        value: this.state.email
      }))), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block",
        loading: this.state.isLoading
      }, gettext("Send link"))));
    }
  }]);

  return RequestResetForm;
}(_form.default);

exports.RequestResetForm = RequestResetForm;

var LinkSent = /*#__PURE__*/function (_React$Component) {
  _inherits(LinkSent, _React$Component);

  var _super2 = _createSuper(LinkSent);

  function LinkSent() {
    _classCallCheck(this, LinkSent);

    return _super2.apply(this, arguments);
  }

  _createClass(LinkSent, [{
    key: "getMessage",
    value: function getMessage() {
      return interpolate(gettext("Reset password link was sent to %(email)s"), {
        email: this.props.user.email
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "well well-form well-form-request-password-reset well-done"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "done-message"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.getMessage())), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-block",
        onClick: this.props.callback
      }, gettext("Request another link"))));
    }
  }]);

  return LinkSent;
}(_react.default.Component);

exports.LinkSent = LinkSent;

var AccountInactivePage = /*#__PURE__*/function (_React$Component2) {
  _inherits(AccountInactivePage, _React$Component2);

  var _super3 = _createSuper(AccountInactivePage);

  function AccountInactivePage() {
    _classCallCheck(this, AccountInactivePage);

    return _super3.apply(this, arguments);
  }

  _createClass(AccountInactivePage, [{
    key: "getActivateButton",
    value: function getActivateButton() {
      if (this.props.activation === "inactive_user") {
        return /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
          href: _.default.get("REQUEST_ACTIVATION_URL")
        }, gettext("Activate your account.")));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-message page-message-info page-forgotten-password-inactive"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-panel"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, gettext("Your account is inactive.")), /*#__PURE__*/_react.default.createElement("p", null, this.props.message), this.getActivateButton()))));
    }
  }]);

  return AccountInactivePage;
}(_react.default.Component);

exports.AccountInactivePage = AccountInactivePage;

var _default = /*#__PURE__*/function (_React$Component3) {
  _inherits(_default, _React$Component3);

  var _super4 = _createSuper(_default);

  function _default(props) {
    var _this2;

    _classCallCheck(this, _default);

    _this2 = _super4.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "complete", function (apiResponse) {
      _this2.setState({
        complete: apiResponse
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "reset", function () {
      _this2.setState({
        complete: false
      });
    });

    _this2.state = {
      complete: false
    };
    return _this2;
  }

  _createClass(_default, [{
    key: "showInactivePage",
    value: function showInactivePage(apiResponse) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(AccountInactivePage, {
        activation: apiResponse.code,
        message: apiResponse.detail
      }), document.getElementById("page-mount"));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.complete) {
        return /*#__PURE__*/_react.default.createElement(LinkSent, {
          callback: this.reset,
          user: this.state.complete
        });
      }

      return /*#__PURE__*/_react.default.createElement(RequestResetForm, {
        callback: this.complete,
        showInactivePage: this.showInactivePage
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/ajax":365,"../services/snackbar":376,"../utils/banned-page":379,"../utils/validators":393,"./..":302,"./button":8,"./form":56,"react":"react","react-dom":"react-dom"}],202:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PasswordChangedPage = exports.ResetPasswordForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ = _interopRequireDefault(require("./.."));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _signIn = _interopRequireDefault(require("./sign-in.js"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _auth = _interopRequireDefault(require("../services/auth"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _bannedPage = _interopRequireDefault(require("../utils/banned-page"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResetPasswordForm = /*#__PURE__*/function (_Form) {
  _inherits(ResetPasswordForm, _Form);

  var _super = _createSuper(ResetPasswordForm);

  function ResetPasswordForm(props) {
    var _this;

    _classCallCheck(this, ResetPasswordForm);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      password: ""
    };
    return _this;
  }

  _createClass(ResetPasswordForm, [{
    key: "clean",
    value: function clean() {
      if (this.state.password.trim().length) {
        return true;
      } else {
        _snackbar.default.error(gettext("Enter new password."));

        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("CHANGE_PASSWORD_API"), {
        password: this.state.password
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.props.callback(apiResponse);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 403 && rejection.ban) {
        (0, _bannedPage.default)(rejection.ban);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "well well-form well-form-reset-password"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control-input"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        className: "form-control",
        placeholder: gettext("Enter new password"),
        disabled: this.state.isLoading,
        onChange: this.bindInput("password"),
        value: this.state.password
      }))), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block",
        loading: this.state.isLoading
      }, gettext("Change password"))));
    }
  }]);

  return ResetPasswordForm;
}(_form.default);

exports.ResetPasswordForm = ResetPasswordForm;

var PasswordChangedPage = /*#__PURE__*/function (_React$Component) {
  _inherits(PasswordChangedPage, _React$Component);

  var _super2 = _createSuper(PasswordChangedPage);

  function PasswordChangedPage() {
    _classCallCheck(this, PasswordChangedPage);

    return _super2.apply(this, arguments);
  }

  _createClass(PasswordChangedPage, [{
    key: "getMessage",
    value: function getMessage() {
      return interpolate(gettext("%(username)s, your password has been changed successfully."), {
        username: this.props.user.username
      }, true);
    }
  }, {
    key: "showSignIn",
    value: function showSignIn() {
      _modal.default.show(_signIn.default);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-message page-message-success page-forgotten-password-changed"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-panel"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.getMessage()), /*#__PURE__*/_react.default.createElement("p", null, gettext("You will have to sign in using new password before continuing.")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.showSignIn
      }, gettext("Sign in")))))));
    }
  }]);

  return PasswordChangedPage;
}(_react.default.Component);

exports.PasswordChangedPage = PasswordChangedPage;

var _default = /*#__PURE__*/function (_React$Component2) {
  _inherits(_default, _React$Component2);

  var _super3 = _createSuper(_default);

  function _default() {
    var _this2;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "complete", function (apiResponse) {
      _auth.default.softSignOut(); // nuke "redirect_to" field so we don't end
      // coming back to error page after sign in


      $('#hidden-login-form input[name="redirect_to"]').remove();

      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(PasswordChangedPage, {
        user: apiResponse
      }), document.getElementById("page-mount"));
    });

    return _this2;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(ResetPasswordForm, {
        callback: this.complete
      });
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../services/ajax":365,"../services/auth":366,"../services/modal":371,"../services/snackbar":376,"../utils/banned-page":379,"./..":302,"./button":8,"./form":56,"./sign-in.js":211,"react":"react","react-dom":"react-dom"}],203:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../.."));

var _form = _interopRequireDefault(require("../form"));

var _posts = require("../../reducers/posts");

var _search = require("../../reducers/search");

var _users = require("../../reducers/users");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onQueryChange", function (event) {
      _this.changeValue("query", event.target.value);
    });

    _this.state = {
      isLoading: false,
      query: props.search.query
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.query.length) {
        this.handleSubmit();
      }
    }
  }, {
    key: "clean",
    value: function clean() {
      if (!this.state.query.trim().length) {
        _snackbar.default.error(gettext("You have to enter search query."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      _store.default.dispatch((0, _search.update)({
        isLoading: true
      }));

      return _ajax.default.get(_.default.get("SEARCH_API"), {
        q: this.state.query.trim()
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(providers) {
      _store.default.dispatch((0, _search.update)({
        query: this.state.query.trim(),
        isLoading: false,
        providers: providers
      }));

      providers.forEach(function (provider) {
        if (provider.id === "users") {
          _store.default.dispatch((0, _users.hydrate)(provider.results.results));
        } else if (provider.id === "threads") {
          _store.default.dispatch((0, _posts.load)(provider.results));
        }
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      _snackbar.default.apiError(rejection);

      _store.default.dispatch((0, _search.update)({
        isLoading: false
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header page-search-form"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-md-3"
      }, /*#__PURE__*/_react.default.createElement("h1", null, gettext("Search"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-md-9"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row xs-margin-top sm-margin-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-8 col-md-9"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.props.search.isLoading || this.state.isLoading,
        onChange: this.onQueryChange,
        type: "text",
        value: this.state.query
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 col-sm-4 col-md-3"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary btn-block btn-outline",
        disabled: this.props.search.isLoading || this.state.isLoading
      }, gettext("Search"))))))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../..":302,"../../reducers/posts":354,"../../reducers/search":357,"../../reducers/users":364,"../../services/ajax":365,"../../services/snackbar":376,"../../services/store":377,"../form":56,"react":"react"}],204:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.default = _default;

var _reactRedux = require("react-redux");

var _threads = _interopRequireDefault(require("./threads"));

var _users = _interopRequireDefault(require("./users"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  threads: _threads.default,
  users: _users.default
};

function select(store) {
  return {
    posts: store.posts,
    search: store.search,
    tick: store.tick.tick,
    user: store.auth.user,
    users: store.users
  };
}

function _default(providers) {
  return providers.map(function (provider) {
    return {
      path: provider.url,
      component: (0, _reactRedux.connect)(select)(components[provider.id]),
      provider: provider
    };
  });
}

},{"./threads":207,"./users":209,"react-redux":"react-redux"}],205:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.SearchTime = SearchTime;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("./form"));

var _sidenav = _interopRequireDefault(require("./sidenav"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page page-search"
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    provider: props.provider,
    search: props.search
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/_react.default.createElement(_sidenav.default, {
    providers: props.search.providers
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-9"
  }, props.children, /*#__PURE__*/_react.default.createElement(SearchTime, {
    provider: props.provider,
    search: props.search
  })))));
}

function SearchTime(props) {
  var time = null;
  props.search.providers.forEach(function (p) {
    if (p.id === props.provider.id) {
      time = p.time;
    }
  });
  if (time === null) return null;
  var copy = gettext("Search took %(time)s s to complete");
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: "search-footer"
  }, /*#__PURE__*/_react.default.createElement("p", null, interpolate(copy, {
    time: time
  }, true)));
}

},{"./form":203,"./sidenav":206,"react":"react"}],206:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Badge = Badge;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "list-group nav-side"
  }, props.providers.map(function (provider) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      activeClassName: "active",
      className: "list-group-item",
      key: provider.id,
      to: provider.url
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, provider.icon), provider.name, /*#__PURE__*/_react.default.createElement(Badge, {
      results: provider.results
    }));
  }));
}

function Badge(props) {
  if (!props.results) return null;
  var count = props.results.count;

  if (count > 1000000) {
    count = Math.ceil(count / 1000000) + "KK";
  } else if (count > 1000) {
    count = Math.ceil(count / 1000) + "K";
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "badge"
  }, count);
}

},{"react":"react","react-router":"react-router"}],207:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Blankslate = Blankslate;

var _react = _interopRequireDefault(require("react"));

var _page = _interopRequireDefault(require("../page"));

var _results = _interopRequireDefault(require("./results"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_page.default, {
    provider: props.route.provider,
    search: props.search
  }, /*#__PURE__*/_react.default.createElement(Blankslate, {
    query: props.search.query,
    posts: props.posts
  }, /*#__PURE__*/_react.default.createElement(_results.default, _extends({
    provider: props.route.provider,
    query: props.search.query
  }, props.posts))));
}

function Blankslate(props) {
  if (props.posts && props.posts.count) return props.children;

  if (props.query.length) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, gettext("No threads matching search query have been found."));
  }

  return /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("Enter at least two characters to search threads."));
}

},{"../page":205,"./results":208,"react":"react"}],208:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.LoadMore = void 0;

var _react = _interopRequireDefault(require("react"));

var _postFeed = _interopRequireDefault(require("../../post-feed"));

var _button = _interopRequireDefault(require("../../button"));

var _misagoMarkup = _interopRequireDefault(require("../../misago-markup"));

var _posts = require("../../../reducers/posts");

var _search = require("../../../reducers/search");

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_postFeed.default, {
    isReady: true,
    posts: props.results
  }), /*#__PURE__*/_react.default.createElement(LoadMore, props));
}

var LoadMore = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadMore, _React$Component);

  var _super = _createSuper(LoadMore);

  function LoadMore() {
    var _this;

    _classCallCheck(this, LoadMore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _store.default.dispatch((0, _posts.update)({
        isBusy: true
      }));

      _ajax.default.get(_this.props.provider.api, {
        q: _this.props.query,
        page: _this.props.next
      }).then(function (providers) {
        providers.forEach(function (provider) {
          if (provider.id !== "threads") return;

          _store.default.dispatch((0, _posts.append)(provider.results));

          _store.default.dispatch((0, _search.updateProvider)(provider));
        });

        _store.default.dispatch((0, _posts.update)({
          isBusy: false
        }));
      }, function (rejection) {
        _snackbar.default.apiError(rejection);

        _store.default.dispatch((0, _posts.update)({
          isBusy: false
        }));
      });
    });

    return _this;
  }

  _createClass(LoadMore, [{
    key: "render",
    value: function render() {
      if (!this.props.more) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pager-more"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn btn-default btn-outline",
        loading: this.props.isBusy,
        onClick: this.onClick
      }, gettext("Show more")));
    }
  }]);

  return LoadMore;
}(_react.default.Component);

exports.LoadMore = LoadMore;

},{"../../../reducers/posts":354,"../../../reducers/search":357,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"../../button":8,"../../misago-markup":60,"../../post-feed":122,"react":"react"}],209:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Blankslate = Blankslate;

var _react = _interopRequireDefault(require("react"));

var _page = _interopRequireDefault(require("../page"));

var _usersList = _interopRequireDefault(require("../../users-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_page.default, {
    provider: props.route.provider,
    search: props.search
  }, /*#__PURE__*/_react.default.createElement(Blankslate, {
    query: props.search.query,
    users: props.users
  }, /*#__PURE__*/_react.default.createElement(_usersList.default, {
    cols: 3,
    isReady: true,
    users: props.users
  })));
}

function Blankslate(props) {
  if (props.users.length) return props.children;

  if (props.query.length) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, gettext("No users matching search query have been found."));
  }

  return /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("Enter at least two characters to search users."));
}

},{"../../users-list":284,"../page":205,"react":"react"}],210:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = Icon;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "change", function (value) {
      return function () {
        _this.props.onChange({
          target: {
            value: value
          }
        });
      };
    });

    return _this;
  }

  _createClass(_default, [{
    key: "getChoice",
    value: function getChoice() {
      var _this2 = this;

      var choice = null;
      this.props.choices.map(function (item) {
        if (item.value === _this2.props.value) {
          choice = item;
        }
      });
      return choice;
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return this.getChoice().icon;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.getChoice().label;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group btn-select-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-select dropdown-toggle",
        id: this.props.id || null,
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "aria-describedby": this.props["aria-describedby"] || null,
        disabled: this.props.disabled || false
      }, /*#__PURE__*/_react.default.createElement(Icon, {
        icon: this.getIcon()
      }), this.getLabel()), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu"
      }, this.props.choices.map(function (item, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn-link",
          onClick: _this3.change(item.value)
        }, /*#__PURE__*/_react.default.createElement(Icon, {
          icon: item.icon
        }), item.label));
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function Icon(_ref) {
  var icon = _ref.icon;
  if (!icon) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, icon);
}

},{"react":"react"}],211:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./.."));

var _button = _interopRequireDefault(require("./button"));

var _form = _interopRequireDefault(require("./form"));

var _StartSocialAuth = _interopRequireDefault(require("./StartSocialAuth"));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _bannedPage = _interopRequireDefault(require("../utils/banned-page"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      showActivation: false,
      username: "",
      password: "",
      validators: {
        username: [],
        password: []
      }
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.isValid()) {
        _snackbar.default.error(gettext("Fill out both fields."));

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("AUTH_API"), {
        username: this.state.username,
        password: this.state.password
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      var form = $("#hidden-login-form");
      form.append('<input type="text" name="username" />');
      form.append('<input type="password" name="password" />'); // fill out form with user credentials and submit it, this will tell
      // Misago to redirect user back to right page, and will trigger browser's
      // key ring feature

      form.find('input[type="hidden"]').val(_ajax.default.getCsrfToken());
      form.find('input[name="redirect_to"]').val(window.location.pathname);
      form.find('input[name="username"]').val(this.state.username);
      form.find('input[name="password"]').val(this.state.password);
      form.submit(); // keep form loading

      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        if (rejection.code === "inactive_admin") {
          _snackbar.default.info(rejection.detail);
        } else if (rejection.code === "inactive_user") {
          _snackbar.default.info(rejection.detail);

          this.setState({
            showActivation: true
          });
        } else if (rejection.code === "banned") {
          (0, _bannedPage.default)(rejection.detail);

          _modal.default.hide();
        } else {
          _snackbar.default.error(rejection.detail);
        }
      } else if (rejection.status === 403 && rejection.ban) {
        (0, _bannedPage.default)(rejection.ban);

        _modal.default.hide();
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "getActivationButton",
    value: function getActivationButton() {
      if (!this.state.showActivation) return null;
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "btn btn-success btn-block",
        href: _.default.get("REQUEST_ACTIVATION_URL")
      }, gettext("Activate account"));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog modal-sm modal-sign-in",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": gettext("Close"),
        className: "close",
        "data-dismiss": "modal",
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Sign in"))), /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_StartSocialAuth.default, {
        buttonLabel: gettext("Sign in with %(site)s"),
        formLabel: gettext("Or use your forum account:"),
        labelClassName: "text-center"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control-input"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control input-lg",
        disabled: this.state.isLoading,
        id: "id_username",
        onChange: this.bindInput("username"),
        placeholder: gettext("Username or e-mail"),
        type: "text",
        value: this.state.username
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control-input"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control input-lg",
        disabled: this.state.isLoading,
        id: "id_password",
        onChange: this.bindInput("password"),
        placeholder: gettext("Password"),
        type: "password",
        value: this.state.password
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, this.getActivationButton(), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block",
        loading: this.state.isLoading
      }, gettext("Sign in")), /*#__PURE__*/_react.default.createElement("a", {
        className: "btn btn-default btn-block",
        href: _.default.get("FORGOTTEN_PASSWORD_URL")
      }, gettext("Forgot password?"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../services/ajax":365,"../services/modal":371,"../services/snackbar":376,"../utils/banned-page":379,"./..":302,"./StartSocialAuth":2,"./button":8,"./form":56,"react":"react"}],212:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.Snackbar = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TYPES_CLASSES = {
  info: "alert-info",
  success: "alert-success",
  warning: "alert-warning",
  error: "alert-danger"
};

var Snackbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Snackbar, _React$Component);

  var _super = _createSuper(Snackbar);

  function Snackbar() {
    _classCallCheck(this, Snackbar);

    return _super.apply(this, arguments);
  }

  _createClass(Snackbar, [{
    key: "getSnackbarClass",
    value: function getSnackbarClass() {
      var snackbarClass = "alerts-snackbar";

      if (this.props.isVisible) {
        snackbarClass += " in";
      } else {
        snackbarClass += " out";
      }

      return snackbarClass;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getSnackbarClass()
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "alert " + TYPES_CLASSES[this.props.type]
      }, this.props.message));
    }
  }]);

  return Snackbar;
}(_react.default.Component);

exports.Snackbar = Snackbar;

function select(state) {
  return state.snackbar;
}

},{"react":"react"}],213:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _header = _interopRequireDefault(require("./header"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Complete = function Complete(_ref) {
  var activation = _ref.activation,
      backend_name = _ref.backend_name,
      username = _ref.username;
  var icon = "";
  var message = "";

  if (activation === "user") {
    message = gettext("%(username)s, your account has been created but you need to activate it before you will be able to sign in.");
  } else if (activation === "admin") {
    message = gettext("%(username)s, your account has been created but board administrator will have to activate it before you will be able to sign in.");
  } else {
    message = gettext("%(username)s, your account has been created and you have been signed in to it.");
  }

  if (activation === "active") {
    icon = "check";
  } else {
    icon = "info_outline";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page page-social-auth page-social-sauth-register"
  }, /*#__PURE__*/_react.default.createElement(_header.default, {
    backendName: backend_name
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-md-offset-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel panel-default panel-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "panel-title"
  }, gettext("Registration completed!"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body panel-message-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, icon)), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, interpolate(message, {
    username: username
  }, true)), /*#__PURE__*/_react.default.createElement("p", {
    className: "help-block"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-default",
    href: _.default.get("MISAGO_PATH")
  }, gettext("Return to forum index"))))))))));
};

var _default = Complete;
exports.default = _default;

},{"../..":302,"./header":214,"react":"react"}],214:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var backendName = _ref.backendName;
  var pageTitleTpl = gettext("Sign in with %(backend)s");
  var pageTitle = interpolate(pageTitleTpl, {
    backend: backendName
  }, true);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-header-bg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "page-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("h1", null, pageTitle))));
};

var _default = Header;
exports.default = _default;

},{"react":"react"}],215:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _register = _interopRequireDefault(require("./register"));

var _complete = _interopRequireDefault(require("./complete"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SocialAuth = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialAuth, _React$Component);

  var _super = _createSuper(SocialAuth);

  function SocialAuth(props) {
    var _this;

    _classCallCheck(this, SocialAuth);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRegistrationComplete", function (_ref) {
      var activation = _ref.activation,
          email = _ref.email,
          step = _ref.step,
          username = _ref.username;

      _this.setState({
        activation: activation,
        email: email,
        step: step,
        username: username
      });
    });

    _this.state = {
      step: props.step,
      activation: props.activation || "",
      email: props.email || "",
      username: props.username || ""
    };
    return _this;
  }

  _createClass(SocialAuth, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backend_name = _this$props.backend_name,
          url = _this$props.url;
      var _this$state = this.state,
          activation = _this$state.activation,
          email = _this$state.email,
          step = _this$state.step,
          username = _this$state.username;

      if (step === "register") {
        return /*#__PURE__*/_react.default.createElement(_register.default, {
          backend_name: backend_name,
          email: email,
          url: url,
          username: username,
          onRegistrationComplete: this.handleRegistrationComplete
        });
      }

      return /*#__PURE__*/_react.default.createElement(_complete.default, {
        activation: activation,
        backend_name: backend_name,
        email: email,
        url: url,
        username: username
      });
    }
  }]);

  return SocialAuth;
}(_react.default.Component);

exports.default = SocialAuth;

},{"./complete":213,"./register":216,"react":"react"}],216:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../.."));

var _RegisterLegalFootnote = _interopRequireDefault(require("../RegisterLegalFootnote"));

var _button = _interopRequireDefault(require("../button"));

var _form = _interopRequireDefault(require("../form"));

var _formGroup = _interopRequireDefault(require("../form-group"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var validators = _interopRequireWildcard(require("../../utils/validators"));

var _header = _interopRequireDefault(require("./header"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Register = /*#__PURE__*/function (_Form) {
  _inherits(Register, _Form);

  var _super = _createSuper(Register);

  function Register(props) {
    var _this;

    _classCallCheck(this, Register);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePrivacyPolicyChange", function (event) {
      var value = event.target.value;

      _this.handleToggleAgreement("privacyPolicy", value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTermsOfServiceChange", function (event) {
      var value = event.target.value;

      _this.handleToggleAgreement("termsOfService", value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleAgreement", function (agreement, value) {
      _this.setState(function (prevState, props) {
        if (prevState[agreement] === null) {
          var _errors = _objectSpread(_objectSpread({}, prevState.errors), {}, _defineProperty({}, agreement, null));

          return _defineProperty({
            errors: _errors
          }, agreement, value);
        }

        var validator = _this.state.validators[agreement][0];

        var errors = _objectSpread(_objectSpread({}, prevState.errors), {}, _defineProperty({}, agreement, [validator(null)]));

        return _defineProperty({
          errors: errors
        }, agreement, null);
      });
    });

    var formValidators = {
      email: [validators.email()],
      username: [validators.usernameContent()]
    };

    if (!!_.default.get("TERMS_OF_SERVICE_ID")) {
      formValidators.termsOfService = [validators.requiredTermsOfService()];
    }

    if (!!_.default.get("PRIVACY_POLICY_ID")) {
      formValidators.privacyPolicy = [validators.requiredPrivacyPolicy()];
    }

    _this.state = {
      email: props.email || "",
      emailProtected: !!props.email,
      username: props.username || "",
      termsOfService: null,
      privacyPolicy: null,
      validators: formValidators,
      errors: {},
      isLoading: false
    };
    return _this;
  }

  _createClass(Register, [{
    key: "clean",
    value: function clean() {
      var errors = this.validate();
      var lengths = [this.state.email.trim().length, this.state.username.trim().length];

      if (lengths.indexOf(0) !== -1) {
        _snackbar.default.error(gettext("Fill out all fields."));

        return false;
      }

      var validators = this.state.validators;
      var checkTermsOfService = !!_.default.get("TERMS_OF_SERVICE_ID");

      if (checkTermsOfService && this.state.termsOfService === null) {
        _snackbar.default.error(validators.termsOfService[0](null));

        return false;
      }

      var checkPrivacyPolicy = !!_.default.get("PRIVACY_POLICY_ID");

      if (checkPrivacyPolicy && this.state.privacyPolicy === null) {
        _snackbar.default.error(validators.privacyPolicy[0](null));

        _snackbar.default.error(gettext("You need to accept the privacy policy."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.url, {
        email: this.state.email,
        username: this.state.username,
        terms_of_service: this.state.termsOfService,
        privacy_policy: this.state.privacyPolicy
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response) {
      var onRegistrationComplete = this.props.onRegistrationComplete;
      onRegistrationComplete(response);
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 200) {
        // We've entered "errored" state because response is HTML instead of exptected JSON
        var onRegistrationComplete = this.props.onRegistrationComplete;
        var username = this.state.username;
        onRegistrationComplete({
          activation: "active",
          step: "done",
          username: username
        });
      } else if (rejection.status === 400) {
        var stateUpdate = {
          errors: rejection
        };

        if (rejection.email) {
          stateUpdate.emailProtected = false;
        }

        this.setState(stateUpdate);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var backend_name = this.props.backend_name;
      var _this$state = this.state,
          email = _this$state.email,
          emailProtected = _this$state.emailProtected,
          username = _this$state.username,
          isLoading = _this$state.isLoading;
      var emailHelpText = null;

      if (emailProtected) {
        var emailHelpTextTpl = gettext("Your e-mail address has been verified by %(backend)s.");
        emailHelpText = interpolate(emailHelpTextTpl, {
          backend: backend_name
        }, true);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-social-auth page-social-sauth-register"
      }, /*#__PURE__*/_react.default.createElement(_header.default, {
        backendName: backend_name
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-6 col-md-offset-3"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel panel-default panel-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "panel-title"
      }, gettext("Complete your details"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_username",
        label: gettext("Username"),
        validation: this.state.errors.username
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "id_username",
        className: "form-control",
        disabled: isLoading,
        onChange: this.bindInput("username"),
        value: username
      })), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_email",
        label: gettext("E-mail address"),
        helpText: emailHelpText,
        validation: emailProtected ? null : this.state.errors.email
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "email",
        id: "id_email",
        className: "form-control",
        disabled: isLoading || emailProtected,
        onChange: this.bindInput("email"),
        value: email
      })), /*#__PURE__*/_react.default.createElement(_RegisterLegalFootnote.default, {
        errors: this.state.errors,
        privacyPolicy: this.state.privacyPolicy,
        termsOfService: this.state.termsOfService,
        onPrivacyPolicyChange: this.handlePrivacyPolicyChange,
        onTermsOfServiceChange: this.handleTermsOfServiceChange
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Sign in")))))))));
    }
  }]);

  return Register;
}(_form.default);

exports.default = Register;

},{"../..":302,"../../services/ajax":365,"../../services/snackbar":376,"../../utils/validators":393,"../RegisterLegalFootnote":1,"../button":8,"../form":56,"../form-group":55,"./header":214,"react":"react"}],217:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Breadcrumb = Breadcrumb;
exports.GoBack = GoBack;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-breadcrumbs"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: "breadcrumb hidden-xs"
  }, props.path.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Breadcrumb, {
      key: item.id,
      node: item
    });
  })), /*#__PURE__*/_react.default.createElement(GoBack, props)));
}

function Breadcrumb(props) {
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: props.node.url.index
  }, props.node.name));
}

function GoBack(props) {
  var lastItem = props.path[props.path.length - 1];
  return /*#__PURE__*/_react.default.createElement("a", {
    href: lastItem.url.index,
    className: "go-back-sm visible-xs-block"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chevron_left"), lastItem.name);
}

},{"react":"react"}],218:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Moderation = Moderation;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _breadcrumbs = _interopRequireDefault(require("./breadcrumbs"));

var _thread = require("../moderation/thread");

var _stats = _interopRequireDefault(require("./stats"));

var _form = _interopRequireDefault(require("../../form"));

var _validators = require("../../posting/utils/validators");

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

var thread = _interopRequireWildcard(require("../../../reducers/thread"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      _this.changeValue("title", event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onEdit", function () {
      _this.setState({
        isEditing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      _this.setState({
        title: _this.props.thread.title,
        isEditing: false
      });
    });

    _this.state = {
      isEditing: false,
      isLoading: false,
      title: props.thread.title,
      validators: {
        title: (0, _validators.getTitleValidators)()
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.state.title.trim().length) {
        _snackbar.default.error(gettext("You have to enter thread title."));

        return false;
      }

      var errors = this.validate();

      if (errors.title) {
        _snackbar.default.error(errors.title[0]);

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.patch(this.props.thread.api.index, [{
        op: "replace",
        path: "title",
        value: this.state.title
      }]);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      _store.default.dispatch(thread.update(data));

      this.setState({
        isEditing: false
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(rejection.detail[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          thread = _this$props.thread,
          user = _this$props.user;
      var showModeration = !!user.id && (0, _thread.isModerationVisible)(thread);

      if (this.state.isEditing) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "page-header"
        }, /*#__PURE__*/_react.default.createElement(_breadcrumbs.default, {
          path: thread.path
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row xs-margin-top title-edit-form"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.handleSubmit
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-6 col-md-6"
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "form-control",
          type: "text",
          value: this.state.title,
          onChange: this.onChange
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-6 col-md-4"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row xs-margin-top-half sm-margin-top-no md-margin-top-no"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-6"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-primary btn-block btn-outline",
          disabled: this.state.isLoading,
          title: gettext("Change title")
        }, gettext("Save changes"))), /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-6"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-default btn-block btn-outline",
          disabled: this.state.isLoading,
          onClick: this.onCancel,
          title: gettext("Cancel"),
          type: "button"
        }, gettext("Cancel")))))))), /*#__PURE__*/_react.default.createElement(_stats.default, {
          thread: thread
        }));
      } else if (user.id && thread.acl.can_edit) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "page-header"
        }, /*#__PURE__*/_react.default.createElement(_breadcrumbs.default, {
          path: thread.path
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: showModeration ? "col-sm-9 col-md-8" : "col-sm-10 col-md-10"
        }, /*#__PURE__*/_react.default.createElement("h1", null, thread.title)), /*#__PURE__*/_react.default.createElement("div", {
          className: showModeration ? "col-sm-3 col-md-4" : "col-sm-3 col-md-2"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row xs-margin-top md-margin-top-no"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: showModeration ? "col-xs-6" : "col-xs-12"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-default btn-block btn-outline",
          onClick: this.onEdit,
          title: gettext("Edit title"),
          type: "button"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icon"
        }, "edit"), /*#__PURE__*/_react.default.createElement("span", {
          className: "hidden-sm"
        }, gettext("Edit")))), showModeration && /*#__PURE__*/_react.default.createElement(Moderation, this.props))))), /*#__PURE__*/_react.default.createElement(_stats.default, {
          thread: thread
        }));
      } else if (showModeration) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "page-header"
        }, /*#__PURE__*/_react.default.createElement(_breadcrumbs.default, {
          path: thread.path
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-9 col-md-10"
        }, /*#__PURE__*/_react.default.createElement("h1", null, thread.title)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-3 col-md-2"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row xs-margin-top md-margin-top-no"
        }, /*#__PURE__*/_react.default.createElement(Moderation, _extends({
          isSingle: true
        }, this.props)))))), /*#__PURE__*/_react.default.createElement(_stats.default, {
          thread: thread
        }));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header"
      }, /*#__PURE__*/_react.default.createElement(_breadcrumbs.default, {
        path: thread.path
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("h1", null, thread.title)), /*#__PURE__*/_react.default.createElement(_stats.default, {
        thread: thread
      }));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function Moderation(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.isSingle ? "col-xs-12" : "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-group btn-group-justified"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": "false",
    "aria-haspopup": "true",
    className: "btn btn-default btn-outline dropdown-toggle",
    "data-toggle": "dropdown",
    disabled: props.thread.isBusy,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "settings"), /*#__PURE__*/_react.default.createElement("span", {
    className: props.isSingle ? "" : "hidden-sm"
  }, gettext("Moderation"))), /*#__PURE__*/_react.default.createElement(_thread.ModerationControls, {
    posts: props.posts,
    thread: props.thread,
    user: props.user
  }))));
}

},{"../../../reducers/thread":360,"../../../services/ajax":365,"../../../services/snackbar":376,"../../../services/store":377,"../../form":56,"../../posting/utils/validators":144,"../moderation/thread":227,"./breadcrumbs":217,"./stats":219,"react":"react"}],219:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Weight = Weight;
exports.Unapproved = Unapproved;
exports.IsHidden = IsHidden;
exports.IsClosed = IsClosed;
exports.Replies = Replies;
exports.LastReply = LastReply;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _escapeHtml = _interopRequireDefault(require("../../../utils/escape-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_POSTER_URL = '<a href="%(url)s" class="poster-title">%(user)s</a>';
var LAST_POSTER_SPAN = '<span class="poster-title">%(user)s</span>';
var LAST_REPLY = '<abbr class="last-title" title="%(absolute)s">%(relative)s</abbr>';

function Weight(props) {
  if (props.thread.weight == 2) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-pinned-globally"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "bookmark"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Pinned globally")));
  } else if (props.thread.weight == 1) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-pinned-locally"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "bookmark_border"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Pinned locally")));
  } else {
    return null;
  }
}

function Unapproved(props) {
  if (props.thread.is_unapproved) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-unapproved"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "remove_circle"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Unapproved")));
  } else if (props.thread.has_unapproved_posts) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-unapproved-posts"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "remove_circle_outline"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Unapproved posts")));
  } else {
    return null;
  }
}

function IsHidden(props) {
  if (props.thread.is_hidden) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-hidden"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "visibility_off"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Hidden")));
  } else {
    return null;
  }
}

function IsClosed(props) {
  if (props.thread.is_closed) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "thread-closed"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "lock_outline"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-legend"
    }, gettext("Closed")));
  } else {
    return null;
  }
}

function Replies(props) {
  var message = ngettext("%(replies)s reply", "%(replies)s replies", props.thread.replies);
  var legend = interpolate(message, {
    replies: props.thread.replies
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "thread-replies"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "forum"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-legend"
  }, legend));
}

function LastReply(props) {
  var user = null;

  if (props.thread.url.last_poster) {
    user = interpolate(LAST_POSTER_URL, {
      url: (0, _escapeHtml.default)(props.thread.url.last_poster),
      user: (0, _escapeHtml.default)(props.thread.last_poster_name)
    }, true);
  } else {
    user = interpolate(LAST_POSTER_SPAN, {
      user: (0, _escapeHtml.default)(props.thread.last_poster_name)
    }, true);
  }

  var date = interpolate(LAST_REPLY, {
    absolute: (0, _escapeHtml.default)(props.thread.last_post_on.format("LLL")),
    relative: (0, _escapeHtml.default)(props.thread.last_post_on.fromNow())
  }, true);
  var message = interpolate((0, _escapeHtml.default)(gettext("last reply by %(user)s %(date)s")), {
    date: date,
    user: user
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "thread-last-reply",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
}

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "header-stats"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, /*#__PURE__*/_react.default.createElement(Weight, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(Unapproved, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(IsHidden, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(IsClosed, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(Replies, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(LastReply, {
    thread: props.thread
  }))));
}

},{"../../../utils/escape-html":383,"react":"react"}],220:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approve = approve;
exports.protect = protect;
exports.unprotect = unprotect;
exports.hide = hide;
exports.unhide = unhide;
exports.patch = patch;
exports.merge = merge;
exports.remove = remove;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var posts = _interopRequireWildcard(require("../../../../reducers/posts"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

var _errorsList = _interopRequireDefault(require("./errors-list"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function approve(props) {
  var selection = props.selection;
  var ops = [{
    op: "replace",
    path: "is-unapproved",
    value: false
  }];
  var newState = selection.map(function (post) {
    return {
      id: post.id,
      is_unapproved: false
    };
  });
  var previousState = selection.map(function (post) {
    return {
      id: post.id,
      is_unapproved: post.is_unapproved
    };
  });
  patch(props, ops, newState, previousState);
}

function protect(props) {
  var selection = props.selection;
  var ops = [{
    op: "replace",
    path: "is-protected",
    value: true
  }];
  var newState = selection.map(function (post) {
    return {
      id: post.id,
      is_protected: true
    };
  });
  var previousState = selection.map(function (post) {
    return {
      id: post.id,
      is_protected: post.is_protected
    };
  });
  patch(props, ops, newState, previousState);
}

function unprotect(props) {
  var selection = props.selection;
  var ops = [{
    op: "replace",
    path: "is-protected",
    value: false
  }];
  var newState = selection.map(function (post) {
    return {
      id: post.id,
      is_protected: false
    };
  });
  var previousState = selection.map(function (post) {
    return {
      id: post.id,
      is_protected: post.is_protected
    };
  });
  patch(props, ops, newState, previousState);
}

function hide(props) {
  var selection = props.selection;
  var ops = [{
    op: "replace",
    path: "is-hidden",
    value: true
  }];
  var newState = selection.map(function (post) {
    return {
      id: post.id,
      is_hidden: true,
      hidden_on: (0, _moment.default)(),
      hidden_by_name: props.user.username,
      url: Object.assign(post.url, {
        hidden_by: props.user.url
      })
    };
  });
  var previousState = selection.map(function (post) {
    return {
      id: post.id,
      is_hidden: post.is_hidden,
      hidden_on: post.hidden_on,
      hidden_by_name: post.hidden_by_name,
      url: post.url
    };
  });
  patch(props, ops, newState, previousState);
}

function unhide(props) {
  var selection = props.selection;
  var ops = [{
    op: "replace",
    path: "is-hidden",
    value: false
  }];
  var newState = selection.map(function (post) {
    return {
      id: post.id,
      is_hidden: false,
      hidden_on: (0, _moment.default)(),
      hidden_by_name: props.user.username,
      url: Object.assign(post.url, {
        hidden_by: props.user.url
      })
    };
  });
  var previousState = selection.map(function (post) {
    return {
      id: post.id,
      is_hidden: post.is_hidden,
      hidden_on: post.hidden_on,
      hidden_by_name: post.hidden_by_name,
      url: post.url
    };
  });
  patch(props, ops, newState, previousState);
}

function patch(props, ops, newState, previousState) {
  var selection = props.selection,
      thread = props.thread; // patch selected items

  newState.forEach(function (item) {
    post.patch(item, item);
  }); // deselect all the things

  _store.default.dispatch(posts.deselectAll()); // call ajax


  var data = {
    ops: ops,
    ids: selection.map(function (post) {
      return post.id;
    })
  };

  _ajax.default.patch(thread.api.posts.index, data).then(function (data) {
    data.forEach(function (item) {
      _store.default.dispatch(post.patch(item, item));
    });
  }, function (rejection) {
    if (rejection.status !== 400) {
      // rollback all
      previousState.forEach(function (item) {
        _store.default.dispatch(post.patch(item, item));
      });
      return _snackbar.default.apiError(rejection);
    }

    var errors = [];
    var rollback = [];
    rejection.forEach(function (item) {
      if (item.detail) {
        errors.push(item);
        rollback.push(item.id);
      } else {
        _store.default.dispatch(post.patch(item, item));
      }

      previousState.forEach(function (item) {
        if (rollback.indexOf(item) !== -1) {
          _store.default.dispatch(post.patch(item, item));
        }
      });
    });
    var posts = {};
    selection.forEach(function (item) {
      posts[item.id] = item;
    });

    _modal.default.show( /*#__PURE__*/_react.default.createElement(_errorsList.default, {
      errors: errors,
      posts: posts
    }));
  });
}

function merge(props) {
  var confirmed = confirm(gettext("Are you sure you want to merge selected posts? This action is not reversible!"));

  if (!confirmed) {
    return;
  }

  props.selection.slice(1).map(function (selection) {
    _store.default.dispatch(post.patch(selection, {
      isDeleted: true
    }));
  });

  _ajax.default.post(props.thread.api.posts.merge, {
    posts: props.selection.map(function (post) {
      return post.id;
    })
  }).then(function (data) {
    _store.default.dispatch(post.patch(data, post.hydrate(data)));
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail);
    } else {
      _snackbar.default.apiError(rejection);
    }

    props.selection.slice(1).map(function (selection) {
      _store.default.dispatch(post.patch(selection, {
        isDeleted: false
      }));
    });
  });

  _store.default.dispatch(posts.deselectAll());
}

function remove(props) {
  var confirmed = confirm(gettext("Are you sure you want to delete selected posts? This action is not reversible!"));

  if (!confirmed) {
    return;
  }

  props.selection.map(function (selection) {
    _store.default.dispatch(post.patch(selection, {
      isDeleted: true
    }));
  });
  var ids = props.selection.map(function (post) {
    return post.id;
  });

  _ajax.default.delete(props.thread.api.posts.index, ids).then(function () {
    return;
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail);
    } else {
      _snackbar.default.apiError(rejection);
    }

    props.selection.map(function (selection) {
      _store.default.dispatch(post.patch(selection, {
        isDeleted: false
      }));
    });
  });

  _store.default.dispatch(posts.deselectAll());
}

},{"../../../../reducers/post":353,"../../../../reducers/posts":354,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"./errors-list":222,"moment":"moment","react":"react"}],221:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Delete = exports.Unhide = exports.Hide = exports.Unprotect = exports.Protect = exports.Split = exports.Move = exports.Merge = exports.Approve = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var moderation = _interopRequireWildcard(require("./actions"));

var _move = _interopRequireDefault(require("./move"));

var _split = _interopRequireDefault(require("./split"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu"
  }, /*#__PURE__*/_react.default.createElement(Approve, props), /*#__PURE__*/_react.default.createElement(Merge, props), /*#__PURE__*/_react.default.createElement(Move, props), /*#__PURE__*/_react.default.createElement(Split, props), /*#__PURE__*/_react.default.createElement(Protect, props), /*#__PURE__*/_react.default.createElement(Unprotect, props), /*#__PURE__*/_react.default.createElement(Unhide, props), /*#__PURE__*/_react.default.createElement(Hide, props), /*#__PURE__*/_react.default.createElement(Delete, props));
}

var Approve = /*#__PURE__*/function (_React$Component) {
  _inherits(Approve, _React$Component);

  var _super = _createSuper(Approve);

  function Approve() {
    var _this;

    _classCallCheck(this, Approve);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      moderation.approve(_this.props);
    });

    return _this;
  }

  _createClass(Approve, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_approve && post.is_unapproved;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "done"), gettext("Approve")));
    }
  }]);

  return Approve;
}(_react.default.Component);

exports.Approve = Approve;

var Merge = /*#__PURE__*/function (_React$Component2) {
  _inherits(Merge, _React$Component2);

  var _super2 = _createSuper(Merge);

  function Merge() {
    var _this2;

    _classCallCheck(this, Merge);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      moderation.merge(_this2.props);
    });

    return _this2;
  }

  _createClass(Merge, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.length > 1 && this.props.selection.find(function (post) {
        return post.acl.can_merge;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "call_merge"), gettext("Merge")));
    }
  }]);

  return Merge;
}(_react.default.Component);

exports.Merge = Merge;

var Move = /*#__PURE__*/function (_React$Component3) {
  _inherits(Move, _React$Component3);

  var _super3 = _createSuper(Move);

  function Move() {
    var _this3;

    _classCallCheck(this, Move);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_move.default, _this3.props));
    });

    return _this3;
  }

  _createClass(Move, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_move;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), gettext("Move")));
    }
  }]);

  return Move;
}(_react.default.Component);

exports.Move = Move;

var Split = /*#__PURE__*/function (_React$Component4) {
  _inherits(Split, _React$Component4);

  var _super4 = _createSuper(Split);

  function Split() {
    var _this4;

    _classCallCheck(this, Split);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "onClick", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_split.default, _this4.props));
    });

    return _this4;
  }

  _createClass(Split, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_move;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "call_split"), gettext("Split")));
    }
  }]);

  return Split;
}(_react.default.Component);

exports.Split = Split;

var Protect = /*#__PURE__*/function (_React$Component5) {
  _inherits(Protect, _React$Component5);

  var _super5 = _createSuper(Protect);

  function Protect() {
    var _this5;

    _classCallCheck(this, Protect);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this5), "onClick", function () {
      moderation.protect(_this5.props);
    });

    return _this5;
  }

  _createClass(Protect, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return !post.is_protected && post.acl.can_protect;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_outline"), gettext("Protect")));
    }
  }]);

  return Protect;
}(_react.default.Component);

exports.Protect = Protect;

var Unprotect = /*#__PURE__*/function (_React$Component6) {
  _inherits(Unprotect, _React$Component6);

  var _super6 = _createSuper(Unprotect);

  function Unprotect() {
    var _this6;

    _classCallCheck(this, Unprotect);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this6), "onClick", function () {
      moderation.unprotect(_this6.props);
    });

    return _this6;
  }

  _createClass(Unprotect, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.is_protected && post.acl.can_protect;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_open"), gettext("Unprotect")));
    }
  }]);

  return Unprotect;
}(_react.default.Component);

exports.Unprotect = Unprotect;

var Hide = /*#__PURE__*/function (_React$Component7) {
  _inherits(Hide, _React$Component7);

  var _super7 = _createSuper(Hide);

  function Hide() {
    var _this7;

    _classCallCheck(this, Hide);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this7), "onClick", function () {
      moderation.hide(_this7.props);
    });

    return _this7;
  }

  _createClass(Hide, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_hide && !post.is_hidden;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility_off"), gettext("Hide")));
    }
  }]);

  return Hide;
}(_react.default.Component);

exports.Hide = Hide;

var Unhide = /*#__PURE__*/function (_React$Component8) {
  _inherits(Unhide, _React$Component8);

  var _super8 = _createSuper(Unhide);

  function Unhide() {
    var _this8;

    _classCallCheck(this, Unhide);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this8), "onClick", function () {
      moderation.unhide(_this8.props);
    });

    return _this8;
  }

  _createClass(Unhide, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_unhide && post.is_hidden;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility"), gettext("Unhide")));
    }
  }]);

  return Unhide;
}(_react.default.Component);

exports.Unhide = Unhide;

var Delete = /*#__PURE__*/function (_React$Component9) {
  _inherits(Delete, _React$Component9);

  var _super9 = _createSuper(Delete);

  function Delete() {
    var _this9;

    _classCallCheck(this, Delete);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this9), "onClick", function () {
      moderation.remove(_this9.props);
    });

    return _this9;
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      var isVisible = this.props.selection.find(function (post) {
        return post.acl.can_delete;
      });
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "clear"), gettext("Delete")));
    }
  }]);

  return Delete;
}(_react.default.Component);

exports.Delete = Delete;

},{"../../../../services/modal":371,"./actions":220,"./move":224,"./split":225,"react":"react"}],222:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.PostErrors = PostErrors;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var errors = _ref.errors,
      posts = _ref.posts;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog",
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Moderation"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("One or more posts could not be changed:")), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled list-errored-items"
  }, errors.map(function (post) {
    return /*#__PURE__*/_react.default.createElement(PostErrors, {
      errors: post.detail,
      key: post.id,
      post: posts[post.id]
    });
  })))));
}

function PostErrors(_ref2) {
  var errors = _ref2.errors,
      post = _ref2.post;
  var heading = interpolate(gettext("%(username)s on %(posted_on)s"), {
    posted_on: post.posted_on.format("LL, LT"),
    username: post.poster_name
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h5", null, heading, ":"), errors.map(function (error, i) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: i
    }, error);
  }));
}

},{"react":"react"}],223:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.isVisible = isVisible;

var _react = _interopRequireDefault(require("react"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  if (!props.user.id || !isVisible(props.thread, props.posts.results)) {
    return null;
  }

  var selection = props.posts.results.filter(function (post) {
    return post.isSelected;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropup"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": "true",
    "aria-haspopup": "true",
    className: "btn btn-default dropdown-toggle btn-block btn-outline",
    "data-toggle": "dropdown",
    disabled: !selection.length,
    type: "button"
  }, gettext("Posts options")), /*#__PURE__*/_react.default.createElement(_dropdown.default, _extends({
    selection: selection
  }, props)));
}

function isVisible(thread, posts) {
  if (thread.acl.can_merge_posts && posts.length > 1) {
    // fast test: show moderation menu if we can merge posts
    return true;
  } // slow test: show moderation if any of posts has moderation options


  var visible = false;
  posts.forEach(function (post) {
    if (!post.is_event) {
      var showModeration = post.acl.can_approve && post.is_unapproved || post.acl.can_delete || !post.is_hidden && post.acl.can_hide || post.acl.can_move || post.acl.can_merge || post.acl.can_protect || post.is_hidden && post.acl.can_unhide || post.acl.can_unprotect;

      if (showModeration) {
        visible = true;
      }
    }
  });
  return visible;
}

},{"./dropdown":221,"react":"react"}],224:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../../button"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUrlChange", function (event) {
      _this.changeValue("url", event.target.value);
    });

    _this.state = {
      isLoading: false,
      url: "",
      validators: {
        url: []
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.state.url.trim().length) {
        _snackbar.default.error(gettext("You have to enter link to the other thread."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.thread.api.posts.move, {
        new_thread: this.state.url,
        posts: this.props.selection.map(function (post) {
          return post.id;
        })
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(success) {
      this.props.selection.forEach(function (selection) {
        _store.default.dispatch(post.patch(selection, {
          isDeleted: true
        }));
      });

      _modal.default.hide();

      _snackbar.default.success(gettext("Selected posts were moved to the other thread."));
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(rejection.detail);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_url",
        label: gettext("Link to thread you want to move posts to")
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading,
        id: "id_url",
        onChange: this.onUrlChange,
        value: this.state.url
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary",
        loading: this.state.isLoading
      }, gettext("Move posts"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function ModalHeader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Move posts")));
}

},{"../../../../reducers/post":353,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../button":8,"../../../form":56,"../../../form-group":55,"react":"react"}],225:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Loader = Loader;
exports.Error = Error;
exports.Modal = Modal;
exports.ModerationForm = exports.PostingConfig = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../../button"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var _categorySelect = _interopRequireDefault(require("../../../category-select"));

var _modalLoader = _interopRequireDefault(require("../../../modal-loader"));

var _select = _interopRequireDefault(require("../../../select"));

var post = _interopRequireWildcard(require("../../../../reducers/post"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

var validators = _interopRequireWildcard(require("../../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement(PostingConfig, _extends({}, props, {
    Form: ModerationForm
  }));
}

var PostingConfig = /*#__PURE__*/function (_React$Component) {
  _inherits(PostingConfig, _React$Component);

  var _super = _createSuper(PostingConfig);

  function PostingConfig(props) {
    var _this;

    _classCallCheck(this, PostingConfig);

    _this = _super.call(this, props);
    _this.state = {
      isLoaded: false,
      isError: false,
      categories: []
    };
    return _this;
  }

  _createClass(PostingConfig, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(misago.get("THREAD_EDITOR_API")).then(function (data) {
        // hydrate categories, extract posting options
        var categories = data.map(function (item) {
          return Object.assign(item, {
            disabled: item.post === false,
            label: item.name,
            value: item.id,
            post: item.post
          });
        });

        _this2.setState({
          isLoaded: true,
          categories: categories
        });
      }, function (rejection) {
        _this2.setState({
          isError: rejection.detail
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isError) {
        return /*#__PURE__*/_react.default.createElement(Error, {
          message: this.state.isError
        });
      } else if (this.state.isLoaded) {
        return /*#__PURE__*/_react.default.createElement(ModerationForm, _extends({}, this.props, {
          categories: this.state.categories
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement(Loader, null);
      }
    }
  }]);

  return PostingConfig;
}(_react.default.Component);

exports.PostingConfig = PostingConfig;

var ModerationForm = /*#__PURE__*/function (_Form) {
  _inherits(ModerationForm, _Form);

  var _super2 = _createSuper(ModerationForm);

  function ModerationForm(props) {
    var _this3;

    _classCallCheck(this, ModerationForm);

    _this3 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this3), "onCategoryChange", function (ev) {
      var categoryId = ev.target.value;
      var newState = {
        category: categoryId
      };

      if (_this3.acl[categoryId].can_pin_threads < newState.weight) {
        newState.weight = 0;
      }

      if (!_this3.acl[categoryId].can_hide_threads) {
        newState.is_hidden = 0;
      }

      if (!_this3.acl[categoryId].can_close_threads) {
        newState.is_closed = false;
      }

      _this3.setState(newState);
    });

    _this3.state = {
      isLoading: false,
      title: "",
      category: null,
      categories: props.categories,
      weight: 0,
      is_hidden: 0,
      is_closed: false,
      validators: {
        title: [validators.required()]
      },
      errors: {}
    };
    _this3.isHiddenChoices = [{
      value: 0,
      icon: "visibility",
      label: gettext("No")
    }, {
      value: 1,
      icon: "visibility_off",
      label: gettext("Yes")
    }];
    _this3.isClosedChoices = [{
      value: false,
      icon: "lock_outline",
      label: gettext("No")
    }, {
      value: true,
      icon: "lock",
      label: gettext("Yes")
    }];
    _this3.acl = {};

    _this3.props.categories.forEach(function (category) {
      if (category.post) {
        if (!_this3.state.category) {
          _this3.state.category = category.id;
        }

        _this3.acl[category.id] = {
          can_pin_threads: category.post.pin,
          can_close_threads: category.post.close,
          can_hide_threads: category.post.hide
        };
      }
    });

    return _this3;
  }

  _createClass(ModerationForm, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Form contains errors."));

        this.setState({
          errors: this.validate()
        });
        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(this.props.thread.api.posts.split, {
        title: this.state.title,
        category: this.state.category,
        weight: this.state.weight,
        is_hidden: this.state.is_hidden,
        is_closed: this.state.is_closed,
        posts: this.props.selection.map(function (post) {
          return post.id;
        })
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(apiResponse) {
      this.props.selection.forEach(function (selection) {
        _store.default.dispatch(post.patch(selection, {
          isDeleted: true
        }));
      });

      _modal.default.hide();

      _snackbar.default.success(gettext("Selected posts were split into new thread."));
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        this.setState({
          errors: Object.assign({}, this.state.errors, rejection)
        });

        _snackbar.default.error(gettext("Form contains errors."));
      } else if (rejection.status === 403 && Array.isArray(rejection)) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(ErrorsModal, {
          errors: rejection
        }));
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "getWeightChoices",
    value: function getWeightChoices() {
      var choices = [{
        value: 0,
        icon: "remove",
        label: gettext("Not pinned")
      }, {
        value: 1,
        icon: "bookmark_border",
        label: gettext("Pinned locally")
      }];

      if (this.acl[this.state.category].can_pin_threads == 2) {
        choices.push({
          value: 2,
          icon: "bookmark",
          label: gettext("Pinned globally")
        });
      }

      return choices;
    }
  }, {
    key: "renderWeightField",
    value: function renderWeightField() {
      if (this.acl[this.state.category].can_pin_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Thread weight"),
          for: "id_weight",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_weight",
          onChange: this.bindInput("weight"),
          value: this.state.weight,
          choices: this.getWeightChoices()
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderHiddenField",
    value: function renderHiddenField() {
      if (this.acl[this.state.category].can_hide_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Hide thread"),
          for: "id_is_hidden",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_hidden"),
          value: this.state.is_hidden,
          choices: this.isHiddenChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderClosedField",
    value: function renderClosedField() {
      if (this.acl[this.state.category].can_close_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Close thread"),
          for: "id_is_closed",
          labelClass: "col-sm-4",
          controlClass: "col-sm-8"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_closed"),
          value: this.state.is_closed,
          choices: this.isClosedChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(Modal, {
        className: "modal-dialog"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Thread title"),
        for: "id_title",
        labelClass: "col-sm-4",
        controlClass: "col-sm-8",
        validation: this.state.errors.title
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "id_title",
        className: "form-control",
        type: "text",
        onChange: this.bindInput("title"),
        value: this.state.title
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Category"),
        for: "id_category",
        labelClass: "col-sm-4",
        controlClass: "col-sm-8",
        validation: this.state.errors.category
      }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
        id: "id_category",
        onChange: this.onCategoryChange,
        value: this.state.category,
        choices: this.state.categories
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), this.renderWeightField(), this.renderHiddenField(), this.renderClosedField()), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Split posts")))));
    }
  }]);

  return ModerationForm;
}(_form.default);

exports.ModerationForm = ModerationForm;

function Loader() {
  return /*#__PURE__*/_react.default.createElement(Modal, {
    className: "modal-dialog"
  }, /*#__PURE__*/_react.default.createElement(_modalLoader.default, null));
}

function Error(props) {
  return /*#__PURE__*/_react.default.createElement(Modal, {
    className: "modal-dialog modal-message"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("You can't move selected posts at the moment.")), /*#__PURE__*/_react.default.createElement("p", null, props.message), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default",
    "data-dismiss": "modal",
    type: "button"
  }, gettext("Ok"))));
}

function Modal(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className,
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Split posts into new thread"))), props.children));
}

},{"../../../../reducers/post":353,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../../utils/validators":393,"../../../button":8,"../../../category-select":21,"../../../form":56,"../../../form-group":55,"../../../modal-loader":61,"../../../select":210,"react":"react"}],226:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _merge = _interopRequireDefault(require("./merge"));

var _move = _interopRequireDefault(require("./move"));

var thread = _interopRequireWildcard(require("../../../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callApi", function (ops, successMessage) {
      _store.default.dispatch(thread.busy()); // by the chance update thread acl too


      ops.push({
        op: "add",
        path: "acl",
        value: true
      });

      _ajax.default.patch(_this.props.thread.api.index, ops).then(function (data) {
        _store.default.dispatch(thread.update(data));

        _store.default.dispatch(thread.release());

        _snackbar.default.success(successMessage);
      }, function (rejection) {
        _store.default.dispatch(thread.release());

        if (rejection.status === 400) {
          _snackbar.default.error(rejection.detail[0]);
        } else {
          _snackbar.default.apiError(rejection);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pinGlobally", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 2
      }], gettext("Thread has been pinned globally."));
    });

    _defineProperty(_assertThisInitialized(_this), "pinLocally", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 1
      }], gettext("Thread has been pinned locally."));
    });

    _defineProperty(_assertThisInitialized(_this), "unpin", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 0
      }], gettext("Thread has been unpinned."));
    });

    _defineProperty(_assertThisInitialized(_this), "approve", function () {
      _this.callApi([{
        op: "replace",
        path: "is-unapproved",
        value: false
      }], gettext("Thread has been approved."));
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.callApi([{
        op: "replace",
        path: "is-closed",
        value: false
      }], gettext("Thread has been opened."));
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.callApi([{
        op: "replace",
        path: "is-closed",
        value: true
      }], gettext("Thread has been closed."));
    });

    _defineProperty(_assertThisInitialized(_this), "unhide", function () {
      _this.callApi([{
        op: "replace",
        path: "is-hidden",
        value: false
      }], gettext("Thread has been made visible."));
    });

    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      _this.callApi([{
        op: "replace",
        path: "is-hidden",
        value: true
      }], gettext("Thread has been made hidden."));
    });

    _defineProperty(_assertThisInitialized(_this), "move", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_move.default, {
        posts: _this.props.posts,
        thread: _this.props.thread
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "merge", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_merge.default, {
        thread: _this.props.thread
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "delete", function () {
      if (!confirm(gettext("Are you sure you want to delete this thread?"))) {
        return;
      }

      _store.default.dispatch(thread.busy());

      _ajax.default.delete(_this.props.thread.api.index).then(function (data) {
        _snackbar.default.success(gettext("Thread has been deleted."));

        window.location = _this.props.thread.category.url.index;
      }, function (rejection) {
        _store.default.dispatch(thread.release());

        _snackbar.default.apiError(rejection);
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "getPinGloballyButton",
    value: function getPinGloballyButton() {
      if (this.props.thread.weight === 2) return null;
      if (!this.props.thread.acl.can_pin_globally) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.pinGlobally,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "bookmark"), gettext("Pin globally")));
    }
  }, {
    key: "getPinLocallyButton",
    value: function getPinLocallyButton() {
      if (this.props.thread.weight === 1) return null;
      if (!this.props.thread.acl.can_pin) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.pinLocally,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "bookmark_border"), gettext("Pin locally")));
    }
  }, {
    key: "getUnpinButton",
    value: function getUnpinButton() {
      if (this.props.thread.weight === 0) return null;
      if (!this.props.thread.acl.can_pin) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.unpin,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "panorama_fish_eye"), gettext("Unpin")));
    }
  }, {
    key: "getMoveButton",
    value: function getMoveButton() {
      if (!this.props.thread.acl.can_move) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.move,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), gettext("Move")));
    }
  }, {
    key: "getMergeButton",
    value: function getMergeButton() {
      if (!this.props.thread.acl.can_merge) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.merge,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "call_merge"), gettext("Merge")));
    }
  }, {
    key: "getApproveButton",
    value: function getApproveButton() {
      if (!this.props.thread.is_unapproved) return null;
      if (!this.props.thread.acl.can_approve) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.approve,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "done"), gettext("Approve")));
    }
  }, {
    key: "getOpenButton",
    value: function getOpenButton() {
      if (!this.props.thread.is_closed) return null;
      if (!this.props.thread.acl.can_close) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.open,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_open"), gettext("Open")));
    }
  }, {
    key: "getCloseButton",
    value: function getCloseButton() {
      if (this.props.thread.is_closed) return null;
      if (!this.props.thread.acl.can_close) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.close,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_outline"), gettext("Close")));
    }
  }, {
    key: "getUnhideButton",
    value: function getUnhideButton() {
      if (!this.props.thread.is_hidden) return null;
      if (!this.props.thread.acl.can_unhide) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.unhide,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility"), gettext("Unhide")));
    }
  }, {
    key: "getHideButton",
    value: function getHideButton() {
      if (this.props.thread.is_hidden) return null;
      if (!this.props.thread.acl.can_hide) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.hide,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility_off"), gettext("Hide")));
    }
  }, {
    key: "getDeleteButton",
    value: function getDeleteButton() {
      if (!this.props.thread.acl.can_delete) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.delete,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "clear"), gettext("Delete")));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right stick-to-bottom"
      }, this.getPinGloballyButton(), this.getPinLocallyButton(), this.getUnpinButton(), this.getMoveButton(), this.getMergeButton(), this.getApproveButton(), this.getOpenButton(), this.getCloseButton(), this.getUnhideButton(), this.getHideButton(), this.getDeleteButton());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../../reducers/thread":360,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"./merge":229,"./move":230,"react":"react"}],227:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModerationControls", {
  enumerable: true,
  get: function get() {
    return _controls.default;
  }
});
Object.defineProperty(exports, "isModerationVisible", {
  enumerable: true,
  get: function get() {
    return _isVisible.default;
  }
});

var _controls = _interopRequireDefault(require("./controls"));

var _isVisible = _interopRequireDefault(require("./is-visible"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./controls":226,"./is-visible":228}],228:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(thread) {
  return !!(thread.acl.can_approve && thread.is_unapproved || thread.acl.can_close || thread.acl.can_delete || thread.acl.can_hide || thread.acl.can_move || thread.acl.can_merge || thread.acl.can_pin || thread.acl.can_pin_globally && thread.weight !== 2 || thread.acl.can_unhide && thread.is_hidden);
}

},{}],229:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var _mergeConflict = _interopRequireDefault(require("../../../merge-conflict"));

var thread = _interopRequireWildcard(require("../../../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSuccess", function (success) {
      _this.handleSuccessUnmounted(success); // keep form loading


      _this.setState({
        isLoading: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSuccessUnmounted", function (success) {
      _snackbar.default.success(gettext("Thread has been merged with other one."));

      window.location = success.url;
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (rejection) {
      _store.default.dispatch(thread.release());

      if (rejection.status === 400) {
        if (rejection.best_answers || rejection.polls) {
          _modal.default.show( /*#__PURE__*/_react.default.createElement(_mergeConflict.default, {
            api: _this.props.thread.api.merge,
            bestAnswers: rejection.best_answers,
            data: {
              other_thread: _this.state.url
            },
            polls: rejection.polls,
            onError: _this.handleError,
            onSuccess: _this.handleSuccessUnmounted
          }));
        } else if (rejection.best_answer) {
          _snackbar.default.error(rejection.best_answer[0]);
        } else if (rejection.poll) {
          _snackbar.default.error(rejection.poll[0]);
        } else {
          _snackbar.default.error(rejection.detail);
        }
      } else {
        _snackbar.default.apiError(rejection);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onUrlChange", function (event) {
      _this.changeValue("url", event.target.value);
    });

    _this.state = {
      isLoading: false,
      url: "",
      validators: {
        url: []
      },
      errors: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (!this.state.url.trim().length) {
        _snackbar.default.error(gettext("You have to enter link to the other thread."));

        return false;
      }

      return true;
    }
  }, {
    key: "send",
    value: function send() {
      // freeze thread
      _store.default.dispatch(thread.busy());

      return _ajax.default.post(this.props.thread.api.merge, {
        other_thread: this.state.url
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        for: "id_url",
        label: gettext("Link to thread you want to merge with"),
        help_text: gettext("Merge will delete current thread and move its contents to the thread specified here.")
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        disabled: this.state.isLoading || this.props.thread.isBusy,
        id: "id_url",
        onChange: this.onUrlChange,
        value: this.state.url
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary",
        loading: this.state.isLoading || this.props.thread.isBusy
      }, gettext("Merge thread"))))));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function ModalHeader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Merge thread")));
}

},{"../../../../reducers/thread":360,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../form":56,"../../../form-group":55,"../../../merge-conflict":59,"react":"react"}],230:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;
exports.ModalLoading = ModalLoading;
exports.ModalMessage = ModalMessage;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("../../../form"));

var _formGroup = _interopRequireDefault(require("../../../form-group"));

var _categorySelect = _interopRequireDefault(require("../../../category-select"));

var _modalLoader = _interopRequireDefault(require("../../../modal-loader"));

var posts = _interopRequireWildcard(require("../../../../reducers/posts"));

var thread = _interopRequireWildcard(require("../../../../reducers/thread"));

var _ = _interopRequireDefault(require("../../../.."));

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCategoryChange", function (event) {
      _this.changeValue("category", event.target.value);
    });

    _this.state = {
      isReady: false,
      isLoading: false,
      isError: false,
      category: null,
      categories: []
    };
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ajax.default.get(_.default.get("THREAD_EDITOR_API")).then(function (data) {
        var category = null; // hydrate categories, extract posting options

        var categories = data.map(function (item) {
          // pick first category that allows posting and if it may, override it with initial one
          if (item.post !== false && !category) {
            category = item.id;
          }

          return Object.assign(item, {
            disabled: item.post === false,
            label: item.name,
            value: item.id
          });
        });

        _this2.setState({
          isReady: true,
          category: category,
          categories: categories
        });
      }, function (rejection) {
        _this2.setState({
          isError: rejection.detail
        });
      });
    }
  }, {
    key: "send",
    value: function send() {
      // freeze thread
      _store.default.dispatch(thread.busy());

      return _ajax.default.patch(this.props.thread.api.index, [{
        op: "replace",
        path: "category",
        value: this.state.category
      }]);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      // refresh thread and displayed posts
      _ajax.default.get(this.props.thread.api.posts.index, {
        page: this.props.posts.page
      }).then(function (data) {
        _store.default.dispatch(thread.replace(data));

        _store.default.dispatch(posts.load(data.post_set));

        _store.default.dispatch(thread.release());

        _snackbar.default.success(gettext("Thread has been moved."));

        _modal.default.hide();
      }, function (rejection) {
        _store.default.dispatch(thread.release());

        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "handleError",
    value: function handleError(rejection) {
      if (rejection.status === 400) {
        _snackbar.default.error(rejection.detail[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isReady) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-dialog",
          role: "document"
        }, /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: this.handleSubmit
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-content"
        }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-body"
        }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          for: "id_category",
          label: gettext("New category")
        }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
          choices: this.state.categories,
          disabled: this.state.isLoading || this.props.thread.isBusy,
          id: "id_category",
          onChange: this.onCategoryChange,
          value: this.state.category
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-footer"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-default",
          "data-dismiss": "modal",
          disabled: this.state.isLoading,
          type: "button"
        }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-primary",
          loading: this.state.isLoading || this.props.thread.isBusy
        }, gettext("Move thread"))))));
      } else if (this.state.isError) {
        return /*#__PURE__*/_react.default.createElement(ModalMessage, {
          message: this.state.isError
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(ModalLoading, null);
      }
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

function ModalHeader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": gettext("Close"),
    className: "close",
    "data-dismiss": "modal",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, gettext("Move thread")));
}

function ModalLoading(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog",
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement(_modalLoader.default, null)));
}

function ModalMessage(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog modal-message",
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/_react.default.createElement(ModalHeader, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "lead"
  }, gettext("You can't move this thread at the moment.")), /*#__PURE__*/_react.default.createElement("p", null, props.message), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default",
    "data-dismiss": "modal",
    type: "button"
  }, gettext("Ok")))));
}

},{"../../../..":302,"../../../../reducers/posts":354,"../../../../reducers/thread":360,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../category-select":21,"../../../form":56,"../../../form-group":55,"../../../modal-loader":61,"react":"react"}],231:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Pager = Pager;
exports.FirstPage = FirstPage;
exports.PreviousPage = PreviousPage;
exports.NextPage = NextPage;
exports.LastPage = LastPage;
exports.More = More;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "misago-pagination pull-left"
  }, /*#__PURE__*/_react.default.createElement(Pager, props), /*#__PURE__*/_react.default.createElement(More, {
    more: props.posts.more
  }));
}

function Pager(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-paginator"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(FirstPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(PreviousPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(NextPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(LastPage, props)));
}

function FirstPage(props) {
  if (props.posts.isLoaded && props.posts.first) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-outline btn-icon",
      to: props.thread.url.index,
      title: gettext("Go to first page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "first_page"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-outline btn-icon disabled",
      title: gettext("Go to first page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "first_page"));
  }
}

function PreviousPage(props) {
  if (props.posts.isLoaded && props.posts.page > 1) {
    var previousUrl = "";

    if (props.posts.previous) {
      previousUrl = props.posts.previous + "/";
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-outline btn-icon",
      to: props.thread.url.index + previousUrl,
      title: gettext("Go to previous page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_left"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-outline btn-icon disabled",
      title: gettext("Go to previous page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_left"));
  }
}

function NextPage(props) {
  if (props.posts.isLoaded && props.posts.more) {
    var nextUrl = "";

    if (props.posts.next) {
      nextUrl = props.posts.next + "/";
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-outline btn-icon",
      to: props.thread.url.index + nextUrl,
      title: gettext("Go to next page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_right"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-outline btn-icon disabled",
      title: gettext("Go to next page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_right"));
  }
}

function LastPage(props) {
  if (props.posts.isLoaded && props.posts.last) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-outline btn-icon",
      to: props.thread.url.index + props.posts.last + "/",
      title: gettext("Go to last page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "last_page"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-outline btn-icon disabled",
      title: gettext("Go to last page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "last_page"));
  }
}

function More(props) {
  var message = null;

  if (props.more) {
    message = ngettext("There is %(more)s more post in this thread.", "There are %(more)s more posts in this thread.", props.more);
    message = interpolate(message, {
      more: props.more
    }, true);
  } else {
    message = gettext("There are no more posts in this thread.");
  }

  return /*#__PURE__*/_react.default.createElement("p", null, message);
}

},{"react":"react","react-router":"react-router"}],232:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("button", {
    className: props.className || "btn btn-primary btn-outline",
    onClick: props.onClick,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chat"), gettext("Reply"));
}

},{"react":"react"}],233:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.paths = paths;

var _reactRedux = require("react-redux");

var _route = _interopRequireDefault(require("./route"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function select(store) {
  return {
    participants: store.participants,
    poll: store.poll,
    posts: store.posts,
    thread: store.thread,
    tick: store.tick.tick,
    user: store.auth.user
  };
}

function paths() {
  var thread = _.default.get("THREAD");

  var basePath = thread.url.index.replace(thread.slug + "-" + thread.pk, ":slug");
  return [{
    path: basePath,
    component: (0, _reactRedux.connect)(select)(_route.default)
  }, {
    path: basePath + ":page/",
    component: (0, _reactRedux.connect)(select)(_route.default)
  }];
}

},{"../..":302,"./route":234,"react-redux":"react-redux"}],234:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _participants = _interopRequireDefault(require("../participants"));

var _poll = require("../poll");

var _postsList = _interopRequireDefault(require("../posts-list"));

var _header = _interopRequireDefault(require("./header"));

var _toolbarTop = _interopRequireDefault(require("./toolbar-top"));

var _toolbarBottom = _interopRequireDefault(require("./toolbar-bottom"));

var participants = _interopRequireWildcard(require("../../reducers/participants"));

var poll = _interopRequireWildcard(require("../../reducers/poll"));

var posts = _interopRequireWildcard(require("../../reducers/posts"));

var thread = _interopRequireWildcard(require("../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _polls = _interopRequireDefault(require("../../services/polls"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _store = _interopRequireDefault(require("../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "update", function (data) {
      _store.default.dispatch(thread.replace(data));

      _store.default.dispatch(posts.load(data.post_set));

      if (data.participants) {
        _store.default.dispatch(participants.replace(data.participants));
      }

      if (data.poll) {
        _store.default.dispatch(poll.replace(data.poll));
      }

      _this.setPageTitle();
    });

    _defineProperty(_assertThisInitialized(_this), "openReplyForm", function () {
      _posting.default.open({
        mode: "REPLY",
        config: _this.props.thread.api.editor,
        submit: _this.props.thread.api.posts.index
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.shouldFetchData()) {
        this.fetchData();
        this.setPageTitle();
      }

      this.startPollingApi();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.shouldFetchData()) {
        this.fetchData();
        this.startPollingApi();
        this.setPageTitle();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopPollingApi();
    }
  }, {
    key: "shouldFetchData",
    value: function shouldFetchData() {
      if (this.props.posts.isLoaded) {
        var page = (this.props.params.page || 1) * 1;
        return page != this.props.posts.page;
      } else {
        return false;
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;

      _store.default.dispatch(posts.unload());

      _ajax.default.get(this.props.thread.api.posts.index, {
        page: this.props.params.page || 1
      }, "posts").then(function (data) {
        _this2.update(data);
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "startPollingApi",
    value: function startPollingApi() {
      _polls.default.start({
        poll: "thread-posts",
        url: this.props.thread.api.posts.index,
        data: {
          page: this.props.params.page || 1
        },
        update: this.update,
        frequency: 120 * 1000,
        delayed: true
      });
    }
  }, {
    key: "stopPollingApi",
    value: function stopPollingApi() {
      _polls.default.stop("thread-posts");
    }
  }, {
    key: "setPageTitle",
    value: function setPageTitle() {
      _pageTitle.default.set({
        title: this.props.thread.title,
        parent: this.props.thread.category.name,
        page: (this.props.params.page || 1) * 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = "page page-thread";

      if (this.props.thread.category.css_class) {
        className += " page-thread-" + this.props.thread.category.css_class;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement(_header.default, this.props)), /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(_toolbarTop.default, _extends({
        openReplyForm: this.openReplyForm
      }, this.props)), /*#__PURE__*/_react.default.createElement(_poll.Poll, {
        poll: this.props.poll,
        thread: this.props.thread,
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement(_participants.default, {
        participants: this.props.participants,
        thread: this.props.thread,
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement(_postsList.default, this.props), /*#__PURE__*/_react.default.createElement(_toolbarBottom.default, _extends({
        openReplyForm: this.openReplyForm
      }, this.props))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../reducers/participants":351,"../../reducers/poll":352,"../../reducers/posts":354,"../../reducers/thread":360,"../../services/ajax":365,"../../services/page-title":373,"../../services/polls":374,"../../services/posting":375,"../../services/snackbar":376,"../../services/store":377,"../participants":101,"../poll":106,"../posts-list":151,"./header":218,"./toolbar-bottom":236,"./toolbar-top":237,"react":"react"}],235:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getIcon = getIcon;
exports.getLabel = getLabel;
exports.Dropdown = Dropdown;
exports.update = update;
exports.Email = exports.Enable = exports.Disable = void 0;

var _react = _interopRequireDefault(require("react"));

var actions = _interopRequireWildcard(require("../../reducers/thread"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(props) {
  if (!props.user.id) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": "true",
    "aria-haspopup": "true",
    className: "btn btn-default dropdown-toggle btn-block btn-outline",
    "data-toggle": "dropdown",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, getIcon(props.thread.subscription)), getLabel(props.thread.subscription)), /*#__PURE__*/_react.default.createElement(Dropdown, props));
}

function getIcon(subscription) {
  if (subscription === true) {
    return "star";
  } else if (subscription === false) {
    return "star_half";
  } else {
    return "star_border";
  }
}

function getLabel(subscription) {
  if (subscription === true) {
    return gettext("E-mail");
  } else if (subscription === false) {
    return gettext("Enabled");
  } else {
    return gettext("Disabled");
  }
}

function Dropdown(props) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: props.dropdownClassName || "dropdown-menu stick-to-bottom"
  }, /*#__PURE__*/_react.default.createElement(Disable, props), /*#__PURE__*/_react.default.createElement(Enable, props), /*#__PURE__*/_react.default.createElement(Email, props));
}

var Disable = /*#__PURE__*/function (_React$Component) {
  _inherits(Disable, _React$Component);

  var _super = _createSuper(Disable);

  function Disable() {
    var _this;

    _classCallCheck(this, Disable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      if (_this.props.thread.subscription === null) {
        return;
      }

      update(_this.props.thread, null, "unsubscribe");
    });

    return _this;
  }

  _createClass(Disable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star_border"), gettext("Unsubscribe")));
    }
  }]);

  return Disable;
}(_react.default.Component);

exports.Disable = Disable;

var Enable = /*#__PURE__*/function (_React$Component2) {
  _inherits(Enable, _React$Component2);

  var _super2 = _createSuper(Enable);

  function Enable() {
    var _this2;

    _classCallCheck(this, Enable);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onClick", function () {
      if (_this2.props.thread.subscription === false) {
        return;
      }

      update(_this2.props.thread, false, "notify");
    });

    return _this2;
  }

  _createClass(Enable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star_half"), gettext("Subscribe")));
    }
  }]);

  return Enable;
}(_react.default.Component);

exports.Enable = Enable;

var Email = /*#__PURE__*/function (_React$Component3) {
  _inherits(Email, _React$Component3);

  var _super3 = _createSuper(Email);

  function Email() {
    var _this3;

    _classCallCheck(this, Email);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "onClick", function () {
      if (_this3.props.thread.subscription === true) {
        return;
      }

      update(_this3.props.thread, true, "email");
    });

    return _this3;
  }

  _createClass(Email, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star"), gettext("Subscribe with e-mail")));
    }
  }]);

  return Email;
}(_react.default.Component);

exports.Email = Email;

function update(thread, newState, value) {
  var oldState = {
    subscription: thread.subscription
  };

  _store.default.dispatch(actions.update({
    subscription: newState
  }));

  _ajax.default.patch(thread.api.index, [{
    op: "replace",
    path: "subscription",
    value: value
  }]).then(function (finalState) {
    _store.default.dispatch(actions.update(finalState));
  }, function (rejection) {
    if (rejection.status === 400) {
      _snackbar.default.error(rejection.detail[0]);
    } else {
      _snackbar.default.apiError(rejection);
    }

    _store.default.dispatch(actions.update(oldState));
  });
}

},{"../../reducers/thread":360,"../../services/ajax":365,"../../services/snackbar":376,"../../services/store":377,"react":"react"}],236:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Options = Options;
exports.Moderation = Moderation;
exports.Subscription = Subscription;
exports.Reply = Reply;
exports.Spacer = Spacer;

var _react = _interopRequireDefault(require("react"));

var _paginator = require("./paginator");

var _posts = _interopRequireDefault(require("./moderation/posts"));

var _replyButton = _interopRequireDefault(require("./reply-button"));

var _subscription = _interopRequireDefault(require("./subscription"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-toolbar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 text-center visible-xs-block"
  }, /*#__PURE__*/_react.default.createElement(_paginator.More, {
    more: props.posts.more
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-vertical-spacer"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-7"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(_paginator.Pager, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-8 col-md-7 hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(_paginator.More, {
    more: props.posts.more
  })))), /*#__PURE__*/_react.default.createElement(Options, {
    visible: !!props.user.id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-vertical-spacer hidden-md hidden-lg"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(Spacer, props), /*#__PURE__*/_react.default.createElement(Moderation, props), /*#__PURE__*/_react.default.createElement(Subscription, props), /*#__PURE__*/_react.default.createElement(Reply, {
    thread: props.thread,
    onClick: props.openReplyForm
  }))));
}

function Options(props) {
  if (!props.visible) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-5"
  }, props.children);
}

function Moderation(props) {
  if (!props.user.id) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(_posts.default, props));
}

function Subscription(props) {
  var xsClass = "col-xs-6";

  if (!props.thread.acl.can_reply) {
    xsClass = "col-xs-12";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: xsClass + " col-sm-4"
  }, /*#__PURE__*/_react.default.createElement(_subscription.default, _extends({
    btnClassName: "btn-block",
    className: "dropup"
  }, props)));
}

function Reply(props) {
  if (!props.thread.acl.can_reply) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6 col-sm-4"
  }, /*#__PURE__*/_react.default.createElement(_replyButton.default, {
    className: "btn btn-primary btn-block btn-outline",
    onClick: props.onClick
  }));
}

function Spacer(props) {
  if (props.thread.acl.can_reply) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hidden-xs hidden-sm col-sm-4"
  });
}

},{"./moderation/posts":223,"./paginator":231,"./reply-button":232,"./subscription":235,"react":"react"}],237:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.GotoMenu = GotoMenu;
exports.GotoNew = GotoNew;
exports.GotoBestAnswer = GotoBestAnswer;
exports.GotoUnapproved = GotoUnapproved;
exports.GotoLast = GotoLast;
exports.CompactOptions = CompactOptions;
exports.GotoNewCompact = GotoNewCompact;
exports.GotoUnapprovedCompact = GotoUnapprovedCompact;
exports.GotoLastCompact = GotoLastCompact;
exports.Reply = Reply;
exports.SubscriptionMenu = SubscriptionMenu;
exports.Spacer = Spacer;
exports.StartPollCompact = exports.StartPoll = void 0;

var _react = _interopRequireDefault(require("react"));

var _replyButton = _interopRequireDefault(require("./reply-button"));

var _subscription = _interopRequireDefault(require("./subscription"));

var _posting = _interopRequireDefault(require("../../services/posting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  var hiddenSpecialOption = !props.thread.acl.can_start_poll || props.thread.poll;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-toolbar row-toolbar-bottom-margin"
  }, /*#__PURE__*/_react.default.createElement(GotoMenu, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-9 col-md-5 col-md-offset-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(Spacer, {
    visible: !props.user.id
  }), /*#__PURE__*/_react.default.createElement(Spacer, {
    visible: hiddenSpecialOption
  }), /*#__PURE__*/_react.default.createElement(SubscriptionMenu, props), /*#__PURE__*/_react.default.createElement(StartPoll, props), /*#__PURE__*/_react.default.createElement(Reply, props))));
}

function GotoMenu(props) {
  var user = props.user;
  var className = "col-xs-3 col-sm-3 col-md-5";

  if (user.is_anonymous) {
    className = "col-xs-12 col-sm-3 col-md-5";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row hidden-xs hidden-sm"
  }, /*#__PURE__*/_react.default.createElement(GotoLast, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(GotoNew, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(GotoBestAnswer, {
    thread: props.thread
  }), /*#__PURE__*/_react.default.createElement(GotoUnapproved, {
    thread: props.thread
  })), /*#__PURE__*/_react.default.createElement(CompactOptions, props));
}

function GotoNew(props) {
  if (!props.thread.is_new) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.new_post,
    className: "btn btn-default btn-block btn-outline",
    title: gettext("Go to first new post")
  }, gettext("New")));
}

function GotoBestAnswer(props) {
  if (!props.thread.best_answer) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.best_answer,
    className: "btn btn-default btn-block btn-outline",
    title: gettext("Go to best answer")
  }, gettext("Best answer")));
}

function GotoUnapproved(props) {
  if (!props.thread.has_unapproved_posts || !props.thread.acl.can_approve) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.unapproved_post,
    className: "btn btn-default btn-block btn-outline",
    title: gettext("Go to first unapproved post")
  }, gettext("Unapproved")));
}

function GotoLast(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.last_post,
    className: "btn btn-default btn-block btn-outline",
    title: gettext("Go to last post")
  }, gettext("Last")));
}

function CompactOptions(props) {
  var user = props.user;

  if (user.is_anonymous) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "visible-xs-block visible-sm-block"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: props.thread.url.last_post,
      className: "btn btn-default btn-block btn-outline"
    }, gettext("Last post")));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown visible-xs-block visible-sm-block"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": "true",
    "aria-haspopup": "true",
    className: "btn btn-default dropdown-toggle btn-block btn-outline",
    "data-toggle": "dropdown",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "expand_more"), /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-text hidden-xs"
  }, gettext("Options"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu"
  }, /*#__PURE__*/_react.default.createElement(StartPollCompact, props), /*#__PURE__*/_react.default.createElement(GotoNewCompact, props), /*#__PURE__*/_react.default.createElement(GotoUnapprovedCompact, props), /*#__PURE__*/_react.default.createElement(GotoLastCompact, props)));
}

function GotoNewCompact(props) {
  if (!props.thread.is_new) return null;
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.new_post,
    className: "btn btn-link"
  }, gettext("Go to first new post")));
}

function GotoUnapprovedCompact(props) {
  if (!props.thread.has_unapproved_posts || !props.thread.acl.can_approve) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.unapproved_post,
    className: "btn btn-link"
  }, gettext("Go to first unapproved post")));
}

function GotoLastCompact(props) {
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: props.thread.url.last_post,
    className: "btn btn-link"
  }, gettext("Go to last post")));
}

function Reply(props) {
  if (!props.thread.acl.can_reply) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(_replyButton.default, {
    className: "btn btn-primary btn-block btn-outline",
    onClick: props.openReplyForm
  }));
}

function SubscriptionMenu(props) {
  if (!props.user.id) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-4"
  }, /*#__PURE__*/_react.default.createElement(_subscription.default, _extends({
    className: "dropdown",
    dropdownClassName: "dropdown-menu dropdown-menu-right stick-to-bottom"
  }, props)));
}

var StartPoll = /*#__PURE__*/function (_React$Component) {
  _inherits(StartPoll, _React$Component);

  var _super = _createSuper(StartPoll);

  function StartPoll() {
    var _this;

    _classCallCheck(this, StartPoll);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _posting.default.open({
        mode: "POLL",
        submit: _this.props.thread.api.poll,
        thread: _this.props.thread,
        poll: null
      });
    });

    return _this;
  }

  _createClass(StartPoll, [{
    key: "render",
    value: function render() {
      if (!this.props.thread.acl.can_start_poll || this.props.thread.poll) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-4 hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block btn-outline",
        onClick: this.onClick,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "poll"), gettext("Add poll")));
    }
  }]);

  return StartPoll;
}(_react.default.Component);

exports.StartPoll = StartPoll;

var StartPollCompact = /*#__PURE__*/function (_StartPoll) {
  _inherits(StartPollCompact, _StartPoll);

  var _super2 = _createSuper(StartPollCompact);

  function StartPollCompact() {
    _classCallCheck(this, StartPollCompact);

    return _super2.apply(this, arguments);
  }

  _createClass(StartPollCompact, [{
    key: "render",
    value: function render() {
      if (!this.props.thread.acl.can_start_poll || this.props.thread.poll) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.onClick,
        type: "button"
      }, gettext("Add poll")));
    }
  }]);

  return StartPollCompact;
}(StartPoll);

exports.StartPollCompact = StartPollCompact;

function Spacer(props) {
  if (!props.visible) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 hidden-xs"
  });
}

},{"../../services/posting":375,"./reply-button":232,"./subscription":235,"react":"react"}],238:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _empty = _interopRequireDefault(require("./list/empty"));

var _ready = _interopRequireDefault(require("./list/ready"));

var _preview = _interopRequireDefault(require("./list/preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (!props.isLoaded) {
    return /*#__PURE__*/_react.default.createElement(_preview.default, null);
  }

  if (props.threads.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_empty.default, {
      diffSize: props.diffSize,
      applyDiff: props.applyDiff
    }, props.children);
  }

  return /*#__PURE__*/_react.default.createElement(_ready.default, {
    activeCategory: props.category,
    categories: props.categories,
    list: props.list,
    threads: props.threads,
    diffSize: props.diffSize,
    applyDiff: props.applyDiff,
    showOptions: props.showOptions,
    selection: props.selection,
    busyThreads: props.busyThreads
  });
}

},{"./list/empty":240,"./list/preview":241,"./list/ready":242,"react":"react"}],239:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getMessage = getMessage;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var applyDiff = props.applyDiff,
      diffSize = props.diffSize;
  if (diffSize === 0) return null;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "list-group-item threads-diff-message"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn btn-block btn-default",
    onClick: applyDiff
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "cached"), /*#__PURE__*/_react.default.createElement("span", {
    className: "diff-message"
  }, getMessage(diffSize))));
}

function getMessage(diffSize) {
  var message = ngettext("There is %(threads)s new or updated thread. Click this message to show it.", "There are %(threads)s new or updated threads. Click this message to show them.", diffSize);
  return interpolate(message, {
    threads: diffSize
  }, true);
}

},{"react":"react"}],240:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _diffMessage = _interopRequireDefault(require("./diff-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getDiffMessage",
    value: function getDiffMessage() {
      if (this.props.diffSize === 0) return null;
      return /*#__PURE__*/_react.default.createElement(_diffMessage.default, {
        applyDiff: this.props.applyDiff,
        diffSize: this.props.diffSize
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "threads-list ui-ready"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, this.getDiffMessage(), this.props.children));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./diff-message":239,"react":"react"}],241:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _preview = _interopRequireDefault(require("../thread/preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "threads-list ui-preview"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, /*#__PURE__*/_react.default.createElement(_preview.default, null)));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../thread/preview":249,"react":"react"}],242:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _diffMessage = _interopRequireDefault(require("./diff-message"));

var _ready = _interopRequireDefault(require("../thread/ready"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "threads-list ui-ready"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-group"
  }, /*#__PURE__*/_react.default.createElement(_diffMessage.default, {
    diffSize: props.diffSize,
    applyDiff: props.applyDiff
  }), props.threads.map(function (thread) {
    return /*#__PURE__*/_react.default.createElement(_ready.default, {
      activeCategory: props.activeCategory,
      categories: props.categories,
      list: props.list,
      thread: thread,
      showOptions: props.showOptions,
      isSelected: props.selection.indexOf(thread.id) >= 0,
      isBusy: props.busyThreads.indexOf(thread.id) >= 0,
      key: thread.id
    });
  })));
}

},{"../thread/ready":250,"./diff-message":239,"react":"react"}],243:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.HiddenLabel = HiddenLabel;
exports.ClosedLabel = ClosedLabel;
exports.PollLabel = PollLabel;
exports.BestAnswerLabel = BestAnswerLabel;
exports.RepliesLabel = RepliesLabel;
exports.LastReplyLabel = LastReplyLabel;
exports.LastPoster = LastPoster;

var _react = _interopRequireDefault(require("react"));

var _category = _interopRequireDefault(require("./category"));

var _options = require("../options");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category,
      isBusy = _ref.isBusy,
      showOptions = _ref.showOptions,
      isSelected = _ref.isSelected,
      thread = _ref.thread;
  var className = "col-xs-12 col-sm-12";

  if (showOptions) {
    if (thread.moderation.length) {
      className = "col-xs-6 col-sm-12";
    } else {
      className = "col-xs-9 col-sm-12";
    }
  }

  var statusFlags = 0;
  if (thread.is_hidden) statusFlags += 1;
  if (thread.is_closed) statusFlags += 1;
  if (thread.has_poll) statusFlags += 1;
  var allFlagsVisible = showOptions && statusFlags === 3;
  var textClassName = "detail-text hidden-xs";

  if (allFlagsVisible) {
    textClassName += " hidden-sm";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row thread-details-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_category.default, {
    className: "item-title thread-detail-category hidden-xs",
    category: category
  }), /*#__PURE__*/_react.default.createElement(HiddenLabel, {
    textClassName: textClassName,
    display: thread.is_hidden
  }), /*#__PURE__*/_react.default.createElement(ClosedLabel, {
    textClassName: textClassName,
    display: thread.is_closed
  }), /*#__PURE__*/_react.default.createElement(PollLabel, {
    textClassName: textClassName,
    display: thread.has_poll
  }), /*#__PURE__*/_react.default.createElement(BestAnswerLabel, {
    thread: thread
  }), /*#__PURE__*/_react.default.createElement(RepliesLabel, {
    forceFullText: !showOptions || statusFlags < 2,
    replies: thread.replies
  }), /*#__PURE__*/_react.default.createElement(LastReplyLabel, {
    datetime: thread.last_post_on,
    url: thread.url.last_post
  }), /*#__PURE__*/_react.default.createElement(LastPoster, {
    posterName: thread.last_poster_name,
    url: thread.url.last_poster
  })), /*#__PURE__*/_react.default.createElement(_options.OptionsXs, {
    disabled: isBusy,
    display: showOptions,
    isSelected: isSelected,
    thread: thread
  }));
}

function HiddenLabel(_ref2) {
  var display = _ref2.display,
      textClassName = _ref2.textClassName;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "thread-detail-hidden"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "visibility_off"), /*#__PURE__*/_react.default.createElement("span", {
    className: textClassName
  }, gettext("Hidden")));
}

function ClosedLabel(_ref3) {
  var display = _ref3.display,
      textClassName = _ref3.textClassName;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "thread-detail-closed"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "lock_outline"), /*#__PURE__*/_react.default.createElement("span", {
    className: textClassName
  }, gettext("Closed")));
}

function PollLabel(_ref4) {
  var display = _ref4.display,
      textClassName = _ref4.textClassName;
  if (!display) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "thread-detail-poll"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "assessment"), /*#__PURE__*/_react.default.createElement("span", {
    className: textClassName
  }, gettext("Poll")));
}

function BestAnswerLabel(_ref5) {
  var thread = _ref5.thread;
  if (!thread.best_answer) return null;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "visible-xs-inline-block thread-detail-answered",
    href: thread.url.best_answer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "check_box"));
}

function RepliesLabel(_ref6) {
  var replies = _ref6.replies,
      forceFullText = _ref6.forceFullText;
  var text = ngettext("%(replies)s reply", "%(replies)s replies", replies);
  var compactClassName = "";
  var fullClassName = "";

  if (forceFullText) {
    compactClassName = "detail-text hide";
    fullClassName = "detail-text";
  } else {
    compactClassName = "detail-text visible-xs-inline-block";
    fullClassName = "detail-text hidden-xs";
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "thread-detail-replies"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "forum"), /*#__PURE__*/_react.default.createElement("span", {
    className: compactClassName
  }, replies), /*#__PURE__*/_react.default.createElement("span", {
    className: fullClassName
  }, interpolate(text, {
    replies: replies
  }, true)));
}

function LastReplyLabel(_ref7) {
  var datetime = _ref7.datetime,
      url = _ref7.url;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "visible-sm-inline-block thread-detail-last-reply",
    href: url,
    title: datetime.format("LLL")
  }, datetime.fromNow(true));
}

function LastPoster(props) {
  var posterName = props.posterName,
      url = props.url;
  var className = "visible-sm-inline-block item-title thread-last-poster";

  if (url) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: className,
      href: url
    }, posterName);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, posterName);
}

},{"../options":248,"./category":244,"react":"react"}],244:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category,
      className = _ref.className;
  if (!category) return null;

  if (category.css_class) {
    className += " thread-detail-category-" + category.css_class;
  }

  return /*#__PURE__*/_react.default.createElement("a", {
    className: className,
    href: category.url.index
  }, category.name);
}

},{"react":"react"}],245:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BottomDetails", {
  enumerable: true,
  get: function get() {
    return _bottom.default;
  }
});
Object.defineProperty(exports, "TopDetails", {
  enumerable: true,
  get: function get() {
    return _top.default;
  }
});

var _bottom = _interopRequireDefault(require("./bottom"));

var _top = _interopRequireDefault(require("./top"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./bottom":243,"./top":246}],246:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.NewLabel = NewLabel;
exports.PinnedLabel = PinnedLabel;
exports.UnapprovedLabel = UnapprovedLabel;
exports.BestAnswerLabel = BestAnswerLabel;
exports.LastReplyLabel = LastReplyLabel;
exports.LastPoster = LastPoster;

var _react = _interopRequireDefault(require("react"));

var _category = _interopRequireDefault(require("./category"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var category = _ref.category,
      thread = _ref.thread;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "thread-details-top"
  }, /*#__PURE__*/_react.default.createElement(NewLabel, {
    isRead: thread.is_read,
    url: thread.url.new_post
  }), /*#__PURE__*/_react.default.createElement(PinnedLabel, {
    weight: thread.weight
  }), /*#__PURE__*/_react.default.createElement(UnapprovedLabel, {
    thread: thread.is_unapproved,
    posts: thread.has_unapproved_posts
  }), /*#__PURE__*/_react.default.createElement(BestAnswerLabel, {
    thread: thread
  }), /*#__PURE__*/_react.default.createElement(_category.default, {
    className: "item-title thread-detail-category visible-xs-inline-block",
    category: category
  }), /*#__PURE__*/_react.default.createElement(LastReplyLabel, {
    datetime: thread.last_post_on,
    url: thread.url.last_post
  }), /*#__PURE__*/_react.default.createElement(LastPoster, {
    posterName: thread.last_poster_name,
    url: thread.url.last_poster
  }));
}

function NewLabel(_ref2) {
  var isRead = _ref2.isRead,
      url = _ref2.url;
  if (isRead) return null;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "thread-detail-new",
    href: url
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "comment"), /*#__PURE__*/_react.default.createElement("span", {
    className: "detail-text"
  }, gettext("New posts")));
}

function PinnedLabel(_ref3) {
  var weight = _ref3.weight;
  if (weight === 0) return null;
  var className = "thread-detail-pinned-globally";
  var icon = "bookmark";
  var text = gettext("Pinned globally");

  if (weight === 1) {
    className = "thread-detail-pinned-locally";
    icon = "bookmark_border";
    text = gettext("Pinned locally");
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: "detail-text"
  }, text));
}

function UnapprovedLabel(_ref4) {
  var posts = _ref4.posts,
      thread = _ref4.thread;
  if (!posts && !thread) return null;
  var className = "thread-detail-unapproved-posts";
  var icon = "remove_circle_outline";
  var text = gettext("Unapproved posts");

  if (thread) {
    className = "thread-detail-unapproved";
    icon = "remove_circle";
    text = gettext("Unapproved");
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: "detail-text"
  }, text));
}

function BestAnswerLabel(_ref5) {
  var thread = _ref5.thread;
  if (!thread.best_answer) return null;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "hidden-xs thread-detail-answered",
    href: thread.url.best_answer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "check_box"), /*#__PURE__*/_react.default.createElement("span", {
    className: "detail-text"
  }, gettext("Answered")));
}

function LastReplyLabel(_ref6) {
  var datetime = _ref6.datetime,
      url = _ref6.url;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "visible-xs-inline-block thread-detail-last-reply",
    href: url,
    title: datetime.format("LLL")
  }, datetime.fromNow(true));
}

function LastPoster(props) {
  var posterName = props.posterName,
      url = props.url;

  if (url) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "visible-xs-inline-block item-title thread-last-poster",
      href: url
    }, posterName);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "visible-xs-inline-block item-title thread-last-poster"
  }, posterName);
}

},{"./category":244,"react":"react"}],247:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Timestamp = Timestamp;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var _userUrl = _interopRequireDefault(require("./user-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var thread = _ref.thread;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left"
  }, /*#__PURE__*/_react.default.createElement(_userUrl.default, {
    className: "thread-last-poster-avatar",
    title: thread.last_poster_name,
    url: thread.url.last_poster
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    className: "media-object",
    size: 40,
    user: thread.last_poster
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement(_userUrl.default, {
    className: "item-title thread-last-poster",
    url: thread.url.last_poster
  }, thread.last_poster_name), /*#__PURE__*/_react.default.createElement(Timestamp, {
    datetime: thread.last_post_on,
    url: thread.url.last_post
  })));
}

function Timestamp(_ref2) {
  var datetime = _ref2.datetime,
      url = _ref2.url;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "thread-last-reply",
    href: url,
    title: datetime.format("LLL")
  }, datetime.fromNow(true));
}

},{"../../avatar":6,"./user-url":255,"react":"react"}],248:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = Options;
exports.OptionsXs = OptionsXs;
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _compact = _interopRequireDefault(require("./subscription/compact"));

var _full = _interopRequireDefault(require("./subscription/full"));

var select = _interopRequireWildcard(require("../../../reducers/selection"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Options(_ref) {
  var display = _ref.display,
      disabled = _ref.disabled,
      isSelected = _ref.isSelected,
      thread = _ref.thread;
  if (!display) return null;
  var className = "col-sm-2 col-md-2 hidden-xs";

  if (thread.moderation.length) {
    className = "col-sm-3 col-md-2 hidden-xs";
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row thread-options"
  }, /*#__PURE__*/_react.default.createElement(_full.default, {
    thread: thread,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_compact.default, {
    thread: thread,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(Checkbox, {
    thread: thread,
    disabled: disabled,
    isSelected: isSelected
  })));
}

function OptionsXs(_ref2) {
  var display = _ref2.display,
      disabled = _ref2.disabled,
      isSelected = _ref2.isSelected,
      thread = _ref2.thread;
  if (!display) return null;
  var className = "";

  if (thread.moderation.length) {
    className += "col-xs-6";
  } else {
    className += "col-xs-3";
  }

  className += " visible-xs-block thread-options-xs";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row thread-options"
  }, /*#__PURE__*/_react.default.createElement(_full.default, {
    thread: thread,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_compact.default, {
    thread: thread,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(Checkbox, {
    thread: thread,
    disabled: disabled,
    isSelected: isSelected
  })));
}

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "toggleSelection", function () {
      _store.default.dispatch(select.item(_this.props.thread.id));
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          isSelected = _this$props.isSelected,
          thread = _this$props.thread;
      if (!thread.moderation.length) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-icon btn-block",
        onClick: this.toggleSelection,
        disabled: disabled
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, isSelected ? "check_box" : "check_box_outline_blank")));
    }
  }]);

  return Checkbox;
}(_react.default.Component);

exports.Checkbox = Checkbox;

},{"../../../reducers/selection":358,"../../../services/store":377,"./subscription/compact":251,"./subscription/full":252,"react":"react"}],249:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "list-group-item thread-preview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "thread-details-top visible-xs-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("span", {
        className: "item-title thread-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(60, 200) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text hidden-xs",
        style: {
          width: random.int(60, 200) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text hidden-xs",
        style: {
          width: random.int(60, 200) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "thread-details-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../utils/random":388,"react":"react"}],250:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getClassName = getClassName;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var _details = require("./details");

var _lastAction = _interopRequireDefault(require("./last-action"));

var _options = require("./options");

var _userUrl = _interopRequireDefault(require("./user-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var activeCategory = props.activeCategory,
      categories = props.categories,
      list = props.list,
      thread = props.thread,
      isBusy = props.isBusy,
      isSelected = props.isSelected,
      showOptions = props.showOptions;
  var category = null;

  if (activeCategory.id !== thread.category) {
    category = categories[thread.category];
  }

  var flavor = category || activeCategory;
  var className = "thread-main col-xs-12";

  if (showOptions) {
    if (thread.moderation.length) {
      className += " col-sm-9 col-md-7";
    } else {
      className += " col-sm-10 col-md-7";
    }
  } else {
    className += " col-sm-12 col-md-9";
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: getClassName(thread.is_read, isBusy, isSelected, flavor)
  }, /*#__PURE__*/_react.default.createElement(_details.TopDetails, {
    category: category,
    thread: thread
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row thread-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-left hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(_userUrl.default, {
    className: "thread-starter-avatar",
    title: thread.starter_name,
    url: thread.url.starter
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: 40,
    user: thread.starter
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-body"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: thread.url.index,
    className: "item-title thread-title"
  }, thread.title), /*#__PURE__*/_react.default.createElement(_details.BottomDetails, {
    category: category,
    disabled: isBusy,
    isSelected: isSelected,
    showOptions: showOptions,
    thread: thread
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-3 hidden-xs hidden-sm thread-last-action"
  }, /*#__PURE__*/_react.default.createElement(_lastAction.default, {
    thread: thread
  })), /*#__PURE__*/_react.default.createElement(_options.Options, {
    disabled: isBusy,
    display: showOptions,
    isSelected: isSelected,
    thread: thread
  })));
}

function getClassName(isRead, isBusy, isSelected, flavor) {
  var styles = ["list-group-item"];

  if (flavor && flavor.css_class) {
    styles.push("list-group-category-has-flavor");
    styles.push("list-group-item-category-" + flavor.css_class);
  }

  if (isRead) {
    styles.push("thread-read");
  } else {
    styles.push("thread-new");
  }

  if (isBusy) {
    styles.push("thread-busy");
  } else if (isSelected) {
    styles.push("thread-selected");
  }

  return styles.join(" ");
}

},{"../../avatar":6,"./details":245,"./last-action":247,"./options":248,"./user-url":255,"react":"react"}],251:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _full = _interopRequireDefault(require("./full"));

var _modal = _interopRequireDefault(require("./modal"));

var _modal2 = _interopRequireDefault(require("../../../../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_SubscriptionFull) {
  _inherits(_default, _SubscriptionFull);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "showOptions", function () {
      _modal2.default.show( /*#__PURE__*/_react.default.createElement(_modal.default, {
        thread: _this.props.thread
      }));
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var moderation = this.props.thread.moderation;
      var className = "";

      if (moderation.length) {
        className += "col-xs-6";
      } else {
        className += "col-xs-12";
      }

      className += " hidden-md hidden-lg";
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: this.getClassName(),
        disabled: this.props.disabled,
        onClick: this.showOptions
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.getIcon())));
    }
  }]);

  return _default;
}(_full.default);

exports.default = _default;

},{"../../../../services/modal":371,"./full":252,"./modal":253,"react":"react"}],252:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = Label;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _options = _interopRequireDefault(require("./options"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getIcon",
    value: function getIcon() {
      if (this.props.thread.subscription === true) {
        return "star";
      } else if (this.props.thread.subscription === false) {
        return "star_half";
      }

      return "star_border";
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.props.thread.subscription === true) {
        return "btn btn-default btn-icon btn-block btn-subscribe btn-subscribe-full dropdown-toggle";
      } else if (this.props.thread.subscription === false) {
        return "btn btn-default btn-icon btn-block btn-subscribe btn-subscribe-half dropdown-toggle";
      }

      return "btn btn-default btn-icon btn-block btn-subscribe dropdown-toggle";
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$thread = this.props.thread,
          moderation = _this$props$thread.moderation,
          subscription = _this$props$thread.subscription;
      var fullwidth = !moderation.length;
      var className = fullwidth ? "col-xs-12" : "col-xs-6";
      className += " hidden-xs hidden-sm";
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group btn-group-justified"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: this.getClassName(),
        disabled: this.props.disabled,
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.getIcon()), /*#__PURE__*/_react.default.createElement(Label, {
        moderation: moderation,
        subscription: subscription
      })), /*#__PURE__*/_react.default.createElement(_options.default, {
        className: "dropdown-menu dropdown-menu-right",
        thread: this.props.thread
      }))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function Label(_ref) {
  var moderation = _ref.moderation,
      subscription = _ref.subscription;
  if (moderation.length) return null;
  var text = gettext("Disabled");

  if (subscription === true) {
    text = gettext("E-mail");
  } else if (subscription === false) {
    text = gettext("Enabled");
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-text"
  }, text);
}

},{"./options":254,"react":"react"}],253:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _options = _interopRequireDefault(require("./options"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog modal-sm",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Change subscription"))), /*#__PURE__*/_react.default.createElement(_options.default, {
        className: "modal-menu",
        thread: this.props.thread
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./options":254,"react":"react"}],254:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../../button"));

var _threads = require("../../../../reducers/threads");

var _ajax = _interopRequireDefault(require("../../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STATE_UPDATES = {
  unsubscribe: null,
  notify: false,
  email: true
};

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setSubscription", function (newState) {
      _modal.default.hide();

      _this.setState({
        isLoading: true
      });

      var oldState = _this.props.thread.subscription;

      _store.default.dispatch((0, _threads.patch)(_this.props.thread, {
        subscription: STATE_UPDATES[newState]
      }));

      _ajax.default.patch(_this.props.thread.api.index, [{
        op: "replace",
        path: "subscription",
        value: newState
      }]).then(function () {
        _this.setState({
          isLoading: false
        });
      }, function (rejection) {
        _this.setState({
          isLoading: false
        });

        _store.default.dispatch((0, _threads.patch)(_this.props.thread, {
          subscription: STATE_UPDATES[oldState]
        }));

        _snackbar.default.apiError(rejection);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unsubscribe", function () {
      _this.setSubscription("unsubscribe");
    });

    _defineProperty(_assertThisInitialized(_this), "notify", function () {
      _this.setSubscription("notify");
    });

    _defineProperty(_assertThisInitialized(_this), "email", function () {
      _this.setSubscription("email");
    });

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-link",
        onClick: this.unsubscribe
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star_border"), gettext("Unsubscribe"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-link",
        onClick: this.notify
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star_half"), gettext("Subscribe"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-link",
        onClick: this.email
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "star"), gettext("Subscribe with e-mail"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../../reducers/threads":361,"../../../../services/ajax":365,"../../../../services/modal":371,"../../../../services/snackbar":376,"../../../../services/store":377,"../../../button":8,"react":"react"}],255:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      url = _ref.url;

  if (url) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: className,
      href: url,
      title: title
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    title: title
  }, children);
}

},{"react":"react"}],256:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Subcategory = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Subcategory = /*#__PURE__*/function (_React$Component) {
  _inherits(Subcategory, _React$Component);

  var _super = _createSuper(Subcategory);

  function Subcategory() {
    _classCallCheck(this, Subcategory);

    return _super.apply(this, arguments);
  }

  _createClass(Subcategory, [{
    key: "getUrl",
    value: function getUrl() {
      if (this.props.listPath) {
        return this.props.category.url.index + this.props.listPath;
      } else {
        return this.props.category.url.index;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
        to: this.getUrl(),
        className: "btn btn-link"
      }, this.props.category.name));
    }
  }]);

  return Subcategory;
}(_react.default.Component);

exports.Subcategory = Subcategory;

var _default = /*#__PURE__*/function (_React$Component2) {
  _inherits(_default, _React$Component2);

  var _super2 = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super2.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown category-picker"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default btn-outline dropdown-toggle btn-block",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "label_outline"), /*#__PURE__*/_react.default.createElement("span", {
        className: "hidden-xs"
      }, gettext("Category"))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu stick-to-bottom categories-menu"
      }, this.props.choices.map(function (id) {
        if (_this.props.categories[id]) {
          return /*#__PURE__*/_react.default.createElement(Subcategory, {
            category: _this.props.categories[id],
            listPath: _this.props.list.path,
            key: id
          });
        } else {
          return null;
        }
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react","react-router":"react-router"}],257:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareLastPostAge = compareLastPostAge;
exports.compareGlobalWeight = compareGlobalWeight;
exports.compareWeight = compareWeight;

function compareLastPostAge(a, b) {
  if (a.last_post > b.last_post) {
    return -1;
  } else if (a.last_post < b.last_post) {
    return 1;
  } else {
    return 0;
  }
}

function compareGlobalWeight(a, b) {
  if (a.weight === 2 && a.weight > b.weight) {
    return -1;
  } else if (b.weight === 2 && a.weight < b.weight) {
    return 1;
  } else {
    return compareLastPostAge(a, b);
  }
}

function compareWeight(a, b) {
  if (a.weight > b.weight) {
    return -1;
  } else if (a.weight < b.weight) {
    return 1;
  } else {
    return compareLastPostAge(a, b);
  }
}

},{}],258:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _pageLead = _interopRequireDefault(require("../page-lead"));

var _toolbar = _interopRequireDefault(require("./toolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getCategoryDescription",
    value: function getCategoryDescription() {
      if (this.props.pageLead) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "category-description"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "page-lead"
        }, /*#__PURE__*/_react.default.createElement("p", null, this.props.pageLead)));
      } else if (this.props.route.category.description) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "category-description"
        }, /*#__PURE__*/_react.default.createElement(_pageLead.default, {
          copy: this.props.route.category.description.html
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "getDisableToolbar",
    value: function getDisableToolbar() {
      return !this.props.isLoaded || this.props.isBusy || this.props.busyThreads.length;
    }
  }, {
    key: "getToolbar",
    value: function getToolbar() {
      var isVisible = this.props.subcategories.length || this.props.user.id;
      if (!isVisible) return null;
      return /*#__PURE__*/_react.default.createElement(_toolbar.default, {
        subcategories: this.props.subcategories,
        categories: this.props.route.categories,
        categoriesMap: this.props.route.categoriesMap,
        list: this.props.route.list,
        threads: this.props.threads,
        moderation: this.props.moderation,
        selection: this.props.selection,
        selectAllThreads: this.props.selectAllThreads,
        selectNoneThreads: this.props.selectNoneThreads,
        addThreads: this.props.addThreads,
        freezeThread: this.props.freezeThread,
        deleteThread: this.props.deleteThread,
        updateThread: this.props.updateThread,
        api: this.props.api,
        route: this.props.route,
        disabled: this.getDisableToolbar(),
        user: this.props.user
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, this.getCategoryDescription(), this.getToolbar(), this.props.children);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../page-lead":92,"./toolbar":269,"react":"react"}],259:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParentCategory = ParentCategory;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _button = _interopRequireDefault(require("../button"));

var _dropdownToggle = _interopRequireDefault(require("../dropdown-toggle"));

var _nav = _interopRequireDefault(require("./nav"));

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _posting = _interopRequireDefault(require("../../services/posting"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "startThread", function () {
      _posting.default.open(_this.props.startThread || {
        mode: "START",
        config: _.default.get("THREAD_EDITOR_API"),
        submit: _.default.get("THREADS_API"),
        category: _this.props.route.category.id
      });
    });

    _this.state = {
      isBusy: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "hasGoBackButton",
    value: function hasGoBackButton() {
      return !!this.props.route.category.parent;
    }
  }, {
    key: "getGoBackButton",
    value: function getGoBackButton() {
      if (!this.props.route.category.parent) return null;
      var parent = this.props.categories[this.props.route.category.parent];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "hidden-xs col-sm-2 col-lg-1"
      }, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
        className: "btn btn-default btn-icon btn-aligned btn-go-back btn-block btn-outline",
        to: parent.url.index + this.props.route.list.path
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "keyboard_arrow_left")));
    }
  }, {
    key: "getStartThreadButton",
    value: function getStartThreadButton() {
      if (!this.props.user.id) return null;
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary btn-block btn-outline",
        onClick: this.startThread,
        disabled: this.props.disabled
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "chat"), gettext("Start thread"));
    }
  }, {
    key: "render",
    value: function render() {
      var headerClassName = "col-xs-12";

      if (this.hasGoBackButton()) {
        headerClassName += " col-sm-10 col-lg-11 sm-align-row-buttons";
      }

      var isAuthenticated = !!this.props.user.id;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: isAuthenticated ? "col-sm-9 col-md-10" : "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, this.getGoBackButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/_react.default.createElement(ParentCategory, {
        categories: this.props.categories,
        category: this.props.route.category.parent
      }), /*#__PURE__*/_react.default.createElement("h1", null, this.props.title)))), isAuthenticated && /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-3 col-md-2 xs-margin-top"
      }, this.getStartThreadButton()))), /*#__PURE__*/_react.default.createElement(_nav.default, {
        baseUrl: this.props.route.category.url.index,
        list: this.props.route.list,
        lists: this.props.route.lists
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function ParentCategory(_ref) {
  var categories = _ref.categories,
      category = _ref.category;
  if (!category) return null;
  var parent = categories[category];
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
    className: "go-back-sm visible-xs-block",
    to: parent.url.index
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "chevron_left"), parent.parent ? parent.name : gettext("Threads"));
}

},{"../..":302,"../../services/ajax":365,"../../services/posting":375,"../../services/snackbar":376,"../../services/store":377,"../button":8,"../dropdown-toggle":27,"./nav":266,"react":"react","react-router":"react-router"}],260:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.props.list.type === "all") {
        if (this.props.emptyMessage) {
          return /*#__PURE__*/_react.default.createElement("li", {
            className: "list-group-item empty-message"
          }, /*#__PURE__*/_react.default.createElement("p", {
            className: "lead"
          }, this.props.emptyMessage), /*#__PURE__*/_react.default.createElement("p", null, gettext("Why not start one yourself?")));
        } else {
          return /*#__PURE__*/_react.default.createElement("li", {
            className: "list-group-item empty-message"
          }, /*#__PURE__*/_react.default.createElement("p", {
            className: "lead"
          }, this.props.category.special_role ? gettext("There are no threads on this forum... yet!") : gettext("There are no threads in this category.")), /*#__PURE__*/_react.default.createElement("p", null, gettext("Why not start one yourself?")));
        }
      } else {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "list-group-item empty-message"
        }, gettext("No threads matching specified criteria were found."));
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],261:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _errorsList = _interopRequireDefault(require("./errors-list"));

var _merge = _interopRequireDefault(require("./merge"));

var _move = _interopRequireDefault(require("./move"));

var select = _interopRequireWildcard(require("../../../reducers/selection"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

var _countdown = _interopRequireDefault(require("../../../utils/countdown"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callApi", function (ops, successMessage) {
      var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // freeze threads
      _this.props.threads.forEach(function (thread) {
        _this.props.freezeThread(thread.id);
      }); // list ids


      var ids = _this.props.threads.map(function (thread) {
        return thread.id;
      }); // always return current acl


      ops.push({
        op: "add",
        path: "acl",
        value: true
      });

      _ajax.default.patch(_this.props.api, {
        ids: ids,
        ops: ops
      }).then(function (data) {
        // unfreeze
        _this.props.threads.forEach(function (thread) {
          _this.props.freezeThread(thread.id);
        }); // update threads


        data.forEach(function (thread) {
          _this.props.updateThread(thread);
        }); // show success message and call callback

        _snackbar.default.success(successMessage);

        if (onSuccess) {
          onSuccess();
        }
      }, function (rejection) {
        // unfreeze
        _this.props.threads.forEach(function (thread) {
          _this.props.freezeThread(thread.id);
        }); // escape on non-400 error


        if (rejection.status !== 400) {
          return _snackbar.default.apiError(rejection);
        } // build errors list


        var errors = [];
        var threadsMap = {};

        _this.props.threads.forEach(function (thread) {
          threadsMap[thread.id] = thread;
        });

        rejection.forEach(function (_ref) {
          var id = _ref.id,
              detail = _ref.detail;

          if (typeof threadsMap[id] !== "undefined") {
            errors.push({
              errors: detail,
              thread: threadsMap[id]
            });
          }
        });

        _modal.default.show( /*#__PURE__*/_react.default.createElement(_errorsList.default, {
          errors: errors
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pinGlobally", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 2
      }], gettext("Selected threads were pinned globally."));
    });

    _defineProperty(_assertThisInitialized(_this), "pinLocally", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 1
      }], gettext("Selected threads were pinned locally."));
    });

    _defineProperty(_assertThisInitialized(_this), "unpin", function () {
      _this.callApi([{
        op: "replace",
        path: "weight",
        value: 0
      }], gettext("Selected threads were unpinned."));
    });

    _defineProperty(_assertThisInitialized(_this), "approve", function () {
      _this.callApi([{
        op: "replace",
        path: "is-unapproved",
        value: false
      }], gettext("Selected threads were approved."));
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.callApi([{
        op: "replace",
        path: "is-closed",
        value: false
      }], gettext("Selected threads were opened."));
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.callApi([{
        op: "replace",
        path: "is-closed",
        value: true
      }], gettext("Selected threads were closed."));
    });

    _defineProperty(_assertThisInitialized(_this), "unhide", function () {
      _this.callApi([{
        op: "replace",
        path: "is-hidden",
        value: false
      }], gettext("Selected threads were unhidden."));
    });

    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      _this.callApi([{
        op: "replace",
        path: "is-hidden",
        value: true
      }], gettext("Selected threads were hidden."));
    });

    _defineProperty(_assertThisInitialized(_this), "move", function () {
      _modal.default.show( /*#__PURE__*/_react.default.createElement(_move.default, {
        callApi: _this.callApi,
        categories: _this.props.categories,
        categoriesMap: _this.props.categoriesMap,
        route: _this.props.route,
        user: _this.props.user
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "merge", function () {
      var errors = [];

      _this.props.threads.forEach(function (thread) {
        if (!thread.acl.can_merge) {
          errors.append({
            id: thread.id,
            title: thread.title,
            errors: [gettext("You don't have permission to merge this thread with others.")]
          });
        }
      });

      if (_this.props.threads.length < 2) {
        _snackbar.default.info(gettext("You have to select at least two threads to merge."));
      } else if (errors.length) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(_errorsList.default, {
          errors: errors
        }));

        return;
      } else {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(_merge.default, _this.props));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "delete", function () {
      if (!confirm(gettext("Are you sure you want to delete selected threads?"))) {
        return;
      }

      _this.props.threads.map(function (thread) {
        _this.props.freezeThread(thread.id);
      });

      var ids = _this.props.threads.map(function (thread) {
        return thread.id;
      });

      _ajax.default.delete(_this.props.api, ids).then(function () {
        _this.props.threads.map(function (thread) {
          _this.props.freezeThread(thread.id);

          _this.props.deleteThread(thread);
        });

        _snackbar.default.success(gettext("Selected threads were deleted."));
      }, function (rejection) {
        if (rejection.status === 400) {
          var failedThreads = rejection.map(function (thread) {
            return thread.id;
          });

          _this.props.threads.map(function (thread) {
            _this.props.freezeThread(thread.id);

            if (failedThreads.indexOf(thread.id) === -1) {
              _this.props.deleteThread(thread);
            }
          });

          _modal.default.show( /*#__PURE__*/_react.default.createElement(_errorsList.default, {
            errors: rejection
          }));
        } else {
          _snackbar.default.apiError(rejection);
        }
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "getPinGloballyButton",
    value: function getPinGloballyButton() {
      if (!this.props.moderation.can_pin_globally) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.pinGlobally,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "bookmark"), gettext("Pin threads globally")));
    }
  }, {
    key: "getPinLocallyButton",
    value: function getPinLocallyButton() {
      if (!this.props.moderation.can_pin) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.pinLocally,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "bookmark_border"), gettext("Pin threads locally")));
    }
  }, {
    key: "getUnpinButton",
    value: function getUnpinButton() {
      if (!this.props.moderation.can_pin) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.unpin,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "panorama_fish_eye"), gettext("Unpin threads")));
    }
  }, {
    key: "getMoveButton",
    value: function getMoveButton() {
      if (!this.props.moderation.can_move) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.move,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), gettext("Move threads")));
    }
  }, {
    key: "getMergeButton",
    value: function getMergeButton() {
      if (!this.props.moderation.can_merge) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.merge,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "call_merge"), gettext("Merge threads")));
    }
  }, {
    key: "getApproveButton",
    value: function getApproveButton() {
      if (!this.props.moderation.can_approve) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.approve,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "done"), gettext("Approve threads")));
    }
  }, {
    key: "getOpenButton",
    value: function getOpenButton() {
      if (!this.props.moderation.can_close) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.open,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_open"), gettext("Open threads")));
    }
  }, {
    key: "getCloseButton",
    value: function getCloseButton() {
      if (!this.props.moderation.can_close) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.close,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "lock_outline"), gettext("Close threads")));
    }
  }, {
    key: "getUnhideButton",
    value: function getUnhideButton() {
      if (!this.props.moderation.can_unhide) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.unhide,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility"), gettext("Unhide threads")));
    }
  }, {
    key: "getHideButton",
    value: function getHideButton() {
      if (!this.props.moderation.can_hide) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.hide,
        type: "button",
        className: "btn btn-link"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "visibility_off"), gettext("Hide threads")));
    }
  }, {
    key: "getDeleteButton",
    value: function getDeleteButton() {
      if (!this.props.moderation.can_delete) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.delete,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "clear"), gettext("Delete threads")));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: this.props.className
      }, this.getPinGloballyButton(), this.getPinLocallyButton(), this.getUnpinButton(), this.getMoveButton(), this.getMergeButton(), this.getApproveButton(), this.getOpenButton(), this.getCloseButton(), this.getUnhideButton(), this.getHideButton(), this.getDeleteButton());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../reducers/selection":358,"../../../services/ajax":365,"../../../services/modal":371,"../../../services/snackbar":376,"../../../services/store":377,"../../../utils/countdown":382,"./errors-list":262,"./merge":263,"./move":264,"react":"react"}],262:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreadErrors = ThreadErrors;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": gettext("Close"),
        className: "close",
        "data-dismiss": "modal",
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Threads moderation"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, gettext("One or more threads could not be deleted:")), /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-unstyled list-errored-items"
      }, this.props.errors.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(ThreadErrors, {
          errors: item.errors,
          key: item.thread.id,
          thread: item.thread
        });
      })))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

function ThreadErrors(_ref) {
  var errors = _ref.errors,
      thread = _ref.thread;
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h5", null, thread.title), errors.map(function (message, i) {
    return /*#__PURE__*/_react.default.createElement("p", null, message);
  }));
}

},{"react":"react"}],263:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../../button"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _categorySelect = _interopRequireDefault(require("../../category-select"));

var _select = _interopRequireDefault(require("../../select"));

var _ = _interopRequireDefault(require("../../.."));

var _threads = require("../../../reducers/threads");

var select = _interopRequireWildcard(require("../../../reducers/selection"));

var _errorsList = _interopRequireDefault(require("./errors-list"));

var _mergeConflict = _interopRequireDefault(require("../../merge-conflict"));

var _ajax = _interopRequireDefault(require("../../../services/ajax"));

var _modal = _interopRequireDefault(require("../../../services/modal"));

var _snackbar = _interopRequireDefault(require("../../../services/snackbar"));

var _store = _interopRequireDefault(require("../../../services/store"));

var validators = _interopRequireWildcard(require("../../../utils/validators"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getFormdata", function () {
      return {
        threads: _this.props.threads.map(function (thread) {
          return thread.id;
        }),
        title: _this.state.title,
        category: _this.state.category,
        weight: _this.state.weight,
        is_hidden: _this.state.is_hidden,
        is_closed: _this.state.is_closed
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSuccess", function (apiResponse) {
      // unfreeze and remove merged threads
      _this.props.threads.forEach(function (thread) {
        _this.props.freezeThread(thread.id);

        _this.props.deleteThread(thread);
      }); // deselect all threads


      _store.default.dispatch(select.none()); // append merged thread, filter threads


      _this.props.addThreads([apiResponse]);

      _store.default.dispatch((0, _threads.filterThreads)(_this.props.route.category, _this.props.categoriesMap)); // hide modal


      _modal.default.hide();
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (rejection) {
      if (rejection.status === 400) {
        if (rejection.best_answers || rejection.polls) {
          _modal.default.show( /*#__PURE__*/_react.default.createElement(_mergeConflict.default, {
            api: _.default.get("MERGE_THREADS_API"),
            bestAnswers: rejection.best_answers,
            data: _this.getFormdata(),
            polls: rejection.polls,
            onError: _this.handleError,
            onSuccess: _this.handleSuccess
          }));
        } else {
          _this.setState({
            errors: Object.assign({}, _this.state.errors, rejection)
          });

          _snackbar.default.error(gettext("Form contains errors."));
        }
      } else if (rejection.status === 403 && Array.isArray(rejection)) {
        _modal.default.show( /*#__PURE__*/_react.default.createElement(_errorsList.default, {
          errors: rejection
        }));
      } else if (rejection.best_answer) {
        _snackbar.default.error(rejection.best_answer[0]);
      } else if (rejection.poll) {
        _snackbar.default.error(rejection.poll[0]);
      } else {
        _snackbar.default.apiError(rejection);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCategoryChange", function (ev) {
      var categoryId = ev.target.value;
      var newState = {
        category: categoryId
      };

      if (_this.acl[categoryId].can_pin_threads < newState.weight) {
        newState.weight = 0;
      }

      if (!_this.acl[categoryId].can_hide_threads) {
        newState.is_hidden = 0;
      }

      if (!_this.acl[categoryId].can_close_threads) {
        newState.is_closed = false;
      }

      _this.setState(newState);
    });

    _this.state = {
      isLoading: false,
      title: "",
      category: null,
      weight: 0,
      is_hidden: 0,
      is_closed: false,
      validators: {
        title: [validators.required()]
      },
      errors: {}
    };
    _this.acl = {};

    for (var i in props.user.acl.categories) {
      if (!props.user.acl.categories.hasOwnProperty(i)) {
        continue;
      }

      var acl = props.user.acl.categories[i];
      _this.acl[acl.id] = acl;
    }

    _this.categoryChoices = [];
    props.categories.forEach(function (category) {
      if (category.level > 0) {
        var _acl = _this.acl[category.id];
        var disabled = !_acl.can_start_threads || category.is_closed && !_acl.can_close_threads;

        _this.categoryChoices.push({
          value: category.id,
          disabled: disabled,
          level: category.level - 1,
          label: category.name
        });

        if (!disabled && !_this.state.category) {
          _this.state.category = category.id;
        }
      }
    });
    _this.isHiddenChoices = [{
      value: 0,
      icon: "visibility",
      label: gettext("No")
    }, {
      value: 1,
      icon: "visibility_off",
      label: gettext("Yes")
    }];
    _this.isClosedChoices = [{
      value: false,
      icon: "lock_outline",
      label: gettext("No")
    }, {
      value: true,
      icon: "lock",
      label: gettext("Yes")
    }];
    return _this;
  }

  _createClass(_default, [{
    key: "clean",
    value: function clean() {
      if (this.isValid()) {
        return true;
      } else {
        _snackbar.default.error(gettext("Form contains errors."));

        this.setState({
          errors: this.validate()
        });
        return false;
      }
    }
  }, {
    key: "send",
    value: function send() {
      return _ajax.default.post(_.default.get("MERGE_THREADS_API"), this.getFormdata());
    }
  }, {
    key: "getWeightChoices",
    value: function getWeightChoices() {
      var choices = [{
        value: 0,
        icon: "remove",
        label: gettext("Not pinned")
      }, {
        value: 1,
        icon: "bookmark_border",
        label: gettext("Pinned locally")
      }];

      if (this.acl[this.state.category].can_pin_threads == 2) {
        choices.push({
          value: 2,
          icon: "bookmark",
          label: gettext("Pinned globally")
        });
      }

      return choices;
    }
  }, {
    key: "renderWeightField",
    value: function renderWeightField() {
      if (this.acl[this.state.category].can_pin_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Thread weight"),
          for: "id_weight"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_weight",
          onChange: this.bindInput("weight"),
          value: this.state.weight,
          choices: this.getWeightChoices()
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderHiddenField",
    value: function renderHiddenField() {
      if (this.acl[this.state.category].can_hide_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Hide thread"),
          for: "id_is_hidden"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_hidden"),
          value: this.state.is_hidden,
          choices: this.isHiddenChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderClosedField",
    value: function renderClosedField() {
      if (this.acl[this.state.category].can_close_threads) {
        return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
          label: gettext("Close thread"),
          for: "id_is_closed"
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          id: "id_is_closed",
          onChange: this.bindInput("is_closed"),
          value: this.state.is_closed,
          choices: this.isClosedChoices
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Thread title"),
        for: "id_title",
        validation: this.state.errors.title
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "id_title",
        className: "form-control",
        type: "text",
        onChange: this.bindInput("title"),
        value: this.state.title
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Category"),
        for: "id_category",
        validation: this.state.errors.category
      }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
        id: "id_category",
        onChange: this.onCategoryChange,
        value: this.state.category,
        choices: this.categoryChoices
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix"
      }), this.renderWeightField(), this.renderHiddenField(), this.renderClosedField()), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn-primary",
        loading: this.state.isLoading
      }, gettext("Merge threads"))));
    }
  }, {
    key: "renderCantMergeMessage",
    value: function renderCantMergeMessage() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, gettext("You can't move threads because there are no categories you are allowed to move them to.")), /*#__PURE__*/_react.default.createElement("p", null, gettext("You need permission to start threads in category to be able to merge threads to it.")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        type: "button"
      }, gettext("Ok"))));
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (!this.state.category) {
        return "modal-dialog modal-message";
      } else {
        return "modal-dialog";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Merge threads"))), this.state.category ? this.renderForm() : this.renderCantMergeMessage()));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../..":302,"../../../reducers/selection":358,"../../../reducers/threads":361,"../../../services/ajax":365,"../../../services/modal":371,"../../../services/snackbar":376,"../../../services/store":377,"../../../utils/validators":393,"../../button":8,"../../category-select":21,"../../form":56,"../../form-group":55,"../../merge-conflict":59,"../../select":210,"./errors-list":262,"react":"react"}],264:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _form = _interopRequireDefault(require("../../form"));

var _formGroup = _interopRequireDefault(require("../../form-group"));

var _categorySelect = _interopRequireDefault(require("../../category-select"));

var select = _interopRequireWildcard(require("../../../reducers/selection"));

var _threads = require("../../../reducers/threads");

var _modal = _interopRequireDefault(require("../../../services/modal"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_Form) {
  _inherits(_default, _Form);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      // we don't reload page on submissions
      event.preventDefault();

      _modal.default.hide();

      var onSuccess = function onSuccess() {
        _store.default.dispatch((0, _threads.filterThreads)(_this.props.route.category, _this.props.categoriesMap)); // deselect threads moved outside of visible scope


        var storeState = _store.default.getState();

        var leftThreads = storeState.threads.map(function (thread) {
          return thread.id;
        });

        _store.default.dispatch(select.all(storeState.selection.filter(function (thread) {
          return leftThreads.indexOf(thread) !== -1;
        })));
      };

      _this.props.callApi([{
        op: "replace",
        path: "category",
        value: _this.state.category
      }, {
        op: "replace",
        path: "flatten-categories",
        value: null
      }, {
        op: "add",
        path: "acl",
        value: true
      }], gettext("Selected threads were moved."), onSuccess);
    });

    _this.state = {
      category: null
    };
    var acls = {};

    for (var i in props.user.acl.categories) {
      if (!props.user.acl.categories.hasOwnProperty(i)) {
        continue;
      }

      var acl = props.user.acl.categories[i];
      acls[acl.id] = acl;
    }

    _this.categoryChoices = [];
    props.categories.forEach(function (category) {
      if (category.level > 0) {
        var _acl = acls[category.id];
        var disabled = !_acl.can_start_threads || category.is_closed && !_acl.can_close_threads;

        _this.categoryChoices.push({
          value: category.id,
          disabled: disabled,
          level: category.level - 1,
          label: category.name
        });

        if (!disabled && !_this.state.category) {
          _this.state.category = category.id;
        }
      }
    });
    return _this;
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (!this.state.category) {
        return "modal-dialog modal-message";
      } else {
        return "modal-dialog";
      }
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("New category"),
        for: "id_new_category"
      }, /*#__PURE__*/_react.default.createElement(_categorySelect.default, {
        id: "id_new_category",
        onChange: this.bindInput("category"),
        value: this.state.category,
        choices: this.categoryChoices
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        disabled: this.state.isLoading,
        type: "button"
      }, gettext("Cancel")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary"
      }, gettext("Move threads"))));
    }
  }, {
    key: "renderCantMoveMessage",
    value: function renderCantMoveMessage() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message-icon"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "info_outline")), /*#__PURE__*/_react.default.createElement("div", {
        className: "message-body"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, gettext("You can't move threads because there are no categories you are allowed to move them to.")), /*#__PURE__*/_react.default.createElement("p", null, gettext("You need permission to start threads in category to be able to move threads to it.")), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default",
        "data-dismiss": "modal",
        type: "button"
      }, gettext("Ok"))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName(),
        role: "document"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": gettext("Close")
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, gettext("Move threads"))), this.state.category ? this.renderForm() : this.renderCantMoveMessage()));
    }
  }]);

  return _default;
}(_form.default);

exports.default = _default;

},{"../../../reducers/selection":358,"../../../reducers/threads":361,"../../../services/modal":371,"../../../services/store":377,"../../category-select":21,"../../form":56,"../../form-group":55,"react":"react"}],265:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var select = _interopRequireWildcard(require("../../../reducers/selection"));

var _store = _interopRequireDefault(require("../../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
      _store.default.dispatch(select.all(_this.props.threads.map(function (thread) {
        return thread.id;
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "selectNone", function () {
      _store.default.dispatch(select.none());
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        type: "button",
        onClick: this.selectAll
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box"), gettext("Select all"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link",
        type: "button",
        onClick: this.selectNone
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "check_box_outline_blank"), gettext("Select none"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../reducers/selection":358,"../../../services/store":377,"react":"react"}],266:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _li = _interopRequireDefault(require("../li"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var baseUrl = _ref.baseUrl,
      list = _ref.list,
      lists = _ref.lists;
  if (lists.length < 2) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-tabs"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav nav-pills"
  }, lists.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_li.default, {
      isControlled: true,
      isActive: item.path === list.path,
      key: baseUrl + item.path
    }, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      to: baseUrl + item.path
    }, item.name));
  }))));
}

},{"../li":57,"react":"react","react-router":"react-router"}],267:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelect = getSelect;
exports.getLists = getLists;
exports.paths = paths;

var _reactRedux = require("react-redux");

var _route = _interopRequireDefault(require("./route"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSelect(options) {
  return function (store) {
    return {
      options: options,
      selection: store.selection,
      threads: store.threads,
      tick: store.tick.tick,
      user: store.auth.user
    };
  };
}

function getLists(user) {
  var lists = [{
    type: "all",
    path: "",
    name: gettext("All"),
    longName: gettext("All threads")
  }];

  if (user.id) {
    lists.push({
      type: "my",
      path: "my/",
      name: gettext("My"),
      longName: gettext("My threads")
    });
    lists.push({
      type: "new",
      path: "new/",
      name: gettext("New"),
      longName: gettext("New threads")
    });
    lists.push({
      type: "unread",
      path: "unread/",
      name: gettext("Unread"),
      longName: gettext("Unread threads")
    });
    lists.push({
      type: "subscribed",
      path: "subscribed/",
      name: gettext("Subscribed"),
      longName: gettext("Subscribed threads")
    });

    if (user.acl.can_see_unapproved_content_lists) {
      lists.push({
        type: "unapproved",
        path: "unapproved/",
        name: gettext("Unapproved"),
        longName: gettext("Unapproved content")
      });
    }
  }

  return lists;
}

function paths(user, mode) {
  var lists = getLists(user);
  var routes = [];
  var categoriesMap = {};

  _.default.get("CATEGORIES").forEach(function (category) {
    lists.forEach(function (list) {
      categoriesMap[category.id] = category;
      routes.push({
        path: category.url.index + list.path,
        component: (0, _reactRedux.connect)(getSelect(mode))(_route.default),
        categories: _.default.get("CATEGORIES"),
        categoriesMap: categoriesMap,
        category: category,
        lists: lists,
        list: list
      });
    });
  });

  return routes;
}

},{"../..":302,"./route":268,"react-redux":"react-redux"}],268:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _compare = require("./compare");

var _container = _interopRequireDefault(require("./container"));

var _header = _interopRequireDefault(require("./header"));

var _utils = require("./utils");

var _threadsList = _interopRequireDefault(require("../threads-list"));

var _listEmpty = _interopRequireDefault(require("./list-empty"));

var _withDropdown = _interopRequireDefault(require("../with-dropdown"));

var _ = _interopRequireDefault(require("../.."));

var select = _interopRequireWildcard(require("../../reducers/selection"));

var _threads = require("../../reducers/threads");

var _ajax = _interopRequireDefault(require("../../services/ajax"));

var _polls = _interopRequireDefault(require("../../services/polls"));

var _snackbar = _interopRequireDefault(require("../../services/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../services/page-title"));

var sets = _interopRequireWildcard(require("../../utils/sets"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_WithDropdown) {
  _inherits(_default, _WithDropdown);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      _this.setState({
        isBusy: true
      });

      _this.loadThreads(_this.getCategory(), _this.state.next);
    });

    _defineProperty(_assertThisInitialized(_this), "pollResponse", function (data) {
      _this.setState({
        diff: Object.assign({}, data, {
          results: (0, _utils.diffThreads)(_this.props.threads, data.results)
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addThreads", function (threads) {
      _store.default.dispatch((0, _threads.append)(threads, _this.getSorting()));
    });

    _defineProperty(_assertThisInitialized(_this), "applyDiff", function () {
      _this.addThreads(_this.state.diff.results);

      _this.setState(Object.assign({}, _this.state.diff, {
        moderation: (0, _utils.getModerationActions)(_store.default.getState().threads),
        diff: {
          results: []
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "freezeThread", function (thread) {
      _this.setState(function (currentState) {
        return {
          busyThreads: sets.toggle(currentState.busyThreads, thread)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateThread", function (thread) {
      _store.default.dispatch((0, _threads.patch)(thread, thread, _this.getSorting()));
    });

    _defineProperty(_assertThisInitialized(_this), "deleteThread", function (thread) {
      _store.default.dispatch((0, _threads.deleteThread)(thread));
    });

    _this.state = {
      isMounted: true,
      isLoaded: false,
      isBusy: false,
      diff: {
        results: []
      },
      moderation: [],
      busyThreads: [],
      dropdown: false,
      subcategories: [],
      next: 0
    };

    var category = _this.getCategory();

    if (_.default.has("THREADS")) {
      _this.initWithPreloadedData(category, _.default.get("THREADS"));
    } else {
      _this.initWithoutPreloadedData(category);
    }

    return _this;
  }

  _createClass(_default, [{
    key: "getCategory",
    value: function getCategory() {
      if (!this.props.route.category.special_role) {
        return this.props.route.category.id;
      } else {
        return null;
      }
    }
  }, {
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(category, data) {
      this.state = Object.assign(this.state, {
        moderation: (0, _utils.getModerationActions)(data.results),
        subcategories: data.subcategories,
        next: data.next
      });
      this.startPolling(category);
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData(category) {
      this.loadThreads(category);
    }
  }, {
    key: "loadThreads",
    value: function loadThreads(category) {
      var _this2 = this;

      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _ajax.default.get(this.props.options.api, {
        category: category,
        list: this.props.route.list.type,
        start: next || 0
      }, "threads").then(function (data) {
        if (!_this2.state.isMounted) {
          // user changed route before loading completion
          return;
        }

        if (next === 0) {
          _store.default.dispatch((0, _threads.hydrate)(data.results));
        } else {
          _store.default.dispatch((0, _threads.append)(data.results, _this2.getSorting()));
        }

        _this2.setState({
          isLoaded: true,
          isBusy: false,
          moderation: (0, _utils.getModerationActions)(_store.default.getState().threads),
          subcategories: data.subcategories,
          next: data.next
        });

        _this2.startPolling(category);
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "startPolling",
    value: function startPolling(category) {
      _polls.default.start({
        poll: "threads",
        url: this.props.options.api,
        data: {
          category: category,
          list: this.props.route.list.type
        },
        frequency: 120 * 1000,
        update: this.pollResponse
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPageTitle();

      if (_.default.has("THREADS")) {
        // unlike in other components, routes are root components for threads
        // so we can't dispatch store action from constructor
        _store.default.dispatch((0, _threads.hydrate)(_.default.pop("THREADS").results));

        this.setState({
          isLoaded: true
        });
      }

      _store.default.dispatch(select.none());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.isMounted = false;

      _polls.default.stop("threads");
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      if (this.props.options.title) {
        return this.props.options.title;
      }

      return (0, _utils.getTitle)(this.props.route);
    }
  }, {
    key: "setPageTitle",
    value: function setPageTitle() {
      if (this.props.route.category.level || !_.default.get("THREADS_ON_INDEX")) {
        _pageTitle.default.set((0, _utils.getPageTitle)(this.props.route));
      } else if (this.props.options.title) {
        _pageTitle.default.set(this.props.options.title);
      } else {
        if (_.default.get("SETTINGS").index_title) {
          document.title = _.default.get("SETTINGS").index_title;
        } else {
          document.title = _.default.get("SETTINGS").forum_name;
        }
      }
    }
  }, {
    key: "getSorting",
    value: function getSorting() {
      if (this.props.route.category.level) {
        return _compare.compareWeight;
      } else {
        return _compare.compareGlobalWeight;
      }
    } // AJAX

  }, {
    key: "getMoreButton",
    value: function getMoreButton() {
      if (!this.state.next) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pager-more"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "btn btn-default btn-outline",
        loading: this.state.isBusy || this.state.busyThreads.length,
        onClick: this.loadMore
      }, gettext("Show more")));
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var className = "page page-threads";
      className += " page-threads-" + this.props.route.list.type;

      if (isIndex(this.props)) {
        className += " page-threads-index";
      }

      if (this.props.route.category.css_class) {
        className += " page-threads-" + this.props.route.category.css_class;
      }

      return className;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement(_header.default, {
        categories: this.props.route.categoriesMap,
        disabled: !this.state.isLoaded,
        startThread: this.props.options.startThread,
        threads: this.props.threads,
        title: this.getTitle(),
        toggleNav: this.toggleNav,
        route: this.props.route,
        user: this.props.user
      }), /*#__PURE__*/_react.default.createElement(_container.default, {
        api: this.props.options.api,
        route: this.props.route,
        subcategories: this.state.subcategories,
        user: this.props.user,
        pageLead: this.props.options.pageLead,
        threads: this.props.threads,
        threadsCount: this.state.count,
        moderation: this.state.moderation,
        selection: this.props.selection,
        busyThreads: this.state.busyThreads,
        addThreads: this.addThreads,
        freezeThread: this.freezeThread,
        deleteThread: this.deleteThread,
        updateThread: this.updateThread,
        isLoaded: this.state.isLoaded,
        isBusy: this.state.isBusy
      }, /*#__PURE__*/_react.default.createElement(_threadsList.default, {
        category: this.props.route.category,
        categories: this.props.route.categoriesMap,
        list: this.props.route.list,
        selection: this.props.selection,
        threads: this.props.threads,
        diffSize: this.state.diff.results.length,
        applyDiff: this.applyDiff,
        showOptions: !!this.props.user.id,
        isLoaded: this.state.isLoaded,
        busyThreads: this.state.busyThreads
      }, /*#__PURE__*/_react.default.createElement(_listEmpty.default, {
        category: this.props.route.category,
        emptyMessage: this.props.options.emptyMessage,
        list: this.props.route.list
      })), this.getMoreButton()));
    }
  }]);

  return _default;
}(_withDropdown.default);

exports.default = _default;

function isIndex(props) {
  if (props.route.category.level || !_.default.get("THREADS_ON_INDEX")) return false;
  if (props.options.title) return false;
  return true;
}

},{"../..":302,"../../reducers/selection":358,"../../reducers/threads":361,"../../services/ajax":365,"../../services/page-title":373,"../../services/polls":374,"../../services/snackbar":376,"../../services/store":377,"../../utils/sets":391,"../button":8,"../threads-list":238,"../with-dropdown":299,"./compare":257,"./container":258,"./header":259,"./list-empty":260,"./utils":270,"react":"react"}],269:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _categoryPicker = _interopRequireDefault(require("./category-picker"));

var _controls = _interopRequireDefault(require("./moderation/controls"));

var _selection = _interopRequireDefault(require("./moderation/selection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getCategoryPicker",
    value: function getCategoryPicker() {
      if (!this.props.subcategories.length) return null;
      return /*#__PURE__*/_react.default.createElement(_categoryPicker.default, {
        categories: this.props.categoriesMap,
        choices: this.props.subcategories,
        list: this.props.list
      });
    }
  }, {
    key: "showModerationOptions",
    value: function showModerationOptions() {
      return this.props.user.id && this.props.moderation.allow;
    }
  }, {
    key: "getSelectedThreads",
    value: function getSelectedThreads() {
      var _this = this;

      return this.props.threads.filter(function (thread) {
        return _this.props.selection.indexOf(thread.id) >= 0;
      });
    }
  }, {
    key: "getModerationButton",
    value: function getModerationButton() {
      if (!this.showModerationOptions()) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6 col-sm-3 col-md-2"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group btn-group-justified"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group dropdown"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default btn-outline dropdown-toggle",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        disabled: this.props.disabled || !this.props.selection.length
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "settings"), gettext("Options")), /*#__PURE__*/_react.default.createElement(_controls.default, {
        addThreads: this.props.addThreads,
        api: this.props.api,
        categories: this.props.categories,
        categoriesMap: this.props.categoriesMap,
        className: "dropdown-menu dropdown-menu-right stick-to-bottom",
        deleteThread: this.props.deleteThread,
        freezeThread: this.props.freezeThread,
        moderation: this.props.moderation,
        route: this.props.route,
        threads: this.getSelectedThreads(),
        updateThread: this.props.updateThread,
        user: this.props.user
      }))));
    }
  }, {
    key: "getSelectionButton",
    value: function getSelectionButton() {
      if (!this.showModerationOptions()) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-3 col-sm-2 col-md-1"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group btn-group-justified"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-group dropdown"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default btn-outline btn-icon dropdown-toggle",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        disabled: this.props.disabled
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "select_all")), /*#__PURE__*/_react.default.createElement(_selection.default, {
        className: "dropdown-menu dropdown-menu-right stick-to-bottom",
        threads: this.props.threads
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row row-toolbar row-toolbar-bottom-margin"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-3 col-sm-3 col-md-2 dropdown"
      }, this.getCategoryPicker()), /*#__PURE__*/_react.default.createElement("div", {
        className: "hidden-xs col-sm-4 col-md-7"
      }), this.getModerationButton(), this.getSelectionButton());
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./category-picker":256,"./moderation/controls":261,"./moderation/selection":265,"react":"react"}],270:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageTitle = getPageTitle;
exports.getTitle = getTitle;
exports.isThreadChanged = isThreadChanged;
exports.diffThreads = diffThreads;
exports.getModerationActions = getModerationActions;

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPageTitle(route) {
  if (route.category.level) {
    if (route.list.path) {
      return {
        title: route.list.longName,
        parent: route.category.name
      };
    } else {
      return {
        title: route.category.name
      };
    }
  } else if (_.default.get("THREADS_ON_INDEX")) {
    if (route.list.path) {
      return {
        title: route.list.longName
      };
    } else {
      return null;
    }
  } else {
    if (route.list.path) {
      return {
        title: route.list.longName,
        parent: gettext("Threads")
      };
    } else {
      return {
        title: gettext("Threads")
      };
    }
  }
}

function getTitle(route) {
  if (route.category.level) {
    return route.category.name;
  } else if (_.default.get("THREADS_ON_INDEX")) {
    if (_.default.get("SETTINGS").index_header) {
      return _.default.get("SETTINGS").index_header;
    } else {
      return _.default.get("SETTINGS").forum_name;
    }
  } else {
    return gettext("Threads");
  }
}

function isThreadChanged(current, fromDb) {
  return [current.title === fromDb.title, current.weight === fromDb.weight, current.category === fromDb.category, current.last_post === fromDb.last_post, current.last_poster_name === fromDb.last_poster_name].indexOf(false) >= 0;
}

function diffThreads(current, fromDb) {
  var currentMap = {};
  current.forEach(function (thread) {
    currentMap[thread.id] = thread;
  });
  return fromDb.filter(function (thread) {
    if (currentMap[thread.id]) {
      return isThreadChanged(currentMap[thread.id], thread);
    } else {
      return true;
    }
  });
}

function getModerationActions(threads) {
  var moderation = {
    allow: false,
    can_approve: 0,
    can_close: 0,
    can_delete: 0,
    can_hide: 0,
    can_merge: 0,
    can_move: 0,
    can_pin: 0,
    can_pin_globally: 0,
    can_unhide: 0
  };
  threads.forEach(function (thread) {
    if (thread.is_unapproved && thread.acl.can_approve > moderation.can_approve) {
      moderation.can_approve = thread.acl.can_approve;
    }

    if (thread.acl.can_close > moderation.can_close) {
      moderation.can_close = thread.acl.can_close;
    }

    if (thread.acl.can_delete > moderation.can_delete) {
      moderation.can_delete = thread.acl.can_delete;
    }

    if (thread.acl.can_hide > moderation.can_hide) {
      moderation.can_hide = thread.acl.can_hide;
    }

    if (thread.acl.can_merge > moderation.can_merge) {
      moderation.can_merge = thread.acl.can_merge;
    }

    if (thread.acl.can_move > moderation.can_move) {
      moderation.can_move = thread.acl.can_move;
    }

    if (thread.acl.can_pin > moderation.can_pin) {
      moderation.can_pin = thread.acl.can_pin;
    }

    if (thread.acl.can_pin_globally > moderation.can_pin_globally) {
      moderation.can_pin_globally = thread.acl.can_pin_globally;
    }

    if (thread.is_hidden && thread.acl.can_unhide > moderation.can_unhide) {
      moderation.can_unhide = thread.acl.can_unhide;
    }

    moderation.allow = moderation.can_approve || moderation.can_close || moderation.can_delete || moderation.can_hide || moderation.can_merge || moderation.can_move || moderation.can_pin || moderation.can_pin_globally || moderation.can_unhide;
  });
  return moderation;
}

},{"../..":302}],271:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactGuestNav = exports.GuestNav = exports.GuestMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _navbarSearch = _interopRequireDefault(require("../navbar-search"));

var _registerButton = _interopRequireDefault(require("../register-button"));

var _signIn = _interopRequireDefault(require("../sign-in.js"));

var _ = _interopRequireDefault(require("../.."));

var _mobileNavbarDropdown = _interopRequireDefault(require("../../services/mobile-navbar-dropdown"));

var _modal = _interopRequireDefault(require("../../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var GuestMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(GuestMenu, _React$Component);

  var _super = _createSuper(GuestMenu);

  function GuestMenu() {
    _classCallCheck(this, GuestMenu);

    return _super.apply(this, arguments);
  }

  _createClass(GuestMenu, [{
    key: "showSignInModal",
    value: function showSignInModal() {
      _modal.default.show(_signIn.default);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu user-dropdown dropdown-menu-right",
        role: "menu"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "guest-preview"
      }, /*#__PURE__*/_react.default.createElement("h4", null, gettext("You are browsing as guest.")), /*#__PURE__*/_react.default.createElement("p", null, gettext("Sign in or register to start and participate in discussions.")), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, _.default.get("SETTINGS").enable_sso ? /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "btn btn-primary btn-register btn-block",
        href: _.default.get("SETTINGS").SSO_LOGIN_URL
      }, gettext("Sign in"))) : /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-sign-in btn-block",
        onClick: this.showSignInModal,
        type: "button"
      }, gettext("Sign in"))), !_.default.get("SETTINGS").enable_sso && /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_registerButton.default, {
        className: "btn-primary btn-register btn-block"
      }, gettext("Register"))))));
    }
  }]);

  return GuestMenu;
}(_react.default.Component);

exports.GuestMenu = GuestMenu;

var GuestNav = /*#__PURE__*/function (_GuestMenu) {
  _inherits(GuestNav, _GuestMenu);

  var _super2 = _createSuper(GuestNav);

  function GuestNav() {
    _classCallCheck(this, GuestNav);

    return _super2.apply(this, arguments);
  }

  _createClass(GuestNav, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "nav nav-guest"
      }, _.default.get("SETTINGS").enable_sso ? /*#__PURE__*/_react.default.createElement("a", {
        className: "btn navbar-btn btn-primary btn-register",
        href: _.default.get("SETTINGS").SSO_LOGIN_URL
      }, gettext("Sign in")) : /*#__PURE__*/_react.default.createElement("button", {
        className: "btn navbar-btn btn-default btn-sign-in",
        onClick: this.showSignInModal,
        type: "button"
      }, gettext("Sign in")), !_.default.get("SETTINGS").enable_sso && /*#__PURE__*/_react.default.createElement(_registerButton.default, {
        className: "navbar-btn btn-primary btn-register"
      }, gettext("Register")), /*#__PURE__*/_react.default.createElement("div", {
        className: "navbar-left"
      }, /*#__PURE__*/_react.default.createElement(_navbarSearch.default, null)));
    }
  }]);

  return GuestNav;
}(GuestMenu);

exports.GuestNav = GuestNav;

var CompactGuestNav = /*#__PURE__*/function (_React$Component2) {
  _inherits(CompactGuestNav, _React$Component2);

  var _super3 = _createSuper(CompactGuestNav);

  function CompactGuestNav() {
    _classCallCheck(this, CompactGuestNav);

    return _super3.apply(this, arguments);
  }

  _createClass(CompactGuestNav, [{
    key: "showGuestMenu",
    value: function showGuestMenu() {
      _mobileNavbarDropdown.default.show(GuestMenu);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.showGuestMenu
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "64"
      }));
    }
  }]);

  return CompactGuestNav;
}(_react.default.Component);

exports.CompactGuestNav = CompactGuestNav;

},{"../..":302,"../../services/mobile-navbar-dropdown":370,"../../services/modal":371,"../avatar":6,"../navbar-search":77,"../register-button":198,"../sign-in.js":211,"react":"react"}],272:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.CompactUserMenu = exports.UserMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _guestNav = require("./guest-nav");

var _userNav = require("./user-nav");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UserMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(UserMenu, _React$Component);

  var _super = _createSuper(UserMenu);

  function UserMenu() {
    _classCallCheck(this, UserMenu);

    return _super.apply(this, arguments);
  }

  _createClass(UserMenu, [{
    key: "render",
    value: function render() {
      if (this.props.isAuthenticated) {
        return /*#__PURE__*/_react.default.createElement(_userNav.UserNav, {
          user: this.props.user
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_guestNav.GuestNav, null);
      }
    }
  }]);

  return UserMenu;
}(_react.default.Component);

exports.UserMenu = UserMenu;

var CompactUserMenu = /*#__PURE__*/function (_React$Component2) {
  _inherits(CompactUserMenu, _React$Component2);

  var _super2 = _createSuper(CompactUserMenu);

  function CompactUserMenu() {
    _classCallCheck(this, CompactUserMenu);

    return _super2.apply(this, arguments);
  }

  _createClass(CompactUserMenu, [{
    key: "render",
    value: function render() {
      if (this.props.isAuthenticated) {
        return /*#__PURE__*/_react.default.createElement(_userNav.CompactUserNav, {
          user: this.props.user
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_guestNav.CompactGuestNav, null);
      }
    }
  }]);

  return CompactUserMenu;
}(_react.default.Component);

exports.CompactUserMenu = CompactUserMenu;

function select(state) {
  return state.auth;
}

},{"./guest-nav":271,"./user-nav":273,"react":"react"}],273:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateThreadsBadge = PrivateThreadsBadge;
exports.UserNav = UserNav;
exports.UserPrivateThreadsLink = UserPrivateThreadsLink;
exports.selectUserMenu = selectUserMenu;
exports.CompactUserNav = exports.UserMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _avatar = _interopRequireDefault(require("../avatar"));

var _root = _interopRequireWildcard(require("../change-avatar/root"));

var _navbarSearch = _interopRequireDefault(require("../navbar-search"));

var _ = _interopRequireDefault(require("../.."));

var _mobileNavbarDropdown = _interopRequireDefault(require("../../services/mobile-navbar-dropdown"));

var _modal = _interopRequireDefault(require("../../services/modal"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UserMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(UserMenu, _React$Component);

  var _super = _createSuper(UserMenu);

  function UserMenu() {
    _classCallCheck(this, UserMenu);

    return _super.apply(this, arguments);
  }

  _createClass(UserMenu, [{
    key: "logout",
    value: function logout() {
      var decision = confirm(gettext("Are you sure you want to sign out?"));

      if (decision) {
        $("#hidden-logout-form").submit();
      }
    }
  }, {
    key: "changeAvatar",
    value: function changeAvatar() {
      _modal.default.show((0, _reactRedux.connect)(_root.select)(_root.default));
    }
  }, {
    key: "render",
    value: function render() {
      var user = this.props.user;
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu user-dropdown dropdown-menu-right",
        role: "menu"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "dropdown-header"
      }, /*#__PURE__*/_react.default.createElement("strong", null, user.username), /*#__PURE__*/_react.default.createElement("div", {
        className: "row user-stats"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "message"), user.posts), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "forum"), user.threads), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "favorite"), user.followers), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "favorite_outline"), user.following))), /*#__PURE__*/_react.default.createElement("li", {
        className: "divider"
      }), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: user.url
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "account_circle"), gettext("See your profile"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _.default.get("USERCP_URL")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "done_all"), gettext("Change options"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-link",
        onClick: this.changeAvatar,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "portrait"), gettext("Change avatar"))), !!user.acl.can_use_private_threads && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _.default.get("PRIVATE_THREADS_URL")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "message"), gettext("Private threads"), /*#__PURE__*/_react.default.createElement(PrivateThreadsBadge, {
        user: user
      }))), /*#__PURE__*/_react.default.createElement("li", {
        className: "divider"
      }), /*#__PURE__*/_react.default.createElement("li", {
        className: "dropdown-buttons"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-default btn-block",
        onClick: this.logout,
        type: "button"
      }, gettext("Log out"))));
    }
  }]);

  return UserMenu;
}(_react.default.Component);

exports.UserMenu = UserMenu;

function PrivateThreadsBadge(_ref) {
  var user = _ref.user;
  if (!user.unread_private_threads) return null;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "badge"
  }, user.unread_private_threads);
}

function UserNav(_ref2) {
  var user = _ref2.user;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "ul nav navbar-nav nav-user"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_navbarSearch.default, null)), /*#__PURE__*/_react.default.createElement(UserPrivateThreadsLink, {
    user: user
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown"
  }, /*#__PURE__*/_react.default.createElement("a", {
    "aria-haspopup": "true",
    "aria-expanded": "false",
    className: "dropdown-toggle",
    "data-toggle": "dropdown",
    href: user.url,
    role: "button"
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    user: user,
    size: "64"
  })), /*#__PURE__*/_react.default.createElement(UserMenu, {
    user: user
  })));
}

function UserPrivateThreadsLink(_ref3) {
  var user = _ref3.user;
  if (!user.acl.can_use_private_threads) return null;
  var title = null;

  if (user.unread_private_threads) {
    title = gettext("You have unread private threads!");
  } else {
    title = gettext("Private threads");
  }

  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    className: "navbar-icon",
    href: _.default.get("PRIVATE_THREADS_URL"),
    title: title
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icon"
  }, "message"), user.unread_private_threads > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "badge"
  }, user.unread_private_threads)));
}

function selectUserMenu(state) {
  return {
    user: state.auth.user
  };
}

var CompactUserNav = /*#__PURE__*/function (_React$Component2) {
  _inherits(CompactUserNav, _React$Component2);

  var _super2 = _createSuper(CompactUserNav);

  function CompactUserNav() {
    _classCallCheck(this, CompactUserNav);

    return _super2.apply(this, arguments);
  }

  _createClass(CompactUserNav, [{
    key: "showUserMenu",
    value: function showUserMenu() {
      _mobileNavbarDropdown.default.showConnected("user-menu", (0, _reactRedux.connect)(selectUserMenu)(UserMenu));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.showUserMenu
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        user: this.props.user,
        size: "50"
      }));
    }
  }]);

  return CompactUserNav;
}(_react.default.Component);

exports.CompactUserNav = CompactUserNav;

},{"../..":302,"../../services/mobile-navbar-dropdown":370,"../../services/modal":371,"../avatar":6,"../change-avatar/root":25,"../navbar-search":77,"react":"react","react-redux":"react-redux"}],274:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatusClassName = getStatusClassName;
exports.getStatusDescription = getStatusDescription;
exports.StatusLabel = exports.StatusIcon = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getClass",
    value: function getClass() {
      return getStatusClassName(this.props.status);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: this.getClass()
      }, this.props.children);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

var StatusIcon = /*#__PURE__*/function (_React$Component2) {
  _inherits(StatusIcon, _React$Component2);

  var _super2 = _createSuper(StatusIcon);

  function StatusIcon() {
    _classCallCheck(this, StatusIcon);

    return _super2.apply(this, arguments);
  }

  _createClass(StatusIcon, [{
    key: "getIcon",
    value: function getIcon() {
      if (this.props.status.is_banned) {
        return "remove_circle_outline";
      } else if (this.props.status.is_hidden) {
        return "help_outline";
      } else if (this.props.status.is_online_hidden) {
        return "label";
      } else if (this.props.status.is_offline_hidden) {
        return "label_outline";
      } else if (this.props.status.is_online) {
        return "lens";
      } else if (this.props.status.is_offline) {
        return "panorama_fish_eye";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon status-icon"
      }, this.getIcon());
    }
  }]);

  return StatusIcon;
}(_react.default.Component);

exports.StatusIcon = StatusIcon;

var StatusLabel = /*#__PURE__*/function (_React$Component3) {
  _inherits(StatusLabel, _React$Component3);

  var _super3 = _createSuper(StatusLabel);

  function StatusLabel() {
    _classCallCheck(this, StatusLabel);

    return _super3.apply(this, arguments);
  }

  _createClass(StatusLabel, [{
    key: "getHelp",
    value: function getHelp() {
      return getStatusDescription(this.props.user, this.props.status);
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (this.props.status.is_banned) {
        return gettext("Banned");
      } else if (this.props.status.is_hidden) {
        return gettext("Hidden");
      } else if (this.props.status.is_online_hidden) {
        return gettext("Online (hidden)");
      } else if (this.props.status.is_offline_hidden) {
        return gettext("Offline (hidden)");
      } else if (this.props.status.is_online) {
        return gettext("Online");
      } else if (this.props.status.is_offline) {
        return gettext("Offline");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: this.props.className || "status-label",
        title: this.getHelp()
      }, this.getLabel());
    }
  }]);

  return StatusLabel;
}(_react.default.Component);

exports.StatusLabel = StatusLabel;

function getStatusClassName(status) {
  var className = "";

  if (status.is_banned) {
    className = "banned";
  } else if (status.is_hidden) {
    className = "offline";
  } else if (status.is_online_hidden) {
    className = "online";
  } else if (status.is_offline_hidden) {
    className = "offline";
  } else if (status.is_online) {
    className = "online";
  } else if (status.is_offline) {
    className = "offline";
  }

  return "user-status user-" + className;
}

function getStatusDescription(user, status) {
  if (status.is_banned) {
    if (status.banned_until) {
      return interpolate(gettext("%(username)s is banned until %(ban_expires)s"), {
        username: user.username,
        ban_expires: status.banned_until.format("LL, LT")
      }, true);
    } else {
      return interpolate(gettext("%(username)s is banned"), {
        username: user.username
      }, true);
    }
  } else if (status.is_hidden) {
    return interpolate(gettext("%(username)s is hiding presence"), {
      username: user.username
    }, true);
  } else if (status.is_online_hidden) {
    return interpolate(gettext("%(username)s is online (hidden)"), {
      username: user.username
    }, true);
  } else if (status.is_offline_hidden) {
    return interpolate(gettext("%(username)s was last seen %(last_click)s (hidden)"), {
      username: user.username,
      last_click: status.last_click.fromNow()
    }, true);
  } else if (status.is_online) {
    return interpolate(gettext("%(username)s is online"), {
      username: user.username
    }, true);
  } else if (status.is_offline) {
    return interpolate(gettext("%(username)s was last seen %(last_click)s"), {
      username: user.username,
      last_click: status.last_click.fromNow()
    }, true);
  }
}

},{"react":"react"}],275:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

var random = _interopRequireWildcard(require("../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.props.hiddenOnMobile) {
        return "list-group-item hidden-xs hidden-sm";
      } else {
        return "list-group-item";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "change-avatar"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "user-avatar"
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "100"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "change-author"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 100) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "change"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "change-date"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(80, 140) + "px"
        }
      }, "\xA0")));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../utils/random":388,"../avatar":6,"react":"react"}],276:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "renderUserAvatar",
    value: function renderUserAvatar() {
      if (this.props.change.changed_by) {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: this.props.change.changed_by.url,
          className: "user-avatar-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
          user: this.props.change.changed_by,
          size: "100"
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "user-avatar-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
          size: "100"
        }));
      }
    }
  }, {
    key: "renderUsername",
    value: function renderUsername() {
      if (this.props.change.changed_by) {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: this.props.change.changed_by.url,
          className: "item-title"
        }, this.props.change.changed_by.username);
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "item-title"
        }, this.props.change.changed_by_username);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "list-group-item",
        key: this.props.change.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "change-avatar"
      }, this.renderUserAvatar()), /*#__PURE__*/_react.default.createElement("div", {
        className: "change-author"
      }, this.renderUsername()), /*#__PURE__*/_react.default.createElement("div", {
        className: "change"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "old-username"
      }, this.props.change.old_username), /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, "arrow_forward"), /*#__PURE__*/_react.default.createElement("span", {
        className: "new-username"
      }, this.props.change.new_username)), /*#__PURE__*/_react.default.createElement("div", {
        className: "change-date"
      }, /*#__PURE__*/_react.default.createElement("abbr", {
        title: this.props.change.changed_on.format("LLL")
      }, this.props.change.changed_on.fromNow())));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../avatar":6,"react":"react"}],277:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      if (this.props.emptyMessage) {
        return this.props.emptyMessage;
      } else {
        return gettext("No name changes have been recorded for your account.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "username-history ui-ready"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "list-group-item empty-message"
      }, this.getEmptyMessage())));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],278:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _changePreview = _interopRequireDefault(require("./change-preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "username-history ui-preview"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, [0, 1, 2].map(function (i) {
        return /*#__PURE__*/_react.default.createElement(_changePreview.default, {
          hiddenOnMobile: i > 0,
          key: i
        });
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./change-preview":275,"react":"react"}],279:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _change = _interopRequireDefault(require("./change"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "username-history ui-ready"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, this.props.changes.map(function (change) {
        return /*#__PURE__*/_react.default.createElement(_change.default, {
          change: change,
          key: change.id
        });
      })));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./change":276,"react":"react"}],280:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _listEmpty = _interopRequireDefault(require("./list-empty"));

var _listReady = _interopRequireDefault(require("./list-ready"));

var _listPreview = _interopRequireDefault(require("./list-preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.props.isLoaded) {
        if (this.props.changes.length) {
          return /*#__PURE__*/_react.default.createElement(_listReady.default, {
            changes: this.props.changes
          });
        } else {
          return /*#__PURE__*/_react.default.createElement(_listEmpty.default, {
            emptyMessage: this.props.emptyMessage
          });
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_listPreview.default, null);
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./list-empty":277,"./list-preview":278,"./list-ready":279,"react":"react"}],281:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var _stats = _interopRequireDefault(require("./stats"));

var _userTitle = _interopRequireDefault(require("./user-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var showStatus = _ref.showStatus,
      user = _ref.user;
  var rank = user.rank;
  var className = "panel user-card";

  if (rank.css_class) {
    className += " user-card-" + rank.css_class;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3 user-card-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "user-card-small-avatar"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: user.url
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: "50",
    size2x: "80",
    user: user
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-9 col-sm-12 user-card-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "user-card-avatar"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: user.url
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
    size: "150",
    size2x: "200",
    user: user
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "user-card-username"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: user.url
  }, user.username)), /*#__PURE__*/_react.default.createElement("div", {
    className: "user-card-title"
  }, /*#__PURE__*/_react.default.createElement(_userTitle.default, {
    rank: rank,
    title: user.title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "user-card-stats"
  }, /*#__PURE__*/_react.default.createElement(_stats.default, {
    showStatus: showStatus,
    user: user
  }))))));
}

},{"../../avatar":6,"./stats":282,"./user-title":283,"react":"react"}],282:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Status = Status;
exports.JoinDate = JoinDate;
exports.Posts = Posts;
exports.Threads = Threads;
exports.Followers = Followers;
exports.getStatClassName = getStatClassName;

var _react = _interopRequireDefault(require("react"));

var _userStatus = _interopRequireWildcard(require("../../user-status"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var showStatus = _ref.showStatus,
      user = _ref.user;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/_react.default.createElement(Status, {
    showStatus: showStatus,
    user: user
  }), /*#__PURE__*/_react.default.createElement(JoinDate, {
    user: user
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "user-stat-divider"
  }), /*#__PURE__*/_react.default.createElement(Posts, {
    user: user
  }), /*#__PURE__*/_react.default.createElement(Threads, {
    user: user
  }), /*#__PURE__*/_react.default.createElement(Followers, {
    user: user
  }));
}

function Status(_ref2) {
  var showStatus = _ref2.showStatus,
      user = _ref2.user;
  if (!showStatus) return null;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "user-stat-status"
  }, /*#__PURE__*/_react.default.createElement(_userStatus.default, {
    status: user.status
  }, /*#__PURE__*/_react.default.createElement(_userStatus.StatusLabel, {
    status: user.status,
    user: user
  })));
}

function JoinDate(_ref3) {
  var user = _ref3.user;
  var joined_on = user.joined_on;
  var title = interpolate(gettext("Joined on %(joined_on)s"), {
    joined_on: joined_on.format("LL, LT")
  }, true);
  var message = interpolate(gettext("Joined %(joined_on)s"), {
    joined_on: joined_on.fromNow()
  }, true);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "user-stat-join-date"
  }, /*#__PURE__*/_react.default.createElement("abbr", {
    title: title
  }, message));
}

function Posts(_ref4) {
  var user = _ref4.user;
  var className = getStatClassName("user-stat-posts", user.posts);
  var message = ngettext("%(posts)s post", "%(posts)s posts", user.posts);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: className
  }, interpolate(message, {
    posts: user.posts
  }, true));
}

function Threads(_ref5) {
  var user = _ref5.user;
  var className = getStatClassName("user-stat-threads", user.threads);
  var message = ngettext("%(threads)s thread", "%(threads)s threads", user.threads);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: className
  }, interpolate(message, {
    threads: user.threads
  }, true));
}

function Followers(_ref6) {
  var user = _ref6.user;
  var className = getStatClassName("user-stat-followers", user.followers);
  var message = ngettext("%(followers)s follower", "%(followers)s followers", user.followers);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: className
  }, interpolate(message, {
    followers: user.followers
  }, true));
}

function getStatClassName(className, stat) {
  if (stat === 0) {
    return className + " user-stat-empty";
  }

  return className;
}

},{"../../user-status":274,"react":"react"}],283:[function(require,module,exports){
arguments[4][130][0].apply(exports,arguments)
},{"dup":130,"react":"react"}],284:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _card = _interopRequireDefault(require("./card"));

var _preview = _interopRequireDefault(require("./preview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var cols = _ref.cols,
      isReady = _ref.isReady,
      showStatus = _ref.showStatus,
      users = _ref.users;
  var colClassName = "col-xs-12 col-sm-4";

  if (cols === 4) {
    colClassName += " col-md-3";
  }

  if (!isReady) {
    return /*#__PURE__*/_react.default.createElement(_preview.default, {
      colClassName: colClassName,
      cols: cols
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "users-cards-list ui-ready"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, users.map(function (user) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: colClassName,
      key: user.id
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      showStatus: showStatus,
      user: user
    }));
  })));
}

},{"./card":281,"./preview":286,"react":"react"}],285:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "panel user-card user-card-preview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-3 user-card-left"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-card-small-avatar"
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "50",
        size2x: "80"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 col-sm-12 user-card-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-card-avatar"
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "150",
        size2x: "200"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-card-username"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(60, 150) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-card-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(60, 150) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-card-stats"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-unstyled"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("li", {
        className: "user-stat-divider"
      }), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 70) + "px"
        }
      }, "\xA0"))))))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../utils/random":388,"../../avatar":6,"react":"react"}],286:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _card = _interopRequireDefault(require("./card"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var colClassName = _ref.colClassName,
      cols = _ref.cols;
  var list = Array.apply(null, {
    length: cols
  }).map(Number.call, Number);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "users-cards-list ui-preview"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, list.map(function (i) {
    var className = colClassName;
    if (i !== 0) className += " hidden-xs";
    if (i === 3) className += " hidden-sm";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      key: i
    }, /*#__PURE__*/_react.default.createElement(_card.default, null));
  })));
}

},{"./card":285,"react":"react"}],287:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      return interpolate(gettext("No users have posted any new messages during last %(days)s days."), {
        days: this.props.trackedPeriod
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "active-posters-list"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.getEmptyMessage())));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],288:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = _interopRequireDefault(require("../../avatar"));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.props.hiddenOnMobile) {
        return "list-group-item hidden-xs hidden-sm";
      } else {
        return "list-group-item";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-user-avatar"
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        size: "50"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-user"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-name"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "item-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 80) + "px"
        }
      }, "\xA0"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-details"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "user-status"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "status-icon ui-preview-text"
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "status-label ui-preview-text hidden-xs hidden-sm",
        style: {
          width: random.int(30, 50) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("span", {
        className: "rank-name"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 50) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("span", {
        className: "user-title hidden-xs hidden-sm"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(30, 50) + "px"
        }
      }, "\xA0"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-compact-stats visible-xs-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rank-position"
      }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(20, 30) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("small", null, gettext("Rank"))), /*#__PURE__*/_react.default.createElement("span", {
        className: "rank-posts-counted"
      }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(20, 30) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("small", null, gettext("Ranked posts"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-position hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(20, 30) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("small", null, gettext("Rank"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-posts-counted hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(20, 30) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("small", null, gettext("Ranked posts"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-posts-total hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(20, 30) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("small", null, gettext("Total posts"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../utils/random":388,"../../avatar":6,"react":"react"}],289:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _avatar = _interopRequireDefault(require("../../avatar"));

var _userStatus = _interopRequireWildcard(require("../../user-status"));

var _ = _interopRequireDefault(require("../../.."));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.rank.css_class) {
        return "list-group-item list-group-rank-" + this.props.rank.css_class;
      } else {
        return "list-group-item";
      }
    }
  }, {
    key: "getUserStatus",
    value: function getUserStatus() {
      if (this.props.user.status) {
        return /*#__PURE__*/_react.default.createElement(_userStatus.default, {
          user: this.props.user,
          status: this.props.user.status
        }, /*#__PURE__*/_react.default.createElement(_userStatus.StatusIcon, {
          user: this.props.user,
          status: this.props.user.status
        }), /*#__PURE__*/_react.default.createElement(_userStatus.StatusLabel, {
          user: this.props.user,
          status: this.props.user.status,
          className: "status-label hidden-xs hidden-sm"
        }));
      }

      return /*#__PURE__*/_react.default.createElement("span", {
        className: "user-status"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "status-icon ui-preview-text"
      }, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
        className: "status-label ui-preview-text hidden-xs hidden-sm",
        style: {
          width: random.int(30, 50) + "px"
        }
      }, "\xA0"));
    }
  }, {
    key: "getRankName",
    value: function getRankName() {
      if (!this.props.rank.is_tab) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "rank-name item-title"
        }, this.props.rank.name);
      }

      var rankUrl = _.default.get("USERS_LIST_URL") + this.props.rank.slug + "/";
      return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
        to: rankUrl,
        className: "rank-name item-title"
      }, this.props.rank.name);
    }
  }, {
    key: "getUserTitle",
    value: function getUserTitle() {
      if (!this.props.user.title) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "user-title hidden-xs hidden-sm"
      }, this.props.user.title);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-user-avatar"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.user.url
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        user: this.props.user,
        size: 50,
        size2x: 64
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-user"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-name"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.user.url,
        className: "item-title"
      }, this.props.user.username)), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-details"
      }, this.getUserStatus(), this.getRankName(), this.getUserTitle()), /*#__PURE__*/_react.default.createElement("div", {
        className: "user-compact-stats visible-xs-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rank-position"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "#", this.props.counter), /*#__PURE__*/_react.default.createElement("small", null, gettext("Rank"))), /*#__PURE__*/_react.default.createElement("span", {
        className: "rank-posts-counted"
      }, /*#__PURE__*/_react.default.createElement("strong", null, this.props.user.meta.score), /*#__PURE__*/_react.default.createElement("small", null, gettext("Ranked posts"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-position hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "#", this.props.counter), /*#__PURE__*/_react.default.createElement("small", null, gettext("Rank"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-posts-counted hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, this.props.user.meta.score), /*#__PURE__*/_react.default.createElement("small", null, gettext("Ranked posts"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "rank-posts-total hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, this.props.user.posts), /*#__PURE__*/_react.default.createElement("small", null, gettext("Total posts"))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"../../../utils/random":388,"../../avatar":6,"../../user-status":274,"react":"react","react-router":"react-router"}],290:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _listItemPreview = _interopRequireDefault(require("./list-item-preview"));

var random = _interopRequireWildcard(require("../../../utils/random"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "active-posters-list"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead ui-preview"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-preview-text",
        style: {
          width: random.int(50, 220) + "px"
        }
      }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
        className: "active-posters ui-preview"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, [0, 1, 2].map(function (i) {
        return /*#__PURE__*/_react.default.createElement(_listItemPreview.default, {
          hiddenOnMobile: i > 0,
          key: i
        });
      })))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../../utils/random":388,"./list-item-preview":288,"react":"react"}],291:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _listItem = _interopRequireDefault(require("./list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "getLeadMessage",
    value: function getLeadMessage() {
      var message = ngettext("%(posters)s top poster from last %(days)s days.", "%(posters)s top posters from last %(days)s days.", this.props.count);
      return interpolate(message, {
        posters: this.props.count,
        days: this.props.trackedPeriod
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "active-posters-list"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "lead"
      }, this.getLeadMessage()), /*#__PURE__*/_react.default.createElement("div", {
        className: "active-posters ui-ready"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-group"
      }, this.props.users.map(function (user, i) {
        return /*#__PURE__*/_react.default.createElement(_listItem.default, {
          user: user,
          rank: user.rank,
          counter: i + 1,
          key: user.id
        });
      })))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"./list-item":289,"react":"react"}],292:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _listEmpty = _interopRequireDefault(require("./list-empty"));

var _listPreview = _interopRequireDefault(require("./list-preview"));

var _listReady = _interopRequireDefault(require("./list-ready"));

var _ = _interopRequireDefault(require("../../.."));

var _users = require("../../../reducers/users");

var _polls = _interopRequireDefault(require("../../../services/polls"));

var _store = _interopRequireDefault(require("../../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (data) {
      _store.default.dispatch((0, _users.hydrate)(data.results));

      _this.setState({
        isLoaded: true,
        trackedPeriod: data.tracked_period,
        count: data.count
      });
    });

    if (_.default.has("USERS")) {
      _this.initWithPreloadedData(_.default.pop("USERS"));
    } else {
      _this.initWithoutPreloadedData();
    }

    _this.startPolling();

    return _this;
  }

  _createClass(_default, [{
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(data) {
      this.state = {
        isLoaded: true,
        trackedPeriod: data.tracked_period,
        count: data.count
      };

      _store.default.dispatch((0, _users.hydrate)(data.results));
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData() {
      this.state = {
        isLoaded: false
      };
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      _polls.default.start({
        poll: "active-posters",
        url: _.default.get("USERS_API"),
        data: {
          list: "active"
        },
        frequency: 90 * 1000,
        update: this.update
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: this.props.route.extra.name,
        parent: gettext("Users")
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _polls.default.stop("active-posters");
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isLoaded) {
        if (this.state.count > 0) {
          return /*#__PURE__*/_react.default.createElement(_listReady.default, {
            users: this.props.users,
            trackedPeriod: this.state.trackedPeriod,
            count: this.state.count
          });
        } else {
          return /*#__PURE__*/_react.default.createElement(_listEmpty.default, {
            trackedPeriod: this.state.trackedPeriod
          });
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_listPreview.default, null);
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"../../../reducers/users":364,"../../../services/page-title":373,"../../../services/polls":374,"../../../services/store":377,"./list-empty":287,"./list-preview":290,"./list-ready":291,"react":"react"}],293:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _li = _interopRequireDefault(require("../li"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var baseUrl = _ref.baseUrl,
      lists = _ref.lists;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav nav-pills"
  }, lists.map(function (list) {
    var url = listUrl(baseUrl, list);
    return /*#__PURE__*/_react.default.createElement(_li.default, {
      path: url,
      key: url
    }, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      to: url
    }, list.name));
  }));
}

var listUrl = function listUrl(baseUrl, list) {
  var url = baseUrl;

  if (list.component === "rank") {
    url += list.slug;
  } else {
    url += list.component;
  }

  return url + "/";
};

},{"../..":302,"../li":57,"react":"react","react-router":"react-router"}],294:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _usersList = _interopRequireDefault(require("../../users-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_usersList.default, {
        cols: 4,
        isReady: false
      }));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../users-list":284,"react":"react"}],295:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _pager = _interopRequireDefault(require("./pager"));

var _usersList = _interopRequireDefault(require("../../users-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_usersList.default, {
    cols: 4,
    isReady: true,
    showStatus: true,
    users: props.users
  }), /*#__PURE__*/_react.default.createElement(_pager.default, props));
}

},{"../../users-list":284,"./pager":296,"react":"react"}],296:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.Pager = Pager;
exports.FirstPage = FirstPage;
exports.PreviousPage = PreviousPage;
exports.NextPage = NextPage;
exports.LastPage = LastPage;
exports.More = More;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _resetScroll = _interopRequireDefault(require("../../../utils/reset-scroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  if (props.pages === 1) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-toolbar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 text-center visible-xs-block"
  }, /*#__PURE__*/_react.default.createElement(More, {
    more: props.more
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-vertical-spacer"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-7"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(Pager, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-8 col-md-7 hidden-xs"
  }, /*#__PURE__*/_react.default.createElement(More, {
    more: props.more
  })))));
}

function Pager(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-paginator"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(FirstPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(PreviousPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(NextPage, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react.default.createElement(LastPage, props)));
}

function FirstPage(props) {
  if (props.isLoaded && props.first) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-icon btn-outline",
      onClick: _resetScroll.default,
      to: props.baseUrl,
      title: gettext("Go to first page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "first_page"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-icon btn-outline disabled",
      title: gettext("Go to first page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "first_page"));
  }
}

function PreviousPage(props) {
  if (props.isLoaded && props.page > 1) {
    var previousUrl = "";

    if (props.previous) {
      previousUrl = props.previous + "/";
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-icon btn-outline",
      onClick: _resetScroll.default,
      to: props.baseUrl + previousUrl,
      title: gettext("Go to previous page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_left"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-icon btn-outline disabled",
      title: gettext("Go to previous page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_left"));
  }
}

function NextPage(props) {
  if (props.isLoaded && props.more) {
    var nextUrl = "";

    if (props.next) {
      nextUrl = props.next + "/";
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-icon btn-outline",
      onClick: _resetScroll.default,
      to: props.baseUrl + nextUrl,
      title: gettext("Go to next page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_right"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-icon btn-outline disabled",
      title: gettext("Go to next page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "chevron_right"));
  }
}

function LastPage(props) {
  if (props.isLoaded && props.last) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
      className: "btn btn-default btn-block btn-icon btn-outline",
      onClick: _resetScroll.default,
      to: props.baseUrl + props.last + "/",
      title: gettext("Go to last page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "last_page"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-default btn-block btn-icon btn-outline disabled",
      title: gettext("Go to last page")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icon"
    }, "last_page"));
  }
}

function More(props) {
  var message = null;

  if (props.more) {
    message = ngettext("There is %(more)s more member with this role.", "There are %(more)s more members with this role.", props.more);
    message = interpolate(message, {
      more: props.more
    }, true);
  } else {
    message = gettext("There are no more members with this role.");
  }

  return /*#__PURE__*/_react.default.createElement("p", null, message);
}

},{"../../../utils/reset-scroll":389,"react":"react","react-router":"react-router"}],297:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _pageLead = _interopRequireDefault(require("../../page-lead"));

var _list = _interopRequireDefault(require("./list"));

var _listLoading = _interopRequireDefault(require("./list-loading"));

var _ = _interopRequireDefault(require("../../.."));

var _users = require("../../../reducers/users");

var _polls = _interopRequireDefault(require("../../../services/polls"));

var _store = _interopRequireDefault(require("../../../services/store"));

var _pageTitle = _interopRequireDefault(require("../../../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (data) {
      _store.default.dispatch((0, _users.hydrate)(data.results));

      data.isLoaded = true;

      _this.setState(data);
    });

    if (_.default.has("USERS")) {
      _this.initWithPreloadedData(_.default.pop("USERS"));
    } else {
      _this.initWithoutPreloadedData();
    }

    _this.startPolling(props.params.page || 1);

    return _this;
  }

  _createClass(_default, [{
    key: "initWithPreloadedData",
    value: function initWithPreloadedData(data) {
      this.state = Object.assign(data, {
        isLoaded: true
      });

      _store.default.dispatch((0, _users.hydrate)(data.results));
    }
  }, {
    key: "initWithoutPreloadedData",
    value: function initWithoutPreloadedData() {
      this.state = {
        isLoaded: false
      };
    }
  }, {
    key: "startPolling",
    value: function startPolling(page) {
      _polls.default.start({
        poll: "rank-users",
        url: _.default.get("USERS_API"),
        data: {
          rank: this.props.route.rank.id,
          page: page
        },
        frequency: 90 * 1000,
        update: this.update
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _pageTitle.default.set({
        title: this.props.route.rank.name,
        page: this.props.params.page || null,
        parent: gettext("Users")
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _polls.default.stop("rank-users");
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.params.page !== nextProps.params.page) {
        _pageTitle.default.set({
          title: this.props.route.rank.name,
          page: nextProps.params.page || null,
          parent: gettext("Users")
        });

        this.setState({
          isLoaded: false
        });

        _polls.default.stop("rank-users");

        this.startPolling(nextProps.params.page);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      if (this.props.route.rank.css_class) {
        return "rank-users-list rank-users-" + this.props.route.rank.css_class;
      } else {
        return "rank-users-list";
      }
    }
  }, {
    key: "getRankDescription",
    value: function getRankDescription() {
      if (this.props.route.rank.description) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "rank-description"
        }, /*#__PURE__*/_react.default.createElement(_pageLead.default, {
          copy: this.props.route.rank.description.html
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      if (this.state.isLoaded) {
        if (this.state.count > 0) {
          var baseUrl = _.default.get("USERS_LIST_URL") + this.props.route.rank.slug + "/";
          return /*#__PURE__*/_react.default.createElement(_list.default, _extends({
            baseUrl: baseUrl,
            users: this.props.users
          }, this.state));
        } else {
          return /*#__PURE__*/_react.default.createElement("p", {
            className: "lead"
          }, gettext("There are no users with this rank at the moment."));
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_listLoading.default, null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, this.getRankDescription(), this.getComponent()));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../../..":302,"../../../reducers/users":364,"../../../services/page-title":373,"../../../services/polls":374,"../../../services/store":377,"../../page-lead":92,"./list":295,"./list-loading":294,"react":"react"}],298:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.paths = paths;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _dropdownToggle = _interopRequireDefault(require("../dropdown-toggle"));

var _nav = _interopRequireDefault(require("./nav"));

var _root = _interopRequireDefault(require("./active-posters/root"));

var _root2 = _interopRequireDefault(require("./rank/root"));

var _withDropdown = _interopRequireDefault(require("../with-dropdown"));

var _ = _interopRequireDefault(require("../.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_WithDropdown) {
  _inherits(_default, _WithDropdown);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "page page-users-lists"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header-bg"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("h1", null, gettext("Users"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-tabs"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(_nav.default, {
        lists: _.default.get("USERS_LISTS"),
        baseUrl: _.default.get("USERS_LIST_URL")
      }))))), this.props.children);
    }
  }]);

  return _default;
}(_withDropdown.default);

exports.default = _default;

function select(store) {
  return {
    tick: store.tick.tick,
    user: store.auth.user,
    users: store.users
  };
}

function paths() {
  var paths = [];

  _.default.get("USERS_LISTS").forEach(function (item) {
    if (item.component === "rank") {
      paths.push({
        path: _.default.get("USERS_LIST_URL") + item.slug + "/:page/",
        component: (0, _reactRedux.connect)(select)(_root2.default),
        rank: item
      });
      paths.push({
        path: _.default.get("USERS_LIST_URL") + item.slug + "/",
        component: (0, _reactRedux.connect)(select)(_root2.default),
        rank: item
      });
    } else if (item.component === "active-posters") {
      paths.push({
        path: _.default.get("USERS_LIST_URL") + item.component + "/",
        component: (0, _reactRedux.connect)(select)(_root.default),
        extra: {
          name: item.name
        }
      });
    }
  });

  return paths;
}

},{"../..":302,"../dropdown-toggle":27,"../with-dropdown":299,"./active-posters/root":292,"./nav":293,"./rank/root":297,"react":"react","react-redux":"react-redux"}],299:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleNav", function () {
      _this.setState({
        dropdown: !_this.state.dropdown
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideNav", function () {
      _this.setState({
        dropdown: false
      });
    });

    _this.state = {
      dropdown: false
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getCompactNavClassName",
    value: function getCompactNavClassName() {
      if (this.state.dropdown) {
        return "compact-nav open";
      } else {
        return "compact-nav";
      }
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],300:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.props.onChange({
        target: {
          value: !_this.props.value
        }
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "getClassName",
    value: function getClassName() {
      if (this.props.value) {
        return "btn btn-yes-no btn-yes-no-on";
      } else {
        return "btn btn-yes-no btn-yes-no-off";
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      if (!!this.props.value) {
        return this.props.iconOn || "check_box";
      } else {
        return this.props.iconOff || "check_box_outline_blank";
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (!!this.props.value) {
        return this.props.labelOn || gettext("yes");
      } else {
        return this.props.labelOff || gettext("no");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.toggle,
        className: this.getClassName(),
        id: this.props.id || null,
        "aria-describedby": this.props["aria-describedby"] || null,
        disabled: this.props.disabled || false
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icon"
      }, this.getIcon()), /*#__PURE__*/_react.default.createElement("span", {
        className: "btn-text"
      }, this.getLabel()));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"react":"react"}],301:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _profileDetails = require("../reducers/profile-details");

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          data = _this$props.data,
          dispatch = _this$props.dispatch,
          user = _this$props.user;
      if (data && data.id === user.id) return;

      _ajax.default.get(this.props.user.api.details).then(function (data) {
        dispatch((0, _profileDetails.load)(data));
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

},{"../reducers/profile-details":355,"../services/ajax":365,"../services/snackbar":376,"react":"react"}],302:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Misago = void 0;

var _orderedList = _interopRequireDefault(require("./utils/ordered-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Misago = /*#__PURE__*/function () {
  function Misago() {
    _classCallCheck(this, Misago);

    this._initializers = [];
    this._context = {};
  }

  _createClass(Misago, [{
    key: "addInitializer",
    value: function addInitializer(initializer) {
      this._initializers.push({
        key: initializer.name,
        item: initializer.initializer,
        after: initializer.after,
        before: initializer.before
      });
    }
  }, {
    key: "init",
    value: function init(context) {
      var _this = this;

      this._context = context;
      var initOrder = new _orderedList.default(this._initializers).orderedValues();
      initOrder.forEach(function (initializer) {
        initializer(_this);
      });
    } // context accessors

  }, {
    key: "has",
    value: function has(key) {
      return !!this._context[key];
    }
  }, {
    key: "get",
    value: function get(key, fallback) {
      if (this.has(key)) {
        return this._context[key];
      } else {
        return fallback || undefined;
      }
    }
  }, {
    key: "pop",
    value: function pop(key) {
      if (this.has(key)) {
        var value = this._context[key];
        this._context[key] = null;
        return value;
      } else {
        return undefined;
      }
    }
  }]);

  return Misago;
}(); // create  singleton


exports.Misago = Misago;
var misago = new Misago(); // expose it globally

global.misago = misago; // and export it for tests and stuff

var _default = misago;
exports.default = _default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./utils/ordered-list":387}],303:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _ajax = _interopRequireDefault(require("../services/ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _ajax.default.init(_.default.get("CSRF_COOKIE_NAME"));
}

_.default.addInitializer({
  name: "ajax",
  initializer: initializer
});

},{"../services/ajax":365,"./..":302}],304:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _auth = require("../reducers/auth");

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH_SYNC_RATE = 45; // sync user with backend every 45 seconds

function initializer(context) {
  if (context.get("isAuthenticated")) {
    window.setInterval(function () {
      _ajax.default.get(context.get("AUTH_API")).then(function (data) {
        _store.default.dispatch((0, _auth.patch)(data));
      }, function (rejection) {
        _snackbar.default.apiError(rejection);
      });
    }, AUTH_SYNC_RATE * 1000);
  }
}

_.default.addInitializer({
  name: "auth-sync",
  initializer: initializer,
  after: "auth"
});

},{"../reducers/auth":350,"../services/ajax":365,"../services/snackbar":376,"../services/store":377,"./..":302}],305:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _auth = _interopRequireDefault(require("../services/auth"));

var _modal = _interopRequireDefault(require("../services/modal"));

var _store = _interopRequireDefault(require("../services/store"));

var _localStorage = _interopRequireDefault(require("../services/local-storage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _auth.default.init(_store.default, _localStorage.default, _modal.default);
}

_.default.addInitializer({
  name: "auth",
  initializer: initializer,
  after: "store"
});

},{"../services/auth":366,"../services/local-storage":369,"../services/modal":371,"../services/store":377,"./..":302}],306:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _captcha = _interopRequireDefault(require("../services/captcha"));

var _include = _interopRequireDefault(require("../services/include"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  _captcha.default.init(context, _ajax.default, _include.default, _snackbar.default);
}

_.default.addInitializer({
  name: "captcha",
  initializer: initializer
});

},{"../services/ajax":365,"../services/captcha":367,"../services/include":368,"../services/snackbar":376,"./..":302}],307:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../.."));

var _acceptAgreement = _interopRequireDefault(require("../../components/accept-agreement"));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  if (document.getElementById("required-agreement-mount")) {
    (0, _mountComponent.default)( /*#__PURE__*/_react.default.createElement(_acceptAgreement.default, {
      api: context.get("REQUIRED_AGREEMENT_API")
    }), "required-agreement-mount", false);
  }
}

_.default.addInitializer({
  name: "component:accept-agreement",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/accept-agreement":3,"../../utils/mount-component":386,"react":"react"}],308:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _reactRedux = require("react-redux");

var _ = _interopRequireDefault(require("../.."));

var _authMessage = _interopRequireWildcard(require("../../components/auth-message"));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  (0, _mountComponent.default)((0, _reactRedux.connect)(_authMessage.select)(_authMessage.default), "auth-message-mount");
}

_.default.addInitializer({
  name: "component:auth-message",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/auth-message":5,"../../utils/mount-component":386,"react-redux":"react-redux"}],309:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _bannedPage = _interopRequireDefault(require("../../utils/banned-page"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  if (context.has("BAN_MESSAGE")) {
    (0, _bannedPage.default)(context.get("BAN_MESSAGE"), false);
  }
}

_.default.addInitializer({
  name: "component:banmed-page",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../utils/banned-page":379}],310:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _reactRedux = require("react-redux");

var _categories = _interopRequireWildcard(require("../../components/categories"));

var _ = _interopRequireDefault(require("../.."));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function initializer() {
  if (document.getElementById("categories-mount")) {
    (0, _mountComponent.default)((0, _reactRedux.connect)(_categories.select)(_categories.default), "categories-mount");
  }
}

_.default.addInitializer({
  name: "component:categories",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/categories":20,"../../utils/mount-component":386,"react-redux":"react-redux"}],311:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _root = _interopRequireWildcard(require("../../components/options/root"));

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function initializer(context) {
  if (context.has("USER_OPTIONS")) {
    (0, _routedComponent.default)({
      root: _.default.get("USERCP_URL"),
      component: _root.default,
      paths: (0, _root.paths)()
    });
  }
}

_.default.addInitializer({
  name: "component:options",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/options/root":87,"../../utils/routed-component":390}],312:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _reactRedux = require("react-redux");

var _root = _interopRequireWildcard(require("../../components/profile/root"));

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function initializer(context) {
  if (context.has("PROFILE") && context.has("PROFILE_PAGES")) {
    (0, _routedComponent.default)({
      root: _.default.get("PROFILE").url,
      component: (0, _reactRedux.connect)(_root.select)(_root.default),
      paths: (0, _root.paths)()
    });
  }
}

_.default.addInitializer({
  name: "component:profile",
  initializer: initializer,
  after: "reducer:profile-hydrate"
});

},{"../..":302,"../../components/profile/root":195,"../../utils/routed-component":390,"react-redux":"react-redux"}],313:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _requestActivationLink = _interopRequireDefault(require("../../components/request-activation-link"));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  if (document.getElementById("request-activation-link-mount")) {
    (0, _mountComponent.default)(_requestActivationLink.default, "request-activation-link-mount", false);
  }
}

_.default.addInitializer({
  name: "component:request-activation-link",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/request-activation-link":200,"../../utils/mount-component":386}],314:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _requestPasswordReset = _interopRequireDefault(require("../../components/request-password-reset"));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  if (document.getElementById("request-password-reset-mount")) {
    (0, _mountComponent.default)(_requestPasswordReset.default, "request-password-reset-mount", false);
  }
}

_.default.addInitializer({
  name: "component:request-password-reset",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/request-password-reset":201,"../../utils/mount-component":386}],315:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _resetPasswordForm = _interopRequireDefault(require("../../components/reset-password-form"));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  if (document.getElementById("reset-password-form-mount")) {
    (0, _mountComponent.default)(_resetPasswordForm.default, "reset-password-form-mount", false);
  }
}

_.default.addInitializer({
  name: "component:reset-password-form",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/reset-password-form":202,"../../utils/mount-component":386}],316:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _search = _interopRequireDefault(require("../../components/search"));

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  if (context.get("CURRENT_LINK") === "misago:search") {
    (0, _routedComponent.default)({
      paths: (0, _search.default)(_.default.get("SEARCH_PROVIDERS"))
    });
  }
}

_.default.addInitializer({
  name: "component:search",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/search":204,"../../utils/routed-component":390}],317:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _reactRedux = require("react-redux");

var _ = _interopRequireDefault(require("../.."));

var _snackbar = require("../../components/snackbar");

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  (0, _mountComponent.default)((0, _reactRedux.connect)(_snackbar.select)(_snackbar.Snackbar), "snackbar-mount");
}

_.default.addInitializer({
  name: "component:snackbar",
  initializer: initializer,
  after: "snackbar"
});

},{"../..":302,"../../components/snackbar":212,"../../utils/mount-component":386,"react-redux":"react-redux"}],318:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _react = _interopRequireDefault(require("react"));

var _socialAuth = _interopRequireDefault(require("../../components/social-auth"));

var _ = _interopRequireDefault(require("../.."));

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  if (context.get("CURRENT_LINK") === "misago:social-complete") {
    var props = context.get("SOCIAL_AUTH_FORM");
    (0, _mountComponent.default)( /*#__PURE__*/_react.default.createElement(_socialAuth.default, props), "page-mount");
  }
}

_.default.addInitializer({
  name: "component:social-auth",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/social-auth":215,"../../utils/mount-component":386,"react":"react"}],319:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _root = require("../../components/thread/root");

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  if (context.has("THREAD") && context.has("POSTS")) {
    (0, _routedComponent.default)({
      paths: (0, _root.paths)()
    });
  }
}

_.default.addInitializer({
  name: "component:thread",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/thread/root":233,"../../utils/routed-component":390}],320:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;
exports.getListOptions = getListOptions;

var _root = require("../../components/threads/root");

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIVATE_THREADS_LIST = "misago:private-threads";

function initializer(context) {
  if (context.has("THREADS") && context.has("CATEGORIES")) {
    (0, _routedComponent.default)({
      paths: (0, _root.paths)(context.get("user"), getListOptions(context))
    });
  }
}

function getListOptions(context) {
  var currentLink = context.get("CURRENT_LINK");

  if (currentLink.substr(0, PRIVATE_THREADS_LIST.length) === PRIVATE_THREADS_LIST) {
    return {
      api: context.get("PRIVATE_THREADS_API"),
      startThread: {
        mode: "START_PRIVATE",
        submit: _.default.get("PRIVATE_THREADS_API")
      },
      title: gettext("Private threads"),
      pageLead: gettext("Private threads are threads which only those that started them and those they have invited may see and participate in."),
      emptyMessage: gettext("You aren't participating in any private threads.")
    };
  }

  return {
    api: context.get("THREADS_API")
  };
}

_.default.addInitializer({
  name: "component:threads",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/threads/root":267,"../../utils/routed-component":390}],321:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _reactRedux = require("react-redux");

var _ = _interopRequireDefault(require("../.."));

var _root = require("../../components/user-menu/root");

var _mountComponent = _interopRequireDefault(require("../../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  (0, _mountComponent.default)((0, _reactRedux.connect)(_root.select)(_root.UserMenu), "user-menu-mount");
  (0, _mountComponent.default)((0, _reactRedux.connect)(_root.select)(_root.CompactUserMenu), "user-menu-compact-mount");
}

_.default.addInitializer({
  name: "component:user-menu",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/user-menu/root":272,"../../utils/mount-component":386,"react-redux":"react-redux"}],322:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _root = _interopRequireWildcard(require("../../components/users/root"));

var _ = _interopRequireDefault(require("../.."));

var _routedComponent = _interopRequireDefault(require("../../utils/routed-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function initializer(context) {
  if (context.has("USERS_LISTS")) {
    (0, _routedComponent.default)({
      root: _.default.get("USERS_LIST_URL"),
      component: _root.default,
      paths: (0, _root.paths)()
    });
  }
}

_.default.addInitializer({
  name: "component:users",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../components/users/root":298,"../../utils/routed-component":390}],323:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _include = _interopRequireDefault(require("../services/include"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  _include.default.init(context.get("STATIC_URL"));
}

_.default.addInitializer({
  name: "include",
  initializer: initializer
});

},{"../services/include":368,"./..":302}],324:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _localStorage = _interopRequireDefault(require("../services/local-storage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _localStorage.default.init("misago_");
}

_.default.addInitializer({
  name: "local-storage",
  initializer: initializer
});

},{"../services/local-storage":369,"./..":302}],325:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _mobileNavbarDropdown = _interopRequireDefault(require("../services/mobile-navbar-dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var element = document.getElementById("mobile-navbar-dropdown-mount");

  if (element) {
    _mobileNavbarDropdown.default.init(element);
  }
}

_.default.addInitializer({
  name: "dropdown",
  initializer: initializer,
  before: "store"
});

},{"../services/mobile-navbar-dropdown":370,"./..":302}],326:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _modal = _interopRequireDefault(require("../services/modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var element = document.getElementById("modal-mount");

  if (element) {
    _modal.default.init(element);
  }
}

_.default.addInitializer({
  name: "modal",
  initializer: initializer,
  before: "store"
});

},{"../services/modal":371,"./..":302}],327:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _moment = _interopRequireDefault(require("moment"));

var _ = _interopRequireDefault(require("./.."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _moment.default.locale($("html").attr("lang"));
}

_.default.addInitializer({
  name: "moment",
  initializer: initializer
});

},{"./..":302,"moment":"moment"}],328:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _pageTitle = _interopRequireDefault(require("../services/page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  _pageTitle.default.init(context.get("SETTINGS").forum_index_title, context.get("SETTINGS").forum_name);
}

_.default.addInitializer({
  name: "page-title",
  initializer: initializer
});

},{"../services/page-title":373,"./..":302}],329:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _polls = _interopRequireDefault(require("../services/polls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _polls.default.init(_ajax.default, _snackbar.default);
}

_.default.addInitializer({
  name: "polls",
  initializer: initializer
});

},{"../services/ajax":365,"../services/polls":374,"../services/snackbar":376,"./..":302}],330:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _ajax = _interopRequireDefault(require("../services/ajax"));

var _posting = _interopRequireDefault(require("../services/posting"));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _posting.default.init(_ajax.default, _snackbar.default, document.getElementById("posting-placeholder"));
}

_.default.addInitializer({
  name: "posting",
  initializer: initializer
});

},{"../services/ajax":365,"../services/posting":375,"../services/snackbar":376,"./..":302}],331:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _auth = _interopRequireWildcard(require("../../reducers/auth"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer(context) {
  _store.default.addReducer("auth", _auth.default, Object.assign({
    isAuthenticated: context.get("isAuthenticated"),
    isAnonymous: !context.get("isAuthenticated"),
    user: context.get("user")
  }, _auth.initialState));
}

_.default.addInitializer({
  name: "reducer:auth",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/auth":350,"../../services/store":377}],332:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _participants = _interopRequireDefault(require("../../reducers/participants"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var initialState = null;

  if (_.default.has("THREAD")) {
    initialState = _.default.get("THREAD").participants;
  }

  _store.default.addReducer("participants", _participants.default, initialState || []);
}

_.default.addInitializer({
  name: "reducer:participants",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/participants":351,"../../services/store":377}],333:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _poll = _interopRequireWildcard(require("../../reducers/poll"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var initialState = null;

  if (_.default.has("THREAD") && _.default.get("THREAD").poll) {
    initialState = (0, _poll.hydrate)(_.default.get("THREAD").poll);
  } else {
    initialState = {
      isBusy: false
    };
  }

  _store.default.addReducer("poll", _poll.default, initialState);
}

_.default.addInitializer({
  name: "reducer:poll",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/poll":352,"../../services/store":377}],334:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _posts = _interopRequireWildcard(require("../../reducers/posts"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var initialState = null;

  if (_.default.has("POSTS")) {
    initialState = (0, _posts.hydrate)(_.default.get("POSTS"));
  } else {
    initialState = {
      isLoaded: false,
      isBusy: false
    };
  }

  _store.default.addReducer("posts", _posts.default, initialState);
}

_.default.addInitializer({
  name: "reducer:posts",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/posts":354,"../../services/store":377}],335:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _profileDetails = _interopRequireDefault(require("../../reducers/profile-details"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var initialState = null;

  if (_.default.has("PROFILE_DETAILS")) {
    initialState = _.default.get("PROFILE_DETAILS");
  }

  _store.default.addReducer("profile-details", _profileDetails.default, initialState || {});
}

_.default.addInitializer({
  name: "reducer:profile-details",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/profile-details":355,"../../services/store":377}],336:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _profile = require("../../reducers/profile");

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  if (_.default.has("PROFILE")) {
    _store.default.dispatch((0, _profile.hydrate)(_.default.get("PROFILE")));
  }
}

_.default.addInitializer({
  name: "reducer:profile-hydrate",
  initializer: initializer,
  after: "store"
});

},{"../..":302,"../../reducers/profile":356,"../../services/store":377}],337:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _profile = _interopRequireDefault(require("../../reducers/profile"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("profile", _profile.default, {});
}

_.default.addInitializer({
  name: "reducer:profile",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/profile":356,"../../services/store":377}],338:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _search = _interopRequireWildcard(require("../../reducers/search"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("search", _search.default, Object.assign({}, _search.initialState, {
    providers: _.default.get("SEARCH_PROVIDERS") || [],
    query: _.default.get("SEARCH_QUERY") || ""
  }));
}

_.default.addInitializer({
  name: "reducer:search",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/search":357,"../../services/store":377}],339:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _selection = _interopRequireDefault(require("../../reducers/selection"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("selection", _selection.default, []);
}

_.default.addInitializer({
  name: "reducer:selection",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/selection":358,"../../services/store":377}],340:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _snackbar = _interopRequireWildcard(require("../../reducers/snackbar"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("snackbar", _snackbar.default, _snackbar.initialState);
}

_.default.addInitializer({
  name: "reducer:snackbar",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/snackbar":359,"../../services/store":377}],341:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _thread = _interopRequireWildcard(require("../../reducers/thread"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  var initialState = null;

  if (_.default.has("THREAD")) {
    initialState = (0, _thread.hydrate)(_.default.get("THREAD"));
  } else {
    initialState = {
      isBusy: false
    };
  }

  _store.default.addReducer("thread", _thread.default, initialState);
}

_.default.addInitializer({
  name: "reducer:thread",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/thread":360,"../../services/store":377}],342:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _threads = _interopRequireDefault(require("../../reducers/threads"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("threads", _threads.default, []);
}

_.default.addInitializer({
  name: "reducer:threads",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/threads":361,"../../services/store":377}],343:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _tick = _interopRequireWildcard(require("../../reducers/tick"));

var _store = _interopRequireDefault(require("../../services/store"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("tick", _tick.default, _tick.initialState);
}

_.default.addInitializer({
  name: "reducer:tick",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/tick":362,"../../services/store":377}],344:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _usernameHistory = _interopRequireDefault(require("../../reducers/username-history"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("username-history", _usernameHistory.default, []);
}

_.default.addInitializer({
  name: "reducer:username-history",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/username-history":363,"../../services/store":377}],345:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("../.."));

var _users = _interopRequireDefault(require("../../reducers/users"));

var _store = _interopRequireDefault(require("../../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.addReducer("users", _users.default, []);
}

_.default.addInitializer({
  name: "reducer:users",
  initializer: initializer,
  before: "store"
});

},{"../..":302,"../../reducers/users":364,"../../services/store":377}],346:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _snackbar = _interopRequireDefault(require("../services/snackbar"));

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _snackbar.default.init(_store.default);
}

_.default.addInitializer({
  name: "snackbar",
  initializer: initializer,
  after: "store"
});

},{"../services/snackbar":376,"../services/store":377,"./..":302}],347:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _store.default.init();
}

_.default.addInitializer({
  name: "store",
  initializer: initializer,
  before: "_end"
});

},{"../services/store":377,"./..":302}],348:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _tick = require("../reducers/tick");

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TICK_PERIOD = 50 * 1000; //do the tick every 50s

function initializer() {
  window.setInterval(function () {
    _store.default.dispatch((0, _tick.doTick)());
  }, TICK_PERIOD);
}

_.default.addInitializer({
  name: "tick-start",
  initializer: initializer,
  after: "store"
});

},{"../reducers/tick":362,"../services/store":377,"./..":302}],349:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializer;

var _ = _interopRequireDefault(require("./.."));

var _include = _interopRequireDefault(require("../services/include"));

var _zxcvbn = _interopRequireDefault(require("../services/zxcvbn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializer() {
  _zxcvbn.default.init(_include.default);
}

_.default.addInitializer({
  name: "zxcvbn",
  initializer: initializer
});

},{"../services/include":368,"../services/zxcvbn":378,"./..":302}],350:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patch = patch;
exports.signIn = signIn;
exports.signOut = signOut;
exports.default = auth;
exports.SIGN_OUT = exports.SIGN_IN = exports.PATCH_USER = exports.initialState = void 0;

var _users = require("./users");

var initialState = {
  signedIn: false,
  signedOut: false
};
exports.initialState = initialState;
var PATCH_USER = "PATCH_USER";
exports.PATCH_USER = PATCH_USER;
var SIGN_IN = "SIGN_IN";
exports.SIGN_IN = SIGN_IN;
var SIGN_OUT = "SIGN_OUT";
exports.SIGN_OUT = SIGN_OUT;

function patch(patch) {
  return {
    type: PATCH_USER,
    patch: patch
  };
}

function signIn(user) {
  return {
    type: SIGN_IN,
    user: user
  };
}

function signOut() {
  var soft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: SIGN_OUT,
    soft: soft
  };
}

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case PATCH_USER:
      var newState = Object.assign({}, state);
      newState.user = Object.assign({}, state.user, action.patch);
      return newState;

    case SIGN_IN:
      return Object.assign({}, state, {
        signedIn: action.user
      });

    case SIGN_OUT:
      return Object.assign({}, state, {
        isAuthenticated: false,
        isAnonymous: true,
        signedOut: !action.soft
      });

    case _users.UPDATE_AVATAR:
      if (state.isAuthenticated && state.user.id === action.userId) {
        var _newState = Object.assign({}, state);

        _newState.user = Object.assign({}, state.user, {
          avatars: action.avatars
        });
        return _newState;
      }

      return state;

    case _users.UPDATE_USERNAME:
      if (state.isAuthenticated && state.user.id === action.userId) {
        var _newState2 = Object.assign({}, state);

        _newState2.user = Object.assign({}, state.user, {
          username: action.username,
          slug: action.slug
        });
        return _newState2;
      }

      return state;

    default:
      return state;
  }
}

},{"./users":364}],351:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replace = replace;
exports.default = participants;
exports.REPLACE_PARTICIPANTS = void 0;
var REPLACE_PARTICIPANTS = "REPLACE_PARTICIPANTS";
exports.REPLACE_PARTICIPANTS = REPLACE_PARTICIPANTS;

function replace(newState) {
  return {
    type: REPLACE_PARTICIPANTS,
    state: newState
  };
}

function participants() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case REPLACE_PARTICIPANTS:
      return action.state;

    default:
      return state;
  }
}

},{}],352:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrate = hydrate;
exports.busy = busy;
exports.release = release;
exports.replace = replace;
exports.update = update;
exports.remove = remove;
exports.default = poll;
exports.UPDATE_POLL = exports.REPLACE_POLL = exports.REMOVE_POLL = exports.RELEASE_POLL = exports.BUSY_POLL = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUSY_POLL = "BUSY_POLL";
exports.BUSY_POLL = BUSY_POLL;
var RELEASE_POLL = "RELEASE_POLL";
exports.RELEASE_POLL = RELEASE_POLL;
var REMOVE_POLL = "REMOVE_POLL";
exports.REMOVE_POLL = REMOVE_POLL;
var REPLACE_POLL = "REPLACE_POLL";
exports.REPLACE_POLL = REPLACE_POLL;
var UPDATE_POLL = "UPDATE_POLL";
exports.UPDATE_POLL = UPDATE_POLL;

function hydrate(json) {
  var hasSelectedChoices = false;

  for (var i in json.choices) {
    var choice = json.choices[i];

    if (choice.selected) {
      hasSelectedChoices = true;
      break;
    }
  }

  return Object.assign({}, json, {
    posted_on: (0, _moment.default)(json.posted_on),
    hasSelectedChoices: hasSelectedChoices,
    endsOn: json.length ? (0, _moment.default)(json.posted_on).add(json.length, "days") : null,
    isBusy: false
  });
}

function busy() {
  return {
    type: BUSY_POLL
  };
}

function release() {
  return {
    type: RELEASE_POLL
  };
}

function replace(newState) {
  var hydrated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: REPLACE_POLL,
    state: hydrated ? newState : hydrate(newState)
  };
}

function update(data) {
  return {
    type: UPDATE_POLL,
    data: data
  };
}

function remove() {
  return {
    type: REMOVE_POLL
  };
}

function poll() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case BUSY_POLL:
      return Object.assign({}, state, {
        isBusy: true
      });

    case RELEASE_POLL:
      return Object.assign({}, state, {
        isBusy: false
      });

    case REMOVE_POLL:
      return {
        isBusy: false
      };

    case REPLACE_POLL:
      return action.state;

    case UPDATE_POLL:
      return Object.assign({}, state, action.data);

    default:
      return state;
  }
}

},{"moment":"moment"}],353:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrate = hydrate;
exports.hydrateAttachment = hydrateAttachment;
exports.patch = patch;
exports.default = post;
exports.PATCH_POST = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _users = require("./users");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PATCH_POST = "PATCH_POST";
exports.PATCH_POST = PATCH_POST;

function hydrate(json) {
  return Object.assign({}, json, {
    posted_on: (0, _moment.default)(json.posted_on),
    updated_on: (0, _moment.default)(json.updated_on),
    hidden_on: (0, _moment.default)(json.hidden_on),
    attachments: json.attachments ? json.attachments.map(hydrateAttachment) : null,
    poster: json.poster ? (0, _users.hydrateUser)(json.poster) : null,
    isSelected: false,
    isBusy: false,
    isDeleted: false
  });
}

function hydrateAttachment(json) {
  return Object.assign({}, json, {
    uploaded_on: (0, _moment.default)(json.uploaded_on)
  });
}

function patch(post, patch) {
  return {
    type: PATCH_POST,
    post: post,
    patch: patch
  };
}

function post() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case PATCH_POST:
      if (state.id == action.post.id) {
        return Object.assign({}, state, action.patch);
      }

      return state;

    default:
      return state;
  }
}

},{"./users":364,"moment":"moment"}],354:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = select;
exports.deselect = deselect;
exports.deselectAll = deselectAll;
exports.hydrate = hydrate;
exports.load = load;
exports.append = append;
exports.unload = unload;
exports.update = update;
exports.default = posts;
exports.UPDATE_POSTS = exports.UNLOAD_POSTS = exports.LOAD_POSTS = exports.DESELECT_POSTS = exports.DESELECT_POST = exports.SELECT_POST = exports.APPEND_POSTS = void 0;

var _post = _interopRequireWildcard(require("./post"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var APPEND_POSTS = "APPEND_POSTS";
exports.APPEND_POSTS = APPEND_POSTS;
var SELECT_POST = "SELECT_POST";
exports.SELECT_POST = SELECT_POST;
var DESELECT_POST = "DESELECT_POST";
exports.DESELECT_POST = DESELECT_POST;
var DESELECT_POSTS = "DESELECT_POSTS";
exports.DESELECT_POSTS = DESELECT_POSTS;
var LOAD_POSTS = "LOAD_POSTS";
exports.LOAD_POSTS = LOAD_POSTS;
var UNLOAD_POSTS = "UNLOAD_POSTS";
exports.UNLOAD_POSTS = UNLOAD_POSTS;
var UPDATE_POSTS = "UPDATE_POSTS";
exports.UPDATE_POSTS = UPDATE_POSTS;

function select(post) {
  return {
    type: SELECT_POST,
    post: post
  };
}

function deselect(post) {
  return {
    type: DESELECT_POST,
    post: post
  };
}

function deselectAll() {
  return {
    type: DESELECT_POSTS
  };
}

function hydrate(json) {
  return Object.assign({}, json, {
    results: json.results.map(_post.hydrate),
    isLoaded: true,
    isBusy: false,
    isSelected: false
  });
}

function load(newState) {
  var hydrated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: LOAD_POSTS,
    state: hydrated ? newState : hydrate(newState)
  };
}

function append(newState) {
  var hydrated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: APPEND_POSTS,
    state: hydrated ? newState : hydrate(newState)
  };
}

function unload() {
  return {
    type: UNLOAD_POSTS
  };
}

function update(newState) {
  return {
    type: UPDATE_POSTS,
    update: newState
  };
}

function posts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case SELECT_POST:
      var selectedPosts = state.results.map(function (post) {
        if (post.id == action.post.id) {
          return Object.assign({}, post, {
            isSelected: true
          });
        } else {
          return post;
        }
      });
      return Object.assign({}, state, {
        results: selectedPosts
      });

    case DESELECT_POST:
      var deseletedPosts = state.results.map(function (post) {
        if (post.id == action.post.id) {
          return Object.assign({}, post, {
            isSelected: false
          });
        } else {
          return post;
        }
      });
      return Object.assign({}, state, {
        results: deseletedPosts
      });

    case DESELECT_POSTS:
      var deseletedAllPosts = state.results.map(function (post) {
        return Object.assign({}, post, {
          isSelected: false
        });
      });
      return Object.assign({}, state, {
        results: deseletedAllPosts
      });

    case APPEND_POSTS:
      var results = state.results.slice();
      var resultsIds = state.results.map(function (post) {
        return post.id;
      });
      action.state.results.map(function (post) {
        if (resultsIds.indexOf(post.id) === -1) {
          results.push(post);
        }
      });
      return Object.assign({}, action.state, {
        results: results
      });

    case LOAD_POSTS:
      return action.state;

    case UNLOAD_POSTS:
      return Object.assign({}, state, {
        isLoaded: false
      });

    case UPDATE_POSTS:
      return Object.assign({}, state, action.update);

    case _post.PATCH_POST:
      var reducedPosts = state.results.map(function (post) {
        return (0, _post.default)(post, action);
      });
      return Object.assign({}, state, {
        results: reducedPosts
      });

    default:
      return state;
  }
}

},{"./post":353}],355:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = load;
exports.default = details;
exports.LOAD_DETAILS = void 0;
var LOAD_DETAILS = "LOAD_DETAILS";
exports.LOAD_DETAILS = LOAD_DETAILS;

function load(newState) {
  return {
    type: LOAD_DETAILS,
    newState: newState
  };
}

function details() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case LOAD_DETAILS:
      return action.newState;

    default:
      return state;
  }
}

},{}],356:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrate = hydrate;
exports.patch = patch;
exports.default = auth;
exports.PATCH_PROFILE = exports.HYDRATE_PROFILE = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _users = require("./users");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HYDRATE_PROFILE = "HYDRATE_PROFILE";
exports.HYDRATE_PROFILE = HYDRATE_PROFILE;
var PATCH_PROFILE = "PATCH_PROFILE";
exports.PATCH_PROFILE = PATCH_PROFILE;

function hydrate(profile) {
  return {
    type: HYDRATE_PROFILE,
    profile: profile
  };
}

function patch(patch) {
  return {
    type: PATCH_PROFILE,
    patch: patch
  };
}

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case HYDRATE_PROFILE:
      return Object.assign({}, action.profile, {
        joined_on: (0, _moment.default)(action.profile.joined_on),
        status: (0, _users.hydrateStatus)(action.profile.status)
      });

    case PATCH_PROFILE:
      return Object.assign({}, state, action.patch);

    case _users.UPDATE_AVATAR:
      if (state.id === action.userId) {
        return Object.assign({}, state, {
          avatars: action.avatars
        });
      }

      return state;

    case _users.UPDATE_USERNAME:
      if (state.id === action.userId) {
        return Object.assign({}, state, {
          username: action.username,
          slug: action.slug
        });
      }

      return state;

    default:
      return state;
  }
}

},{"./users":364,"moment":"moment"}],357:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replace = replace;
exports.update = update;
exports.updateProvider = updateProvider;
exports.default = participants;
exports.initialState = exports.UPDATE_SEARCH_PROVIDER = exports.UPDATE_SEARCH = exports.REPLACE_SEARCH = void 0;
var REPLACE_SEARCH = "REPLACE_SEARCH";
exports.REPLACE_SEARCH = REPLACE_SEARCH;
var UPDATE_SEARCH = "UPDATE_SEARCH";
exports.UPDATE_SEARCH = UPDATE_SEARCH;
var UPDATE_SEARCH_PROVIDER = "UPDATE_SEARCH_PROVIDER";
exports.UPDATE_SEARCH_PROVIDER = UPDATE_SEARCH_PROVIDER;
var initialState = {
  isLoading: false,
  query: "",
  providers: []
};
exports.initialState = initialState;

function replace(newState) {
  return {
    type: REPLACE_SEARCH,
    state: {
      isLoading: false,
      providers: newState
    }
  };
}

function update(newState) {
  return {
    type: UPDATE_SEARCH,
    update: newState
  };
}

function updateProvider(provider) {
  return {
    type: UPDATE_SEARCH_PROVIDER,
    provider: provider
  };
}

function participants() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case REPLACE_SEARCH:
      return action.state;

    case UPDATE_SEARCH:
      return Object.assign({}, state, action.update);

    case UPDATE_SEARCH_PROVIDER:
      return Object.assign({}, state, {
        providers: state.providers.map(function (provider) {
          if (provider.id === action.provider.id) {
            return action.provider;
          } else {
            return provider;
          }
        })
      });

    default:
      return state;
  }
}

},{}],358:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = all;
exports.none = none;
exports.item = item;
exports.default = selection;
exports.SELECT_ITEM = exports.SELECT_NONE = exports.SELECT_ALL = void 0;

var _sets = require("../utils/sets");

var SELECT_ALL = "SELECT_ALL";
exports.SELECT_ALL = SELECT_ALL;
var SELECT_NONE = "SELECT_NONE";
exports.SELECT_NONE = SELECT_NONE;
var SELECT_ITEM = "SELECT_ITEM";
exports.SELECT_ITEM = SELECT_ITEM;

function all(itemsIds) {
  return {
    type: SELECT_ALL,
    items: itemsIds
  };
}

function none() {
  return {
    type: SELECT_NONE
  };
}

function item(itemId) {
  return {
    type: SELECT_ITEM,
    item: itemId
  };
}

function selection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case SELECT_ALL:
      return action.items;

    case SELECT_NONE:
      return [];

    case SELECT_ITEM:
      return (0, _sets.toggle)(state, action.item);

    default:
      return state;
  }
}

},{"../utils/sets":391}],359:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSnackbar = showSnackbar;
exports.hideSnackbar = hideSnackbar;
exports.default = snackbar;
exports.HIDE_SNACKBAR = exports.SHOW_SNACKBAR = exports.initialState = void 0;
var initialState = {
  type: "info",
  message: "",
  isVisible: false
};
exports.initialState = initialState;
var SHOW_SNACKBAR = "SHOW_SNACKBAR";
exports.SHOW_SNACKBAR = SHOW_SNACKBAR;
var HIDE_SNACKBAR = "HIDE_SNACKBAR";
exports.HIDE_SNACKBAR = HIDE_SNACKBAR;

function showSnackbar(message, type) {
  return {
    type: SHOW_SNACKBAR,
    message: message,
    messageType: type
  };
}

function hideSnackbar() {
  return {
    type: HIDE_SNACKBAR
  };
}

function snackbar() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (action.type === SHOW_SNACKBAR) {
    return {
      type: action.messageType,
      message: action.message,
      isVisible: true
    };
  } else if (action.type === HIDE_SNACKBAR) {
    return Object.assign({}, state, {
      isVisible: false
    });
  } else {
    return state;
  }
}

},{}],360:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrate = hydrate;
exports.busy = busy;
exports.release = release;
exports.replace = replace;
exports.update = update;
exports.updateAcl = updateAcl;
exports.default = thread;
exports.UPDATE_THREAD_ACL = exports.UPDATE_THREAD = exports.REPLACE_THREAD = exports.RELEASE_THREAD = exports.BUSY_THREAD = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _poll = require("./poll");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUSY_THREAD = "BUSY_THREAD";
exports.BUSY_THREAD = BUSY_THREAD;
var RELEASE_THREAD = "RELEASE_THREAD";
exports.RELEASE_THREAD = RELEASE_THREAD;
var REPLACE_THREAD = "REPLACE_THREAD";
exports.REPLACE_THREAD = REPLACE_THREAD;
var UPDATE_THREAD = "UPDATE_THREAD";
exports.UPDATE_THREAD = UPDATE_THREAD;
var UPDATE_THREAD_ACL = "UPDATE_THREAD_ACL";
exports.UPDATE_THREAD_ACL = UPDATE_THREAD_ACL;

function hydrate(json) {
  return Object.assign({}, json, {
    started_on: (0, _moment.default)(json.started_on),
    last_post_on: (0, _moment.default)(json.last_post_on),
    best_answer_marked_on: json.best_answer_marked_on ? (0, _moment.default)(json.best_answer_marked_on) : null,
    isBusy: false
  });
}

function busy() {
  return {
    type: BUSY_THREAD
  };
}

function release() {
  return {
    type: RELEASE_THREAD
  };
}

function replace(newState) {
  var hydrated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: REPLACE_THREAD,
    state: hydrated ? newState : hydrate(newState)
  };
}

function update(data) {
  return {
    type: UPDATE_THREAD,
    data: data
  };
}

function updateAcl(data) {
  return {
    type: UPDATE_THREAD_ACL,
    data: data
  };
}

function thread() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case BUSY_THREAD:
      return Object.assign({}, state, {
        isBusy: true
      });

    case RELEASE_THREAD:
      return Object.assign({}, state, {
        isBusy: false
      });

    case _poll.REMOVE_POLL:
      return Object.assign({}, state, {
        poll: null
      });

    case _poll.REPLACE_POLL:
      return Object.assign({}, state, {
        poll: action.state
      });

    case REPLACE_THREAD:
      return action.state;

    case UPDATE_THREAD:
      return Object.assign({}, state, action.data);

    case UPDATE_THREAD_ACL:
      var acl = Object.assign({}, state.acl, action.data);
      return Object.assign({}, state, {
        acl: acl
      });

    default:
      return state;
  }
}

},{"./poll":352,"moment":"moment"}],361:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.append = append;
exports.deleteThread = deleteThread;
exports.filterThreads = filterThreads;
exports.hydrate = hydrate;
exports.patch = patch;
exports.sort = sort;
exports.getThreadModerationOptions = getThreadModerationOptions;
exports.hydrateThread = hydrateThread;
exports.default = thread;
exports.MODERATION_PERMISSIONS = exports.SORT_THREADS = exports.PATCH_THREAD = exports.HYDRATE_THREADS = exports.FILTER_THREADS = exports.DELETE_THREAD = exports.APPEND_THREADS = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _concatUnique = _interopRequireDefault(require("../utils/concat-unique"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPEND_THREADS = "APPEND_THREADS";
exports.APPEND_THREADS = APPEND_THREADS;
var DELETE_THREAD = "DELETE_THREAD";
exports.DELETE_THREAD = DELETE_THREAD;
var FILTER_THREADS = "FILTER_THREADS";
exports.FILTER_THREADS = FILTER_THREADS;
var HYDRATE_THREADS = "HYDRATE_THREADS";
exports.HYDRATE_THREADS = HYDRATE_THREADS;
var PATCH_THREAD = "PATCH_THREAD";
exports.PATCH_THREAD = PATCH_THREAD;
var SORT_THREADS = "SORT_THREADS";
exports.SORT_THREADS = SORT_THREADS;
var MODERATION_PERMISSIONS = ["can_announce", "can_approve", "can_close", "can_hide", "can_move", "can_merge", "can_pin", "can_review"];
exports.MODERATION_PERMISSIONS = MODERATION_PERMISSIONS;

function append(items, sorting) {
  return {
    type: APPEND_THREADS,
    items: items,
    sorting: sorting
  };
}

function deleteThread(thread) {
  return {
    type: DELETE_THREAD,
    thread: thread
  };
}

function filterThreads(category, categoriesMap) {
  return {
    type: FILTER_THREADS,
    category: category,
    categoriesMap: categoriesMap
  };
}

function hydrate(items) {
  return {
    type: HYDRATE_THREADS,
    items: items
  };
}

function patch(thread, patch) {
  var sorting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: PATCH_THREAD,
    thread: thread,
    patch: patch,
    sorting: sorting
  };
}

function sort(sorting) {
  return {
    type: SORT_THREADS,
    sorting: sorting
  };
}

function getThreadModerationOptions(thread_acl) {
  var options = [];
  MODERATION_PERMISSIONS.forEach(function (perm) {
    if (thread_acl[perm]) {
      options.push(perm);
    }
  });
  return options;
}

function hydrateThread(thread) {
  return Object.assign({}, thread, {
    started_on: (0, _moment.default)(thread.started_on),
    last_post_on: (0, _moment.default)(thread.last_post_on),
    moderation: getThreadModerationOptions(thread.acl)
  });
}

function thread() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case APPEND_THREADS:
      var mergedState = (0, _concatUnique.default)(action.items.map(hydrateThread), state);
      return mergedState.sort(action.sorting);

    case DELETE_THREAD:
      return state.filter(function (item) {
        return item.id !== action.thread.id;
      });

    case FILTER_THREADS:
      return state.filter(function (item) {
        var itemCategory = action.categoriesMap[item.category];

        if (itemCategory.lft >= action.category.lft && itemCategory.rght <= action.category.rght) {
          // same or sub category
          return true;
        } else if (item.weight == 2) {
          // globally pinned
          return true;
        } else {
          // thread moved outside displayed scope, hide it
          return false;
        }
      });

    case HYDRATE_THREADS:
      return action.items.map(hydrateThread);

    case PATCH_THREAD:
      var patchedState = state.map(function (item) {
        if (item.id === action.thread.id) {
          return Object.assign({}, item, action.patch);
        } else {
          return item;
        }
      });

      if (action.sorting) {
        return patchedState.sort(action.sorting);
      }

      return patchedState;

    case SORT_THREADS:
      return state.sort(action.sorting);

    default:
      return state;
  }
}

},{"../utils/concat-unique":381,"moment":"moment"}],362:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doTick = doTick;
exports.default = tick;
exports.TICK = exports.initialState = void 0;
var initialState = {
  tick: 0
};
exports.initialState = initialState;
var TICK = "TICK";
exports.TICK = TICK;

function doTick() {
  return {
    type: TICK
  };
}

function tick() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (action.type === TICK) {
    return Object.assign({}, state, {
      tick: state.tick + 1
    });
  } else {
    return state;
  }
}

},{}],363:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNameChange = addNameChange;
exports.append = append;
exports.hydrate = hydrate;
exports.hydrateNamechange = hydrateNamechange;
exports.default = username;
exports.HYDRATE_HISTORY = exports.APPEND_HISTORY = exports.ADD_NAME_CHANGE = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _users = require("./users");

var _concatUnique = _interopRequireDefault(require("../utils/concat-unique"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_NAME_CHANGE = "ADD_NAME_CHANGE";
exports.ADD_NAME_CHANGE = ADD_NAME_CHANGE;
var APPEND_HISTORY = "APPEND_HISTORY";
exports.APPEND_HISTORY = APPEND_HISTORY;
var HYDRATE_HISTORY = "HYDRATE_HISTORY";
exports.HYDRATE_HISTORY = HYDRATE_HISTORY;

function addNameChange(change, user, changedBy) {
  return {
    type: ADD_NAME_CHANGE,
    change: change,
    user: user,
    changedBy: changedBy
  };
}

function append(items) {
  return {
    type: APPEND_HISTORY,
    items: items
  };
}

function hydrate(items) {
  return {
    type: HYDRATE_HISTORY,
    items: items
  };
}

function hydrateNamechange(namechange) {
  return Object.assign({}, namechange, {
    changed_on: (0, _moment.default)(namechange.changed_on)
  });
}

function username() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case ADD_NAME_CHANGE:
      var newState = state.slice();
      newState.unshift({
        id: Math.floor(Date.now() / 1000),
        // just small hax for getting id
        changed_by: action.changedBy,
        changed_by_username: action.changedBy.username,
        changed_on: (0, _moment.default)(),
        new_username: action.change.username,
        old_username: action.user.username
      });
      return newState;

    case APPEND_HISTORY:
      return (0, _concatUnique.default)(state, action.items.map(hydrateNamechange));

    case HYDRATE_HISTORY:
      return action.items.map(hydrateNamechange);

    case _users.UPDATE_AVATAR:
      return state.map(function (item) {
        item = Object.assign({}, item);

        if (item.changed_by && item.changed_by.id === action.userId) {
          item.changed_by = Object.assign({}, item.changed_by, {
            avatars: action.avatars
          });
        }

        return item;
      });

    case _users.UPDATE_USERNAME:
      return state.map(function (item) {
        item = Object.assign({}, item);

        if (item.changed_by && item.changed_by.id === action.userId) {
          item.changed_by = Object.assign({}, item.changed_by, {
            username: action.username,
            slug: action.slug
          });
        }

        return Object.assign({}, item);
      });

    default:
      return state;
  }
}

},{"../utils/concat-unique":381,"./users":364,"moment":"moment"}],364:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.append = append;
exports.hydrate = hydrate;
exports.hydrateStatus = hydrateStatus;
exports.hydrateUser = hydrateUser;
exports.updateAvatar = updateAvatar;
exports.updateUsername = updateUsername;
exports.default = user;
exports.UPDATE_USERNAME = exports.UPDATE_AVATAR = exports.HYDRATE_USERS = exports.APPEND_USERS = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _concatUnique = _interopRequireDefault(require("../utils/concat-unique"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPEND_USERS = "APPEND_USERS";
exports.APPEND_USERS = APPEND_USERS;
var HYDRATE_USERS = "HYDRATE_USERS";
exports.HYDRATE_USERS = HYDRATE_USERS;
var UPDATE_AVATAR = "UPDATE_AVATAR";
exports.UPDATE_AVATAR = UPDATE_AVATAR;
var UPDATE_USERNAME = "UPDATE_USERNAME";
exports.UPDATE_USERNAME = UPDATE_USERNAME;

function append(items) {
  return {
    type: APPEND_USERS,
    items: items
  };
}

function hydrate(items) {
  return {
    type: HYDRATE_USERS,
    items: items
  };
}

function hydrateStatus(status) {
  if (status) {
    return Object.assign({}, status, {
      last_click: status.last_click ? (0, _moment.default)(status.last_click) : null,
      banned_until: status.banned_until ? (0, _moment.default)(status.banned_until) : null
    });
  } else {
    return null;
  }
}

function hydrateUser(user) {
  return Object.assign({}, user, {
    joined_on: (0, _moment.default)(user.joined_on),
    status: hydrateStatus(user.status)
  });
}

function updateAvatar(user, avatars) {
  return {
    type: UPDATE_AVATAR,
    userId: user.id,
    avatars: avatars
  };
}

function updateUsername(user, username, slug) {
  return {
    type: UPDATE_USERNAME,
    userId: user.id,
    username: username,
    slug: slug
  };
}

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action.type) {
    case APPEND_USERS:
      return (0, _concatUnique.default)(state, action.items.map(hydrateUser));

    case HYDRATE_USERS:
      return action.items.map(hydrateUser);

    case UPDATE_AVATAR:
      return state.map(function (item) {
        item = Object.assign({}, item);

        if (item.id === action.userId) {
          item.avatars = action.avatars;
        }

        return item;
      });

    default:
      return state;
  }
}

},{"../utils/concat-unique":381,"moment":"moment"}],365:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Ajax = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Ajax = /*#__PURE__*/function () {
  function Ajax() {
    _classCallCheck(this, Ajax);

    this._cookieName = null;
    this._csrfToken = null;
    this._locks = {};
  }

  _createClass(Ajax, [{
    key: "init",
    value: function init(cookieName) {
      this._cookieName = cookieName;
    }
  }, {
    key: "getCsrfToken",
    value: function getCsrfToken() {
      if (document.cookie.indexOf(this._cookieName) !== -1) {
        var cookieRegex = new RegExp(this._cookieName + "=([^;]*)");
        var cookie = document.cookie.match(cookieRegex)[0];
        return cookie ? cookie.split("=")[1] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "request",
    value: function request(method, url, data) {
      var self = this;
      return new Promise(function (resolve, reject) {
        var xhr = {
          url: url,
          method: method,
          headers: {
            "X-CSRFToken": self.getCsrfToken()
          },
          data: data ? JSON.stringify(data) : null,
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          success: function success(data) {
            resolve(data);
          },
          error: function error(jqXHR) {
            var rejection = jqXHR.responseJSON || {};
            rejection.status = jqXHR.status;

            if (rejection.status === 0) {
              rejection.detail = gettext("Lost connection with application.");
            }

            if (rejection.status === 404) {
              if (!rejection.detail || rejection.detail === "NOT FOUND") {
                rejection.detail = gettext("Action link is invalid.");
              }
            }

            if (rejection.status === 500 && !rejection.detail) {
              rejection.detail = gettext("Unknown error has occured.");
            }

            rejection.statusText = jqXHR.statusText;
            reject(rejection);
          }
        };
        $.ajax(xhr);
      });
    }
  }, {
    key: "get",
    value: function get(url, params, lock) {
      if (params) {
        url += "?" + $.param(params);
      }

      if (lock) {
        var self = this; // update url in existing lock?

        if (this._locks[lock]) {
          this._locks[lock].url = url;
        } // immediately dereference promise handlers without doing anything
        // we are already waiting for existing response to resolve


        if (this._locks[lock] && this._locks[lock].waiter) {
          return {
            then: function then() {
              return;
            }
          }; // return promise that will begin when original one resolves
        } else if (this._locks[lock] && this._locks[lock].wait) {
          this._locks[lock].waiter = true;
          return new Promise(function (resolve, reject) {
            var wait = function wait(url) {
              // keep waiting on promise
              if (self._locks[lock].wait) {
                window.setTimeout(function () {
                  wait(url);
                }, 300); // poll for new url
              } else if (self._locks[lock].url !== url) {
                wait(self._locks[lock].url); // ajax backend for response
              } else {
                self._locks[lock].waiter = false;
                self.request("GET", self._locks[lock].url).then(function (data) {
                  if (self._locks[lock].url === url) {
                    resolve(data);
                  } else {
                    self._locks[lock].waiter = true;
                    wait(self._locks[lock].url);
                  }
                }, function (rejection) {
                  if (self._locks[lock].url === url) {
                    reject(rejection);
                  } else {
                    self._locks[lock].waiter = true;
                    wait(self._locks[lock].url);
                  }
                });
              }
            };

            window.setTimeout(function () {
              wait(url);
            }, 300);
          }); // setup new lock without waiter
        } else {
          this._locks[lock] = {
            url: url,
            wait: true,
            waiter: false
          };
          return new Promise(function (resolve, reject) {
            self.request("GET", url).then(function (data) {
              self._locks[lock].wait = false;

              if (self._locks[lock].url === url) {
                resolve(data);
              }
            }, function (rejection) {
              self._locks[lock].wait = false;

              if (self._locks[lock].url === url) {
                reject(rejection);
              }
            });
          });
        }
      } else {
        return this.request("GET", url);
      }
    }
  }, {
    key: "post",
    value: function post(url, data) {
      return this.request("POST", url, data);
    }
  }, {
    key: "patch",
    value: function patch(url, data) {
      return this.request("PATCH", url, data);
    }
  }, {
    key: "put",
    value: function put(url, data) {
      return this.request("PUT", url, data);
    }
  }, {
    key: "delete",
    value: function _delete(url, data) {
      return this.request("DELETE", url, data);
    }
  }, {
    key: "upload",
    value: function upload(url, data, progress) {
      var self = this;
      return new Promise(function (resolve, reject) {
        var xhr = {
          url: url,
          method: "POST",
          headers: {
            "X-CSRFToken": self.getCsrfToken()
          },
          data: data,
          contentType: false,
          processData: false,
          xhr: function xhr() {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                progress(Math.round(evt.loaded / evt.total * 100));
              }
            }, false);
            return xhr;
          },
          success: function success(response) {
            resolve(response);
          },
          error: function error(jqXHR) {
            var rejection = jqXHR.responseJSON || {};
            rejection.status = jqXHR.status;

            if (rejection.status === 0) {
              rejection.detail = gettext("Lost connection with application.");
            }

            if (rejection.status === 413 && !rejection.detail) {
              rejection.detail = gettext("Upload was rejected by server as too large.");
            }

            if (rejection.status === 404) {
              if (!rejection.detail || rejection.detail === "NOT FOUND") {
                rejection.detail = gettext("Action link is invalid.");
              }
            }

            if (rejection.status === 500 && !rejection.detail) {
              rejection.detail = gettext("Unknown error has occured.");
            }

            rejection.statusText = jqXHR.statusText;
            reject(rejection);
          }
        };
        $.ajax(xhr);
      });
    }
  }]);

  return Ajax;
}();

exports.Ajax = Ajax;

var _default = new Ajax();

exports.default = _default;

},{}],366:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Auth = void 0;

var _auth = require("../reducers/auth");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);
  }

  _createClass(Auth, [{
    key: "init",
    value: function init(store, local, modal) {
      this._store = store;
      this._local = local;
      this._modal = modal; // tell other tabs what auth state is because we are most current with it

      this.syncSession(); // listen for other tabs to tell us that state changed

      this.watchState();
    }
  }, {
    key: "syncSession",
    value: function syncSession() {
      var state = this._store.getState().auth;

      if (state.isAuthenticated) {
        this._local.set("auth", {
          isAuthenticated: true,
          username: state.user.username
        });
      } else {
        this._local.set("auth", {
          isAuthenticated: false
        });
      }
    }
  }, {
    key: "watchState",
    value: function watchState() {
      var _this = this;

      var state = this._store.getState().auth;

      this._local.watch("auth", function (newState) {
        if (newState.isAuthenticated) {
          _this._store.dispatch((0, _auth.signIn)({
            username: newState.username
          }));
        } else if (state.isAuthenticated) {
          // check if we are authenticated in this tab
          // because some browser plugins prune local store
          // aggressively, forcing erroneous message to display here
          // tracking bug #955
          _this._store.dispatch((0, _auth.signOut)());
        }
      });

      this._modal.hide();
    }
  }, {
    key: "signIn",
    value: function signIn(user) {
      this._store.dispatch((0, _auth.signIn)(user));

      this._local.set("auth", {
        isAuthenticated: true,
        username: user.username
      });

      this._modal.hide();
    }
  }, {
    key: "signOut",
    value: function signOut() {
      this._store.dispatch((0, _auth.signOut)());

      this._local.set("auth", {
        isAuthenticated: false
      });

      this._modal.hide();
    }
  }, {
    key: "softSignOut",
    value: function softSignOut() {
      this._store.dispatch((0, _auth.signOut)(true));

      this._local.set("auth", {
        isAuthenticated: false
      });

      this._modal.hide();
    }
  }]);

  return Auth;
}();

exports.Auth = Auth;

var _default = new Auth();

exports.default = _default;

},{"../reducers/auth":350}],367:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Captcha = exports.ReCaptcha = exports.ReCaptchaComponent = exports.QACaptcha = exports.NoCaptcha = exports.BaseCaptcha = void 0;

var _react = _interopRequireDefault(require("react"));

var _formGroup = _interopRequireDefault(require("../components/form-group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseCaptcha = /*#__PURE__*/function () {
  function BaseCaptcha() {
    _classCallCheck(this, BaseCaptcha);
  }

  _createClass(BaseCaptcha, [{
    key: "init",
    value: function init(context, ajax, include, snackbar) {
      this._context = context;
      this._ajax = ajax;
      this._include = include;
      this._snackbar = snackbar;
    }
  }]);

  return BaseCaptcha;
}();

exports.BaseCaptcha = BaseCaptcha;

var NoCaptcha = /*#__PURE__*/function (_BaseCaptcha) {
  _inherits(NoCaptcha, _BaseCaptcha);

  var _super = _createSuper(NoCaptcha);

  function NoCaptcha() {
    _classCallCheck(this, NoCaptcha);

    return _super.apply(this, arguments);
  }

  _createClass(NoCaptcha, [{
    key: "load",
    value: function load() {
      return new Promise(function (resolve) {
        // immediately resolve as we don't have anything to validate
        resolve();
      });
    }
  }, {
    key: "validator",
    value: function validator() {
      return null;
    }
  }, {
    key: "component",
    value: function component() {
      return null;
    }
  }]);

  return NoCaptcha;
}(BaseCaptcha);

exports.NoCaptcha = NoCaptcha;

var QACaptcha = /*#__PURE__*/function (_BaseCaptcha2) {
  _inherits(QACaptcha, _BaseCaptcha2);

  var _super2 = _createSuper(QACaptcha);

  function QACaptcha() {
    _classCallCheck(this, QACaptcha);

    return _super2.apply(this, arguments);
  }

  _createClass(QACaptcha, [{
    key: "load",
    value: function load() {
      var self = this;
      return new Promise(function (resolve, reject) {
        self._ajax.get(self._context.get("CAPTCHA_API")).then(function (data) {
          self.question = data.question;
          self.helpText = data.help_text;
          resolve();
        }, function () {
          self._snackbar.error(gettext("Failed to load CAPTCHA."));

          reject();
        });
      });
    }
  }, {
    key: "validator",
    value: function validator() {
      return [];
    }
  }, {
    key: "component",
    value: function component(kwargs) {
      return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: this.question,
        for: "id_captcha",
        labelClass: kwargs.labelClass || "",
        controlClass: kwargs.controlClass || "",
        validation: kwargs.form.state.errors.captcha,
        helpText: this.helpText || null
      }, /*#__PURE__*/_react.default.createElement("input", {
        "aria-describedby": "id_captcha_status",
        className: "form-control",
        disabled: kwargs.form.state.isLoading,
        id: "id_captcha",
        onChange: kwargs.form.bindInput("captcha"),
        type: "text",
        value: kwargs.form.state.captcha
      }));
    }
  }]);

  return QACaptcha;
}(BaseCaptcha);

exports.QACaptcha = QACaptcha;

var ReCaptchaComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ReCaptchaComponent, _React$Component);

  var _super3 = _createSuper(ReCaptchaComponent);

  function ReCaptchaComponent() {
    _classCallCheck(this, ReCaptchaComponent);

    return _super3.apply(this, arguments);
  }

  _createClass(ReCaptchaComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      grecaptcha.render("recaptcha", {
        sitekey: this.props.siteKey,
        callback: function callback(response) {
          // fire fakey event to binding
          _this.props.binding({
            target: {
              value: response
            }
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "recaptcha"
      });
    }
  }]);

  return ReCaptchaComponent;
}(_react.default.Component);

exports.ReCaptchaComponent = ReCaptchaComponent;

var ReCaptcha = /*#__PURE__*/function (_BaseCaptcha3) {
  _inherits(ReCaptcha, _BaseCaptcha3);

  var _super4 = _createSuper(ReCaptcha);

  function ReCaptcha() {
    _classCallCheck(this, ReCaptcha);

    return _super4.apply(this, arguments);
  }

  _createClass(ReCaptcha, [{
    key: "load",
    value: function load() {
      this._include.include("https://www.google.com/recaptcha/api.js", true);

      return new Promise(function (resolve) {
        var wait = function wait() {
          if (typeof grecaptcha === "undefined") {
            window.setTimeout(function () {
              wait();
            }, 200);
          } else {
            resolve();
          }
        };

        wait();
      });
    }
  }, {
    key: "validator",
    value: function validator() {
      return [];
    }
  }, {
    key: "component",
    value: function component(kwargs) {
      return /*#__PURE__*/_react.default.createElement(_formGroup.default, {
        label: gettext("Please solve the quick test"),
        for: "id_captcha",
        labelClass: kwargs.labelClass || "",
        controlClass: kwargs.controlClass || "",
        validation: kwargs.form.state.errors.captcha,
        helpText: gettext("This test helps us prevent automated spam registrations on our site.")
      }, /*#__PURE__*/_react.default.createElement(ReCaptchaComponent, {
        binding: kwargs.form.bindInput("captcha"),
        siteKey: this._context.get("SETTINGS").recaptcha_site_key
      }));
    }
  }]);

  return ReCaptcha;
}(BaseCaptcha);

exports.ReCaptcha = ReCaptcha;

var Captcha = /*#__PURE__*/function () {
  function Captcha() {
    _classCallCheck(this, Captcha);
  }

  _createClass(Captcha, [{
    key: "init",
    value: function init(context, ajax, include, snackbar) {
      switch (context.get("SETTINGS").captcha_type) {
        case "no":
          this._captcha = new NoCaptcha();
          break;

        case "qa":
          this._captcha = new QACaptcha();
          break;

        case "re":
          this._captcha = new ReCaptcha();
          break;
      }

      this._captcha.init(context, ajax, include, snackbar);
    } // accessors for underlying strategy

  }, {
    key: "load",
    value: function load() {
      return this._captcha.load();
    }
  }, {
    key: "validator",
    value: function validator() {
      return this._captcha.validator();
    }
  }, {
    key: "component",
    value: function component(kwargs) {
      return this._captcha.component(kwargs);
    }
  }]);

  return Captcha;
}();

exports.Captcha = Captcha;

var _default = new Captcha();

exports.default = _default;

},{"../components/form-group":55,"react":"react"}],368:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Include = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Include = /*#__PURE__*/function () {
  function Include() {
    _classCallCheck(this, Include);
  }

  _createClass(Include, [{
    key: "init",
    value: function init(staticUrl) {
      this._staticUrl = staticUrl;
      this._included = [];
    }
  }, {
    key: "include",
    value: function include(script) {
      var remote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this._included.indexOf(script) === -1) {
        this._included.push(script);

        this._include(script, remote);
      }
    }
  }, {
    key: "_include",
    value: function _include(script, remote) {
      $.ajax({
        url: (!remote ? this._staticUrl : "") + script,
        cache: true,
        dataType: "script"
      });
    }
  }]);

  return Include;
}();

exports.Include = Include;

var _default = new Include();

exports.default = _default;

},{}],369:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LocalStorage = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var storage = window.localStorage;

var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }

  _createClass(LocalStorage, [{
    key: "init",
    value: function init(prefix) {
      var _this = this;

      this._prefix = prefix;
      this._watchers = [];
      window.addEventListener("storage", function (e) {
        var newValueJson = JSON.parse(e.newValue);

        _this._watchers.forEach(function (watcher) {
          if (watcher.key === e.key && e.oldValue !== e.newValue) {
            watcher.callback(newValueJson);
          }
        });
      });
    }
  }, {
    key: "set",
    value: function set(key, value) {
      storage.setItem(this._prefix + key, JSON.stringify(value));
    }
  }, {
    key: "get",
    value: function get(key) {
      var itemString = storage.getItem(this._prefix + key);

      if (itemString) {
        return JSON.parse(itemString);
      } else {
        return null;
      }
    }
  }, {
    key: "watch",
    value: function watch(key, callback) {
      this._watchers.push({
        key: this._prefix + key,
        callback: callback
      });
    }
  }]);

  return LocalStorage;
}();

exports.LocalStorage = LocalStorage;

var _default = new LocalStorage();

exports.default = _default;

},{}],370:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MobileNavbarDropdown = void 0;

var _mountComponent = _interopRequireDefault(require("../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MobileNavbarDropdown = /*#__PURE__*/function () {
  function MobileNavbarDropdown() {
    _classCallCheck(this, MobileNavbarDropdown);
  }

  _createClass(MobileNavbarDropdown, [{
    key: "init",
    value: function init(element) {
      this._element = element;
      this._component = null;
    }
  }, {
    key: "show",
    value: function show(component) {
      if (this._component === component) {
        this.hide();
      } else {
        this._component = component;
        (0, _mountComponent.default)(component, this._element.id);
        $(this._element).addClass("open");
      }
    }
  }, {
    key: "showConnected",
    value: function showConnected(name, component) {
      if (this._component === name) {
        this.hide();
      } else {
        this._component = name;
        (0, _mountComponent.default)(component, this._element.id, true);
        $(this._element).addClass("open");
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      $(this._element).removeClass("open");
      this._component = null;
    }
  }]);

  return MobileNavbarDropdown;
}();

exports.MobileNavbarDropdown = MobileNavbarDropdown;

var _default = new MobileNavbarDropdown();

exports.default = _default;

},{"../utils/mount-component":386}],371:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _mountComponent = _interopRequireDefault(require("../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Modal = /*#__PURE__*/function () {
  function Modal() {
    _classCallCheck(this, Modal);
  }

  _createClass(Modal, [{
    key: "init",
    value: function init(element) {
      var _this = this;

      this._element = element;
      this._modal = $(element).modal({
        show: false
      });

      this._modal.on("hidden.bs.modal", function () {
        _reactDom.default.unmountComponentAtNode(_this._element);
      });
    }
  }, {
    key: "show",
    value: function show(component) {
      (0, _mountComponent.default)(component, this._element.id);

      this._modal.modal("show");
    }
  }, {
    key: "hide",
    value: function hide() {
      this._modal.modal("hide");
    }
  }]);

  return Modal;
}();

exports.Modal = Modal;

var _default = new Modal();

exports.default = _default;

},{"../utils/mount-component":386,"react-dom":"react-dom"}],372:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseYoutubeUrl = parseYoutubeUrl;
exports.cleanUrl = cleanUrl;
exports.getVideoIdFromUrl = getVideoIdFromUrl;
exports.default = exports.OneBox = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ytRegExp = new RegExp("^.*(?:(?:youtu.be/|v/|vi/|u/w/|embed/)|(?:(?:watch)??v(?:i)?=|&v(?:i)?=))([^#&?]*).*");

var OneBox = /*#__PURE__*/function () {
  function OneBox() {
    var _this = this;

    _classCallCheck(this, OneBox);

    _defineProperty(this, "render", function (domnode) {
      if (!domnode) return;

      _this.highlightCode(domnode);

      _this.embedYoutubePlayers(domnode);
    });

    this._youtube = {};
  }

  _createClass(OneBox, [{
    key: "highlightCode",
    value: function highlightCode(domnode) {
      var codeblocks = domnode.querySelectorAll("pre>code");

      for (var i = 0; i < codeblocks.length; i++) {
        var code = codeblocks[i];
        hljs.highlightBlock(code);
      }
    }
  }, {
    key: "embedYoutubePlayers",
    value: function embedYoutubePlayers(domnode) {
      var anchors = domnode.querySelectorAll("p>a");

      for (var i = 0; i < anchors.length; i++) {
        var a = anchors[i];
        var p = a.parentNode;
        var onlyChild = p.childNodes.length === 1;

        if (!this._youtube[a.href]) {
          this._youtube[a.href] = parseYoutubeUrl(a.href);
        }

        var youtubeMovie = this._youtube[a.href];

        if (onlyChild && !!youtubeMovie && youtubeMovie.data !== false) {
          this.swapYoutubePlayer(a, youtubeMovie);
        }
      }
    }
  }, {
    key: "swapYoutubePlayer",
    value: function swapYoutubePlayer(element, youtube) {
      var url = "https://www.youtube.com/embed/";
      url += youtube.video;
      url += "?rel=0";

      if (youtube.start) {
        url += "&start=" + youtube.start;
      }

      var player = $('<iframe class="embed-responsive-item" src="' + url + '" allowfullscreen></iframe>');
      $(element).replaceWith(player);
      player.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
    }
  }]);

  return OneBox;
}();

exports.OneBox = OneBox;

var _default = new OneBox();

exports.default = _default;

function parseYoutubeUrl(url) {
  var cleanedUrl = cleanUrl(url);
  var video = getVideoIdFromUrl(cleanedUrl);
  if (!video) return null;
  var start = 0;

  if (cleanedUrl.indexOf("?") > 0) {
    var query = cleanedUrl.substr(cleanedUrl.indexOf("?") + 1);
    var timebit = query.split("&").filter(function (i) {
      return i.substr(0, 2) === "t=";
    })[0];

    if (timebit) {
      var bits = timebit.substr(2).split("m");

      if (bits[0].substr(-1) === "s") {
        start += parseInt(bits[0].substr(0, bits[0].length - 1));
      } else {
        start += parseInt(bits[0]) * 60;

        if (!!bits[1] && bits[1].substr(-1) === "s") {
          start += parseInt(bits[1].substr(0, bits[1].length - 1));
        }
      }
    }
  }

  return {
    start: start,
    video: video
  };
}

function cleanUrl(url) {
  var clean = url;

  if (url.substr(0, 8) === "https://") {
    clean = clean.substr(8);
  } else if (url.substr(0, 7) === "http://") {
    clean = clean.substr(7);
  }

  if (clean.substr(0, 4) === "www.") {
    clean = clean.substr(4);
  }

  return clean;
}

function getVideoIdFromUrl(url) {
  if (url.indexOf("youtu") === -1) return null;
  var video = url.match(ytRegExp);

  if (video) {
    return video[1];
  }

  return null;
}

},{}],373:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageTitle = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PageTitle = /*#__PURE__*/function () {
  function PageTitle() {
    _classCallCheck(this, PageTitle);
  }

  _createClass(PageTitle, [{
    key: "init",
    value: function init(indexTitle, forumName) {
      this._indexTitle = indexTitle;
      this._forumName = forumName;
    }
  }, {
    key: "set",
    value: function set(title) {
      if (!title) {
        document.title = this._indexTitle || this._forumName;
        return;
      }

      if (typeof title === "string") {
        title = {
          title: title
        };
      }

      var finalTitle = title.title;

      if (title.page > 1) {
        var pageLabel = interpolate(gettext("page: %(page)s"), {
          page: title.page
        }, true);
        finalTitle += " (" + pageLabel + ")";
      }

      if (title.parent) {
        finalTitle += " | " + title.parent;
      }

      document.title = finalTitle + " | " + this._forumName;
    }
  }]);

  return PageTitle;
}();

exports.PageTitle = PageTitle;

var _default = new PageTitle();

exports.default = _default;

},{}],374:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Polls = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Polls = /*#__PURE__*/function () {
  function Polls() {
    _classCallCheck(this, Polls);
  }

  _createClass(Polls, [{
    key: "init",
    value: function init(ajax, snackbar) {
      this._ajax = ajax;
      this._snackbar = snackbar;
      this._polls = {};
    }
  }, {
    key: "start",
    value: function start(kwargs) {
      var _this = this;

      this.stop(kwargs.poll);

      var poolServer = function poolServer() {
        _this._polls[kwargs.poll] = kwargs;

        _this._ajax.get(kwargs.url, kwargs.data || null).then(function (data) {
          if (!_this._polls[kwargs.poll]._stopped) {
            kwargs.update(data);
            _this._polls[kwargs.poll].timeout = window.setTimeout(poolServer, kwargs.frequency);
          }
        }, function (rejection) {
          if (!_this._polls[kwargs.poll]._stopped) {
            if (kwargs.error) {
              kwargs.error(rejection);
            } else {
              _this._snackbar.apiError(rejection);
            }
          }
        });
      };

      if (kwargs.delayed) {
        this._polls[kwargs.poll] = {
          timeout: window.setTimeout(poolServer, kwargs.frequency)
        };
      } else {
        poolServer();
      }
    }
  }, {
    key: "stop",
    value: function stop(pollId) {
      if (this._polls[pollId]) {
        window.clearTimeout(this._polls[pollId].timeout);
        this._polls[pollId]._stopped = true;
      }
    }
  }]);

  return Polls;
}();

exports.Polls = Polls;

var _default = new Polls();

exports.default = _default;

},{}],375:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Posting = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _poll = require("../components/poll");

var _posting = _interopRequireDefault(require("../components/posting"));

var _mountComponent = _interopRequireDefault(require("../utils/mount-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Posting = /*#__PURE__*/function () {
  function Posting() {
    var _this = this;

    _classCallCheck(this, Posting);

    _defineProperty(this, "close", function () {
      if (_this._isOpen && !_this._isClosing) {
        _this._isClosing = true;

        _this._placeholder.removeClass("slide-in");

        window.setTimeout(function () {
          _reactDom.default.unmountComponentAtNode(document.getElementById("posting-mount"));

          _this._isClosing = false;
          _this._isOpen = false;
        }, 300);
      }
    });
  }

  _createClass(Posting, [{
    key: "init",
    value: function init(ajax, snackbar, placeholder) {
      this._ajax = ajax;
      this._snackbar = snackbar;
      this._placeholder = $(placeholder);
      this._mode = null;
      this._isOpen = false;
      this._isClosing = false;
    }
  }, {
    key: "open",
    value: function open(props) {
      if (this._isOpen === false) {
        this._mode = props.mode;
        this._isOpen = props.submit;

        this._realOpen(props);
      } else if (this._isOpen !== props.submit) {
        var message = gettext("You are already working on other message. Do you want to discard it?");

        if (this._mode == "POLL") {
          message = gettext("You are already working on a poll. Do you want to discard it?");
        }

        var changeForm = confirm(message);

        if (changeForm) {
          this._mode = props.mode;
          this._isOpen = props.submit;

          this._realOpen(props);
        }
      } else if (this._mode == "REPLY" && props.mode == "REPLY") {
        this._realOpen(props);
      }
    }
  }, {
    key: "_realOpen",
    value: function _realOpen(props) {
      if (props.mode == "POLL") {
        (0, _mountComponent.default)( /*#__PURE__*/_react.default.createElement(_poll.PollForm, props), "posting-mount");
      } else {
        (0, _mountComponent.default)( /*#__PURE__*/_react.default.createElement(_posting.default, props), "posting-mount");
      }

      this._placeholder.addClass("slide-in");

      $("html, body").animate({
        scrollTop: this._placeholder.offset().top
      }, 1000);
    }
  }]);

  return Posting;
}();

exports.Posting = Posting;

var _default = new Posting();

exports.default = _default;

},{"../components/poll":106,"../components/posting":134,"../utils/mount-component":386,"react":"react","react-dom":"react-dom"}],376:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Snackbar = void 0;

var _snackbar = require("../reducers/snackbar");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HIDE_ANIMATION_LENGTH = 300;
var MESSAGE_SHOW_LENGTH = 5000;

var Snackbar = /*#__PURE__*/function () {
  function Snackbar() {
    _classCallCheck(this, Snackbar);
  }

  _createClass(Snackbar, [{
    key: "init",
    value: function init(store) {
      this._store = store;
      this._timeout = null;
    }
  }, {
    key: "alert",
    value: function alert(message, type) {
      var _this = this;

      if (this._timeout) {
        window.clearTimeout(this._timeout);

        this._store.dispatch((0, _snackbar.hideSnackbar)());

        this._timeout = window.setTimeout(function () {
          _this._timeout = null;

          _this.alert(message, type);
        }, HIDE_ANIMATION_LENGTH);
      } else {
        this._store.dispatch((0, _snackbar.showSnackbar)(message, type));

        this._timeout = window.setTimeout(function () {
          _this._store.dispatch((0, _snackbar.hideSnackbar)());

          _this._timeout = null;
        }, MESSAGE_SHOW_LENGTH);
      }
    } // shorthands for message types

  }, {
    key: "info",
    value: function info(message) {
      this.alert(message, "info");
    }
  }, {
    key: "success",
    value: function success(message) {
      this.alert(message, "success");
    }
  }, {
    key: "warning",
    value: function warning(message) {
      this.alert(message, "warning");
    }
  }, {
    key: "error",
    value: function error(message) {
      this.alert(message, "error");
    } // shorthand for api errors

  }, {
    key: "apiError",
    value: function apiError(rejection) {
      var message = rejection.detail;

      if (!message) {
        if (rejection.status === 404) {
          message = gettext("Action link is invalid.");
        } else {
          message = gettext("Unknown error has occured.");
        }
      }

      if (rejection.status === 403 && message === "Permission denied") {
        message = gettext("You don't have permission to perform this action.");
      }

      this.error(message);
    }
  }]);

  return Snackbar;
}();

exports.Snackbar = Snackbar;

var _default = new Snackbar();

exports.default = _default;

},{"../reducers/snackbar":359}],377:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StoreWrapper = void 0;

var _redux = require("redux");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StoreWrapper = /*#__PURE__*/function () {
  function StoreWrapper() {
    _classCallCheck(this, StoreWrapper);

    this._store = null;
    this._reducers = {};
    this._initialState = {};
  }

  _createClass(StoreWrapper, [{
    key: "addReducer",
    value: function addReducer(name, reducer, initialState) {
      this._reducers[name] = reducer;
      this._initialState[name] = initialState;
    }
  }, {
    key: "init",
    value: function init() {
      this._store = (0, _redux.createStore)((0, _redux.combineReducers)(this._reducers), this._initialState);
    }
  }, {
    key: "getStore",
    value: function getStore() {
      return this._store;
    } // Store API

  }, {
    key: "getState",
    value: function getState() {
      return this._store.getState();
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      return this._store.dispatch(action);
    }
  }]);

  return StoreWrapper;
}();

exports.StoreWrapper = StoreWrapper;

var _default = new StoreWrapper();

exports.default = _default;

},{"redux":"redux"}],378:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Zxcvbn = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* global zxcvbn */
var Zxcvbn = /*#__PURE__*/function () {
  function Zxcvbn() {
    _classCallCheck(this, Zxcvbn);
  }

  _createClass(Zxcvbn, [{
    key: "init",
    value: function init(include) {
      this._include = include;
      this._isLoaded = false;
    }
  }, {
    key: "scorePassword",
    value: function scorePassword(password, inputs) {
      // 0-4 score, the more the stronger password
      if (this._isLoaded) {
        return zxcvbn(password, inputs).score;
      }

      return 0;
    }
  }, {
    key: "load",
    value: function load() {
      if (!this._isLoaded) {
        this._include.include("misago/js/zxcvbn.js");

        return this._loadingPromise();
      } else {
        return this._loadedPromise();
      }
    }
  }, {
    key: "_loadingPromise",
    value: function _loadingPromise() {
      var self = this;
      return new Promise(function (resolve, reject) {
        var wait = function wait() {
          var tries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          tries += 1;

          if (tries > 200) {
            reject();
          } else if (typeof zxcvbn === "undefined") {
            window.setTimeout(function () {
              wait(tries);
            }, 200);
          } else {
            self._isLoaded = true;
            resolve();
          }
        };

        wait();
      });
    }
  }, {
    key: "_loadedPromise",
    value: function _loadedPromise() {
      // we have already loaded zxcvbn.js, resolve away!
      return new Promise(function (resolve) {
        resolve();
      });
    }
  }]);

  return Zxcvbn;
}();

exports.Zxcvbn = Zxcvbn;

var _default = new Zxcvbn();

exports.default = _default;

},{}],379:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _bannedPage = _interopRequireDefault(require("../components/banned-page"));

var _ = _interopRequireDefault(require("./.."));

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select = function select(state) {
  return state.tick;
};

var RedrawedBannedPage = (0, _reactRedux.connect)(select)(_bannedPage.default);

function _default(ban, changeState) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _store.default.getStore()
  }, /*#__PURE__*/_react.default.createElement(RedrawedBannedPage, {
    message: ban.message,
    expires: ban.expires_on ? (0, _moment.default)(ban.expires_on) : null
  })), document.getElementById("page-mount"));

  if (typeof changeState === "undefined" || changeState) {
    var forumName = _.default.get("SETTINGS").forum_name;

    document.title = gettext("You are banned") + " | " + forumName;
    window.history.pushState({}, "", _.default.get("BANNED_URL"));
  }
}

},{"../components/banned-page":7,"../services/store":377,"./..":302,"moment":"moment","react":"react","react-dom":"react-dom","react-redux":"react-redux"}],380:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(list, rowWidth) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var rows = [];
  var row = [];
  list.forEach(function (element) {
    row.push(element);

    if (row.length === rowWidth) {
      rows.push(row);
      row = [];
    }
  }); // pad row to required length?

  if (padding !== false && row.length > 0 && row.length < rowWidth) {
    for (var i = row.length; i < rowWidth; i++) {
      row.push(padding);
    }
  }

  if (row.length) {
    rows.push(row);
  }

  return rows;
}

},{}],381:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(a, b) {
  var ids = [];
  return a.concat(b).filter(function (item) {
    if (ids.indexOf(item.id) === -1) {
      ids.push(item.id);
      return true;
    } else {
      return false;
    }
  });
}

},{}],382:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default(callback, count) {
    _classCallCheck(this, _default);

    this._callback = callback;
    this._count = count;
  }

  _createClass(_default, [{
    key: "count",
    value: function count() {
      this._count -= 1;

      if (this._count === 0) {
        this._callback();
      }
    }
  }]);

  return _default;
}();

exports.default = _default;

},{}],383:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var map = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;"
};

function _default(text) {
  return text.replace(/[&<>"']/g, function (m) {
    return map[m];
  });
}

},{}],384:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.roundSize = roundSize;

function _default(bytes) {
  if (bytes > 1024 * 1024 * 1024) {
    return roundSize(bytes / (1024 * 1024 * 1024)) + " GB";
  } else if (bytes > 1024 * 1024) {
    return roundSize(bytes / (1024 * 1024)) + " MB";
  } else if (bytes > 1024) {
    return roundSize(bytes / 1024) + " KB";
  } else {
    return roundSize(bytes) + " B";
  }
}

function roundSize(value) {
  return value.toFixed(1);
}

},{}],385:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var URL_PATTERN = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i");

function _default(str) {
  return URL_PATTERN.test($.trim(str));
}

},{}],386:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(Component, rootElementId) {
  var connected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var rootElement = document.getElementById(rootElementId);
  var finalComponent = Component.props ? Component : /*#__PURE__*/_react.default.createElement(Component, null);

  if (rootElement) {
    if (connected) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: _store.default.getStore()
      }, finalComponent), rootElement);
    } else {
      _reactDom.default.render(finalComponent, rootElement);
    }
  }
}

},{"../services/store":377,"react":"react","react-dom":"react-dom","react-redux":"react-redux"}],387:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OrderedList = /*#__PURE__*/function () {
  function OrderedList(items) {
    _classCallCheck(this, OrderedList);

    this.isOrdered = false;
    this._items = items || [];
  }

  _createClass(OrderedList, [{
    key: "add",
    value: function add(key, item, order) {
      this._items.push({
        key: key,
        item: item,
        after: order ? order.after || null : null,
        before: order ? order.before || null : null
      });
    }
  }, {
    key: "get",
    value: function get(key, value) {
      for (var i = 0; i < this._items.length; i++) {
        if (this._items[i].key === key) {
          return this._items[i].item;
        }
      }

      return value;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.get(key) !== undefined;
    }
  }, {
    key: "values",
    value: function values() {
      var values = [];

      for (var i = 0; i < this._items.length; i++) {
        values.push(this._items[i].item);
      }

      return values;
    }
  }, {
    key: "order",
    value: function order(values_only) {
      if (!this.isOrdered) {
        this._items = this._order(this._items);
        this.isOrdered = true;
      }

      if (values_only || typeof values_only === "undefined") {
        return this.values();
      } else {
        return this._items;
      }
    }
  }, {
    key: "orderedValues",
    value: function orderedValues() {
      return this.order(true);
    }
  }, {
    key: "_order",
    value: function _order(unordered) {
      // Index of unordered items
      var index = [];
      unordered.forEach(function (item) {
        index.push(item.key);
      }); // Ordered items

      var ordered = [];
      var ordering = []; // First pass: register items that
      // don't specify their order

      unordered.forEach(function (item) {
        if (!item.after && !item.before) {
          ordered.push(item);
          ordering.push(item.key);
        }
      }); // Second pass: register items that
      // specify their before to "_end"

      unordered.forEach(function (item) {
        if (item.before === "_end") {
          ordered.push(item);
          ordering.push(item.key);
        }
      }); // Third pass: keep iterating items
      // until we hit iterations limit or finish
      // ordering list

      function insertItem(item) {
        var insertAt = -1;

        if (ordering.indexOf(item.key) === -1) {
          if (item.after) {
            insertAt = ordering.indexOf(item.after);

            if (insertAt !== -1) {
              insertAt += 1;
            }
          } else if (item.before) {
            insertAt = ordering.indexOf(item.before);
          }

          if (insertAt !== -1) {
            ordered.splice(insertAt, 0, item);
            ordering.splice(insertAt, 0, item.key);
          }
        }
      }

      var iterations = 200;

      while (iterations > 0 && index.length !== ordering.length) {
        iterations -= 1;
        unordered.forEach(insertItem);
      }

      return ordered;
    }
  }]);

  return OrderedList;
}();

var _default = OrderedList;
exports.default = _default;

},{}],388:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.int = int;
exports.range = range;

function int(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function range(min, max) {
  var array = new Array(int(min, max));

  for (var i = 0; i < array.length; i++) {
    array[i] = i;
  }

  return array;
}

},{}],389:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {
  window.scrollTo(0, 0);
}

},{}],390:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _store = _interopRequireDefault(require("../services/store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootElement = document.getElementById("page-mount");

function _default(options) {
  var routes = {
    component: options.component || null,
    childRoutes: []
  };

  if (options.root) {
    routes.childRoutes = [{
      path: options.root,
      onEnter: function onEnter(nextState, replaceState) {
        replaceState(null, options.paths[0].path);
      }
    }].concat(options.paths);
  } else {
    routes.childRoutes = options.paths;
  }

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _store.default.getStore()
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Router, {
    routes: routes,
    history: _reactRouter.browserHistory
  })), rootElement);
}

},{"../services/store":377,"react":"react","react-dom":"react-dom","react-redux":"react-redux","react-router":"react-router"}],391:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.push = push;
exports.remove = remove;
exports.toggle = toggle;

function push(array, value) {
  if (array.indexOf(value) === -1) {
    var copy = array.slice();
    copy.push(value);
    return copy;
  } else {
    return array;
  }
}

function remove(array, value) {
  if (array.indexOf(value) >= 0) {
    return array.filter(function (i) {
      return i !== value;
    });
  } else {
    return array;
  }
}

function toggle(array, value) {
  if (array.indexOf(value) === -1) {
    var copy = array.slice();
    copy.push(value);
    return copy;
  } else {
    return array.filter(function (i) {
      return i !== value;
    });
  }
}

},{}],392:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(string, subString) {
  string = (string + "").toLowerCase();
  subString = (subString + "").toLowerCase();
  if (subString.length <= 0) return 0;
  var n = 0;
  var pos = 0;
  var step = subString.length;

  while (true) {
    pos = string.indexOf(subString, pos);

    if (pos >= 0) {
      n += 1;
      pos += step;
    } else {
      break;
    }
  }

  return n;
}

},{}],393:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;
exports.requiredTermsOfService = requiredTermsOfService;
exports.requiredPrivacyPolicy = requiredPrivacyPolicy;
exports.email = email;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.usernameMinLength = usernameMinLength;
exports.usernameMaxLength = usernameMaxLength;
exports.usernameContent = usernameContent;
exports.passwordMinLength = passwordMinLength;
var EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
var USERNAME = new RegExp("^[0-9a-z]+$", "i");

function required(message) {
  return function (value) {
    if (value === false || value === null || $.trim(value).length === 0) {
      return message || gettext("This field is required.");
    }
  };
}

function requiredTermsOfService(message) {
  var error = gettext("You have to accept the terms of service.");
  return required(message || error);
}

function requiredPrivacyPolicy(message) {
  var error = gettext("You have to accept the privacy policy.");
  return required(message || error);
}

function email(message) {
  return function (value) {
    if (!EMAIL.test(value)) {
      return message || gettext("Enter a valid email address.");
    }
  };
}

function minLength(limitValue, message) {
  return function (value) {
    var returnMessage = "";
    var length = $.trim(value).length;

    if (length < limitValue) {
      if (message) {
        returnMessage = message(limitValue, length);
      } else {
        returnMessage = ngettext("Ensure this value has at least %(limit_value)s character (it has %(show_value)s).", "Ensure this value has at least %(limit_value)s characters (it has %(show_value)s).", limitValue);
      }

      return interpolate(returnMessage, {
        limit_value: limitValue,
        show_value: length
      }, true);
    }
  };
}

function maxLength(limitValue, message) {
  return function (value) {
    var returnMessage = "";
    var length = $.trim(value).length;

    if (length > limitValue) {
      if (message) {
        returnMessage = message(limitValue, length);
      } else {
        returnMessage = ngettext("Ensure this value has at most %(limit_value)s character (it has %(show_value)s).", "Ensure this value has at most %(limit_value)s characters (it has %(show_value)s).", limitValue);
      }

      return interpolate(returnMessage, {
        limit_value: limitValue,
        show_value: length
      }, true);
    }
  };
}

function usernameMinLength(lengthMin) {
  var message = function message(lengthMin) {
    return ngettext("Username must be at least %(limit_value)s character long.", "Username must be at least %(limit_value)s characters long.", lengthMin);
  };

  return minLength(lengthMin, message);
}

function usernameMaxLength(lengthMax) {
  var message = function message(lengthMax) {
    return ngettext("Username cannot be longer than %(limit_value)s character.", "Username cannot be longer than %(limit_value)s characters.", lengthMax);
  };

  return maxLength(lengthMax, message);
}

function usernameContent() {
  return function (value) {
    if (!USERNAME.test($.trim(value))) {
      return gettext("Username can only contain Chinese character, latin alphabet letters and digits.");
    }
  };
}

function passwordMinLength(limitValue) {
  return function (value) {
    var length = value.length;

    if (length < limitValue) {
      var returnMessage = ngettext("Valid password must be at least %(limit_value)s character long.", "Valid password must be at least %(limit_value)s characters long.", limitValue);
      return interpolate(returnMessage, {
        limit_value: limitValue,
        show_value: length
      }, true);
    }
  };
}

},{}]},{},[302,303,304,305,306,323,324,325,326,327,328,329,330,346,347,348,349,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345]);
